import { $t } from '@monorepo/i18n';
import { Status } from '@monorepo/types/orders/orderingControl/orderingControl.types';
import { PlanOrderType } from '@monorepo/types/process/productionPlan/productionPlan.types';
import { IPermissonCode } from '@monorepo/types';

const STATE_LIST_BASE = [
    { label: '进行中', value: 'IN_PROGRESS' },
    { label: '已过期', value: 'EXPIRED' },
    { label: '未开始', value: 'NOT_STARTED' },
    { label: '已停用', value: 'NOT_ACTIVE' },
];
const ORDER_STATUS_LIST = 1;
const PRODUCT_CHAIN_PATH = 'mars-server-chain/admin/api/internal';
const PRODUCT_REPORT_PATH = 'mars-server-report/admin/api/internal';
const PRODUCT_STOCK_PATH = 'mars-server-stock/admin/api/internal';
const MARS_SERVER_API_PATH = 'mars-server-api/admin/api/internal';
const MARS_SERVER_FINANCE = 'mars-server-finance/admin/api/internal';
const MARS_SERVER_PLATFORM_MP_PATH = 'mars-server-platform-mp/admin/api/internal';
const MARS_SERVER_ADMIN = 'mars-server-admin/admin/api/internal';
const MARS_USER_CENTER_PATH = 'mars-server-user-center/admin/api/internal';
const MARS_IDP_SERVER_PATH = 'mars-idp-server/admin/api/internal';
const MARS_CORE_SERVER_PATH = 'mars-server-core/admin/api/internal';
const MARS_FINANCE_SERVER_PATH = 'mars-server-finance/admin/api/internal';
const MARS_EARTH_SERVER_PATH = 'mars-server-plugin/admin/api/internal';
const MARS_SERVER_POS_PATH = 'mars-server-pos/admin/api/internal';
const MARS_OMS_POS_PATH = 'mars-server-oms/admin/api/internal';
const MARS_OMS_PAY_PATH = 'mars-server-pay/admin/api/internal';
const MARS_CRM_PATH = 'mars-server-crm/admin/api/internal';
const MARS_WECHAT_MP_PATH = 'mars-server-wechat-mp/admin/api/internal';
const MARS_WECHAT_MP_API_PATH = 'mars-server-wechat-mp/wechat_mp/api/internal';
const MARS_SERVER_WECOM_PATH = 'mars-server-wecom/admin/api/internal';
// 列表缓存配置
const CACHE_ROUTE_CONFIG = [
    // 客户共享分组
    {
        routeType: 'main-operations-clubCardGroup',
        routePath: '/main-operations/clubCardGroup',
    },
    // 打印模板设置
    {
        routeType: 'stock-settings-printTemplate',
        routePath: '/settings/printTemplate',
    },
    // 仓库档案
    {
        routeType: 'stock-document-storehouseFile',
        routePath: '/document/store',
    },
    // 物品查询模板
    {
        routeType: 'stock-document-queryTemplate',
        routePath: '/document/productQueryTemplate',
    },
    // 物品角标
    {
        routeType: 'stock-document-itemCornerLabel',
        routePath: '/document/itemCornerLabel',
    },
    // 仓库物品规则
    {
        routeType: 'stock-item-rule',
        routePath: '/document/stockItemRule',
    },
    // 成本卡管理
    {
        routeType: 'stock-document-costCard',
        routePath: '/document/costCard',
    },
    // 供应商档案
    {
        routeType: 'stock-purchase-supplier',
        routePath: '/purchasing/supplier',
    },
    // 供应商用户
    {
        routeType: 'stock-purchase-supplierUser',
        routePath: '/purchasing/supplierUser',
    },
    // 供应商用户角色
    {
        routeType: 'stock-purchase-supplierUserRole',
        routePath: '/purchasing/supplierUserRole',
    },
    // 物品档案
    {
        routeType: 'stock-document-itemFile',
        routePath: '/document/product',
    },
    // 虚拟物品
    {
        routeType: 'stock-document-virtualItem',
        routePath: '/document/virtualItem',
    },
    // 库存盘点单
    {
        routeType: 'stock-check-checkOrder',
        routePath: '/check/checkOrder',
    },
    // 库存调整单
    {
        routeType: 'stock-check-adjustmentOrder',
        routePath: '/check/adjustmentOrder',
    },
    // 库存转仓单
    {
        routeType: 'stock-check-transfer',
        routePath: '/check/stockTransfer',
    },
    // 库存成本调整单
    {
        routeType: 'stock-cost-adjustment',
        routePath: '/check/stockCostAdjustment',
    },
    // 会计期
    {
        routeType: 'stock-accounting-periods',
        routePath: '/accounting/periods',
    },
    // 生产计划单
    {
        routeType: 'stock-process-productionPlan',
        routePath: '/process/productionPlan',
    },
    // 生产领料单
    {
        routeType: 'stock-process-productionProcess',
        routePath: '/process/productionProcess',
    },
    // 生产入库单
    {
        routeType: 'stock-process-productionStorage',
        routePath: '/process/productionStorage',
    },
    // 生产任务单
    {
        routeType: 'stock-process-productionOrder',
        routePath: '/process/productionOrder',
    },
    // 门店加工单
    {
        routeType: 'stock-process-locationProcessOrder',
        routePath: '/process/locationProcessOrder',
    },
    // 配方管理
    {
        routeType: 'stock-process-goodsFormula',
        routePath: '/process/goodsFormula',
    },
    // 采购订单
    {
        routeType: 'stock-purchase-purchaseOrder',
        routePath: '/purchasing/purchaseOrder',
    },
    // 采购直发单
    {
        routeType: 'stock-purchase-directOrder',
        routePath: '/purchasing/directOrder',
    },
    // 采购收货单
    {
        routeType: 'stock-purchase-receiveOrder',
        routePath: '/purchasing/receiveOrder',
    },
    // 采购退货单
    {
        routeType: 'stock-purchase-returnOrder',
        routePath: '/purchasing/returnOrder',
    },
    // 要货单
    {
        routeType: 'stock-order-requestOrder',
        routePath: '/orders/requestOrder',
    },
    // 调出单
    {
        routeType: 'stock-order-transferOutOrder',
        routePath: '/orders/transferOutOrder',
    },
    // 调入单
    {
        routeType: 'stock-order-transferInOrder',
        routePath: '/orders/transferInOrder',
    },
    // 内部申请单
    {
        routeType: 'stock-order-innerApplyOrder',
        routePath: '/orders/innerApplyOrder',
    },
    // 门店订货控制
    {
        routeType: 'stock-order-orderingControl',
        routePath: '/orders/orderingControl',
    },
    // 要货模板
    {
        routeType: 'stock-order-requestTemplate',
        routePath: '/orders/requestTemplate',
    },
    // 配送中心
    {
        routeType: 'stock-order-distributionCenter',
        routePath: '/orders/distributionCenter',
    },
    // 效期商品
    {
        routeType: 'main-operations-validity',
        routePath: '/main-operations/EXPGoods',
    },
    // 配送结算
    {
        routeType: 'stock-finance-distributionSettlement',
        routePath: '/finance/distributionSettlement',
    },
    // 供应商预付
    {
        routeType: 'stock-finance-supplierPrepayment',
        routePath: '/finance/supplierPrepayment',
    },
    // 供应商结算
    {
        routeType: 'stock-finance-supplierSettlement',
        routePath: '/finance/supplierSettlement',
    },
    // 门店预收
    {
        routeType: 'stock-finance-locationPrepayment',
        routePath: '/finance/locationPrepayment',
    },
    // 门店费用
    {
        routeType: 'stock-finance-locationExpense',
        routePath: '/finance/locationExpense',
    },
    // 供应商费用
    {
        routeType: 'stock-finance-supplierExpense',
        routePath: '/finance/supplierExpense',
    },
    // 费用项目
    {
        routeType: 'stock-finance-costProject',
        routePath: '/finance/costProject',
    },
    // 作业人员
    {
        routeType: 'stock-process-operator',
        routePath: '/process/operator',
    },
    // 生产模板
    {
        routeType: 'stock-process-template',
        routePath: '/process/template',
    },
    // 财务中心-发票管理-开票主体
    {
        routeType: 'main-finance-invoice-management',
        routePath: '/main-base/invoice-management',
    },
    // 财务中心-发票管理-门店设置
    {
        routeType: 'main-finance-invoice-locations',
        routePath: '/main-base/invoice-locations',
    },
    // 财务中心-商户支付-支付记录
    {
        routeType: 'main-finance-payRecord',
        routePath: '/main-finance/payRecord',
    },
    // 财务中心-商户支付-我的商户
    {
        routeType: 'main-finance-myMerchant',
        routePath: '/main-finance/myMerchant',
    },
    // 财务中心-平台小程序-交易汇总
    {
        routeType: 'main-finance-appletPayTrade',
        routePath: '/main-finance/appletPayTrade',
    },
    // 财务中心-平台小程序-支付记录
    {
        routeType: 'main-finance-appletPayRecord',
        routePath: '/main-finance/appletPayRecord',
    },
    // 营业收款稽核
    {
        routeType: 'main-report-business-collection-reconciliation',
        routePath: '/main-report/business-collection-reconciliation',
    },
    // 团购券核销记录
    {
        routeType: 'main-report-group-purchase-coupon-record',
        routePath: '/main-report/group-purchase-coupon-record',
    },
    // 财务中心-商户支付-交易汇总
    {
        routeType: 'main-finance-payTrade',
        routePath: '/main-finance/payTrade',
    },
    // 财务中心-储值消费分账
    {
        routeType: 'main-finance-storedValueConsumptionSettlementForm',
        routePath: '/main-finance/storedValueConsumptionSettlementForm',
    },
    // 财务中心-礼品卡消费分账
    {
        routeType: 'main-finance-giftCardConsumptionSettlementForm',
        routePath: '/main-finance/giftCardConsumptionSettlementForm',
    },
    // 财务中心-券核销分账
    {
        routeType: 'main-finance-voucherVerificationSettlementForm',
        routePath: '/main-finance/voucherVerificationSettlementForm',
    },
    // 财务中心-总部分账
    {
        routeType: 'main-finance-headquartersSettlementForm',
        routePath: '/main-finance/headquartersSettlementForm',
    },
    // 财务中心-总部费用单
    {
        routeType: 'main-finance-headquartersExpense',
        routePath: '/main-finance/headquartersExpense',
    },
    // 财务中心-门店分账
    {
        routeType: 'main-finance-locationSettlementForm',
        routePath: '/main-finance/locationSettlementForm',
    },
    // 财务中心-门店费用单
    {
        routeType: 'main-finance-locationExpense',
        routePath: '/main-finance/locationExpense',
    },
    // 财务中心-自定义分账
    {
        routeType: 'main-finance-customSettlementForm',
        routePath: '/main-finance/customSettlementForm',
    },
    // 挂账管理-企业挂账管理
    {
        routeType: 'main-operations-accountManagement',
        routePath: '/main-operations/accountManagement',
    },
    // 挂账管理-个人挂账管理
    {
        routeType: 'main-operations-employeeBillingManagement',
        routePath: '/main-operations/employeeBillingManagement',
    },
    // 交班统计
    {
        routeType: 'main-report-shift-handover-statistics',
        routePath: '/main-report/shift-handover-statistics',
    },
    // 设备管理
    {
        routeType: 'main-operations-equipmentSettings',
        routePath: '/main-operations/equipmentSettings',
    },
    {
        routeType: 'main-operations-kdsDeviceManagement',
        routePath: '/main-operations/kdsDeviceManagement',
    },
    {
        routeType: 'main-operations-printerManagement',
        routePath: '/main-operations/printerManagement',
    },
    {
        routeType: 'main-operations-tvScreenDevice',
        routePath: '/main-operations/tvScreenDevice',
    },
    // 门店复制
    {
        routeType: 'main-operations-locationCopy',
        routePath: '/main-operations/locationCopy',
    },
    // 业务设置
    {
        routeType: 'main-operations-businessSettings',
        routePath: '/main-operations/businessSettings',
    },
    // 辅屏设置
    {
        routeType: 'main-operations-screenSetting',
        routePath: '/main-operations/screenSetting',
    },
    // 快递模板
    {
        routeType: 'main-operations-courierTemplate',
        routePath: '/main-operations/courierTemplate',
    },
    // 客户标签
    {
        routeType: 'main-operations-customer-group',
        routePath: '/main-operations/customer-group',
    },
    // 企微客户列表
    {
        routeType: 'main-operations-wecom-customerList',
        routePath: '/main-operations/wecom/customerList',
    },
    // 企微客户群
    {
        routeType: 'main-operations-wecom-customerGroupList',
        routePath: '/main-operations/wecom/customerGroupList',
    },
    // 商品类别
    {
        routeType: 'main-operations-goods-goodsCategory',
        routePath: '/main-operations/goods/goodsCategory',
    },
    // 门店标准商品
    {
        routeType: 'main-operations-locationProduct',
        routePath: '/main-operations/locationProduct',
    },
    // 门店套餐商品
    {
        routeType: 'main-operations-storeCombo',
        routePath: '/main-operations/storeCombo',
    },
    // 门店商品类别
    {
        routeType: 'main-operations-goods-locationProductCategory',
        routePath: '/main-operations/goods/locationProductCategory',
    },
    // 商品系列
    {
        routeType: 'main-operations-goods-collections',
        routePath: '/main-operations/goods/collections',
    },
    // 商品科目
    {
        routeType: 'main-operations-income-subject',
        routePath: '/main-operations/goods/incomeSubject',
    },
    // 商品排序
    {
        routeType: 'main-operations-goods-productSort',
        routePath: '/main-operations/goods/productSort',
    },
    // 商品角标
    {
        routeType: 'main-operations-goods-cornerMark',
        routePath: '/main-operations/goods/cornerMark',
    },
    // 菜品属性
    {
        routeType: 'main-operations-goods-goodsAttribute',
        routePath: '/main-operations/goods/goodsAttribute',
    },
    // 门店菜品属性
    {
        routeType: 'main-operations-goods-storeAttribute',
        routePath: '/main-operations/goods/storeAttribute',
    },
    // 包装盒
    {
        routeType: 'main-operations-goods-box',
        routePath: '/main-operations/goods/box',
    },
    // 时段菜单
    {
        routeType: 'main-operations-goods-timePeriodMenu',
        routePath: '/main-operations/goods/timePeriodMenu',
    },
    // 门店时段菜单
    {
        routeType: 'main-operations-goods-storeTimePeriodMenu',
        routePath: '/main-operations/goods/storeTimePeriodMenu',
    },
    // 菜品时段
    {
        routeType: 'main-operations-goods-productTimePeriod',
        routePath: '/main-operations/goods/productTimePeriod',
    },
    // 必点菜
    {
        routeType: 'main-operations-goods-mustOrderProduct',
        routePath: '/main-operations/goods/mustOrderProduct',
    },
    // 储值体系-退余额管理
    {
        routeType: 'main-operations-deposit',
        routePath: '/main-operations/deposit',
    },
    // 客户管理-卡类型
    {
        routeType: 'main-operations-cardKind',
        routePath: '/main-operations/cardKind',
    },
    // 客户管理-客户列表
    {
        routeType: 'main-operations-customers',
        routePath: '/main-operations/customers',
    },
    // 客户管理-会员卡列表
    {
        routeType: 'main-operations-clubCard',
        routePath: '/main-operations/clubCard',
    },
    // 客户管理-会员体系
    // {
    //   routeType: 'main-operations-vip',
    //   routePath: '/main-operations/vip',
    // },
    // 聚合配送
    {
        routeType: 'main-operations-aggregatedDelivery',
        routePath: '/main-operations/aggregatedDelivery',
    },
    // 门店管理
    {
        routeType: 'main-operations-settings-locations',
        routePath: '/main-operations/settings/locations',
    },
    // 裱花网络
    {
        routeType: 'main-operations-settings-decorator',
        routePath: '/main-operations/settings/cake-decorator',
    },
    // 员工角色
    {
        routeType: 'main-operations-staffRole',
        routePath: '/main-operations/staffRole',
    },
    // 员工管理
    {
        routeType: 'main-operations-staffManagement',
        routePath: '/main-operations/staffManagement',
    },
    // 预储值
    {
        routeType: 'main-operations-preDeposit',
        routePath: '/main-operations/preDeposit',
    },
    {
        routeType: 'main-operations-takeout-product',
        routePath: '/main-operations/oms/takeout/product',
    },
    // 共享互斥
    {
        routeType: 'main-operations-sharedMutex',
        routePath: '/main-operations/sharedMutex',
    },
    {
        routeType: 'main-operations-sitDownOrder',
        routePath: '/main-operations/sitDownOrder',
    },
    {
        routeType: 'main-operations-pickUpDistributionOrder',
        routePath: '/main-operations/pickUpDistributionOrder',
    },
    {
        routeType: 'main-operations-thirdOrder',
        routePath: '/main-operations/thirdOrder',
    },
    {
        routeType: 'main-operations-productAppointmentOrder',
        routePath: '/main-operations/productAppointmentOrder',
    },
    {
        routeType: 'main-operations-productMallOrder',
        routePath: '/main-operations/productMallOrder',
    },
    {
        routeType: 'main-operations-scanOrder',
        routePath: '/main-operations/scanOrder',
    },
    // 售后订单
    {
        routeType: 'main-operations-afterSaleOrders',
        routePath: '/main-operations/afterSaleOrders',
    },
    // 卡券售后订单
    {
        routeType: 'main-operations-cardCouponAfterSalesOrders',
        routePath: '/main-operations/cardCouponAfterSalesOrders',
    },
    // 用户协议
    {
        routeType: 'main-operations-weapp-userAgreement',
        routePath: '/main-operations/weapp/userAgreement',
    },
    // 弹窗发券
    {
        routeType: 'main-operations-popUpCoupons',
        routePath: '/main-operations/crm/marketingActivities/popUpCoupons',
    },
    // 领券活动
    {
        routeType: 'main-operations-getDiscount',
        routePath: '/main-operations/crm/marketingActivities/getDiscount',
    },
    // 优惠券包
    {
        routeType: 'main-operations-discountPackage',
        routePath: '/main-operations/marketingActivities/discountPackage',
    },
    // 问卷调查
    {
        routeType: 'main-operations-questionnaireSurvey',
        routePath: '/main-operations/crm/marketingActivities/questionnaireSurvey',
    },
    // 加价购
    {
        routeType: 'main-operations-markUpPurchase',
        routePath: '/main-operations/promotion/marketingActivities/markUpPurchase',
    },
    // 权益卡
    {
        routeType: 'main-operations-equityCard',
        routePath: '/main-operations/marketingActivities/equityCard',
    },
    // 注册有礼
    {
        routeType: 'main-operations-collectCard',
        routePath: '/main-operations/crm/marketingActivities/collectCard',
    },
    // 新客专享
    {
        routeType: 'main-operations-newCustomerExclusive',
        routePath: '/main-operations/crm/marketingActivities/newCustomerExclusive',
    },
    // 群接龙
    {
        routeType: 'main-operations-groupRelay',
        routePath: '/main-operations/crm/marketingActivities/groupRelay',
    },
    // 好友裂变
    {
        routeType: 'main-operations-friendFission',
        routePath: '/main-operations/crm/marketingActivities/friendFission',
    },
    // 券模板
    {
        routeType: 'main-operations-discounts',
        routePath: '/main-operations/marketingActivities/discounts',
    },
    // 抵用券
    {
        routeType: 'main-operations-vouchers',
        routePath: '/main-operations/settings/vouchers',
    },
    // 升级有礼
    {
        routeType: 'main-operations-giftLevel',
        routePath: '/main-operations/crm/marketingActivities/giftLevel',
    },
    // 消费有礼
    {
        routeType: 'main-operations-giftConsume',
        routePath: '/main-operations/crm/marketingActivities/giftConsume',
    },
    // 储值活动
    {
        routeType: 'main-operations-giftDeposit',
        routePath: '/main-operations/crm/marketingActivities/giftDeposit',
    },
    // 拼团
    {
        routeType: 'main-operations-groupBuying',
        routePath: '/main-operations/crm/marketingActivities/groupBuying',
    },
    // 评价有礼
    {
        routeType: 'main-operations-evaluationGift',
        routePath: '/main-operations/crm/marketingActivities/evaluationGift',
    },
    // 趣味竞猜
    {
        routeType: 'main-operations-funGame',
        routePath: '/main-operations/crm/marketingActivities/funGame',
    },
    // 满赠
    {
        routeType: 'main-operations-fullGifts',
        routePath: '/main-operations/promotion/marketingActivities/fullGifts',
    },
    // 抽奖有礼
    {
        routeType: 'main-operations-luckyDraw',
        routePath: '/main-operations/crm/marketingActivities/luckyDraw',
    },
    // 满X件Y折
    {
        routeType: 'main-operations-secondHalf',
        routePath: '/main-operations/promotion/marketingActivities/secondHalf',
    },
    {
        routeType: 'main-operations-userRole',
        routePath: '/main-operations/userRole',
    },
    {
        routeType: 'main-operations-userManagement',
        routePath: '/main-operations/userManagement',
    },
    {
        routeType: 'main-operations-recommendAddPurchase',
        routePath: '/main-operations/crm/marketingActivities/recommendAddPurchase',
    },
    {
        routeType: 'main-operations-discountedBuying',
        routePath: '/main-operations/promotion/marketingActivities/discountedBuying',
    },
    {
        routeType: 'main-operations-creditExchangeList',
        routePath: '/main-operations/marketingActivities/creditExchangeList',
    },
    {
        routeType: 'main-operations-standardProduct',
        routePath: '/main-operations/standardProduct',
    },
    {
        routeType: 'main-operations-mallProduct',
        routePath: '/main-operations/mallProduct',
    },
    {
        routeType: 'main-operations-advertisingList',
        routePath: '/main-operations/crm/marketingActivities/advertisingList',
    },
    {
        routeType: 'main-operations-sendDiscount',
        routePath: '/main-operations/crm/marketingActivities/sendDiscount',
    },
    {
        routeType: 'main-operations-combo',
        routePath: '/main-operations/combo',
    },
    {
        routeType: 'main-operations-platform-product',
        routePath: '/main-operations/platform/product',
    },
    {
        routeType: 'main-operations-weapp-product',
        routePath: '/main-operations/weapp/product',
    },
    {
        routeType: 'main-operations-fullReduce',
        routePath: '/main-operations/promotion/marketingActivities/fullReduce',
    },
    {
        routeType: 'main-operations-timeLimitDiscount',
        routePath: '/main-operations/promotion/marketingActivities/timeLimitDiscount',
    },
    {
        routeType: 'main-operations-serviceFee',
        routePath: '/main-operations/serviceFee',
    },
    // 采购模版
    {
        routeType: 'stock-purchase-purchaseTemplate',
        routePath: '/purchasing/purchaseTemplate',
    },
    {
        routeType: 'main-operations-cake-decorator',
        routePath: '/main-operations/setting/cake-decorator',
    },
    {
        routeType: 'stock-earth-locationReplenishment',
        routePath: '/earthOrders/earthLocationReplenishment',
    },
    {
        routeType: 'stock-earth-transferOutOrder',
        routePath: '/earthOrders/earthTransferOutOrder',
    },
    {
        routeType: 'stock-earth-transferInOrder',
        routePath: '/earthOrders/earthTransferInOrder',
    },
    {
        routeType: 'stock-earth-innerApplyOrder',
        routePath: '/earthOrders/earthInnerApplyOrder',
    },
    {
        routeType: 'stock-check-inventoryLossOrder',
        routePath: '/check/inventoryLossOrder',
    },
    {
        routeType: 'main-operations-billScanningCode',
        routePath: '/main-operations/settings/billScanningCode',
    },
    {
        routeType: 'main-operations-payTypeSetting',
        routePath: '/main-operations/settings/payType',
    },
    {
        routeType: 'main-operations-goods-productionDepartment',
        routePath: '/main-operations/goods/productionDepartment',
    },
    {
        routeType: 'main-operations-equipmentSettings',
        routePath: '/main-operations/equipmentSettings',
    },
    {
        routeType: 'main-operations-kdsDeviceManagement',
        routePath: '/main-operations/kdsDeviceManagement',
    },
    {
        routeType: 'main-operations-printerManagement',
        routePath: '/main-operations/printerManagement',
    },
    {
        routeType: 'main-operations-tvScreenDevice',
        routePath: '/main-operations/tvScreenDevice',
    },
    {
        routeType: 'main-operations-pos-product',
        routePath: '/main-operations/pos/product',
    },
    {
        routeType: 'main-operations-cardorders',
        routePath: '/main-operations/cardorders',
    },
    // 超量折扣
    {
        routeType: 'stock-order-exceedDiscountOrder',
        routePath: '/orders/exceedDiscountOrder',
    },
    {
        routeType: 'main-operations-product-release',
        routePath: '/main-product/product-release',
    },
    {
        routeType: 'main-operations-product-dynamic-price',
        routePath: '/main-product/product-dynamic-price',
    },
    {
        routeType: 'product-standard',
        routePath: '/product/product-standard',
    },
    {
        routeType: 'product-standard-location',
        routePath: '/product/product-standard-location',
    },
    {
        routeType: 'product-standard',
        routePath: '/product/product-standard-single',
    },
    {
        routeType: 'product-mall',
        routePath: '/product/product-mall',
    },
    // 销售报价单
    {
        routeType: 'stock-wholesale-quote-order',
        routePath: '/wholesale-manager/quote-order',
    },
    {
        routeType: 'stock-wholesale-sale-order',
        routePath: '/wholesale-manager/sale-order',
    },
    {
        routeType: 'stock-wholesale-return-order',
        routePath: '/wholesale-manager/return-order',
    },
    {
        routeType: 'main-finance-locationFinanceSetting',
        routePath: '/main-finance/locationFinanceSetting',
    },
    // 替代品管理
    {
        routeType: 'stock-document-itemReplace',
        routePath: '/document/itemReplace',
    },
];

const SALE_CHANNEL_TYPE = {
    POS: 'POS', // POS 使用原来【POS】
    APP: 'APP_NEW', // APP
    DINE_IN: 'DINE_IN_NEW', // 手机点餐堂食
    SELF_PICK: 'ONLINE_STORE', // 手机点餐自提 使用原来【微店铺】
    TAKE_AWAY: 'TAKE_AWAY_NEW', // 手机点餐自营外卖
    OMS_MT: 'OMS_MT', // 美团外卖
    OMS_EL: 'OMS_EL', // 淘宝闪购·餐饮
    OMS_EB: 'OMS_EB', // 淘宝闪购·零售
    OMS_TIKTOK: 'OMS_TIKTOK', // 抖音外卖
    OMS_TIKTOK_SELF_CHECK: 'OMS_TIKTOK_SELF_CHECK', // 抖音自助核销
    OMS_JD: 'OMS_JD', // 京东秒送
    OMS_MTSG: 'OMS_MTSG', // 美团闪购
};
const SALE_CHANNEL_MAP = {
    [SALE_CHANNEL_TYPE.POS]: $t({ defaultMessage: '收银POS' }),
    [SALE_CHANNEL_TYPE.APP]: 'APP',
    [SALE_CHANNEL_TYPE.DINE_IN]: $t({ defaultMessage: '手机点餐堂食' }),
    [SALE_CHANNEL_TYPE.SELF_PICK]: $t({ defaultMessage: '手机点餐自提' }),
    [SALE_CHANNEL_TYPE.TAKE_AWAY]: $t({ defaultMessage: '手机点餐自营外卖' }),
    [SALE_CHANNEL_TYPE.OMS_MT]: $t({ defaultMessage: '美团外卖' }),
    [SALE_CHANNEL_TYPE.OMS_EL]: $t({ defaultMessage: '淘宝闪购·餐饮' }),
    [SALE_CHANNEL_TYPE.OMS_EB]: $t({ defaultMessage: '淘宝闪购·零售' }),
    [SALE_CHANNEL_TYPE.OMS_TIKTOK]: $t({ defaultMessage: '抖音外卖' }),
    [SALE_CHANNEL_TYPE.OMS_TIKTOK_SELF_CHECK]: $t({ defaultMessage: '抖音自助核销' }),
    [SALE_CHANNEL_TYPE.OMS_JD]: $t({ defaultMessage: '京东秒送' }),
    [SALE_CHANNEL_TYPE.OMS_MTSG]: $t({ defaultMessage: '美团闪购' }),
};
// 售卖渠道
const SALE_CHANNEL_LIST = [
    SALE_CHANNEL_TYPE.POS,
    SALE_CHANNEL_TYPE.SELF_PICK,
    SALE_CHANNEL_TYPE.TAKE_AWAY,
];
// 三方渠道
const THIRD_SALE_CHANNEL_LIST = [
    SALE_CHANNEL_TYPE.OMS_MT,
    SALE_CHANNEL_TYPE.OMS_EL,
    SALE_CHANNEL_TYPE.OMS_EB,
    SALE_CHANNEL_TYPE.OMS_TIKTOK,
    SALE_CHANNEL_TYPE.OMS_TIKTOK_SELF_CHECK,
    SALE_CHANNEL_TYPE.OMS_JD,
    SALE_CHANNEL_TYPE.OMS_MTSG,
];

const signTypeObj = {
    ENTERPRISE: $t({ defaultMessage: '企业挂账' }),
    PERSONAL: $t({ defaultMessage: '个人挂账' }),
};
/** 作废状态 */
const ORDERSTATUSOPTIONS11 = [
    { label: $t({ defaultMessage: '未作废' }), value: 'NORMAL' },
    { label: $t({ defaultMessage: '已作废' }), value: 'ARCHIVED' },
];
const RefBusinessTypeObj = {
    CANCEL: $t({ defaultMessage: '取消' }),
    MANUAL_DECREMENT: $t({ defaultMessage: '手动减免' }),
    MANUAL_INCREMENT: $t({ defaultMessage: '手动增加' }),
    REPAYMENT: $t({ defaultMessage: '还款' }),
    STAFF_CONSUME: $t({ defaultMessage: '员工消费' }),
    STAFF_REFUND: $t({ defaultMessage: '员工退款' }),
};
const PAYMENT_TYPE_AND_DISCOUNT_TYPE_LIST = [
    {
        name: $t({ defaultMessage: '优惠方式' }),
        id: '优惠方式',
        isLeaf: false,
        children: [
            {
                name: $t({ defaultMessage: '优惠券' }),
                id: '优惠券',
                isLeaf: false,
                children: [
                    {
                        name: $t({ defaultMessage: '立减券' }),
                        id: 'MONEY',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '折扣券' }),
                        id: 'PERCENT',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '兑换券' }),
                        id: 'PRODUCT_EXCHANGE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '买A赠B券' }),
                        id: 'PURCHASE_A_GIFT_B',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '限制数量免单券' }),
                        id: 'FREE_PASS',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '减至券' }),
                        id: 'REDUCED_TO',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '运费券' }),
                        id: 'DELIVER_FEE_TICKET',
                        isLeaf: true,
                    },
                ],
            },
            {
                name: $t({ defaultMessage: '促销折扣' }),
                id: '促销折扣',
                isLeaf: false,
                children: [
                    {
                        name: $t({ defaultMessage: '会员价' }),
                        id: 'LEVEL_PRICE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '满减满折' }),
                        id: 'FULL_REDUCE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '限时折扣' }),
                        id: 'LIMIT_DISCOUNT',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '满X件Y折' }),
                        id: 'SECOND_HALF',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '满赠' }),
                        id: 'FULL_GIFT',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '加价购' }),
                        id: 'MARK_UP_PURCHASE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: 'N元任选' }),
                        id: 'ANY_CHOICE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '随机立减' }),
                        id: 'RANDOM_REDUCE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '新客专享' }),
                        id: 'NEW_CUSTOMER_EXCLUSIVE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '拼团' }),
                        id: 'GROUP_BUYING',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '群接龙' }),
                        id: 'GROUP_RELAY',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '减运费' }),
                        id: 'DELIVER_FEE_REDUCE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '权益卡减运费' }),
                        id: 'RIGHT_CARD_REDUCE_DELIVER_FEE',
                        isLeaf: true,
                    },
                    {
                        name: $t({ defaultMessage: '权益卡减包装费' }),
                        id: 'RIGHT_CARD_REDUCE_PACK_FEE',
                        isLeaf: true,
                    },
                ],
            },
            {
                name: $t({ defaultMessage: '手工折扣' }),
                id: 'CUSTOM_DISCOUNT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '赠送' }),
                id: 'GIFT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '改价' }),
                id: 'CHANGE_PRICE',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '手工减免' }),
                id: 'DISCOUNT_REDUCTION',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '抹零' }),
                id: 'WIPE',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '免找零' }),
                id: 'KEEP_CHANGE',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '积分兑换' }),
                id: 'POINT_EXCHANGE',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '积分抵扣' }),
                id: 'POINT_DEDUCT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '积分抵扣运费' }),
                id: 'DELIVER_FEE_POINT_DEDUCT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '次卡抵扣' }),
                id: 'GIFT_CARD_TIMES',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '挂账优惠' }),
                id: 'GROUP_MEAL_DISCOUNT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '平台补齐' }),
                id: 'PLATFORM_COMPLETE',
                isLeaf: true,
            },
        ],
    },
    {
        name: $t({ defaultMessage: '三方平台' }),
        id: '三方平台',
        isLeaf: false,
        children: [
            {
                name: $t({ defaultMessage: '美团外卖支付' }),
                id: 'OMS_MT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '淘宝闪购·餐饮支付' }),
                id: 'OMS_EL',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '淘宝闪购·零售支付' }),
                id: 'OMS_EB',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '抖音外卖支付' }),
                id: 'OMS_TIKTOK',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '抖音自助核销支付' }),
                id: 'OMS_TIKTOK_SELF_CHECK',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '京东秒送支付' }),
                id: 'OMS_JD',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '美团闪购支付' }),
                id: 'OMS_MTSG',
                isLeaf: true,
            },
        ],
    },
    {
        name: $t({ defaultMessage: '三方券' }),
        id: '三方券',
        isLeaf: false,
        children: [
            {
                name: $t({ defaultMessage: '美团券支付' }),
                id: 'VIRTUAL_TICKET_MT',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '抖音券支付' }),
                id: 'VIRTUAL_TICKET_DY',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '快手券支付' }),
                id: 'VIRTUAL_TICKET_KS',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '口碑券支付' }),
                id: 'VIRTUAL_TICKET_KOU_BEI',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '支付宝神券支付' }),
                id: 'VIRTUAL_TICKET_ALI',
                isLeaf: true,
            },
            {
                name: $t({ defaultMessage: '乐檬零售券支付' }),
                id: 'VIRTUAL_TICKET_LEMON_RETAIL',
                isLeaf: true,
            },
        ],
    },
];

const STATE_LIST_STOCK = [
    { label: $t({ defaultMessage: '进行中' }), value: 'IN_PROGRESS' },
    { label: $t({ defaultMessage: '已过期' }), value: 'EXPIRED' },
    { label: $t({ defaultMessage: '未开始' }), value: 'NOT_STARTED' },
    { label: $t({ defaultMessage: '已停用' }), value: 'NOT_ACTIVE' },
];
const settlementManagerStateObj = {
    ANTI_COMPLETED: $t({ defaultMessage: '已完成' }),
    COMPLETED: $t({ defaultMessage: '已完成' }),
    FAILED: $t({ defaultMessage: '已失败' }),
    ANTI_FAILED: $t({ defaultMessage: '已失败' }),
    IN_PROGRESS: $t({ defaultMessage: '进行中' }),
    NOT_STARTED: $t({ defaultMessage: '未开始' }),
};
const costRecalculateStateObj = {
    ALL: '',
    COMPLETED: $t({ defaultMessage: '已完成' }),
    FAILED: $t({ defaultMessage: '失败' }),
    IN_PROGRESS: $t({ defaultMessage: '重算中' }),
    NOT_STARTED: $t({ defaultMessage: '未开始' }),
    NO_PLAN: $t({ defaultMessage: '未计划' }),
    STOP: $t({ defaultMessage: '已中止' }),
};
const statusList = {
    ['FAIL']: $t({ defaultMessage: '全部失败' }),
    ['PART_SUCCESS']: $t({ defaultMessage: '部分成功' }),
    ['PROCESSING']: $t({ defaultMessage: '进行中' }),
    ['SUCCESS']: $t({ defaultMessage: '全部成功' }),
};
/**
 * 状态映射
 */
const statusMap = {
    [Status.Ended]: $t({ defaultMessage: '已结束' }),
    [Status.InProgress]: $t({ defaultMessage: '进行中' }),
    [Status.NotStarted]: $t({ defaultMessage: '未开始' }),
};
/**
 * 星期映射
 */
const weekMap = {
    '1': $t({ defaultMessage: '周一' }),
    '2': $t({ defaultMessage: '周二' }),
    '3': $t({ defaultMessage: '周三' }),
    '4': $t({ defaultMessage: '周四' }),
    '5': $t({ defaultMessage: '周五' }),
    '6': $t({ defaultMessage: '周六' }),
    '7': $t({ defaultMessage: '周日' }),
};
const GainLossTypeMap = {
    ADJUSTMENT: $t({ defaultMessage: '调整单' }),
    ADJUSTMENT_COST: $t({ defaultMessage: '成本调整单' }),
    CHECK: $t({ defaultMessage: '盘点单' }),
    PRODUCT_LOSS: $t({ defaultMessage: '商品报损单' }),
};
const QueryTypeObj = {
    DETAIL: 'GAIN_LOSS_BY_DETAIL',
    ITEM: 'GAIN_LOSS_BY_ITEM',
    LOCATION_ITEM: 'LOCGAIN_LOSS_BY_LOCATION_ITEMATION_ITEM',
    LOCATION_STOREHOUSE_ITEM: 'GAIN_LOSS_BY_LOCATION_STORE_ITEM',
};
const planOrderTypeMapping = {
    [PlanOrderType.FromTask]: $t({ defaultMessage: '生产任务创建' }),
    [PlanOrderType.FromBoard]: $t({ defaultMessage: '生产看板创建' }),
    [PlanOrderType.FromDistributionCenter]: $t({ defaultMessage: '配送中心生成' }),
    [PlanOrderType.FromPlanOrder]: $t({ defaultMessage: '生产计划单生成' }),
    [PlanOrderType.FromRequestOrder]: $t({ defaultMessage: '要货单新增' }),
    [PlanOrderType.FromSafeStock]: $t({ defaultMessage: '安全库存生成' }),
    [PlanOrderType.Manual]: $t({ defaultMessage: '手动新增' }),
    [PlanOrderType.FromOrder]: $t({ defaultMessage: '订单生成' }),
};
const ESupplierPrePayState = {
    PRE_PAY_COMPLETE: $t({ defaultMessage: '已预付' }),
    PRE_PAY_PART: $t({ defaultMessage: '部分预付' }),
    PRE_PAY_WAIT: $t({ defaultMessage: '未预付' }),
};

const OSS_DOMAIN = 'mars-prod.shopmars.cn';
const OSS_ORIGIN = `https://${OSS_DOMAIN}/mars-file`;
/** 总部 */
const HEAD_QUARTERS = 'HEAD_QUARTERS';
/** 配送中心 */
const DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER';
/** 普通门店 */
const NORMAL_SHOP = 'NORMAL_SHOP';
/** 区域 */
const ZONE = 'ZONE';
/** @deprecated 数据最大值已弃用，因为Number类型最大可以接受17位数字，这个值超出后会默认变成100000000000；建议使用MAX_NUMBER_LIMIT */
const MAX_DATA_LIMIT = '999999999999.99999999';
const MAX_NUMBER_LIMIT = '99999999.99999999';
/** 金额最大值 */
const MAX_MONEY_LIMIT = '999999999999.99';
/** 单价最大值 */
const MAX_PRICE_LIMIT = '99999999.99999999';
/** 比例最大值 */
const MAX_RATE_LIMIT = '99999999.99999999';
/** 数据最大值 */
const MAX_LIMIT = 999999.99999999;
/** 默认排序 */
const DEFAULT_SORTER = 'CREATED_DESC';
/** modal表格固定高度 */
const TABLE_HEIGHT = '370px';
const DEFAULT_PROFILE = `${OSS_ORIGIN}/661881175761772544/aff4533f-f8c1-4a6f-b45c-8bae99eba25c/profile.png`;
/** 单据审核状态 */
const STATE_CODE_MAP = {
    10: $t({ defaultMessage: '待审核' }),
    20: $t({ defaultMessage: '已审核' }),
    30: $t({ defaultMessage: '已作废' }),
    40: $t({ defaultMessage: '已通过' }),
    45: $t({ defaultMessage: '已同意' }),
    50: $t({ defaultMessage: '已拒绝' }),
    60: $t({ defaultMessage: '已生成领料' }),
    65: $t({ defaultMessage: '未生成领料' }),
    70: $t({ defaultMessage: '已生成入库' }),
    75: $t({ defaultMessage: '未生成入库' }),
    80: $t({ defaultMessage: '已批复' }),
};
/** 表格表头默认宽度 */
var TABLE_COL_WIDTH;
(function (TABLE_COL_WIDTH) {
    /** 序号 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["INDEX"] = 50] = "INDEX";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["NAME"] = 200] = "NAME";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["PHONE"] = 120] = "PHONE";
    /** 操作 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["OPERATE"] = 50] = "OPERATE";
    /** 单据号 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ORDER_NO"] = 180] = "ORDER_NO";
    /** 单据号 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ORDER_NO_XL"] = 190] = "ORDER_NO_XL";
    /** 单据类型 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ORDER_TYPE"] = 100] = "ORDER_TYPE";
    /** 状态 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["STATUS"] = 120] = "STATUS";
    /** 门店代码 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["LOCATION_CODE"] = 100] = "LOCATION_CODE";
    /** 门店名称 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["LOCATION_NAME"] = 220] = "LOCATION_NAME";
    /** 日期-年月日 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["DATE"] = 100] = "DATE";
    /** 日期-年月日 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["DATE_XL"] = 130] = "DATE_XL";
    /** 日期-年月日时分秒 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["DATE_TIME"] = 150] = "DATE_TIME";
    /** 日期范围 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["DATE_RANGE"] = 300] = "DATE_RANGE";
    /** 业务员 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SALESMAN"] = 160] = "SALESMAN";
    /** 金额 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["MONEY"] = 80] = "MONEY";
    /** XX金额 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["MONEY_XL"] = 100] = "MONEY_XL";
    /** 金额（宽度最大） */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["MONEY_MAX"] = 110] = "MONEY_MAX";
    /** 数量 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["AMOUNT"] = 90] = "AMOUNT";
    /** XX数量 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["AMOUNT_XL"] = 100] = "AMOUNT_XL";
    /** XX数量 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["AMOUNT_XXL"] = 120] = "AMOUNT_XXL";
    /** 数量（宽度最大） */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["AMOUNT_MAX"] = 140] = "AMOUNT_MAX";
    /** 备注 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["MEMO"] = 220] = "MEMO";
    /** 仓库名称 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["STOREHOUSE_NAME"] = 220] = "STOREHOUSE_NAME";
    /** 物品编码 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_CODE"] = 100] = "ITEM_CODE";
    /** 成本卡编码 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["CARD_CODE"] = 120] = "CARD_CODE";
    /** 物品名称 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_NAME"] = 220] = "ITEM_NAME";
    /** 物品分类 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_TYPE_NAME"] = 160] = "ITEM_TYPE_NAME";
    /** 物品规格 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_SKU"] = 130] = "ITEM_SKU";
    /** 单位 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_UNIT"] = 100] = "ITEM_UNIT";
    /** 默认单位 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_DEFAULT_UNIT"] = 100] = "ITEM_DEFAULT_UNIT";
    /** 是否xxx */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_BOOLEAN"] = 80] = "ITEM_BOOLEAN";
    /** 物品id */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_ID"] = 200] = "ITEM_ID";
    /** 品牌名称 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["VENDOR_NAME"] = 220] = "VENDOR_NAME";
    /** 联系人 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["CONTRACT_NAME"] = 160] = "CONTRACT_NAME";
    /** 联系电话 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["CONTRACT_PHONE"] = 100] = "CONTRACT_PHONE";
    /** 地址 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ADDRESS"] = 150] = "ADDRESS";
    /** 仓库代码 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["STOREHOUSE_CODE"] = 100] = "STOREHOUSE_CODE";
    /** 供应商名称 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SUPPLIER_NAME"] = 220] = "SUPPLIER_NAME";
    /** 供应商编码 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SUPPLIER_CODE"] = 120] = "SUPPLIER_CODE";
    /** 换算率 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["RATE"] = 100] = "RATE";
    /** 换算率 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["RATE_XL"] = 120] = "RATE_XL";
    /** 创建人、审核人 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["OPERATOR"] = 160] = "OPERATOR";
    /** 带图标 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["WITH_ICON"] = 120] = "WITH_ICON";
    /** 数量最大 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["NUMBER_MAX"] = 180] = "NUMBER_MAX";
    /** 加工品编码 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["PRODUCT_CODE"] = 120] = "PRODUCT_CODE";
    /** 库存进出明细通用宽度 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ENTRY_EXITDETAILS"] = 120] = "ENTRY_EXITDETAILS";
    /** xx类型 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["TYPE"] = 120] = "TYPE";
    /** 描述 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["DESC"] = 200] = "DESC";
    /** 业务员 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SALESMAN_NAME"] = 160] = "SALESMAN_NAME";
    /** 加工单类型 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["PRODUCE_ORDER_TYPE"] = 120] = "PRODUCE_ORDER_TYPE";
    /** 所属配方 */
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["BELONG_FORMULA"] = 130] = "BELONG_FORMULA";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["ITEM_SPEC"] = 120] = "ITEM_SPEC";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_500"] = 500] = "SIZE_500";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_400"] = 400] = "SIZE_400";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_200"] = 200] = "SIZE_200";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_250"] = 250] = "SIZE_250";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_220"] = 250] = "SIZE_220";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_180"] = 180] = "SIZE_180";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_160"] = 160] = "SIZE_160";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_150"] = 150] = "SIZE_150";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_120"] = 120] = "SIZE_120";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_100"] = 100] = "SIZE_100";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_80"] = 80] = "SIZE_80";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_90"] = 90] = "SIZE_90";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_70"] = 70] = "SIZE_70";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_60"] = 60] = "SIZE_60";
    TABLE_COL_WIDTH[TABLE_COL_WIDTH["SIZE_50"] = 50] = "SIZE_50";
})(TABLE_COL_WIDTH || (TABLE_COL_WIDTH = {}));
/** 促销标记，物品参与超量折扣活动时，需要在名称前添加 */
const EXCEED_DISCOUNT_MARK = '[促]';
// 报表来源
const orderSourceList = [
    { label: 'POS', value: 'POS' },
    { label: $t({ defaultMessage: '管家APP' }), value: 'APP' },
    { label: $t({ defaultMessage: '点餐助手' }), value: 'ORDER_ASSISTANT_APP' },
    { label: $t({ defaultMessage: '微信小程序' }), value: 'ONLINE_STORE_MP' },
    { label: $t({ defaultMessage: '支付宝小程序' }), value: 'ONLINE_STORE_ALIPAY' },
    { label: $t({ defaultMessage: '平台小程序' }), value: 'PLATFORM_ONLINE_STORE' },
    { label: $t({ defaultMessage: 'H5' }), value: 'WX_PA' },
    { label: $t({ defaultMessage: '网页后台' }), value: 'WEB_ADMIN' },
    { label: $t({ defaultMessage: '美团外卖' }), value: 'OMS_MT' },
    { label: $t({ defaultMessage: '淘宝闪购·餐饮' }), value: 'OMS_EL' },
    { label: $t({ defaultMessage: '淘宝闪购·零售' }), value: 'OMS_EB' },
    { label: $t({ defaultMessage: '抖音外卖' }), value: 'OMS_TIKTOK' },
    { label: $t({ defaultMessage: '抖音自助核销' }), value: 'OMS_TIKTOK_SELF_CHECK' },
    { label: $t({ defaultMessage: '京东秒送' }), value: 'OMS_JD' },
    { label: $t({ defaultMessage: '美团闪购' }), value: 'OMS_MTSG' },
];
// 订单来源
const orderOtherSourceList = [
    { label: 'POS', value: 'POS' },
    { label: $t({ defaultMessage: '管家APP' }), value: 'APP' },
    { label: $t({ defaultMessage: '点餐助手' }), value: 'ORDER_ASSISTANT_APP' },
    { label: $t({ defaultMessage: '微信小程序' }), value: 'ONLINE_STORE_MP' },
    { label: $t({ defaultMessage: '支付宝小程序' }), value: 'ONLINE_STORE_ALIPAY' },
    { label: $t({ defaultMessage: '平台小程序' }), value: 'PLATFORM_ONLINE_STORE' },
    { label: $t({ defaultMessage: 'H5' }), value: 'WX_PA' },
    { label: $t({ defaultMessage: '网页后台' }), value: 'WEB_ADMIN' },
    { label: $t({ defaultMessage: '美团外卖' }), value: 'OMS_MT' },
    { label: $t({ defaultMessage: '淘宝闪购·餐饮' }), value: 'OMS_EL' },
    { label: $t({ defaultMessage: '淘宝闪购·零售' }), value: 'OMS_EB' },
    { label: $t({ defaultMessage: '抖音外卖' }), value: 'OMS_TIKTOK' },
    { label: $t({ defaultMessage: '抖音自助核销' }), value: 'OMS_TIKTOK_SELF_CHECK' },
    { label: $t({ defaultMessage: '京东秒送' }), value: 'OMS_JD' },
    { label: $t({ defaultMessage: '美团闪购' }), value: 'OMS_MTSG' },
];
// 业务类型
const DING_MODE = [
    { label: $t({ defaultMessage: '堂食' }), value: 'REAL_DINING_IN' }, // 堂食
    { label: $t({ defaultMessage: '外卖' }), value: 'LOCAL_DELIVER' }, // 外卖
    { label: $t({ defaultMessage: '自提' }), value: 'SELF_PICK' }, // 自提
];
// 订单类型
const orderTypeList = [
    { label: $t({ defaultMessage: '储值' }), value: 'DEPOSIT' },
    { label: $t({ defaultMessage: '优惠券包' }), value: 'DISCOUNT_TICKET_PACK' },
    { label: $t({ defaultMessage: '礼品卡' }), value: 'GIFT_CARD' },
    { label: $t({ defaultMessage: '权益卡' }), value: 'RIGHT_CARD' },
    { label: $t({ defaultMessage: '挂账还款' }), value: 'SIGN_REPAY' },
    { label: $t({ defaultMessage: '订金' }), value: 'DOWN_PAYMENT' },
    { label: $t({ defaultMessage: '押金' }), value: 'DINING_DEPOSIT' },
];
// 报表-单据类型
const OPERATEORDER_SOURCE_MAP = {
    DEPOSIT: $t({ defaultMessage: '储值' }),
    DISCOUNT_TICKET_PACK: $t({ defaultMessage: '优惠券包' }),
    GIFT_CARD: $t({ defaultMessage: '礼品卡' }),
    RIGHT_CARD: $t({ defaultMessage: '权益卡' }),
    MEITUAN_TICKET: $t({ defaultMessage: '美团券' }),
    TIKTOK_TICKET: $t({ defaultMessage: '抖音券' }),
    SIGN_REPAY: $t({ defaultMessage: '挂账还款' }),
    DOWN_PAYMENT: $t({ defaultMessage: '订金' }),
    DINING_DEPOSIT: $t({ defaultMessage: '押金' }),
};
// 报表-分类维度
const CATEGORYDIMENSION = [
    { label: $t({ defaultMessage: '全部分类' }), value: 'ALL_CATEGORY' },
    { label: $t({ defaultMessage: '一级分类' }), value: 'FIRST_LEVEL_CATEGORY' },
];
// 统计指标
const SOURCEITEMVALUE = [
    { label: $t({ defaultMessage: '营业优惠' }), value: 'business_discount_money' },
    { label: $t({ defaultMessage: '营业收入' }), value: 'business_income_money' },
    { label: $t({ defaultMessage: '折后单均' }), value: 'business_income_price' },
    { label: $t({ defaultMessage: '有效订单数' }), value: 'order_count' },
    { label: $t({ defaultMessage: '营业流水' }), value: 'business_running_money' },
    { label: $t({ defaultMessage: '折前单均' }), value: 'business_running_price' },
];
var MARS_Color;
(function (MARS_Color) {
    MARS_Color["ONLINE_STORE_MP"] = "#14E298";
    MARS_Color["POS"] = "#FEC70B";
    MARS_Color["WEB_ADMIN"] = "#226BF3";
    MARS_Color["PLATFORM_ONLINE_STORE"] = "#F8C157";
})(MARS_Color || (MARS_Color = {}));
// 所有来源
var MARS_SOUCE;
(function (MARS_SOUCE) {
    MARS_SOUCE["WEB_ADMIN"] = "web_admin";
    MARS_SOUCE["ONLINE_STORE_MP"] = "wechat_miniprogram";
    MARS_SOUCE["ONLINE_STORE"] = "wechat_miniprogram";
    MARS_SOUCE["POS"] = "pos";
    MARS_SOUCE["APP"] = "app";
    MARS_SOUCE["ORDER_ASSISTANT_APP"] = "order_assistant_app";
    MARS_SOUCE["OMS_MT"] = "oms_mt";
    MARS_SOUCE["OMS_EL"] = "oms_elm";
    MARS_SOUCE["PLATFORM_ONLINE_STORE"] = "miniprogram";
    MARS_SOUCE["OMS_EB"] = "oms_eb";
    MARS_SOUCE["OMS_TIKTOK"] = "douyin_takeout";
    MARS_SOUCE["TIKTOK"] = "douyin";
    MARS_SOUCE["KOU_BEI"] = "koubei";
    MARS_SOUCE["MEI_TUAN"] = "mt";
    MARS_SOUCE["KS"] = "ks";
    MARS_SOUCE["ONLINE_STORE_ALIPAY"] = "alipay_mini_program";
    MARS_SOUCE["OMS_TIKTOK_SELF_CHECK"] = "tiktok_self_verification";
    MARS_SOUCE["WX_PA"] = "wx_pa";
    MARS_SOUCE["OMS_MTSG"] = "oms_mtsg";
    MARS_SOUCE["OMS_JD"] = "oms_jd";
})(MARS_SOUCE || (MARS_SOUCE = {}));
var SOURCE_ITEM;
(function (SOURCE_ITEM) {
    SOURCE_ITEM["business_discount_money"] = "business_discounts";
    SOURCE_ITEM["business_income_money"] = "operating_revenue";
    SOURCE_ITEM["business_income_price"] = "single_average_after_discount";
    SOURCE_ITEM["order_count"] = "number_of_valid_orders";
    SOURCE_ITEM["business_running_money"] = "business_flow";
    SOURCE_ITEM["business_running_price"] = "average_before_discount";
})(SOURCE_ITEM || (SOURCE_ITEM = {}));
const SALESMIX = [
    { label: $t({ defaultMessage: '商品销售' }), value: 'PRODUCT' },
    { label: $t({ defaultMessage: '属性销售' }), value: 'PROPERTY' },
    { label: $t({ defaultMessage: '包装费' }), value: 'PACKAGE_FEE' },
    { label: $t({ defaultMessage: '配送费' }), value: 'DELIVER_FEE' },
];
// 统计方式
const STATISTICALMETHODS = [
    {
        label: $t({ defaultMessage: '单品+套餐' }),
        value: 'PRODUCT_AND_KIT',
    },
    {
        label: $t({ defaultMessage: '单品+套餐明细' }),
        value: 'PRODUCT_AND_KIT_PRODUCT',
    },
    {
        label: $t({ defaultMessage: '单品' }),
        value: 'PRODUCT',
    },
    {
        label: $t({ defaultMessage: '套餐' }),
        value: 'KIT',
    },
    {
        label: $t({ defaultMessage: '套餐明细' }),
        value: 'KIT_PRODUCT',
    },
];
// 订单类型
const EXPRESSMALLSTATISTICS = [
    { label: '商城订单', value: 'SHOP' },
    { label: '积分兑换订单', value: 'EXPRESS_POINT_EXCHANGE' },
];
// 统计间隔
const dateTypeList = [
    {
        label: $t({ defaultMessage: '1小时' }),
        value: 'HOUR',
    },
    {
        label: $t({ defaultMessage: '半小时' }),
        value: 'HALF_HOUR',
    },
    {
        label: $t({ defaultMessage: '15分钟' }),
        value: 'FIFTEEN_MINUTES',
    },
    {
        label: $t({ defaultMessage: '餐段' }),
        value: 'MEAL_SEGMENT',
    },
];
// 储值类型
const STOREDVALUETYPE = [
    { label: $t({ defaultMessage: '商户储值' }), value: 'MERCHANT_DEPOSIT' },
    { label: $t({ defaultMessage: '商户导入' }), value: 'MERCHANT_IMPORT' },
    { label: $t({ defaultMessage: '客户储值' }), value: 'CUSTOMER_DEPOSIT' },
    { label: $t({ defaultMessage: '客户储值退款' }), value: 'RE_DEPOSIT' },
    { label: $t({ defaultMessage: '无单退款（POS反储值）' }), value: 'REFUND_WITHOUT_ORDER' },
    { label: $t({ defaultMessage: '储值（增加余额）' }), value: 'MERCHANT_ADJUST_IN' },
    { label: $t({ defaultMessage: '储值（减少余额）' }), value: 'MERCHANT_ADJUST_OUT' },
    { label: $t({ defaultMessage: '批量储值（增加余额）' }), value: 'MERCHANT_BATCH_DEPOSIT' },
    { label: $t({ defaultMessage: '批量储值（减少余额）' }), value: 'MERCHANT_BATCH_RE_DEPOSIT' },
    { label: $t({ defaultMessage: '储值卡激活' }), value: 'DEPOSIT_CARD_ACTIVE' },
    { label: $t({ defaultMessage: '预储值' }), value: 'PRE_DEPOSIT' },
    { label: $t({ defaultMessage: '其他储值' }), value: 'OTHER_DEPOSIT' },
];
// 卡类型
const CARD_TYPE = [
    { label: $t({ defaultMessage: '现金卡' }), value: 'CASH_CARD' },
    { label: $t({ defaultMessage: '商品次卡' }), value: 'TIMES_CARD' },
    {
        label: $t({ defaultMessage: '储值卡' }),
        value: 'DEPOSIT_CARD',
    },
];
// 变动类型
const OPERATE_LIST = [
    { label: $t({ defaultMessage: '礼品卡购买' }), value: 'GIFT_CARD_PURCHASE' },
    { label: $t({ defaultMessage: '礼品卡购买退回' }), value: 'GIFT_CARD_REFUND' },
    { label: $t({ defaultMessage: '客户消费' }), value: 'CUSTOMER_CONSUME' },
    { label: $t({ defaultMessage: '客户消费退款' }), value: 'CUSTOMER_RE_CONSUME' },
    { label: $t({ defaultMessage: '商家赠送礼品卡' }), value: 'MERCHANT_BATCH_SEND_GIFT_CARD' },
    { label: $t({ defaultMessage: '趣味竞猜奖品' }), value: 'FUN_GUESS_PRIZE' },
    { label: $t({ defaultMessage: '取消支付' }), value: 'CANCEL_PAY' },
    { label: $t({ defaultMessage: '批量制卡' }), value: 'GIFT_CARD_BATCH_MAKE' },
    { label: $t({ defaultMessage: '制卡单作废' }), value: 'GIFT_CARD_MAKE_ORDER_INVALID' },
    { label: $t({ defaultMessage: '礼品卡作废' }), value: 'GIFT_CARD_INVALID' },
    { label: $t({ defaultMessage: '礼品卡绑定' }), value: 'GIFT_CARD_BIND' },
    { label: $t({ defaultMessage: '礼品卡激活' }), value: 'GIFT_CARD_ACTIVE' },
    { label: $t({ defaultMessage: '礼品卡激活绑定' }), value: 'GIFT_CARD_BIND_ACTIVE' },
];
// 扣款类型
const DEDUCTION_LIST = [
    { label: $t({ defaultMessage: '客户消费' }), value: 'CUSTOMER_CONSUME' },
    { label: $t({ defaultMessage: '客户消费退款' }), value: 'CUSTOMER_RE_CONSUME' },
    { label: $t({ defaultMessage: '挂账还款' }), value: 'SIGN_PAYMENT' },
    { label: $t({ defaultMessage: '取消支付' }), value: 'CANCEL_PAY' },
    { label: $t({ defaultMessage: '客户消费(POS手动调整)' }), value: 'POS_ADJUST_CONSUME' },
    { label: $t({ defaultMessage: '储值卡回收' }), value: 'DEPOSIT_CARD_RETRIEVE' },
    { label: $t({ defaultMessage: '其他扣款' }), value: 'OTHER_CONSUME' },
];
var IGiftCardKind;
(function (IGiftCardKind) {
    IGiftCardKind["CASH_CARD"] = "cash_card";
    IGiftCardKind["TIMES_CARD"] = "times_card";
    IGiftCardKind["DEPOSIT_CARD"] = "deposit_card";
    IGiftCardKind["CANCEL_PAY"] = "cancel_payment";
})(IGiftCardKind || (IGiftCardKind = {}));
var IBussinessType;
(function (IBussinessType) {
    IBussinessType["GIFT_CARD_PURCHASE"] = "gift_card_buy";
    IBussinessType["GIFT_CARD_REFUND"] = "gift_card_rebuy";
    IBussinessType["CUSTOMER_CONSUME"] = "gift_card_consume";
    IBussinessType["CUSTOMER_RE_CONSUME"] = "gift_card_refund";
    IBussinessType["MERCHANT_BATCH_SEND_GIFT_CARD"] = "merchant_send_gift_card";
    IBussinessType["FUN_GUESS_PRIZE"] = "fun_game_prize";
    IBussinessType["CANCEL_PAY"] = "cancel_payment";
    IBussinessType["GIFT_CARD_INVALID"] = "gift_card_voided";
    IBussinessType["GIFT_CARD_MAKE_ORDER_INVALID"] = "invalid_business_card_printing_form";
})(IBussinessType || (IBussinessType = {}));
const ACTIVE_STATUS = [
    { label: $t({ defaultMessage: '活跃' }), value: 'ACTIVE' },
    { label: $t({ defaultMessage: '归档' }), value: 'ARCHIVED' },
    { label: $t({ defaultMessage: '草稿' }), value: 'DRAFT' },
];
const TIME_DIMENSION = [
    {
        label: $t({ defaultMessage: '发放日期' }),
        value: 'DISTRIBUTE_DATE',
    },
    {
        label: $t({ defaultMessage: '核销日期' }),
        value: 'CHECKOUT_DATE',
    },
];
const ChoiceDiscountType = [
    {
        label: $t({ defaultMessage: '折扣券' }),
        value: 'PERCENT',
    },
    {
        label: $t({ defaultMessage: '立减券' }),
        value: 'MONEY',
    },
    {
        label: $t({ defaultMessage: '运费券' }),
        value: 'TRANSPORT_EXPENSES',
    },
    {
        label: $t({ defaultMessage: '兑换券' }),
        value: 'PRODUCT_EXCHANGE',
    },
    {
        label: $t({ defaultMessage: '买A赠B券' }),
        value: 'PURCHASE_A_GIFT_B',
    },
    {
        label: $t({ defaultMessage: '限制数量免单券' }),
        value: 'FREE_PASS',
    },
    {
        label: $t({ defaultMessage: '减至券' }),
        value: 'REDUCED_TO',
    },
];
const STATE_LIST = [
    { label: $t({ defaultMessage: '进行中' }), value: 'IN_PROGRESS' },
    { label: $t({ defaultMessage: '已过期' }), value: 'EXPIRED' },
    { label: $t({ defaultMessage: '未开始' }), value: 'NOT_STARTED' },
    { label: $t({ defaultMessage: '已停用' }), value: 'NOT_ACTIVE' },
];
// 时间维度
const TIME_DIMENSION_BusinessReceiptDetail = [
    {
        label: $t({ defaultMessage: '营业日期' }),
        value: 'BIZ_DAY',
    },
    {
        label: $t({ defaultMessage: '支付时间' }),
        value: 'PAYMENT',
    },
];
const getOperateSourceIncludeTriparTitleData = (omsEbHideTb) => [
    { label: 'POS', value: 'POS' },
    { label: $t({ defaultMessage: '管家APP' }), value: 'APP' },
    { label: $t({ defaultMessage: '点餐助手' }), value: 'ORDER_ASSISTANT_APP' },
    { label: $t({ defaultMessage: '微信小程序' }), value: 'ONLINE_STORE_MP' },
    { label: $t({ defaultMessage: '支付宝小程序' }), value: 'ONLINE_STORE_ALIPAY' },
    { label: $t({ defaultMessage: '平台小程序' }), value: 'PLATFORM_ONLINE_STORE' },
    { label: $t({ defaultMessage: 'H5' }), value: 'WX_PA' },
    { label: $t({ defaultMessage: '网页后台' }), value: 'WEB_ADMIN' },
    { label: $t({ defaultMessage: '美团外卖' }), value: 'OMS_MT' },
    { label: $t({ defaultMessage: '淘宝闪购·餐饮' }), value: 'OMS_EL' },
    { label: $t({ defaultMessage: '淘宝闪购·零售' }), value: 'OMS_EB' },
    { label: $t({ defaultMessage: '抖音外卖' }), value: 'OMS_TIKTOK' },
    { label: $t({ defaultMessage: '抖音自助核销' }), value: 'OMS_TIKTOK_SELF_CHECK' },
    { label: $t({ defaultMessage: '京东秒送' }), value: 'OMS_JD' },
    { label: $t({ defaultMessage: '美团闪购' }), value: 'OMS_MTSG' },
    { label: $t({ defaultMessage: '美团' }), value: 'MEI_TUAN' },
    { label: $t({ defaultMessage: '抖音' }), value: 'TIKTOK' },
    { label: $t({ defaultMessage: '快手' }), value: 'KS' },
    { label: $t({ defaultMessage: '口碑' }), value: 'KOU_BEI' },
];
const BUSINESSTYPEOPTIONS = [
    { label: $t({ defaultMessage: '营业收入' }), value: 'BUSINESS_REVENUE' },
    { label: $t({ defaultMessage: '储值' }), value: 'DEPOSIT' },
    { label: $t({ defaultMessage: '礼品卡' }), value: 'GIFT_CARD' },
    { label: $t({ defaultMessage: '权益卡' }), value: 'RIGHT_CARD' },
    { label: $t({ defaultMessage: '优惠券包' }), value: 'DISCOUNT_TICKET_PACK' },
    { label: $t({ defaultMessage: '挂账还款' }), value: 'SIGN_REPAY' },
    { label: $t({ defaultMessage: '订金收退' }), value: 'DOWN_PAYMENT' },
    { label: $t({ defaultMessage: '押金' }), value: 'DINING_DEPOSIT' },
];
const ORDERFINANCIALSTATUSOPTIONS = [
    { label: $t({ defaultMessage: '未付款' }), value: 'PENDING_PAYMENT' },
    { label: $t({ defaultMessage: '部分付款' }), value: 'PARTIAL_PAYMENT' },
    { label: $t({ defaultMessage: '已付款' }), value: 'PAID' },
    { label: $t({ defaultMessage: '部分退款' }), value: 'PARTIAL_REFUND' },
    { label: $t({ defaultMessage: '已退款' }), value: 'REFUNDED' },
    { label: $t({ defaultMessage: '已作废' }), value: 'CANCELED' },
    { label: $t({ defaultMessage: '申请退款（外卖平台）' }), value: 'REQUEST_REFUND' },
    { label: $t({ defaultMessage: '拒绝退款 (外卖平台)' }), value: 'REFUSE_REFUND' },
];
const TIME_DIMENSION_BusinessReceiptStatistics = [
    {
        label: $t({ defaultMessage: '结账日期' }),
        value: 'CHECKOUT',
    },
    {
        label: $t({ defaultMessage: '营业日期' }),
        value: 'BIZ_DAY',
    },
];
const businessType = [
    { label: $t({ defaultMessage: '业务大类' }), value: 'businessCategory' },
    { label: $t({ defaultMessage: '业务小类' }), value: 'businessSubcategories' },
];
const INVOICE_STATUS_OPTIONS = [
    { label: $t({ defaultMessage: '开票中' }), value: 'ISSUING' },
    { label: $t({ defaultMessage: '已开票' }), value: 'ISSUED' },
    { label: $t({ defaultMessage: '开票失败' }), value: 'FAIL_ISSUED' },
    { label: $t({ defaultMessage: '冲红中' }), value: 'CANCELLING' },
    { label: $t({ defaultMessage: '已冲红' }), value: 'CANCELLED' },
    { label: $t({ defaultMessage: '冲红失败' }), value: 'FAIL_CANCELLED' },
];
/**  */
const INVOICE_STATUS_OPTIONS_COLOR = [
    {
        value: 'ISSUING',
        color: '#FFEF9D',
        fontColor: '#4F4700',
    },
    {
        value: 'ISSUED',
        color: '#E0F0FF',
        fontColor: '#00527C',
    },
    {
        value: 'FAIL_ISSUED',
        color: '#FEDAD9',
        fontColor: '#8E1F0B',
    },
    {
        value: 'CANCELLING',
        color: '#FFEF9D',
        fontColor: '#4F4700',
    },
    {
        value: 'CANCELLED',
        color: '#E0F0FF',
        fontColor: '#00527C',
    },
    {
        value: 'FAIL_CANCELLED',
        color: '#FEDAD9',
        fontColor: '#8E1F0B',
    },
];

/*
 * @Author: 毛和水
 * @Date: 2024-10-09 21:27:47
 * @LastEditors: 王仁涛 wangrt@cnlemon.net
 * @LastEditTime: 2026-05-11 21:08:48
 * @Description: file content
 */
const reoutes = [
    {
        name: 'main-report-busincess-analysis-report',
        path: '/main-report/busincess-analysis-report',
        component: './main-report/busincess-analysis-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_OVERVIEW],
    },
    {
        name: 'main-report-business-statistics-report',
        path: '/main-report/business-statistics-report',
        component: './main-report/business-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_STATISTICS],
    },
    {
        name: 'main-report-business-beyond-statistic',
        path: '/main-report/business-beyond-statistic',
        component: './main-report/business-beyond-statistic',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_BEYOND_STATISTICS],
    },
    {
        name: 'main-report-business-detail-report',
        path: '/main-report/business-detail-report',
        component: './main-report/business-detail-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_DETAIL],
    },
    {
        name: 'main-report-business-income-discount-report',
        path: '/main-report/business-income-discount-report',
        component: './main-report/business-income-discount-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_INCOME_DISCOUNT],
    },
    {
        name: 'main-report-business-payment-report',
        path: '/main-report/business-payment-report',
        component: './main-report/business-payment-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_PAYMENT],
    },
    {
        name: 'main-report-business-discount-report',
        path: '/main-report/business-discount-report',
        component: './main-report/business-discount-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_DISCOUNT],
    },
    {
        name: 'main-report-business-refund-statistic',
        path: '/main-report/business-refund-statistic',
        component: './main-report/business-refund-statistic',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_REFUND_STATISTICS],
    },
    {
        name: 'main-report-channel-business-statistics-report',
        path: '/main-report/channel-business-statistics-report',
        component: './main-report/channel-business-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_ORDER_BUSINESS_REPORT_ANALYSIS],
    },
    {
        name: 'main-report-table-business-statistics-report',
        path: '/main-report/table-business-statistics-report',
        component: './main-report/table-business-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_TABLE_BUSINESS_STATISTICS],
    },
    {
        name: 'main-report-session-business-statistics-report',
        path: '/main-report/session-business-statistics-report',
        component: './main-report/session-business-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SESSION_BUSINESS_STATISTICS],
    },
    {
        name: 'main-report-ticket-income-statistics-report',
        path: '/main-report/ticket-income-statistics-report',
        component: './main-report/ticket-income-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_TICKET_INCOME_STATISTICS],
    },
    {
        name: 'main-report-express-mall-statistics',
        path: '/main-report/express-mall-statistics',
        component: './main-report/express-mall-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_EXPRESS_MALL_STATISTICS],
    },
    {
        name: 'main-report-service-fee-statistics',
        path: '/main-report/service-fee-statistics',
        component: './main-report/service-fee-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SERVICE_FEE_ITEM],
    },
    {
        name: 'main-report-product-overview-report',
        path: '/main-report/product-overview-report',
        component: './main-report/product-overview-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_OVERVIEW_REPORT],
    },
    {
        name: 'main-report-product-summary-statistics',
        path: '/main-report/product-summary-statistics',
        component: './main-report/product-summary-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_SUMMARY],
    },
    {
        name: 'main-report-product-sales-summary-report',
        path: '/main-report/product-sales-summary-report',
        component: './main-report/product-sales-summary-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_SALES_SUMMARY],
    },
    {
        name: 'main-report-product-sales-details-report',
        path: '/main-report/product-sales-details-report',
        component: './main-report/product-sales-details-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_SALES_DETAIL],
    },
    {
        name: 'main-report-product-sales-ranking-report',
        path: '/main-report/product-sales-ranking-report',
        component: './main-report/product-sales-ranking-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_SALES_RANKING],
    },
    {
        name: 'main-report-product-marketing-report',
        path: '/main-report/product-marketing-report',
        component: './main-report/product-marketing-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_MARKETING_REPORT],
    },
    {
        name: 'main-report-product-location-sales-report',
        path: '/main-report/product-location-sales-report',
        component: './main-report/product-location-sales-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_LOCATION_SALES],
    },
    {
        name: 'main-report-kit-sales-ranking-report',
        path: '/main-report/kit-sales-ranking-report',
        component: './main-report/kit-sales-ranking-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_KIT_SALE_STATISTICS],
    },
    {
        name: 'main-report-customer-deduction-report',
        path: '/main-report/customer-deduction-report',
        component: './main-report/customer-deduction-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_CONSUME_DETAIL_ANALYSIS],
    },
    {
        name: 'main-report-deposite-payment-method-detail',
        path: '/main-report/deposite-payment-method-detail',
        component: './main-report/deposite-payment-method-detail',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_DEPOSIT_PAYMENT_TYPE_DETAIL_ANALYSIS],
    },
    {
        name: 'main-report-customer-stored-value-report',
        path: '/main-report/customer-stored-value-report',
        component: './main-report/customer-stored-value-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_DEPOSIT_DETAIL_ANALYSIS],
    },
    {
        name: 'main-report-card-sales-detail',
        path: '/main-report/card-sales-detail',
        component: './main-report/card-sales-detail',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_CARD_ORDER_DETAIL_ANALYSIS],
    },
    {
        name: 'main-report-customer-price-report',
        path: '/main-report/customer-price-report',
        component: './main-report/customer-price-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_ORDER_PRICE],
    },
    {
        name: 'main-report-product-association-recommendation',
        path: '/main-report/product-association-recommendation',
        component: './main-report/product-association-recommendation',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_RELATE_SUGGEST],
    },
    {
        name: 'main-report-zero-sales-product-report',
        path: '/main-report/zero-sales-product-report',
        component: './main-report/zero-sales-product-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_ZERO_SALE],
    },
    {
        name: 'main-report-promotion-effect-analysis',
        path: '/main-report/promotion-effect-analysis',
        component: './main-report/promotion-effect-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_DISCOUNT_EFFECT],
    },
    {
        name: 'main-report-marketing-activity-effect-analysis',
        path: '/main-report/marketing-activity-effect-analysis',
        component: './main-report/marketing-activity-effect-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_DISCOUNT_PROMOTION],
    },
    {
        name: 'main-report-clear-sale-report',
        path: '/main-report/clear-sale-report',
        component: './main-report/clear-sale-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_CLEARANCE_LOG],
    },
    {
        name: 'main-report-vip-data-report',
        path: '/main-report/vip-data-report',
        component: './main-report/vip-data-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_MEMBER_DATA],
    },
    {
        name: 'main-report-customer-performance',
        path: '/main-report/customer-performance',
        component: './main-report/customer-performance',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_PERFORMANCE],
    },
    {
        name: 'main-report-gift-card-balance-log',
        path: '/main-report/gift-card-balance-log',
        component: './main-report/gift-card-balance-log',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_GIFT_CARD_BALANCE_LOG],
    },
    {
        name: 'main-report-gift-card-analysis',
        path: '/main-report/gift-card-analysis',
        component: './main-report/gift-card-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_GIFT_CARD],
    },
    {
        name: 'main-report-coupon-template-analysis',
        path: '/main-report/coupon-template-analysis',
        component: './main-report/coupon-template-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_TICKET],
    },
    {
        name: 'main-report-ticket-package-sale-statistics',
        path: '/main-report/ticket-package-sale-statistics',
        component: './main-report/ticket-package-sale-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_TICKET_PACKAGE_SALE],
    },
    {
        name: 'main-report-category-sales-ranking-report',
        path: '/main-report/category-sales-ranking-report',
        component: './main-report/category-sales-ranking-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CATEGORY_SALES_RANKING],
    },
    {
        name: 'main-report-session-product-statistics-report',
        path: '/main-report/session-product-statistics-report',
        component: './main-report/session-product-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SESSION_PRODUCT_STATISTICS],
    },
    {
        name: 'main-report-return-product-statistics-report',
        path: '/main-report/return-product-statistics-report',
        component: './main-report/return-product-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SESSION_PRODUCT_REFUND_STATISTICS],
    },
    {
        name: 'main-report-gift-statistics-report',
        path: '/main-report/gift-statistics-report',
        component: './main-report/gift-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_GIFT_STATISTICS],
    },
    {
        name: 'main-report-feed-sale-statistics-report',
        path: '/main-report/feed-sale-statistics-report',
        component: './main-report/feed-sale-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PROPERTY_SALE_STATISTICS],
    },
    {
        name: 'main-report-method-statistics-report',
        path: '/main-report/method-statistics-report',
        component: './main-report/method-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_MAKE_METHOD_STATISTICS],
    },
    {
        name: 'main-report-platform-order-report',
        path: '/main-report/platform-order-report',
        component: './main-report/platform-order-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_PHONE_ANALYSIS],
    },
    {
        name: 'main-report-sales-consumption',
        path: '/main-report/sales-consumption',
        component: './main-report/sales-consumption',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SALES_CONSUMPTION],
    },
    {
        name: 'main-report-sensitive-operation-report',
        path: '/main-report/sensitive-operation-report',
        component: './main-report/sensitive-operation-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SENSITIVE_OPERATION],
    },
    {
        name: 'main-report-business-receipt-detail',
        path: '/main-report/business-receipt-detail',
        component: './main-report/business-receipt-detail',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_RECEIPT_DETAIL],
    },
    {
        name: 'main-report-salesperson-statistics-report',
        path: '/main-report/salesperson-statistics-report',
        component: './main-report/salesperson-statistics-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_POS_STAFF],
    },
    {
        name: 'main-report-business-receipt-statistics',
        path: '/main-report/business-receipt-statistics',
        component: './main-report/business-receipt-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_RECEIPT_STATISTICS],
    },
    {
        name: 'main-report-business-target-report',
        path: '/main-report/business-target-report',
        component: './main-report/business-target-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_REPORT_BUSINESS_CYCLE_COMPARE],
    },
    {
        name: 'main-report-cashier-statistics',
        path: '/main-report/cashier-statistics',
        component: './main-report/cashier-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CASHIER_STATISTICS],
    },
    {
        name: 'main-report-deposit-report',
        path: '/main-report/deposit-report/old',
        component: './main-report/deposit-report/old-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_DEPOSIT],
    },
    {
        name: 'main-report-deposit-report',
        path: '/main-report/deposit-report',
        component: './main-report/deposit-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_DEPOSIT],
    },
    {
        name: 'main-report-shift-handover-statistics',
        path: '/main-report/shift-handover-statistics/shift-handover-details',
        component: './main-report/shift-handover-statistics/shift-handover-details',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SHIFT_HANDOVER_STATISTICS],
    },
    {
        name: 'main-report-shift-handover-statistics',
        path: '/main-report/shift-handover-statistics',
        component: './main-report/shift-handover-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SHIFT_HANDOVER_STATISTICS],
    },
    {
        name: 'main-report-sign-payment-detail',
        path: '/main-report/sign-payment-detail',
        component: './main-report/sign-payment-detail',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_SIGN_PAYMENT_DETAIL],
    },
    {
        name: 'main-report-deposit-pledge-statistics',
        path: '/main-report/deposit-pledge-statistics',
        component: './main-report/deposit-pledge-statistics',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_DOWN_PAYMENT],
    },
    {
        name: 'main-report-product-cost-gross',
        path: '/main-report/product-cost-gross',
        component: './main-report/product-cost-gross',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PRODUCT_COST_GROSS],
    },
    {
        name: 'main-report-business-collection-reconciliation',
        path: '/main-report/business-collection-reconciliation/difference-detail',
        component: './main-report/business-collection-reconciliation/difference-detail',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_PAY_VERIFY],
    },
    {
        name: 'main-report-business-collection-reconciliation',
        path: '/main-report/business-collection-reconciliation',
        component: './main-report/business-collection-reconciliation',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_BUSINESS_PAY_VERIFY],
    },
    {
        name: 'main-report-third-party-reconciliation-calendar',
        path: '/main-report/third-party-reconciliation-calendar',
        component: './main-report/third-party-reconciliation-calendar',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_OMS_RECONCILE_CALENDAR],
    },
    {
        name: 'main-report-third-party-reconciliation-result-summary',
        path: '/main-report/third-party-reconciliation-result-summary',
        component: './main-report/third-party-reconciliation-result-summary',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_OMS_RECONCILE_SUMMARY],
    },
    {
        name: 'main-report-third-party-reconciliation-result-detail',
        path: '/main-report/third-party-reconciliation-result-detail',
        component: './main-report/third-party-reconciliation-result-detail',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_OMS_RECONCILE_DETAIL],
    },
    {
        name: 'main-report-group-purchase-coupon-record',
        path: '/main-report/group-purchase-coupon-record',
        component: './main-report/group-purchase-coupon-record',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_PLATFORM_TICKET_VERIFY_LOG],
    },
    {
        name: 'main-report-point-analysis-report',
        path: '/main-report/point-analysis-report',
        component: './main-report/point-analysis-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_POINT],
    },
    {
        name: 'main-report-consumption-analysis',
        path: '/main-report/consumption-analysis',
        component: './main-report/consumption-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CONSUMPTION_ANALYSIS],
    },
    {
        name: 'main-report-mall-traffic-overview-report',
        path: '/main-report/mall-traffic-overview-report',
        component: './main-report/mall-traffic-overview-report',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_WESTORE_TRAFFIC_OVERVIEW],
    },
    {
        name: 'main-report-equity-card-stat',
        path: '/main-report/equity-card-stat',
        component: './main-report/equity-card-stat',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_RIGHT_CARD],
    },
    {
        name: 'main-report-customer-consume-analysis',
        path: '/main-report/customer-consume-analysis',
        component: './main-report/customer-consume-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CROSS_LOCATION_CONSUME],
    },
    {
        name: 'main-report-vip-card-operate-analysis',
        path: '/main-report/vip-card-operate-analysis',
        component: './main-report/vip-card-operate-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_CARD_OPERATE_LOG],
    },
    {
        name: 'main-report-deposit-activity-effect-analysis',
        path: '/main-report/deposit-activity-effect-analysis',
        component: './main-report/deposit-activity-effect-analysis',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_GIFT_DEPOSIT],
    },
    {
        name: 'main-report-customer-card-trade-log',
        path: '/main-report/customer-card-trade-log',
        component: './main-report/customer-card-trade-log',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_CARD_TRADE_LOG],
    },
    {
        name: 'main-report-customer-repurchase',
        path: '/main-report/customer-repurchase',
        component: './main-report/customer-repurchase',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_REPURCHASE],
    },
    {
        name: 'main-report-customer-repurchase-product',
        path: '/main-report/customer-repurchase-product',
        component: './main-report/customer-repurchase-product',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_REPURCHASE_PRODUCT_DETAIL],
    },
    {
        name: 'main-report-customer-consume-ratio',
        path: '/main-report/customer-consume-ratio',
        component: './main-report/customer-consume-ratio',
        microApp: 'report-app',
        code_key: [IPermissonCode.PERMISSION_ANALYZE_CUSTOMER_CONSUME_RATE],
    },
];
const getRouteTabs$b = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
}));
var index$3 = getRouteTabs$b({ routes: reoutes, category: 'REPORT_CENTER' });

/*
 * @Author: 张帮辉
 * @LastEditors: 彭鑫诚
 * @Date: 2022-03-01 16:59:06
 * @LastEditTime: 2024-06-25 20:01:52
 * @Description: 要货单路由
 */
var requestOrderPaths = [
    {
        name: 'stock-order-requestOrder',
        path: '/orders/requestOrder',
        component: './orders/requestOrder/requestOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestOrder',
        path: '/orders/requestOrder/new',
        component: './orders/requestOrder/modifyRequestOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestOrder',
        path: '/orders/requestOrder/:id',
        component: './orders/requestOrder/modifyRequestOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestOrder',
        path: '/orders/requestOrder/copy/:copyId',
        component: './orders/requestOrder/modifyRequestOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestOrder',
        path: '/orders/requestOrder/read/:id/:outType?',
        component: './orders/requestOrder/readRequestOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:31:28
 * @LastEditors: 赵泽文
 * @LastEditTime: 2024-05-22 09:09:53
 * @Description: 要货单
 */
var earthLocationReplenishment = [
    {
        name: 'stock-earth-locationReplenishment',
        path: '/earthOrders/earthLocationReplenishment',
        component: './earthOrders/locationReplenishment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-earth-locationReplenishment',
        path: '/earthOrders/earthLocationReplenishment/:id/:outType?',
        component: './earthOrders/locationReplenishment/ReadLocationReplenishment',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-03-03 10:32:31
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-11-20 11:00:12
 * @Description: 调出单路由
 */
var transferOutOrderPaths = [
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder',
        component: './orders/transferOutOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder/batch',
        component: './orders/transferOutOrder/BatchTransferOutOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder/add/:orderId?/:storehouse_num?',
        component: './orders/transferOutOrder/ModifyTransferOutOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder/edit/:id',
        component: './orders/transferOutOrder/ModifyTransferOutOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder/copy/:copyId',
        component: './orders/transferOutOrder/ModifyTransferOutOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder/:id/:outType?',
        component: './orders/transferOutOrder/ReadTransferOutOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 毛和水
 * @Date: 2022-03-01 16:59:06
 * @LastEditTime: 2024-04-07 16:14:13
 * @Description: 要货单路由
 */
var earthTransferOutOrder = [
    {
        name: 'stock-earth-transferOutOrder',
        path: '/earthOrders/earthTransferOutOrder',
        component: './earthOrders/transferOutOrder/transferOutOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-earth-transferOutOrder',
        path: '/earthOrders/earthTransferOutOrder/read/:id/:outType?',
        component: './earthOrders/transferOutOrder/readTransferOutOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 赵泽文
 * @Date: 2022-03-01 16:59:06
 * @LastEditTime: 2023-10-27 16:35:50
 * @Description: 要货单路由
 */
var tranferInOrderPaths = [
    {
        name: 'stock-order-transferInOrder',
        path: '/orders/transferInOrder',
        component: './orders/transferInOrder/transferInOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferInOrder',
        path: '/orders/transferInOrder/new',
        component: './orders/transferInOrder/modifyTransferInOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferInOrder',
        path: '/orders/transferInOrder/:id',
        component: './orders/transferInOrder/modifyTransferInOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferInOrder',
        path: '/orders/transferInOrder/copy/:copyId',
        component: './orders/transferInOrder/modifyTransferInOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-transferInOrder',
        path: '/orders/transferInOrder/read/:id',
        component: './orders/transferInOrder/readTransferInOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: nhsoft.zhangxh
 * @Date: 2022-03-01 16:59:06
 * @LastEditTime: 2023-10-11 09:54:29
 * @Description: 要货单路由
 */
var earthTransferInOrder = [
    {
        name: 'stock-earth-transferInOrder',
        path: '/earthOrders/earthTransferInOrder',
        component: './earthOrders/transferInOrder/transferInOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-earth-transferInOrder',
        path: '/earthOrders/earthTransferInOrder/read/:id',
        component: './earthOrders/transferInOrder/readTransferInOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:31:28
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-10-21 14:52:02
 * @Description: 内部申请单路由
 */
var innerApplyOrderPaths = [
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder',
        component: './orders/innerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder/add',
        component: './orders/innerApplyOrder/ModifyInnerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder/edit/:id',
        component: './orders/innerApplyOrder/ModifyInnerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder/copy/:copyId',
        component: './orders/innerApplyOrder/ModifyInnerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder/reply/:id',
        component: './orders/innerApplyOrder/ReplyInnerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder/return/:id',
        component: './orders/innerApplyOrder/ReturnInnerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder/:id',
        component: './orders/innerApplyOrder/ReadInnerApplyOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: nhsoft.zhangxh
 * @Date: 2023-10-11 09:29:38
 * @LastEditors: nhsoft.zhangxh
 * @LastEditTime: 2023-10-12 14:34:09
 * @Description: file content
 */
var earthInnerApplyOrder = [
    {
        name: 'stock-earth-innerApplyOrder',
        path: '/earthOrders/earthInnerApplyOrder',
        component: './earthOrders/innerApplyOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-earth-innerApplyOrder',
        path: '/earthOrders/earthInnerApplyOrder/:id',
        component: './earthOrders/innerApplyOrder/ReadInnerApplyOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-06-05 09:25:31
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-06-05 09:29:03
 * @FilePath: \mars-front-admin-chain-stock\config\menus\orders\orderingControl.ts
 * @Description: 门店订货控制路由
 */
var orderingControl = [
    {
        name: 'stock-order-orderingControl',
        path: '/orders/orderingControl',
        component: './orders/orderingControl',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-orderingControl',
        path: '/orders/orderingControl/new',
        component: './orders/orderingControl/modifyOrderingControl',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-orderingControl',
        path: '/orders/orderingControl/:id',
        component: './orders/orderingControl/modifyOrderingControl',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-orderingControl',
        path: '/orders/orderingControl/copy/:copyId',
        component: './orders/orderingControl/modifyOrderingControl',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 毛和水
 * @Date: 2022-03-01 16:59:06
 * @LastEditTime: 2024-08-09 08:49:49
 * @Description: 要货单路由
 */
var requestOrderTemplatePaths = [
    {
        name: 'stock-order-requestTemplate',
        path: '/orders/requestTemplate',
        component: './orders/requestTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestTemplate',
        path: '/orders/requestTemplate/new',
        component: './orders/requestTemplate/modifyRequestTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestTemplate',
        path: '/orders/requestTemplate/:id',
        component: './orders/requestTemplate/modifyRequestTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestTemplate',
        path: '/orders/requestTemplate/copy/:copyId',
        component: './orders/requestTemplate/modifyRequestTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-requestTemplate',
        path: '/orders/requestTemplate/read/:readId',
        component: './orders/requestTemplate/modifyRequestTemplate',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-09-08 15:43:38
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-09-09 15:06:24
 * @Description: 超量折扣
 */
var exceedDiscountOrderPaths = [
    {
        name: 'stock-order-exceedDiscountOrder',
        path: '/orders/exceedDiscountOrder',
        component: './orders/exceedDiscountOrder/exceedDiscountOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-exceedDiscountOrder',
        path: '/orders/exceedDiscountOrder/new',
        component: './orders/exceedDiscountOrder/modifyExceedDiscountOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-exceedDiscountOrder',
        path: '/orders/exceedDiscountOrder/read/:readId',
        component: './orders/exceedDiscountOrder/modifyExceedDiscountOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-exceedDiscountOrder',
        path: '/orders/exceedDiscountOrder/copy/:copyId',
        component: './orders/exceedDiscountOrder/modifyExceedDiscountOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-exceedDiscountOrder',
        path: '/orders/exceedDiscountOrder/:id',
        component: './orders/exceedDiscountOrder/modifyExceedDiscountOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 彭鑫诚
 * @Date: 2024-04-24 10:02:46
 * @LastEditors: 赵泽文
 * @LastEditTime: 2024-05-22 20:11:37
 * @Description:  配送中心路由
 */
var distributionCenter = [
    {
        name: 'stock-order-distributionCenter',
        path: '/orders/distributionCenter',
        component: './orders/requestOrderStatistics',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-distributionCenter',
        path: '/orders/distributionCenter/guide',
        component: './orders/requestOrderStatistics/TransferOutGuide',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-distributionCenter',
        path: '/orders/distributionCenter/purchase',
        component: './orders/requestOrderStatistics/PurchaseOrderGuide',
        microApp: 'stock-app',
    },
];

const getRouteTabs$a = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var distributionManager = [
    {
        name: 'stock-order-distributionCenter',
        path: '/orders/distributionCenter',
        routes: getRouteTabs$a({
            routes: distributionCenter,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_REQUEST_ORDER_STATISTICS],
        }),
    },
    {
        name: 'stock-order-requestOrder',
        path: '/orders/requestOrder',
        routes: getRouteTabs$a({
            routes: requestOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_REQUEST_ORDER],
        }),
    },
    {
        name: 'stock-earth-locationReplenishment',
        path: '/earthOrders/earthLocationReplenishment',
        routes: getRouteTabs$a({
            routes: earthLocationReplenishment,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_REQUEST_ORDER],
        }),
    },
    {
        name: 'stock-order-transferOutOrder',
        path: '/orders/transferOutOrder',
        routes: getRouteTabs$a({
            routes: transferOutOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_TRANSFER_OUT_ORDER],
        }),
    },
    {
        name: 'stock-earth-transferOutOrder',
        path: '/earthOrders/earthTransferOutOrder',
        routes: getRouteTabs$a({
            routes: earthTransferOutOrder,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_TRANSFER_OUT_ORDER],
        }),
    },
    {
        name: 'stock-order-transferInOrder',
        path: '/orders/transferInOrder',
        routes: getRouteTabs$a({
            routes: tranferInOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_TRANSFER_IN_ORDER],
        }),
    },
    {
        name: 'stock-earth-transferInOrder',
        path: '/earthOrders/earthTransferInOrder',
        routes: getRouteTabs$a({
            routes: earthTransferInOrder,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_TRANSFER_IN_ORDER],
        }),
    },
    {
        name: 'stock-order-innerApplyOrder',
        path: '/orders/innerApplyOrder',
        routes: getRouteTabs$a({
            routes: innerApplyOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_INNER_APPLY_ORDER],
        }),
    },
    {
        name: 'stock-earth-innerApplyOrder',
        path: '/earthOrders/earthInnerApplyOrder',
        routes: getRouteTabs$a({
            routes: earthInnerApplyOrder,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_INNER_APPLY_ORDER],
        }),
    },
    {
        name: 'stock-order-replenishment-guide',
        path: '/orders/replenishmentGuide',
        component: './orders/replenishmentGuide',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_DISTRIBUTION_MANAGEMENT_REQUEST_GUIDE],
    },
    {
        name: 'stock-order-shipNet',
        path: '/orders/shipNet',
        component: './orders/shipNet',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_CHAIN_SHIP_NET],
    },
    {
        name: 'stock-order-productLocationPrice',
        path: '/orders/productLocationPrice',
        component: './orders/product-location-price',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_CHAIN_PRODUCT_LOCATION_PRICE],
    },
    {
        name: 'stock-order-productLocationProp',
        path: '/orders/productLocationProp',
        component: './orders/productLocationProp',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_CHAIN_PRODUCT_LOCATION_PROP],
    },
    {
        name: 'stock-order-orderingControl',
        path: '/orders/orderingControl',
        routes: getRouteTabs$a({
            routes: orderingControl,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_LOCATION_REQUEST_CONTROL],
        }),
    },
    {
        name: 'stock-order-requestTemplate',
        path: '/orders/requestTemplate',
        routes: getRouteTabs$a({
            routes: requestOrderTemplatePaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_REQUEST_ORDER_TEMPLATE],
        }),
    },
    {
        name: 'stock-order-innerReturnReason',
        path: '/orders/innerReturnReason',
        component: './orders/innerReturnReason',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_INNER_RETURN_REASON],
    },
    {
        name: 'stock-order-exceedDiscountOrder',
        path: '/orders/exceedDiscountOrder',
        routes: getRouteTabs$a({
            routes: exceedDiscountOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_EXCEED_DISCOUNT_ORDER],
        }),
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-05-09 15:38:12
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-10-20 14:53:14
 * @Description: 采购订单types
 */
var purchaseOrderPaths = [
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder',
        component: './purchasing/purchaseOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder/add',
        component: './purchasing/purchaseOrder/ModifyPurchaseOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder/batchAdd',
        component: './purchasing/purchaseOrder/BatchAddPurchaseOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder/edit/:id',
        component: './purchasing/purchaseOrder/ModifyPurchaseOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder/copy/:copyId',
        component: './purchasing/purchaseOrder/ModifyPurchaseOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder/:id',
        component: './purchasing/purchaseOrder/ReadPurchaseOrder',
        microApp: 'stock-app',
    },
];

var directOrderPaths = [
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder',
        component: './purchasing/directOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder/add',
        component: './purchasing/directOrder/ModifyDirectOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder/batchAdd',
        component: './purchasing/directOrder/BatchAddDirectOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder/edit/:id',
        component: './purchasing/directOrder/ModifyDirectOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder/copy/:copyId',
        component: './purchasing/directOrder/ModifyDirectOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder/read/:readId',
        component: './purchasing/directOrder/ModifyDirectOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-03-08 14:43:00
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-10-18 20:09:31
 * @Description: 收货单路由
 */
var receiveOrderPaths = [
    {
        name: 'stock-purchase-receiveOrder',
        path: '/purchasing/receiveOrder',
        component: './purchasing/receiveOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-receiveOrder',
        path: '/purchasing/receiveOrder/add',
        component: './purchasing/receiveOrder/ModifyReceiveOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-receiveOrder',
        path: '/purchasing/receiveOrder/edit/:id',
        component: './purchasing/receiveOrder/ModifyReceiveOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-receiveOrder',
        path: '/purchasing/receiveOrder/copy/:copyId',
        component: './purchasing/receiveOrder/ModifyReceiveOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-receiveOrder',
        path: '/purchasing/receiveOrder/:id',
        component: './purchasing/receiveOrder/ReadReceiveOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-05-10 16:40:03
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-10-20 15:10:38
 * @Description: 退货单路由
 */
var returnOrderPaths = [
    {
        name: 'stock-purchase-returnOrder',
        path: '/purchasing/returnOrder',
        component: './purchasing/returnOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-returnOrder',
        path: '/purchasing/returnOrder/add',
        component: './purchasing/returnOrder/ModifyReturnOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-returnOrder',
        path: '/purchasing/returnOrder/edit/:id',
        component: './purchasing/returnOrder/ModifyReturnOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-returnOrder',
        path: '/purchasing/returnOrder/copy/:copyId',
        component: './purchasing/returnOrder/ModifyReturnOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-returnOrder',
        path: '/purchasing/returnOrder/:id',
        component: './purchasing/returnOrder/ReadReturnOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-05-22 09:26:27
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-21 21:11:21
 * @Description: 供应商关系路由
 */
var supplyPaths = [
    {
        name: 'stock-purchase-supply',
        path: '/purchasing/supply',
        component: './purchasing/supply',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 毛和水
 * @Date: 2022-03-01 16:59:06
 * @LastEditTime: 2024-08-09 08:49:49
 * @Description: 采购模版路由
 */
var purchaseTemplatePaths = [
    {
        name: 'stock-order-purchaseTemplate',
        path: '/purchasing/purchaseTemplate',
        component: './purchasing/purchaseTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-purchaseTemplate',
        path: '/purchasing/purchaseTemplate/new',
        component: './purchasing/purchaseTemplate/modifyPurchaseTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-purchaseTemplate',
        path: '/purchasing/purchaseTemplate/:id',
        component: './purchasing/purchaseTemplate/modifyPurchaseTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-purchaseTemplate',
        path: '/purchasing/purchaseTemplate/copy/:copyId',
        component: './purchasing/purchaseTemplate/modifyPurchaseTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-order-purchaseTemplate',
        path: '/purchasing/purchaseTemplate/read/:readId',
        component: './purchasing/purchaseTemplate/modifyPurchaseTemplate',
        microApp: 'stock-app',
    },
];

const getRouteTabs$9 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var purchasingManager = [
    {
        name: 'stock-purchase-purchaseOrder',
        path: '/purchasing/purchaseOrder',
        routes: getRouteTabs$9({
            routes: purchaseOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PURCHASE_ORDER],
        }),
    },
    {
        name: 'stock-purchase-directOrder',
        path: '/purchasing/directOrder',
        routes: getRouteTabs$9({
            routes: directOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_DIRECT_ORDER],
        }),
    },
    {
        name: 'stock-purchase-receiveOrder',
        path: '/purchasing/receiveOrder',
        routes: getRouteTabs$9({
            routes: receiveOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_RECEIVE_ORDER],
        }),
    },
    {
        name: 'stock-purchase-returnOrder',
        path: '/purchasing/returnOrder',
        routes: getRouteTabs$9({
            routes: returnOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_RETURN_ORDER],
        }),
    },
    {
        name: 'stock-purchase-supply',
        path: '/purchasing/supply',
        routes: getRouteTabs$9({
            routes: supplyPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_PRODUCT],
        }),
    },
    {
        name: 'stock-order-productPurchaseProp',
        path: '/purchasing/productPurchaseProp',
        component: './purchasing/productPurchaseProp',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCT_LOCATION_PURCHASE],
    },
    {
        name: 'stock-order-purchaseTemplate',
        path: '/purchasing/purchaseTemplate',
        routes: getRouteTabs$9({
            routes: purchaseTemplatePaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_CHAIN_RECEIVE_ORDER],
        }),
    },
    {
        name: 'stock-purchase-smart',
        path: '/purchasing/purchaseGuide',
        component: './purchasing/purchaseGuide',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_PURCHASING_MANAGEMENT_PURCHASE_GUIDE],
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 张丛 nhsoft.zhangc
 * @Date: 2022-05-17 14:36:45
 * @LastEditTime: 2024-08-07 14:20:34
 * @Description: 生产领料单路由
 */
var productionProcessPaths = [
    {
        name: 'stock-process-productionProcess',
        path: '/process/productionProcess',
        component: './process/productionProcess/productionProcess',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionProcess',
        path: '/process/productionProcess/add',
        component: './process/productionProcess/modifyProductionProcess',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionProcess',
        path: '/process/productionProcess/edit/:id',
        component: './process/productionProcess/modifyProductionProcess',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionProcess',
        path: '/process/productionProcess/copy/:copyId',
        component: './process/productionProcess/modifyProductionProcess',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionProcess',
        path: '/process/productionProcess/read/:readId',
        component: './process/productionProcess/modifyProductionProcess',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-05-19 11:03:44
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-08-07 17:24:28
 * @Description: 生产计划单路由
 */
var productionPlanPaths = [
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan',
        component: './process/productionPlan',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan/requestGoods',
        component: './process/productionPlan/CreatedByRequestGoods',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan/safetyStock',
        component: './process/productionPlan/CreatedBySafetyStock',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan/add',
        component: './process/productionPlan/ModifyProductionPlan',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan/edit/:id',
        component: './process/productionPlan/ModifyProductionPlan',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan/copy/:copyId',
        component: './process/productionPlan/ModifyProductionPlan',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan/read/:readId',
        component: './process/productionPlan/ModifyProductionPlan',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 张丛 nhsoft.zhangc
 * @Date: 2022-05-25 09:26:54
 * @LastEditTime: 2024-08-15 11:33:32
 * @Description: 生产入库单路由
 */
var productionStoragePaths = [
    {
        name: 'stock-process-productionStorage',
        path: '/process/productionStorage',
        component: './process/productionStorage/productionStorage',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionStorage',
        path: '/process/productionStorage/add',
        component: './process/productionStorage/modifyProductionStorage',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionStorage',
        path: '/process/productionStorage/edit/:id',
        component: './process/productionStorage/modifyProductionStorage',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionStorage',
        path: '/process/productionStorage/copy/:copyId',
        component: './process/productionStorage/modifyProductionStorage',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionStorage',
        path: '/process/productionStorage/read/:readId',
        component: './process/productionStorage/modifyProductionStorage',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-07-24 14:05:04
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-07-24 14:07:48
 */
var processProducts = [
    {
        name: 'stock-process-processProducts',
        path: '/process/processProducts',
        component: './process/processProducts',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-08-09 11:02:59
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-08-09 11:02:59
 */
var productionBoard = [
    {
        name: 'stock-process-productionBoard',
        path: '/process/productionBoard',
        component: './process/productionBoard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionBoard',
        path: '/process/productionBoard/productionCommandOrder',
        component: './process/productionBoard/productionCommandOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-08-09 11:02:59
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-08-09 11:02:59
 */
var productionOrder = [
    {
        name: 'stock-process-productionOrder',
        path: '/process/productionOrder',
        component: './process/productionOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionOrder',
        path: '/process/productionOrder/operationLog',
        component: './process/productionOrder/operationLog',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-productionOrder',
        path: '/process/productionOrder/productionCommandOrder',
        component: './process/productionOrder/productionCommandOrder',
        microApp: 'stock-app',
    },
];

var locationProcessOrder = [
    {
        name: 'stock-process-locationProcessOrder',
        path: '/process/locationProcessOrder',
        component: './process/locationProcessOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-locationProcessOrder',
        path: '/process/locationProcessOrder/add',
        component: './process/locationProcessOrder/modifyLocationProcessOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-locationProcessOrder',
        path: '/process/locationProcessOrder/edit/:id',
        component: './process/locationProcessOrder/modifyLocationProcessOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-locationProcessOrder',
        path: '/process/locationProcessOrder/copy/:copyId',
        component: './process/locationProcessOrder/modifyLocationProcessOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-locationProcessOrder',
        path: '/process/locationProcessOrder/read/:readId',
        component: './process/locationProcessOrder/modifyLocationProcessOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 彭鑫诚
 * @Date: 2024-11-07 20:23:50
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:29:23
 * @Description: 生产模板、作业人员
 */
var processTemplate = [
    {
        name: 'stock-process-template',
        path: '/process/template',
        component: './process/template',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-template',
        path: '/process/template/add',
        component: './process/template/editTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-template',
        path: '/process/template/edit/:id',
        component: './process/template/editTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-template',
        path: '/process/template/copy/:copyId',
        component: './process/template/editTemplate',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:25:37
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:25:54
 * @Description: file content
 */
var processOperator = [
    {
        name: 'stock-process-operator',
        path: '/process/operator',
        component: './process/operator',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-operator',
        path: '/process/operator/add',
        component: './process/operator/editOperator',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-operator',
        path: '/process/operator/edit/:id',
        component: './process/operator/editOperator',
        microApp: 'stock-app',
    },
];

var taskDashBoard = [
    {
        name: 'stock-process-taskDashBoard',
        path: '/process/taskDashBoard',
        component: './process/taskDashBoard',
        microApp: 'stock-app',
    },
];

var labelPrinting = [
    {
        name: 'stock-process-labelPrinting',
        path: '/process/labelPrinting',
        component: './process/labelPrinting',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 刘欢
 * @LastEditors: 赵泽文
 * @Date: 2024-04-11 16:59:06
 * @LastEditTime: 2024-05-27 10:50:22
 * @Description: 配方路由
 */
var goodsFormularPaths = [
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula',
        component: './goods/goodsFormula/index',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula/issueManage',
        component: './goods/goodsFormula/issueManage',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula/new',
        component: './goods/modifyGoodsFormula/index',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula/edit/:id/:activekey/:locationItem',
        component: './goods/modifyGoodsFormula/index',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula/copy/:copyId/:activekey/:locationItem',
        component: './goods/modifyGoodsFormula/index',
        microApp: 'stock-app',
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula/read/:id/:activekey/:type',
        component: './goods/modifyGoodsFormula/index',
        microApp: 'stock-app',
    },
];

const getRouteTabs$8 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var processManager = [
    {
        name: 'stock-process-productionPlan',
        path: '/process/productionPlan',
        routes: getRouteTabs$8({
            routes: productionPlanPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_PLAN_ORDER],
        }),
    },
    {
        name: 'stock-process-productionBoard',
        path: '/process/productionBoard',
        routes: getRouteTabs$8({
            routes: productionBoard,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_BOARD],
        }),
    },
    {
        name: 'stock-process-productionProcess',
        path: '/process/productionProcess',
        routes: getRouteTabs$8({
            routes: productionProcessPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_MATERIAL_ORDER],
        }),
    },
    {
        name: 'stock-process-productionStorage',
        path: '/process/productionStorage',
        routes: getRouteTabs$8({
            routes: productionStoragePaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_STORAGE_ORDER],
        }),
    },
    {
        name: 'stock-process-locationProcessOrder',
        path: '/process/locationProcessOrder',
        routes: getRouteTabs$8({
            routes: locationProcessOrder,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_PRODUCE],
        }),
    },
    {
        name: 'stock-process-productionOrder',
        path: '/process/productionOrder',
        routes: getRouteTabs$8({
            routes: productionOrder,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_TASK],
        }),
    },
    {
        name: 'stock-process-taskDashBoard',
        path: '/process/taskDashBoard',
        routes: getRouteTabs$8({
            routes: taskDashBoard,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_TASK_BOARD],
        }),
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/processProducts',
        routes: getRouteTabs$8({
            routes: processProducts,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCT_PRODUCE_MGR],
        }),
    },
    {
        name: 'stock-process-goodsFormula',
        path: '/process/goodsFormula',
        routes: getRouteTabs$8({
            routes: goodsFormularPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCT_FORMULA],
        }),
    },
    {
        name: 'stock-process-template',
        path: '/process/template',
        routes: getRouteTabs$8({
            routes: processTemplate,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_TMPL],
        }),
    },
    {
        name: 'stock-process-operator',
        path: '/process/operator',
        routes: getRouteTabs$8({
            routes: processOperator,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_OPERATOR],
        }),
    },
    {
        name: 'stock-process-labelPrinting',
        path: '/process/labelPrinting',
        routes: getRouteTabs$8({
            routes: labelPrinting,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_TAG_PRINT],
        }),
    },
];

/*
 * @Author: 张帮辉
 * @LastEditors: 毛和水
 * @Date: 2022-03-15 15:11:13
 * @LastEditTime: 2024-08-02 13:38:10
 * @Description: 盘点单路由
 */
var checkOrderPaths = [
    {
        name: 'stock-check-checkOrder',
        path: '/check/checkOrder',
        component: './check/checkOrder/checkOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-checkOrder',
        path: '/check/checkOrder/add',
        component: './check/checkOrder/modifyCheckOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-checkOrder',
        path: '/check/checkOrder/edit/:id',
        component: './check/checkOrder/modifyCheckOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-checkOrder',
        path: '/check/checkOrder/copy/:copyId',
        component: './check/checkOrder/modifyCheckOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-checkOrder',
        path: '/check/checkOrder/read/:readId',
        component: './check/checkOrder/modifyCheckOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2022-05-05 09:11:17
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-10-20 15:10:55
 * @Description: 调整单路由
 */
var adjustmentOrderPaths = [
    {
        name: 'stock-check-adjustmentOrder',
        path: '/check/adjustmentOrder',
        component: './check/adjustmentOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-adjustmentOrder',
        path: '/check/adjustmentOrder/add',
        component: './check/adjustmentOrder/ModifyAdjustmentOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-adjustmentOrder',
        path: '/check/adjustmentOrder/edit/:id',
        component: './check/adjustmentOrder/ModifyAdjustmentOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-adjustmentOrder',
        path: '/check/adjustmentOrder/copy/:copyId',
        component: './check/adjustmentOrder/ModifyAdjustmentOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-adjustmentOrder',
        path: '/check/adjustmentOrder/:id',
        component: './check/adjustmentOrder/ReadAdjustmentOrder',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 彭鑫诚
 * @Date: 2024-05-31 14:03:15
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-06-03 21:09:17
 * @Description: 库存转仓
 */
var stockTransfer = [
    {
        name: 'stock-check-transfer',
        path: '/check/stockTransfer',
        component: './check/stockTransfer',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-transfer',
        path: '/check/stockTransfer/add',
        component: './check/stockTransfer/modifyStockOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-transfer',
        path: '/check/stockTransfer/edit/:id',
        component: './check/stockTransfer/modifyStockOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-transfer',
        path: '/check/stockTransfer/copy/:copyId',
        component: './check/stockTransfer/modifyStockOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-transfer',
        path: '/check/stockTransfer/read/:id',
        component: './check/stockTransfer/readStockOrder',
        microApp: 'stock-app',
    },
];

var inventoryLossOrderPaths = [
    {
        name: 'stock-check-inventoryLossOrder',
        path: '/check/inventoryLossOrder',
        component: './check/inventoryLossOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-inventoryLossOrder',
        path: '/check/inventoryLossOrder/add',
        component: './check/inventoryLossOrder/ModifyInventoryLossOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-inventoryLossOrder',
        path: '/check/inventoryLossOrder/edit/:id',
        component: './check/inventoryLossOrder/ModifyInventoryLossOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-inventoryLossOrder',
        path: '/check/inventoryLossOrder/copy/:copyId',
        component: './check/inventoryLossOrder/ModifyInventoryLossOrder',
        microApp: 'stock-app',
    },
    {
        name: 'stock-check-inventoryLossOrder',
        path: '/check/inventoryLossOrder/:readId',
        component: './check/inventoryLossOrder/ModifyInventoryLossOrder',
        microApp: 'stock-app',
    },
];

const getRouteTabs$7 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var inventoryManager = [
    {
        name: 'stock-check-checkOrder',
        path: '/check/checkOrder',
        routes: getRouteTabs$7({
            routes: checkOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_CHECK_ORDER],
        }),
    },
    {
        name: 'stock-check-adjustmentOrder',
        path: '/check/adjustmentOrder',
        routes: getRouteTabs$7({
            routes: adjustmentOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_ADJUSTMENT_ORDER],
        }),
    },
    {
        name: 'stock-check-transfer',
        path: '/check/stockTransfer',
        routes: getRouteTabs$7({
            routes: stockTransfer,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_TRANSFER_STOREHOUSE],
        }),
    },
    {
        name: 'stock-check-inventoryLossOrder',
        path: '/check/inventoryLossOrder',
        routes: getRouteTabs$7({
            routes: inventoryLossOrderPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCT_REPORT_LOSS],
        }),
    },
    {
        name: 'stock-check-adjustmentReason',
        path: '/check/adjustmentReason',
        component: './check/adjustmentReason',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_ADJUSTMENT_REASON],
    },
];

/*
 * @Author: 赵康
 * @Date: 2024-06-12 14:03:15
 * @LastEditors: 赵康
 * @LastEditTime: 2024-06-12 14:03:15
 * @Description: 库存成本调整路由
 */
var stockCostAdjustment = [
    {
        name: 'stock-cost-adjustment',
        path: '/check/stockCostAdjustment',
        component: './check/stockCostAdjustment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-cost-adjustment',
        path: '/check/stockCostAdjustment/add',
        component: './check/stockCostAdjustment/modifyStockCostAdjustment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-cost-adjustment',
        path: '/check/stockCostAdjustment/edit/:id',
        component: './check/stockCostAdjustment/modifyStockCostAdjustment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-cost-adjustment',
        path: '/check/stockCostAdjustment/copy/:copyId',
        component: './check/stockCostAdjustment/modifyStockCostAdjustment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-cost-adjustment',
        path: '/check/stockCostAdjustment/read/:id',
        component: './check/stockCostAdjustment/readStockCostAdjustment',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:29:48
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:30:22
 * @Description: file content
 */
var locationPrepayment = [
    {
        name: 'stock-finance-locationPrepayment',
        path: '/finance/locationPrepayment',
        component: './finance/locationPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationPrepayment',
        path: '/finance/locationPrepayment/new',
        component: './finance/locationPrepayment/modifyLocationPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationPrepayment',
        path: '/finance/locationPrepayment/edit/:id',
        component: './finance/locationPrepayment/modifyLocationPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationPrepayment',
        path: '/finance/locationPrepayment/return/:returnId',
        component: './finance/locationPrepayment/modifyLocationPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationPrepayment',
        path: '/finance/locationPrepayment/read/:readId',
        component: './finance/locationPrepayment/modifyLocationPrepayment',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:31:11
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:31:33
 * @Description: file content
 */
var locationExpense = [
    {
        name: 'stock-finance-locationExpense',
        path: '/finance/locationExpense',
        component: './finance/locationExpense',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationExpense',
        path: '/finance/locationExpense/new',
        component: './finance/locationExpense/modifyLocationExpense',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationExpense',
        path: '/finance/locationExpense/edit/:id',
        component: './finance/locationExpense/modifyLocationExpense',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-locationExpense',
        path: '/finance/locationExpense/read/:readId',
        component: './finance/locationExpense/modifyLocationExpense',
        microApp: 'stock-app',
    },
];

var distributionSettlement = [
    {
        name: 'stock-finance-distributionSettlement',
        path: '/finance/distributionSettlement',
        component: './finance/distributionSettlement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-distributionSettlement',
        path: '/finance/distributionSettlement/new',
        component: './finance/distributionSettlement/modifyDistributionSettlement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-distributionSettlement',
        path: '/finance/distributionSettlement/edit/:id',
        component: './finance/distributionSettlement/modifyDistributionSettlement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-distributionSettlement',
        path: '/finance/distributionSettlement/read/:readId',
        component: './finance/distributionSettlement/modifyDistributionSettlement',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:31:45
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:31:58
 * @Description: file content
 */
var supplierPrepayment = [
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment',
        component: './finance/supplierPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment/new',
        component: './finance/supplierPrepayment/EditSupplierPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment/edit/:id',
        component: './finance/supplierPrepayment/EditSupplierPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment/return/:returnId',
        component: './finance/supplierPrepayment/EditSupplierPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment/read/:readId',
        component: './finance/supplierPrepayment/EditSupplierPrepayment',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment/relate/:releatedOrderId',
        component: './finance/supplierPrepayment/EditSupplierPrepayment',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:32:12
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:32:28
 * @Description: file content
 */
var supplierExpense = [
    {
        name: 'stock-finance-supplierExpense',
        path: '/finance/supplierExpense',
        component: './finance/supplierExpense',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierExpense',
        path: '/finance/supplierExpense/new',
        component: './finance/supplierExpense/modifySupplierExpense',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierExpense',
        path: '/finance/supplierExpense/edit/:id',
        component: './finance/supplierExpense/modifySupplierExpense',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierExpense',
        path: '/finance/supplierExpense/read/:readId',
        component: './finance/supplierExpense/modifySupplierExpense',
        microApp: 'stock-app',
    },
];

var supplierSettlement = [
    {
        name: 'stock-finance-supplierSettlement',
        path: '/finance/supplierSettlement',
        component: './finance/supplierSettlement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierSettlement',
        path: '/finance/supplierSettlement/new',
        component: './finance/supplierSettlement/EditSupplierSettlement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierSettlement',
        path: '/finance/supplierSettlement/edit/:id',
        component: './finance/supplierSettlement/EditSupplierSettlement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-supplierSettlement',
        path: '/finance/supplierSettlement/read/:readId',
        component: './finance/supplierSettlement/EditSupplierSettlement',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:33:12
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:33:24
 * @Description: file content
 */
var costProject = [
    {
        name: 'stock-finance-costProject',
        path: '/finance/costProject',
        component: './finance/costProject',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-costProject',
        path: '/finance/costProject/new',
        component: './finance/costProject/modifyCostProject',
        microApp: 'stock-app',
    },
    {
        name: 'stock-finance-costProject',
        path: '/finance/costProject/edit/:id',
        component: './finance/costProject/modifyCostProject',
        microApp: 'stock-app',
    },
];

const getRouteTabs$6 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var financeManager = [
    {
        name: 'stock-cost-adjustment',
        path: '/check/stockCostAdjustment',
        routes: getRouteTabs$6({
            routes: stockCostAdjustment,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_COST_ADJUST],
        }),
    },
    {
        name: 'stock-cost-recalculate',
        path: '/check/stockCostRecalculate',
        component: './check/stockCostRecalculate',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_COST_RECAL],
    },
    {
        name: 'stock-accounting-periods',
        path: '/accounting/periods',
        component: './accounting/periods',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_FINANCIAL_ACCOUNT_PERIOD],
    },
    {
        name: 'stock-accounting-settlementManager',
        path: '/accounting/settlementManager',
        component: './accounting/settlementManager',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_FINANCIAL_ACCOUNT_SETTLEMENT],
    },
    {
        name: 'stock-accounting-settlementManager',
        path: '/accounting/settlementManager/log/:logId',
        component: './accounting/settlementManager/SettlementManagerLog',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_COST_ADJUST],
    },
    {
        name: 'stock-finance-locationPrepayment',
        path: '/finance/locationPrepayment',
        routes: getRouteTabs$6({
            routes: locationPrepayment,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_PRE_RECEIVE],
        }),
    },
    {
        name: 'stock-finance-locationExpense',
        path: '/finance/locationExpense',
        routes: getRouteTabs$6({
            routes: locationExpense,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_FEE],
        }),
    },
    {
        name: 'stock-finance-distributionSettlement',
        path: '/finance/distributionSettlement',
        routes: getRouteTabs$6({
            routes: distributionSettlement,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_FINANCIAL_DELIVER_SETTLEMENT],
        }),
    },
    {
        name: 'stock-finance-locationDealings',
        path: '/finance/locationDealings',
        component: './finance/locationDealings',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_ACCOUNT_AMOUNT],
    },
    {
        name: 'stock-finance-locationPrepaymentSum',
        path: '/finance/locationPrepaymentSum',
        component: './finance/locationPrepaymentSum',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_PRE_RECEIVE_SUMMARY],
    },
    {
        name: 'stock-finance-locationFee',
        path: '/finance/locationFee',
        component: './finance/locationFee',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_FEE_SUMMARY],
    },
    {
        name: 'stock-finance-supplierPrepayment',
        path: '/finance/supplierPrepayment',
        routes: getRouteTabs$6({
            routes: supplierPrepayment,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_PRE_PAY],
        }),
    },
    {
        name: 'stock-finance-supplierExpense',
        path: '/finance/supplierExpense',
        routes: getRouteTabs$6({
            routes: supplierExpense,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_FEE],
        }),
    },
    {
        name: 'stock-finance-supplierSettlement',
        path: '/finance/supplierSettlement',
        routes: getRouteTabs$6({
            routes: supplierSettlement,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_SETTLEMENT_SUB],
        }),
    },
    {
        name: 'stock-finance-supplierDealings',
        path: '/finance/supplierDealings',
        component: './finance/supplierDealings',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_ACCOUNT_AMOUNT],
    },
    {
        name: 'stock-finance-supplierPrepaymentSum',
        path: '/finance/supplierPrepaymentSum',
        component: './finance/supplierPrepaymentSum',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_PRE_PAY_SUMMARY],
    },
    {
        name: 'stock-finance-supplierExpenseSummary',
        path: '/finance/supplierExpenseSummary',
        component: './finance/supplierExpenseSummary',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_FEE_SUMMARY],
    },
    {
        name: 'stock-finance-costProject',
        path: '/finance/costProject',
        routes: getRouteTabs$6({
            routes: costProject,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_FINANCE_FEE_ITEM],
        }),
    },
];

/**
 * 报表中心路由配置
 * 使用独立的 /report/* 路径前缀，避免与业务模块冲突
 */
var reportManager = [
    // ==================== 配送报表 ====================
    {
        name: 'distribution-manager-report',
        path: '/report/orders',
        routes: [
            {
                name: 'stock-report-transiGoods',
                path: '/report/orders/transiGoods',
                component: './orders/transiGoods',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_CHAIN_PRODUCT_IN_TRANSIT],
            },
            {
                name: 'stock-report-requestOrderStatusList',
                path: '/report/orders/requestOrderStatusList',
                component: './orders/requestOrderStatusList',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_CHAIN_REQUEST_ORDER_COMMIT_STATE],
            },
            {
                name: 'stock-report-transferReportsTrack',
                path: '/report/orders/transferReportsTrack',
                component: './orders/transferReportsTrack',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_TRANSFER_TRACK],
            },
        ],
    },
    // ==================== 采购报表 ====================
    {
        name: 'purchasing-manager-report',
        path: '/report/purchasing',
        routes: [
            {
                name: 'stock-report-purchaseSummaryDetails',
                path: '/report/purchasing/summaryDetails',
                component: './purchasing/summaryDetails',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_PURCHASE_SUMMARY_DETAIL],
            },
            {
                name: 'stock-report-purchaseMonitor',
                path: '/report/purchasing/monitor',
                component: './purchasing/monitor',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_PURCHASE_ORDER_MONITOR],
            },
            {
                name: 'stock-report-directOrderDetails',
                path: '/report/purchasing/directOrderDetails',
                component: './purchasing/directOrderDetails',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_PURCHASE_ORDER_SUPPLIER_SHIPMENT_DETAIL],
            },
        ],
    },
    // ==================== 生产报表 ====================
    {
        name: 'process-manager-report',
        path: '/report/process',
        routes: [
            {
                name: 'stock-report-materialAnalysisReport',
                path: '/report/process/materialAnalysisReport',
                component: './process/materialAnalysisReport',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_PRODUCE_MATERIAL_USE_ANALYZE],
            },
            {
                name: 'stock-report-expectedYieldReport',
                path: '/report/process/expectedYieldReport',
                component: './process/expectedYieldReport',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_SHOULD_PRODUCE_RATE_ANALYZE],
            },
            {
                name: 'stock-report-processSummaryReport',
                path: '/report/process/processSummaryReport',
                component: './process/processSummaryReport',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_PROCESS_RATE],
            },
            {
                name: 'stock-report-processStaffReport',
                path: '/report/process/processStaffReport',
                component: './process/processStaffReport',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCE_OPERATOR_PRODUCE_SUMMARY],
            },
        ],
    },
    // ==================== 库存报表 ====================
    {
        name: 'inventory-manager-report',
        path: '/report/check',
        routes: [
            {
                name: 'stock-report-goodsInventory',
                path: '/report/check/goodsInventory',
                component: './document/goodsInventory',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_PRODUCT_STOCK],
            },
            {
                name: 'stock-report-entryExitDetails',
                path: '/report/check/entryExitDetails',
                component: './document/entryExitDetails',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_FILES_PRODUCT_IN_OUT_DETAIL],
            },
            {
                name: 'stock-report-entryStockSummary',
                path: '/report/check/entryStockSummary',
                component: './document/entryStockSummary',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_IN_SUMMARY],
            },
            {
                name: 'stock-report-exitStockSummary',
                path: '/report/check/exitStockSummary',
                component: './document/exitStockSummary',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_OUT_SUMMARY],
            },
            {
                name: 'stock-report-entryExitSummary',
                path: '/report/check/entryExitSummary',
                component: './document/entryExitSummary',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_IN_OUT_SUMMARY],
            },
            {
                name: 'stock-report-statisticsOfChange',
                path: '/report/check/statisticsOfChange',
                component: './document/statisticsOfChange',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_STATISTICS_OF_CHANGE],
            },
            {
                name: 'stock-report-profitLossReport',
                path: '/report/check/profitLossReport',
                component: './document/profitLossReport',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_GAIN_LOSS_REPORT],
            },
            {
                name: 'stock-report-stockInterrupt',
                path: '/report/check/stockInterrupt',
                component: './document/stockInterrupt',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_INTERRUPT_INVENTORY_REPORT],
            },
            {
                name: 'stock-report-inventoryWarn',
                path: '/report/check/inventoryWarn',
                component: './document/inventoryWarn',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_WARN_INVENTORY_REPORT],
            },
            {
                name: 'stock-report-inventoryTurnoverRate',
                path: '/report/check/inventoryTurnoverRate',
                component: './document/inventory-turnover-rate',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_STOCK_INVENTORY_TURNOVER_RATE],
            },
        ],
    },
    // ==================== 财务报表 ====================
    {
        name: 'finance-manager-report',
        path: '/report/finance',
        routes: [
            {
                name: 'stock-report-distributionGrossProfit',
                path: '/report/finance/distributionGrossProfit',
                component: './orders/distributionGrossProfit',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_CHAIN_DISTRIBUTION_GROSS_PROFIT],
            },
            {
                name: 'stock-report-locationGrossProfit',
                path: '/report/finance/locationGrossProfit',
                component: './orders/locationGrossProfit',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_LOCATION_DISTRIBUTION_GROSS_PROFIT],
            },
            {
                name: 'stock-report-productGrossProfit',
                path: '/report/finance/productGrossProfit',
                component: './orders/productGrossProfit',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_GROSS_PROFIT],
            },
            {
                name: 'stock-report-locationGrossProfitDiff',
                path: '/report/finance/locationGrossProfitDiff',
                component: './orders/locationGrossProfitDiff',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_LOCATION_PRODUCT_GROSS_CONTRAST],
            },
            {
                name: 'stock-report-productCostDetail',
                path: '/report/finance/productCostDetail',
                component: './orders/productCostDetail',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_ITEM_COST_DETAIL],
            },
        ],
    },
    // ==================== 客户销售报表 ====================
    {
        name: 'customer-wholesales-report',
        path: '/report/customerSales',
        routes: [
            {
                name: 'stock-report-customerItemsSalesQuery',
                path: '/report/customerSales/itemsSalesQuery',
                component: './wholesale-manager/items-sales-query',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_WHOLESALE_REPORT],
            },
        ],
    },
];

/*
 * @Author: 刘欢
 * @Date: 2024-03-12 16:59:06
 * @LastEditTime: 2025-01-23 16:59:01
 * @Description: 档案路由
 */
var requestDocumentPaths = [
    {
        name: 'stock-document-itemFile',
        path: '/document/product',
        component: './document/product',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product?tabs=3',
        component: './document/product',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product?tabs=2',
        component: './document/product',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product/productStorage',
        component: './document/product/productStorage',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product/productStorage/addProduct/:categoryId',
        component: './document/product/productStorage/modifyProduct',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product/productStorage/addProduct',
        component: './document/product/productStorage/modifyProduct',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product/productStorage/modifyProduct/edit/:id/:locationId',
        component: './document/product/productStorage/modifyProduct',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemFile',
        path: '/document/product/productStorage/readProduct/:type/:id/:locationId',
        component: './document/product/productStorage/modifyProduct',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 刘欢
 * @Date: 2024-03-12 16:59:06
 * @LastEditTime: 2024-05-30 14:28:08
 * @Description: 档案路由
 */
var requestVirtualItemPaths = [
    {
        name: 'stock-document-virtualItem',
        path: '/document/virtualItem',
        component: './document/product/virtualItem',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-virtualItem',
        path: '/document/virtualItem/editProduct/:id',
        component: './document/product/virtualItem/modifyVirtualItem',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-virtualItem',
        path: '/document/virtualItem/addProduct',
        component: './document/product/virtualItem/modifyVirtualItem',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 刘欢
 * @Date: 2024-03-12 16:59:06
 * @LastEditTime: 2024-05-30 14:28:08
 * @Description: 档案路由
 */
var requestCompleteItemPaths = [
    {
        name: 'stock-document-completeItem',
        path: '/document/completeItem',
        component: './document/product/completeManagement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-completeItem',
        path: '/document/completeItem/editProduct/:id',
        component: './document/product/completeManagement/modifyCompleteManagement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-completeItem',
        path: '/document/completeItem/addProduct',
        component: './document/product/completeManagement/modifyCompleteManagement',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 张丛
 * @Date: 2024-04-10 21:14:36
 * @LastEditTime: 2024-05-22 15:06:18
 * @Description: 成本卡路由
 */
var costCard = [
    {
        name: 'stock-document-costCard',
        path: '/document/costCard',
        component: './document/costCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/distributionManagement',
        component: './document/costCard/components/DistributionManagement',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/add',
        component: './document/costCard/components/AddCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/read/:id/:type',
        component: './document/costCard/components/AddCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/edit/:id',
        component: './document/costCard/components/AddCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/copy/:copyId',
        component: './document/costCard/components/AddCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/product/read/:id/:type',
        component: './document/costCard/components/AddProductCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/product/add',
        component: './document/costCard/components/AddProductCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/product/edit/:id',
        component: './document/costCard/components/AddProductCostCard',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard/product/copy/:copyId',
        component: './document/costCard/components/AddProductCostCard',
        microApp: 'stock-app',
    },
];

var storehouse = [
    {
        name: 'stock-document-storehouseFile',
        path: '/document/store',
        component: './document/store',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-storehouseFile',
        path: '/document/store/new',
        component: './document/store/modifyRequestStore',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-storehouseFile',
        path: '/document/store/modifyRequestStore/edit/:storehouse_num/:location_id',
        component: './document/store/modifyRequestStore',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-storehouseFile',
        path: '/document/store/readRequestStore/read/:storehouse_num/:location_id',
        component: './document/store/readRequestStore',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵康
 * @Date: 2024-07-17 16:59:06
 * @LastEditTime: 2024-07-17 16:59:06
 * @Description: 仓库物品规则路由
 */
var requestDocumentItemRule = [
    {
        name: 'stock-item-rule',
        path: '/document/stockItemRule',
        component: './document/stockItemRule',
        microApp: 'stock-app',
    },
    {
        name: 'stock-item-rule',
        path: '/document/stockItemRule/:id',
        component: './document/stockItemRule/detail',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 18:50:30
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 18:50:48
 * @Description: file content
 */
var queryTemplate = [
    {
        name: 'stock-document-queryTemplate',
        path: '/document/productQueryTemplate',
        component: './document/productQueryTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-queryTemplate',
        path: '/document/productQueryTemplate/new',
        component: './document/productQueryTemplate/modifyTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-queryTemplate',
        path: '/document/productQueryTemplate/edit/:id',
        component: './document/productQueryTemplate/modifyTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-queryTemplate',
        path: '/document/productQueryTemplate/copy/:copyId',
        component: './document/productQueryTemplate/modifyTemplate',
        microApp: 'stock-app',
    },
];

var itemCornerLabel = [
    {
        name: 'stock-document-itemCornerLabel',
        path: '/document/itemCornerLabel',
        component: './document/itemCornerLabel',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemCornerLabel',
        path: '/document/itemCornerLabel/detail',
        component: './document/itemCornerLabel/itemCornerLabelDetail',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 陈力恒
 * @Date: 2022-03-17 17:24:05
 * @LastEditors: 陈力恒
 * @LastEditTime: 2022-03-21 18:30:46
 * @Description: 供应商路由
 */
var supplier = [
    {
        name: 'stock-purchase-supplier',
        path: '/purchasing/supplier',
        component: './purchasing/supplier',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplier',
        path: '/purchasing/supplier/new/:locationId',
        component: './purchasing/supplier/modifySupplier',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplier',
        path: '/purchasing/supplier/edit/:id/:locationId',
        component: './purchasing/supplier/modifySupplier',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplier',
        path: '/purchasing/supplier/read/:id/:locationId/:type',
        component: './purchasing/supplier/modifySupplier',
        microApp: 'stock-app',
    },
];

var wholesaleCustomer = [
    {
        name: 'stock-wholesale-customer',
        path: '/wholesale-customer/customer',
        component: './configuration-manager/wholesale-customer/customer',
        microApp: 'stock-app',
    },
    {
        name: 'stock-wholesale-customer',
        path: '/wholesale-customer/customer/new/:locationId',
        component: './configuration-manager/wholesale-customer/customer/detail',
        microApp: 'stock-app',
    },
    {
        name: 'stock-wholesale-customer',
        path: '/wholesale-customer/customer/edit/:id/:locationId',
        component: './configuration-manager/wholesale-customer/customer/detail',
        microApp: 'stock-app',
    },
    {
        name: 'stock-wholesale-customer',
        path: '/wholesale-customer/customer/read/:id/:locationId/:type',
        component: './configuration-manager/wholesale-customer/customer/detail',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:13:25
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:13:59
 * @Description: file content
 */
var supplierUser = [
    //供应商用户
    {
        name: 'stock-purchase-supplierUser',
        path: '/purchasing/supplierUser',
        component: './purchasing/supplierUser',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplierUser',
        path: '/purchasing/supplierUser/new',
        component: './purchasing/supplierUser/modifySupplier',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplierUser',
        path: '/purchasing/supplierUser/edit/:id',
        component: './purchasing/supplierUser/modifySupplier',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplierUser',
        path: '/purchasing/supplierUser/read/:id',
        component: './purchasing/supplierUser/modifySupplier',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-01-13 19:13:40
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-01-13 19:14:14
 * @Description: file content
 */
var supplierUserRole = [
    //供应商用户角色
    {
        name: 'stock-purchase-supplierUserRole',
        path: '/purchasing/supplierUserRole',
        component: './purchasing/supplierUserRole',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplierUserRole',
        path: '/purchasing/supplierUserRole/new',
        component: './purchasing/supplierUserRole/modifySupplierRole',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplierUserRole',
        path: '/purchasing/supplierUserRole/edit/:id',
        component: './purchasing/supplierUserRole/modifySupplierRole',
        microApp: 'stock-app',
    },
    {
        name: 'stock-purchase-supplierUserRole',
        path: '/purchasing/supplierUserRole/read/:id',
        component: './purchasing/supplierUserRole/modifySupplierRole',
        microApp: 'stock-app',
    },
];

/*
 * @Author: 赵泽文
 * @Date: 2025-11-04 11:27:39
 * @LastEditors: 赵泽文
 * @LastEditTime: 2025-11-04 14:23:24
 * @Description: file content
 */
var priceLogs = [
    {
        name: 'stock-document-priceLogs',
        path: '/document/priceLogs',
        component: './document/priceLogs',
        microApp: 'stock-app',
    },
];

var itemReplace = [
    {
        name: 'stock-document-itemReplace',
        path: '/document/itemReplace',
        component: './document/itemReplace',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemReplace',
        path: '/document/itemReplace/add',
        component: './document/itemReplace/ModifyItemReplace',
        microApp: 'stock-app',
    },
    {
        name: 'stock-document-itemReplace',
        path: '/document/itemReplace/edit/:id',
        component: './document/itemReplace/ModifyItemReplace',
        microApp: 'stock-app',
    },
];

const getRouteTabs$5 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var configurationManager = [
    {
        name: 'stock-document-itemFile',
        path: '/document/product',
        routes: getRouteTabs$5({
            routes: requestDocumentPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_RPODUCT_FILES],
        }),
    },
    {
        name: 'stock-document-virtualItem',
        path: '/document/virtualItem',
        routes: getRouteTabs$5({
            routes: requestVirtualItemPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_VIRTUAL_ITEM],
        }),
    },
    {
        name: 'stock-document-completeItem',
        path: '/document/completeItem',
        routes: getRouteTabs$5({
            routes: requestCompleteItemPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_PRODUCT_VARIANT_MATERIAL],
        }),
    },
    {
        name: 'stock-document-priceLogs',
        path: '/document/priceLogs',
        routes: getRouteTabs$5({
            routes: priceLogs,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_ITEM_PRICE_LOG],
        }),
    },
    {
        name: 'stock-wholesale-customer',
        path: '/wholesale-customer/customer',
        routes: getRouteTabs$5({
            routes: wholesaleCustomer,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_WHOLESALE_CUSTOMER_FILE],
        }),
    },
    {
        name: 'stock-purchase-supplier',
        path: '/purchasing/supplier',
        routes: getRouteTabs$5({
            routes: supplier,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER],
        }),
    },
    {
        name: 'stock-purchase-supplierUser',
        path: '/purchasing/supplierUser',
        routes: getRouteTabs$5({
            routes: supplierUser,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_USER],
        }),
    },
    {
        name: 'stock-purchase-supplierUserRole',
        path: '/purchasing/supplierUserRole',
        routes: getRouteTabs$5({
            routes: supplierUserRole,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_ROLE],
        }),
    },
    {
        name: 'stock-purchase-supplierWechatUnbind',
        path: '/purchasing/supplierWechatUnbind',
        component: './purchasing/supplierWechatUnbind',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_SUPPLIER_WECHAT_UNBIND],
    },
    {
        name: 'stock-document-costCard',
        path: '/document/costCard',
        routes: getRouteTabs$5({
            routes: costCard,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_COST_CARD],
        }),
    },
    {
        name: 'stock-document-itemReplace',
        path: '/document/itemReplace',
        routes: getRouteTabs$5({
            routes: itemReplace,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_REPLACE_ITEM],
        }),
    },
    {
        name: 'stock-document-storehouseFile',
        path: '/document/store',
        routes: getRouteTabs$5({
            routes: storehouse,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_FILES_WAREHOUSE_FILES],
        }),
    },
    {
        name: 'stock-item-rule',
        path: '/document/stockItemRule',
        routes: getRouteTabs$5({
            routes: requestDocumentItemRule,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_WAREHOUSE_ITEM_RULES],
        }),
    },
    {
        name: 'stock-document-queryTemplate',
        path: '/document/productQueryTemplate',
        routes: getRouteTabs$5({
            routes: queryTemplate,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_ITEM_QUERY_TMPL],
        }),
    },
    {
        name: 'stock-document-itemCornerLabel',
        path: '/document/itemCornerLabel',
        routes: getRouteTabs$5({
            routes: itemCornerLabel,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_ITEM_CORNER_MARK],
        }),
    },
];

var printTemplatePaths = [
    {
        name: 'stock-settings-printTemplate',
        path: '/settings/printTemplate',
        component: './appSettings/printTemplate',
        microApp: 'stock-app',
    },
    {
        name: 'stock-settings-printTemplate',
        path: '/settings/printTemplate/detail',
        component: './appSettings/printTemplate/detail',
        microApp: 'stock-app',
    },
];

var locationCopyPaths = [
    {
        name: 'stock-settings-locationCopy',
        path: '/settings/locationCopy',
        component: './appSettings/locationCopy',
        microApp: 'stock-app',
    },
    {
        name: 'stock-settings-locationCopy',
        path: '/settings/locationCopy/add',
        component: './appSettings/locationCopy/ModifyLocationCopy',
        microApp: 'stock-app',
    },
    {
        name: 'stock-settings-locationCopy',
        path: '/settings/locationCopy/:id',
        component: './appSettings/locationCopy/ModifyLocationCopy',
        microApp: 'stock-app',
    },
];

const getRouteTabs$4 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var systemSettings = [
    {
        name: 'stock-settings-base',
        path: '/settings/base',
        component: './appSettings/baseSettings',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PARENT_PERMISSION_STOCK_SETTING],
    },
    {
        name: 'stock-settings-printTemplate',
        path: '/settings/printTemplate',
        routes: getRouteTabs$4({
            routes: printTemplatePaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_SETTING_PRINT_TMPL],
        }),
    },
    {
        name: 'stock-settings-appProductSetting',
        path: '/settings/appProductSetting',
        component: './appSettings/appProductSetting',
        microApp: 'stock-app',
        category: 'SUPPLY_CHAIN',
        code_key: [IPermissonCode.PERMISSION_STOCK_APP_ITEM_LIST_SETTING],
    },
    {
        name: 'stock-settings-locationCopy',
        path: '/settings/locationCopy',
        routes: getRouteTabs$4({
            routes: locationCopyPaths,
            category: 'SUPPLY_CHAIN',
            code_key: [IPermissonCode.PERMISSION_STOCK_LOCATION_SYNC],
        }),
    },
    {
        name: 'stock-settings-couplerSettings',
        path: '/settings/couplerSettings',
        routes: [
            {
                name: 'stock-settings-couplerSettings-productSync',
                path: '/settings/couplerSettings/productSync',
                component: './appSettings/couplerSettings/productSync',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_APP_EARTH_BRIDGE],
            },
            {
                name: 'stock-settings-couplerSettings-earthLocation',
                path: '/settings/couplerSettings/earthLocation',
                component: './appSettings/couplerSettings/earthLocation',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_APP_EARTH_BRIDGE_LOCATION],
            },
            {
                name: 'stock-settings-couplerSettings-transferOrder',
                path: '/settings/couplerSettings/transferOrder',
                component: './appSettings/couplerSettings/transferOrder',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_APP_EARTH_BRIDGE_ORDER_LOG],
            },
            {
                name: 'stock-settings-couplerSettings-authorization',
                path: '/settings/couplerSettings/authorization',
                component: './appSettings/couplerSettings/authorization',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_APP_EARTH_BRIDGE_AUTH],
            },
            {
                name: 'stock-settings-couplerSettings-retailSupplyChainSetting',
                path: '/settings/couplerSettings/retailSupplyChainSetting',
                component: './appSettings/couplerSettings/retailSupplyChainSetting',
                microApp: 'stock-app',
                category: 'SUPPLY_CHAIN',
                code_key: [IPermissonCode.PERMISSION_EARTH_CHAIN_SETTING],
            },
        ],
    },
];

const getRouteTabs$3 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var wholesaleManager = getRouteTabs$3({
    routes: [
        {
            name: 'stock-wholesale-sale-order',
            path: '/wholesale-manager/sale-order',
            component: './wholesale-manager/sale-order',
        },
        {
            name: 'stock-wholesale-sale-order',
            path: '/wholesale-manager/sale-order/add',
            component: './wholesale-manager/sale-order/detail',
        },
        {
            name: 'stock-wholesale-sale-order',
            path: '/wholesale-manager/sale-order/edit/:id',
            component: './wholesale-manager/sale-order/detail',
        },
        {
            name: 'stock-wholesale-sale-order',
            path: '/wholesale-manager/sale-order/copy/:id',
            component: './wholesale-manager/sale-order/detail',
        },
        {
            name: 'stock-wholesale-sale-order',
            path: '/wholesale-manager/sale-order/read/:id',
            component: './wholesale-manager/sale-order/detail',
        },
        {
            name: 'stock-wholesale-quote-order',
            path: '/wholesale-manager/quote-order',
            component: './wholesale-manager/quote-order',
        },
        {
            name: 'stock-wholesale-quote-order',
            path: '/wholesale-manager/quote-order/add',
            component: './wholesale-manager/quote-order/detail',
        },
        {
            name: 'stock-wholesale-quote-order',
            path: '/wholesale-manager/quote-order/edit/:id',
            component: './wholesale-manager/quote-order/detail',
        },
        {
            name: 'stock-wholesale-quote-order',
            path: '/wholesale-manager/quote-order/copy/:id',
            component: './wholesale-manager/quote-order/detail',
        },
        {
            name: 'stock-wholesale-quote-order',
            path: '/wholesale-manager/quote-order/read/:id',
            component: './wholesale-manager/quote-order/detail',
        },
        {
            name: 'stock-wholesale-return-order',
            path: '/wholesale-manager/return-order',
            component: './wholesale-manager/return-order',
        },
        {
            name: 'stock-wholesale-return-order',
            path: '/wholesale-manager/return-order/add',
            component: './wholesale-manager/return-order/detail',
        },
        {
            name: 'stock-wholesale-return-order',
            path: '/wholesale-manager/return-order/edit/:id',
            component: './wholesale-manager/return-order/detail',
        },
        {
            name: 'stock-wholesale-return-order',
            path: '/wholesale-manager/return-order/copy/:id',
            component: './wholesale-manager/return-order/detail',
        },
        {
            name: 'stock-wholesale-return-order',
            path: '/wholesale-manager/return-order/read/:id',
            component: './wholesale-manager/return-order/detail',
        },
    ],
    category: 'SUPPLY_CHAIN',
});

const getRouteTabs$2 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
    microApp: 'stock-app',
}));
var kingdee = getRouteTabs$2({
    routes: [
        {
            name: 'stock-kingdee-branchBind',
            path: '/kingdee/branchBind',
            component: './kingdee/branchBind',
        },
        {
            name: 'stock-kingdee-productSync',
            path: '/kingdee/productSync',
            component: './kingdee/productSync',
        },
    ],
    category: 'SUPPLY_CHAIN',
});

const stock = [
    ...distributionManager,
    ...purchasingManager,
    ...processManager,
    ...inventoryManager,
    ...financeManager,
    ...reportManager,
    ...configurationManager,
    ...systemSettings,
    ...wholesaleManager,
    ...kingdee,
];

const saleRoutes = [
    {
        name: 'main-operations-anyChoice',
        path: '/main-operations/promotion/marketingActivities/anyChoice/copy',
        component: './main-operations/marketingActivities/anyChoice/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-anyChoice',
        path: '/main-operations/promotion/marketingActivities/anyChoice',
        component: './main-operations/marketingActivities/anyChoice/list',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-anyChoice',
        path: '/main-operations/promotion/marketingActivities/anyChoice/data',
        component: './main-operations/marketingActivities/anyChoice/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-anyChoice',
        path: '/main-operations/promotion/marketingActivities/anyChoice/detail',
        component: './main-operations/marketingActivities/anyChoice/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-anyChoice',
        path: '/main-operations/promotion/marketingActivities/anyChoice/read',
        component: './main-operations/marketingActivities/anyChoice/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-reduceFreight',
        path: '/main-operations/promotion/marketingActivities/reduceFreight/copy',
        component: './main-operations/marketingActivities/reduceFreight/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-reduceFreight',
        path: '/main-operations/promotion/marketingActivities/reduceFreight',
        component: './main-operations/marketingActivities/reduceFreight/list',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-reduceFreight',
        path: '/main-operations/promotion/marketingActivities/reduceFreight/data',
        component: './main-operations/marketingActivities/reduceFreight/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-reduceFreight',
        path: '/main-operations/promotion/marketingActivities/reduceFreight/detail',
        component: './main-operations/marketingActivities/reduceFreight/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-reduceFreight',
        path: '/main-operations/promotion/marketingActivities/reduceFreight/read',
        component: './main-operations/marketingActivities/reduceFreight/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendProduct',
        path: '/main-operations/crm/marketingActivities/recommendProduct/copy',
        component: './main-operations/marketingActivities/recommendProduct/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendProduct',
        path: '/main-operations/crm/marketingActivities/recommendProduct',
        component: './main-operations/marketingActivities/recommendProduct',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendProduct',
        path: '/main-operations/crm/marketingActivities/recommendProduct/data',
        component: './main-operations/marketingActivities/recommendProduct/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendProduct',
        path: '/main-operations/crm/marketingActivities/recommendProduct/detail',
        component: './main-operations/marketingActivities/recommendProduct/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendProduct',
        path: '/main-operations/crm/marketingActivities/recommendProduct/read',
        component: './main-operations/marketingActivities/recommendProduct/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendProduct',
        path: '/main-operations/crm/marketingActivities/recommendProduct/copy',
        component: './main-operations/marketingActivities/recommendProduct/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-collectStampList',
        path: '/main-operations/crm/marketingActivities/collectStampList',
        component: './main-operations/marketingActivities/collectStampList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-collectStampList',
        path: '/main-operations/crm/marketingActivities/collectStampList/data',
        component: './main-operations/marketingActivities/collectStampList/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-collectStampList',
        path: '/main-operations/crm/marketingActivities/collectStampList/detail',
        component: './main-operations/marketingActivities/collectStampList/collectStamp',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-collectStampList',
        path: '/main-operations/crm/marketingActivities/collectStampList/read',
        component: './main-operations/marketingActivities/collectStampList/collectStamp',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-collectStampList',
        path: '/main-operations/crm/marketingActivities/collectStampList/copy',
        component: './main-operations/marketingActivities/collectStampList/collectStamp',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-funGame',
        path: '/main-operations/crm/marketingActivities/funGame',
        component: './main-operations/marketingActivities/funGame',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-funGame',
        path: '/main-operations/crm/marketingActivities/funGame/guess/data/:id',
        component: './main-operations/marketingActivities/funGame/guess/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-funGame',
        path: '/main-operations/crm/marketingActivities/funGame/guess/:id',
        component: './main-operations/marketingActivities/funGame/guess/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-funGame',
        path: '/main-operations/crm/marketingActivities/funGame/game/maintainResult/:id',
        component: './main-operations/marketingActivities/funGame/game/maintainResult',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-funGame',
        path: '/main-operations/crm/marketingActivities/funGame/game/:id',
        component: './main-operations/marketingActivities/funGame/game/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-randomFullReduce',
        path: '/main-operations/promotion/marketingActivities/randomFullReduce',
        component: './main-operations/marketingActivities/randomFullReduce/list',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-randomFullReduce',
        path: '/main-operations/promotion/marketingActivities/randomFullReduce/data',
        component: './main-operations/marketingActivities/randomFullReduce/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-randomFullReduce',
        path: '/main-operations/promotion/marketingActivities/randomFullReduce/detail',
        component: './main-operations/marketingActivities/randomFullReduce/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-randomFullReduce',
        path: '/main-operations/promotion/marketingActivities/randomFullReduce/read',
        component: './main-operations/marketingActivities/randomFullReduce/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-randomFullReduce',
        path: '/main-operations/promotion/marketingActivities/randomFullReduce/copy',
        component: './main-operations/marketingActivities/randomFullReduce/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE],
        category: 'MARKETING_CENTER',
    },
    // #region 下个模块
    {
        name: 'main-operations-validity',
        path: '/main-operations/EXPGoods',
        component: './main-operations/expProduct',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_VALIDITY_PRODUCT],
    },
    {
        name: 'main-operations-validity',
        path: '/main-operations/EXPGoods/new',
        component: './main-operations/expProduct/modifyExpProduct',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_VALIDITY_PRODUCT],
    },
    {
        name: 'main-operations-validity',
        path: '/main-operations/EXPGoods/:id',
        component: './main-operations/expProduct/modifyExpProduct',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_VALIDITY_PRODUCT],
    },
    {
        name: 'main-operations-storageCondition',
        path: '/main-operations/storageCondition',
        component: './main-operations/storageCondition',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_VALIDITY_STORAGE_CONDITION],
    },
    {
        name: 'main-operations-EXPBoard',
        path: '/main-operations/EXPBoard',
        component: './main-operations/expBoard',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_VALIDITY_BOARD],
    },
    {
        name: 'main-operations-EXPCollect',
        path: '/main-operations/EXPCollect',
        component: './main-operations/expCollect',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_VALIDITY_SUMMARY],
    },
    {
        name: 'main-operations-kdsSettings',
        path: '/main-operations/kdsSettings',
        component: './main-operations/kdsSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_WIN_KDS],
    },
    {
        name: 'main-operations-kdsDeviceManagement',
        path: '/main-operations/kdsDeviceManagement',
        component: './main-operations/kdsDeviceManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_KDS_DEVICE],
    },
    {
        name: 'main-operations-kdsSettings',
        path: '/main-operations/kdsSettings/:id/:type',
        component: './main-operations/kdsSettings/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_WIN_KDS],
    },
    {
        name: 'main-operations-kdsSettings',
        path: '/main-operations/kdsSettings/copy/:id/:type',
        component: './main-operations/kdsSettings/detailCopy',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_WIN_KDS],
    },
    {
        name: 'main-operations-queueSettings',
        path: '/main-operations/queueSettings',
        component: './main-operations/queueSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE],
    },
    {
        name: 'main-operations-QRCodeManagement',
        path: '/main-operations/QRCodeManagement',
        component: './main-operations/QRCodeManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE],
    },
    {
        name: 'main-operations-QRCodeManagement',
        path: '/main-operations/QRCodeManagement/emptyQRCode',
        component: './main-operations/QRCodeManagement/emptyQRCode',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE],
    },
    {
        name: 'main-operations-QRCodeManagement',
        path: '/main-operations/QRCodeManagement/tableQRCode',
        component: './main-operations/QRCodeManagement/tableQRCode',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE],
    },
    {
        name: 'main-operations-tvSettings',
        path: '/main-operations/settings/tvSettings',
        component: './main-operations/settings/tvSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_TAKE_SCREEN],
    },
    {
        name: 'main-operations-tvSettings',
        path: '/main-operations/settings/tvSettings/detail/:id/:title',
        component: './main-operations/settings/tvSettings/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_TAKE_SCREEN],
    },
    {
        name: 'main-operations-tvSettings',
        path: '/main-operations/settings/tvSettings/detail',
        component: './main-operations/settings/tvSettings/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_TAKE_SCREEN],
    },
    {
        name: 'main-operations-tvSettings',
        path: '/main-operations/settings/tvSettings/design',
        component: './main-operations/settings/tvSettings/design',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_TAKE_SCREEN],
    },
    {
        name: 'main-operations-tvScreenDevice',
        path: '/main-operations/tvScreenDevice',
        component: './main-operations/tvScreenDevice',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_TV_DEVICE],
    },
    {
        name: 'main-operations-cake-decorator',
        path: '/main-operations/settings/cakeDecorator',
        component: './main-operations/settings/cakeDecorator',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_TAKE_SCREEN],
    },
    {
        name: 'main-operations-brandName',
        path: '/main-operations/brandName',
        component: './main-operations/brandName',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_VENDOR_MANAGER],
    },
    {
        name: 'main-operations-evaluationSettings',
        path: '/main-operations/settings/evaluationSettings',
        component: './main-operations/settings/evaluationSettings',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SETTING_EVALUATION_SETTING],
    },
    {
        name: 'main-operations-evaluationSettings',
        path: '/main-operations/settings/evaluationSettings/detail',
        component: './main-operations/settings/evaluationSettings/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SETTING_EVALUATION_SETTING],
    },
    {
        name: 'main-operations-printingBusiness',
        path: '/main-operations/printingBusiness',
        component: './main-operations/printingBusiness',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_BUSINESS],
    },
    {
        name: 'main-operations-printingBusiness',
        path: '/main-operations/printingBusiness/:id',
        component: './main-operations/printingBusiness/copy',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_BUSINESS],
    },
    {
        name: 'main-operations-serviceFee',
        path: '/main-operations/serviceFee',
        component: './main-operations/serviceFee',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_BUSINESS_SERVICE_FEE],
    },
    {
        name: 'main-operations-serviceFee',
        path: '/main-operations/serviceFee/detail/:id',
        component: './main-operations/serviceFee/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_BUSINESS_SERVICE_FEE],
    },
    {
        name: 'main-operations-billScanningCode',
        path: '/main-operations/settings/billScanningCode',
        component: './main-operations/settings/billScanningCode',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SCAN_CODE_PAY],
    },
    {
        name: 'main-operations-billScanningCode',
        path: '/main-operations/settings/billScanningCode/new',
        component: './main-operations/settings/billScanningCode/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SCAN_CODE_PAY],
    },
    {
        name: 'main-operations-billScanningCode',
        path: '/main-operations/settings/billScanningCode/detail',
        component: './main-operations/settings/billScanningCode/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SCAN_CODE_PAY],
    },
    {
        name: 'main-operations-stagepositionSettings',
        path: '/main-operations/stagepositionSettings',
        component: './main-operations/stagepositionSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_TABLE],
    },
    {
        name: 'main-operations-stagepositionSettings',
        path: '/main-operations/stagepositionSettings/feeDetail/:id',
        component: './main-operations/stagepositionSettings/components/feeDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_TABLE],
    },
    {
        name: 'main-operations-equipmentSettings',
        path: '/main-operations/equipmentSettings',
        component: './main-operations/equipmentSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_WEB_POS_TERMINAL],
    },
    {
        name: 'main-operations-printerManagement',
        path: '/main-operations/printerManagement',
        component: './main-operations/printerManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRINT_DEVICE],
    },
    {
        name: 'main-operations-equipmentSettings',
        path: '/main-operations/equipmentSettings/createPos',
        component: './main-operations/equipmentSettings/components/posTableDetail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_POS_TERMINAL,
            IPermissonCode.PERMISSION_KDS_DEVICE,
            IPermissonCode.PERMISSION_TV_DEVICE,
        ],
    },
    {
        name: 'main-operations-equipmentSettings',
        path: '/main-operations/equipmentSettings/ruleSetting',
        component: './main-operations/equipmentSettings/components/ruleSetting',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRINT_DEVICE],
    },
    {
        name: 'main-operations-equipmentSettings',
        path: '/main-operations/equipmentSettings/copyPos',
        component: './main-operations/equipmentSettings/components/posTableCopyDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_WEB_POS_TERMINAL],
    },
    {
        name: 'main-operations-cloud-speaker-management',
        path: '/main-operations/cloud-speaker/cloud-speaker-management',
        component: './main-operations/cloud-speaker/cloud-speaker-management',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_CLOUD_SPEAKER],
    },
    {
        name: 'main-operations-cloud-speaker-group',
        path: '/main-operations/cloud-speaker/cloud-speaker-group',
        component: './main-operations/cloud-speaker/cloud-speaker-group',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_CLOUD_SPEAKER_GROUP,
            IPermissonCode.PERMISSION_DEVICE_GROUP_DETAIL,
        ],
    },
    {
        name: 'main-operations-cloud-speaker-rule',
        path: '/main-operations/cloud-speaker/cloud-speaker-rule',
        component: './main-operations/cloud-speaker/cloud-speaker-rule',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_CLOUD_SPEAKER_RULE,
            IPermissonCode.PERMISSION_VOICE_BROADCAST_DETAIL,
        ],
    },
    {
        name: 'main-operations-cloud-speaker-rule',
        path: '/main-operations/cloud-speaker/cloud-speaker-rule/detail/:id',
        component: './main-operations/cloud-speaker/cloud-speaker-rule/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_CLOUD_SPEAKER_RULE,
            IPermissonCode.PERMISSION_VOICE_BROADCAST_DETAIL,
        ],
    },
    {
        name: 'main-operations-locationCopy',
        path: '/main-operations/locationCopy',
        component: './main-operations/locationCopy',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION_DUPLICATE],
    },
    {
        name: 'main-operations-locationCopy',
        path: '/main-operations/locationCopy/:id',
        component: './main-operations/locationCopy/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION_DUPLICATE],
    },
    {
        name: 'main-operations-generalSettings',
        path: '/main-operations/settings/generalSettings',
        component: './main-operations/generalSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_MERCHANT_SETTING],
    },
    {
        name: 'main-operations-generalSettings',
        path: '/main-operations/settings/generalSettings/historyList',
        component: './main-operations/generalSettings/historyList',
        microApp: 'sale-app',
    },
    {
        name: 'main-operations-generalSettings',
        path: '/main-operations/settings/generalSettings/history',
        component: './main-operations/generalSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_MERCHANT_SETTING],
    },
    {
        name: 'main-operations-payTypeSetting',
        path: '/main-operations/settings/payType',
        component: './main-operations/payTypeSetting',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PAY],
    },
    {
        name: 'main-operations-payTypeSetting',
        path: '/main-operations/settings/payType/detail/:id',
        component: './main-operations/payTypeSetting/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PAY],
    },
    {
        name: 'main-operations-payTypeSetting',
        path: '/main-operations/settings/payType/detail',
        component: './main-operations/payTypeSetting/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PAY],
    },
    {
        name: 'main-operations-payTypeSetting',
        path: '/main-operations/settings/paySort',
        component: './main-operations/payTypeSetting/paySort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PAY],
    },
    {
        name: 'main-operations-vouchers',
        path: '/main-operations/settings/vouchers',
        component: './main-operations/vouchers',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_VOUCHER],
    },
    {
        name: 'main-operations-vouchers',
        path: '/main-operations/settings/vouchers/new',
        component: './main-operations/vouchers/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_VOUCHER],
    },
    {
        name: 'main-operations-vouchers',
        path: '/main-operations/settings/vouchers/copy',
        component: './main-operations/vouchers/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_VOUCHER],
    },
    {
        name: 'main-operations-vouchers',
        path: '/main-operations/settings/vouchers/read',
        component: './main-operations/vouchers/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_VOUCHER],
    },
    {
        name: 'main-operations-vouchers',
        path: '/main-operations/settings/vouchers/vouchersSort',
        component: './main-operations/vouchers/vouchersSort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_VOUCHER],
    },
    {
        name: 'main-operations-fileSettings',
        path: '/main-operations/fileSettings',
        component: './main-operations/fileSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_FILES],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings',
        component: './main-operations/businessSettings',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_OPERATE_SETTING_DINING_IN,
            IPermissonCode.PERMISSION_SETTING_SHIPPING_SELF_AND_TAKE_OUT,
            IPermissonCode.PERMISSION_OPERATE_SETTING_TAKE_OUT,
            IPermissonCode.PERMISSION_SETTING_SHIPPING_GROUP_MEAL,
            IPermissonCode.PERMISSION_OPERATE_SETTING_GROUP_MEAL_TAKE_OUT,
        ],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/dining',
        component: './main-operations/businessSettings/components/dining',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_DINING_IN],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/history/dining',
        component: './main-operations/businessSettings/components/dining',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_DINING_IN],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/singleDining',
        component: './main-operations/businessSettings/components/singleDining',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_DINING_IN],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/history/singleDining',
        component: './main-operations/businessSettings/components/singleDining',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_DINING_IN],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/pickup',
        component: './main-operations/businessSettings/components/pickup',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_SELF_AND_TAKE_OUT],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/history/pickup',
        component: './main-operations/businessSettings/components/pickup',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_SELF_AND_TAKE_OUT],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/takeout',
        component: './main-operations/businessSettings/components/takeout',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_TAKE_OUT],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/history/takeout',
        component: './main-operations/businessSettings/components/takeout',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_TAKE_OUT],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/groupPickup',
        component: './main-operations/businessSettings/components/groupPickup',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_GROUP_MEAL],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/history/groupPickup',
        component: './main-operations/businessSettings/components/groupPickup',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_GROUP_MEAL],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/groupTakeout',
        component: './main-operations/businessSettings/components/groupTakeout',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_GROUP_MEAL_TAKE_OUT],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/history/groupTakeout',
        component: './main-operations/businessSettings/components/groupTakeout',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_OPERATE_SETTING_GROUP_MEAL_TAKE_OUT],
    },
    {
        name: 'main-operations-businessSettings',
        path: '/main-operations/businessSettings/historyList',
        component: './main-operations/businessSettings/components/history',
        microApp: 'sale-app',
    },
    {
        name: 'main-operations-operatingParameter',
        path: '/main-operations/operatingParameter',
        component: './main-operations/operatingParameter',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_COMMON],
    },
    {
        name: 'main-operations-operatingParameter',
        path: '/main-operations/operatingParameter/:id',
        component: './main-operations/operatingParameter/copy',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_COMMON],
    },
    {
        name: 'main-operations-operatingParameter',
        path: '/main-operations/operatingParameter/history/list', // 总部设置历史记录
        component: './main-operations/operatingParameter/historyList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_COMMON],
    },
    {
        name: 'main-operations-operatingParameter',
        path: '/main-operations/operatingParameter/location/history/list/:id', // 门店设置历史记录
        component: './main-operations/operatingParameter/historyList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_SHIPPING_COMMON],
    },
    // #region 美团团购券
    {
        name: 'main-operations-meituanCoupon',
        path: '/main-operations/coupons/meituanCoupon',
        component: './main-operations/coupons/meituanCoupon',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_MT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayStore',
        path: '/main-operations/coupons/alipayStore',
        component: './main-operations/coupons/alipayStore',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_ALIPAY_LOCATION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayStore',
        path: '/main-operations/coupons/alipayStoreCoupon',
        component: './main-operations/coupons/alipayStoreCoupon',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_ALIPAY_LOCATION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayStore',
        path: '/main-operations/coupons/alipayStoreCoupon/detail',
        component: './main-operations/coupons/alipayCoupon/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_ALIPAY_LOCATION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayCoupon',
        path: '/main-operations/coupons/alipayCoupon',
        component: './main-operations/coupons/alipayCoupon',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayCoupon',
        path: '/main-operations/coupons/alipayCoupon/detail',
        component: './main-operations/coupons/alipayCoupon/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayCoupon',
        path: '/main-operations/coupons/alipayCoupon/issue',
        component: './main-operations/coupons/alipayCoupon/issue',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-alipayCoupon',
        path: '/main-operations/coupons/alipayCoupon/issueRecord/detail',
        component: './main-operations/coupons/alipayCoupon/issueRecord/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-douyinCoupon',
        path: '/main-operations/coupons/douyinCoupon',
        component: './main-operations/coupons/douyinCoupon',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_DY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-channelFlow-douyin-memberPass',
        path: '/main-operations/channelFlow/douyin/memberPass',
        component: './main-operations/channelFlow/douyin/memberPass',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DY_MEMBER_PASS],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-channelFlow-earth-memberPass',
        path: '/main-operations/channelFlow/earth/memberPass',
        component: './main-operations/channelFlow/earth/memberPass',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_RETAIL_MEMBER_PASS],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-koubeiCoupon',
        path: '/main-operations/coupons/koubeiCoupon',
        component: './main-operations/coupons/koubeiCoupon',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_KOU_BEI],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-kuaishouCoupon',
        path: '/main-operations/coupons/kuaishouCoupon',
        component: './main-operations/coupons/kuaishouCoupon',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_VIRTUAL_TICKET_KS],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-receiptOfDepositary',
        path: '/main-operations/receiptOfDepositary',
        component: './main-operations/receiptOfDepositary',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_STORAGE_ORDER],
    },
    {
        name: 'main-operations-tableOrder',
        path: '/main-operations/tableOrder',
        component: './main-operations/tableOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_TABLE_RESERVE],
    },
    {
        name: 'main-operations-abnormalOrders',
        path: '/main-operations/abnormalOrders',
        component: './main-operations/abnormalOrders',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_EXCEPTION_ORDER_ACCEPT,
            IPermissonCode.PERMISSION_EXCEPTION_ORDER_FULFILL,
            IPermissonCode.PERMISSION_EXCEPTION_ORDER_PAY,
            IPermissonCode.PERMISSION_EXCEPTION_DEPOSIT_ORDER,
        ],
    },
    {
        name: 'main-operations-cardorders',
        path: '/main-operations/cardorders',
        component: './main-operations/cardorders',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_CARD_ORDER],
    },
    {
        name: 'main-operations-cardorders',
        path: '/main-operations/cardorders/:order_id',
        component: './main-operations/cardorders/cardOrderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_CARD_ORDER],
    },
    {
        name: 'main-operations-cardorders',
        path: '/main-operations/cardorders/:order_id/refund',
        component: './main-operations/cardorders/refund',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_CARD_ORDER],
    },
    {
        name: 'main-operations-afterSaleOrders',
        path: '/main-operations/afterSaleOrders',
        component: './main-operations/afterSaleOrders',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AFTER_SALE_ORDER],
    },
    {
        name: 'main-operations-afterSaleOrders',
        path: '/main-operations/afterSaleOrders/:order_after_sale_id',
        component: './main-operations/afterSaleOrders/afterSaleOrderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AFTER_SALE_ORDER],
    },
    {
        name: 'main-operations-afterSaleOrders',
        path: '/main-operations/afterSaleOrders/:order_after_sale_id/:order_after_sale_detail_num',
        component: './main-operations/afterSaleOrders/afterSaleOrderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AFTER_SALE_ORDER],
    },
    {
        name: 'main-operations-cardCouponAfterSalesOrders',
        path: '/main-operations/cardCouponAfterSalesOrders',
        component: './main-operations/cardCouponAfterSalesOrders',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AFTER_SALE_CARD_ORDER],
    },
    {
        name: 'main-operations-cardCouponAfterSalesOrders',
        path: '/main-operations/cardCouponAfterSalesOrders/:order_after_sale_id',
        component: './main-operations/cardCouponAfterSalesOrders/afterSaleOrderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AFTER_SALE_CARD_ORDER],
    },
    {
        name: 'main-operations-cardCouponAfterSalesOrders',
        path: '/main-operations/cardCouponAfterSalesOrders/:order_after_sale_id/:order_after_sale_detail_num',
        component: './main-operations/cardCouponAfterSalesOrders/afterSaleOrderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AFTER_SALE_CARD_ORDER],
    },
    {
        name: 'main-operations-downPayment',
        path: '/main-operations/downPayment',
        component: './main-operations/downPayment',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DOWN_PAYMENT],
    },
    {
        name: 'main-operations-orderComment',
        path: '/main-operations/orderComment',
        component: './main-operations/orderComment',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_EVALUATION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-commentsAnalysis',
        path: '/main-operations/commentsAnalysis',
        component: './main-operations/commentsAnalysis',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_ORDER_EVALUATION_ANALYZE],
    },
    {
        name: 'main-operations-screenSetting',
        path: '/main-operations/screenSetting',
        component: './main-operations/screenSetting',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_SECOND_DISPLAY_SETTING,
            IPermissonCode.PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING,
        ],
    },
    {
        name: 'main-operations-screenSetting',
        path: '/main-operations/screenSetting/history',
        component: './main-operations/screenSetting',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_SECOND_DISPLAY_SETTING,
            IPermissonCode.PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING,
        ],
    },
    {
        name: 'main-operations-screenSetting',
        path: '/main-operations/screenSetting/historyList',
        component: './main-operations/screenSetting/components/historyList',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_SECOND_DISPLAY_SETTING,
            IPermissonCode.PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING,
        ],
    },
    {
        name: 'main-operations-screenSetting',
        path: '/main-operations/screenSetting/carouselEdit',
        component: './main-operations/screenSetting/components/carouselEdit',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_SECOND_DISPLAY_SETTING,
            IPermissonCode.PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING,
        ],
    },
    {
        name: 'main-operations-courierTemplate',
        path: '/main-operations/courierTemplate',
        component: './main-operations/courierTemplate',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_EXPRESS_TMPL],
    },
    {
        name: 'main-operations-courierTemplate',
        path: '/main-operations/courierTemplate/detail',
        component: './main-operations/courierTemplate/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_EXPRESS_TMPL],
    },
    {
        name: 'main-operations-wecom-groupwelcommessage',
        path: '/main-operations/wecom/groupwelcommessage',
        component: './main-operations/wecom/groupwelcommessage',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_GREET],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-groupwelcommessage',
        path: '/main-operations/wecom/groupwelcommessage/detail',
        component: './main-operations/wecom/groupwelcommessage/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_GREET],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-customerGroupSends',
        path: '/main-operations/wecom/customerGroupSends',
        component: './main-operations/wecom/customerGroupSends',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_GROUP_SEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-customerGroupSends',
        path: '/main-operations/wecom/customerGroupSends/detail',
        component: './main-operations/wecom/customerGroupSends/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_GROUP_SEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-massGroupSends',
        path: '/main-operations/wecom/massGroupSends',
        component: './main-operations/wecom/massGroupSends',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_GROUP_SEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-massGroupSends',
        path: '/main-operations/wecom/massGroupSends/detail',
        component: './main-operations/wecom/massGroupSends/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_GROUP_SEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-customer-tag',
        path: '/main-operations/customer-tag',
        component: './main-operations/customer-tag',
        category: 'MARKETING_CENTER',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_MANUAL_TAG],
    },
    {
        name: 'main-operations-customer-tag',
        path: '/main-operations/customer-tag/:id',
        component: './main-operations/customer-tag/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_MANUAL_TAG],
    },
    {
        name: 'main-operations-customer-group',
        path: '/main-operations/customer-group',
        component: './main-operations/customer-group',
        category: 'MARKETING_CENTER',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_CUSTOMER_SYSTEM_TAG,
            IPermissonCode.PERMISSION_CUSTOMER_CONDITION_TAG,
        ],
    },
    {
        name: 'main-operations-customer-group',
        path: '/main-operations/customer-group/:id',
        component: './main-operations/customer-group/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_CUSTOMER_SYSTEM_TAG,
            IPermissonCode.PERMISSION_CUSTOMER_CONDITION_TAG,
        ],
    },
    {
        name: 'main-operations-wecom-groupSendAssistant',
        path: '/main-operations/wecom/groupSendAssistant',
        component: './main-operations/wecom/groupSendAssistant',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_SEND_ASSISANT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-groupSendAssistant',
        path: '/main-operations/wecom/groupSendAssistant/detail',
        component: './main-operations/wecom/groupSendAssistant/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_SEND_ASSISANT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-materialLibrary',
        path: '/main-operations/wecom/materialLibrary',
        component: './main-operations/wecom/materialLibrary',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_MATERIAL],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-customerList',
        path: '/main-operations/wecom/customerList',
        component: './main-operations/wecom/customerList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-customerList',
        path: '/main-operations/wecom/customerList/detail',
        component: './main-operations/wecom/customerList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-clubCardGroup',
        path: '/main-operations/clubCardGroup',
        component: './main-operations/clubCardGroup',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CARD_SHARE_GROUP],
    },
    {
        name: 'main-operations-clubCardGroup',
        path: '/main-operations/clubCardGroup/detail',
        component: './main-operations/clubCardGroup/ModifyClubCardGroup',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CARD_SHARE_GROUP],
    },
    {
        name: 'main-operations-wecom-customerGroupList',
        path: '/main-operations/wecom/customerGroupList',
        component: './main-operations/wecom/customerGroupList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-customerGroupList',
        path: '/main-operations/wecom/customerGroupList/detail',
        component: './main-operations/wecom/customerGroupList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_GROUP],
        category: 'MARKETING_CENTER',
    },
    // 商品管理
    {
        name: 'main-operations-goods-productSort',
        path: '/main-operations/goods/productSort',
        component: './main-operations/goods/productSort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_SORT],
    },
    {
        name: 'main-operations-goods-collections',
        path: '/main-operations/goods/collections',
        component: './main-operations/goods/collections',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_COLLECT],
    },
    {
        name: 'main-operations-goods-collections',
        path: '/main-operations/goods/collections/detail',
        component: './main-operations/goods/collections/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_COLLECT],
    },
    {
        name: 'main-operations-income-subject',
        path: '/main-operations/goods/incomeSubject',
        component: './main-operations/goods/incomeSubject',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_INCOME_SUBJECT],
    },
    {
        name: 'main-operations-goods-productUnit',
        path: '/main-operations/goods/productUnit',
        component: './main-operations/goods/productUnit',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_UNIT],
    },
    {
        name: 'main-operations-goods-cornerMark',
        path: '/main-operations/goods/cornerMark',
        component: './main-operations/goods/cornerMark',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_CORNER_MARK],
    },
    {
        name: 'main-operations-goods-cornerMark',
        path: '/main-operations/goods/cornerMark/detail',
        component: './main-operations/goods/cornerMark/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_CORNER_MARK],
    },
    {
        name: 'main-operations-goods-goodsAttribute',
        path: '/main-operations/goods/goodsAttribute',
        component: './main-operations/goods/goodsAttribute',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_PRODUCT_OPTION_ADD,
            IPermissonCode.PERMISSION_PRODUCT_OPTION_METHOD,
            IPermissonCode.PERMISSION_PRODUCT_OPTION_VARAINT,
            IPermissonCode.PERMISSION_PRODUCT_UNIT,
        ],
    },
    // 包装盒
    {
        name: 'main-operations-goods-goodsAttribute',
        path: '/main-operations/goods/goodsAttribute/box',
        component: './main-operations/goods/box/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PACKAGE_BOX],
    },
    // 标签
    {
        name: 'main-operations-goods-goodsAttribute',
        path: '/main-operations/goods/goodsAttribute/label',
        component: './main-operations/goods/cornerMark/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_CORNER_MARK],
    },
    {
        name: 'main-operations-goods-mustOrderProduct',
        path: '/main-operations/goods/mustOrderProduct',
        component: './main-operations/goods/mustOrderProduct',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_MUST_ORDER],
    },
    {
        name: 'main-operations-goods-mustOrderProduct',
        path: '/main-operations/goods/mustOrderProduct/new',
        component: './main-operations/goods/mustOrderProduct/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_MUST_ORDER],
    },
    {
        name: 'main-operations-goods-mustOrderProduct',
        path: '/main-operations/goods/mustOrderProduct/:id',
        component: './main-operations/goods/mustOrderProduct/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_MUST_ORDER],
    },
    {
        name: 'main-operations-goods-mustOrderProduct',
        path: '/main-operations/goods/mustOrderProduct/show/:showId',
        component: './main-operations/goods/mustOrderProduct/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_MUST_ORDER],
    },
    {
        name: 'main-operations-goods-mustOrderProduct',
        path: '/main-operations/goods/mustOrderProduct/copy/:copyId',
        component: './main-operations/goods/mustOrderProduct/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_MUST_ORDER],
    },
    {
        name: 'main-operations-goods-timePeriodMenu',
        path: '/main-operations/goods/timePeriodMenu',
        component: './main-operations/goods/timePeriodMenu',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY],
    },
    {
        name: 'main-operations-goods-timePeriodMenu',
        path: '/main-operations/goods/timePeriodMenu/detail',
        component: './main-operations/goods/timePeriodMenu/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY],
    },
    {
        name: 'main-operations-goods-storeTimePeriodMenu',
        path: '/main-operations/goods/storeTimePeriodMenu',
        component: './main-operations/goods/timePeriodMenu',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY_LOCATION],
    },
    {
        name: 'main-operations-goods-storeTimePeriodMenu',
        path: '/main-operations/goods/storeTimePeriodMenu/detail',
        component: './main-operations/goods/timePeriodMenu/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY_LOCATION],
    },
    {
        name: 'main-operations-goods-timePeriodMenu',
        path: '/main-operations/goods/timePeriodMenu/clearStore',
        component: './main-operations/goods/timePeriodMenu/clearStore',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY],
    },
    {
        name: 'main-operations-goods-productTimePeriod',
        path: '/main-operations/goods/productTimePeriod',
        component: './main-operations/goods/productTimePeriod',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_PERIOD],
    },
    {
        name: 'main-operations-goods-productTimePeriod',
        path: '/main-operations/goods/productTimePeriod/detail',
        component: './main-operations/goods/productTimePeriod/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_PERIOD],
    },
    // todo 权限调整
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release',
        component: './main-product/product-release',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION,
            IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD,
            IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY,
            IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY_LOCATION,
        ],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/rule',
        component: './main-product/product-release/product-release-rule',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/special-channel',
        component: './main-product/product-release/product-release-special-channel',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/special-channel/:id',
        component: './main-product/product-release/product-release-special-channel',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/dish-release',
        component: './main-product/product-release/product-release-dish-release',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/dish-release/:id',
        component: './main-product/product-release/product-release-dish-release',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/time-period-menu',
        component: './main-product/product-release/time-period-menu-release',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIME_MENUY],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/view/:editId',
        component: './main-product/product-release/product-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/product-view/:editId',
        component: './main-product/product-release/product-release-view-product',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/category-view/:editId/location/:locationId',
        component: './main-product/product-release/product-category-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/category-view/:editId',
        component: './main-product/product-release/product-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/feed-view/:editId/location/:locationId',
        component: './main-product/product-release/product-method-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/feed-view/:editId',
        component: './main-product/product-release/product-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/feed',
        component: './main-product/product-release/product-release-feed',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/property-view/:editId/location/:locationId',
        component: './main-product/product-release/product-method-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/property-view/:editId',
        component: './main-product/product-release/product-release-view',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION_RECORD],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/product-delete',
        component: './main-product/product-release/product-release-delete-product',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        path: '/main-product/product-release/product-delete/:id',
        component: './main-product/product-release/product-release-delete-product',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        // title: '菜品下发',
        path: '/main-product/product-release/batch-category',
        component: './main-product/product-release/product-category-release',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-release',
        // title: '菜品下发',
        path: '/main-product/product-release/product-release-cook-way',
        component: './main-product/product-release/product-release-cook-way',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_DISTRIBUTION],
    },
    {
        name: 'main-operations-product-template',
        path: '/main-product/product-template',
        component: './main-product/product-template',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_RECIPE_TEMPLATE_CATEGORY],
    },
    {
        name: 'main-operations-product-template',
        path: '/main-product/product-template/detail',
        component: './main-product/product-template/product-template-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_RECIPE_TEMPLATE_CATEGORY],
    },
    {
        name: 'main-operations-product-dynamic-price',
        path: '/main-product/product-dynamic-price',
        component: './main-product/product-dynamic-price',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIMED_PRICE],
    },
    {
        name: 'main-operations-product-dynamic-price',
        path: '/main-product/product-dynamic-price/detail',
        component: './main-product/product-dynamic-price/product-dynamic-price-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIMED_PRICE],
    },
    {
        name: 'main-operations-product-dynamic-price',
        path: '/main-product/product-dynamic-price/detail/:id',
        component: './main-product/product-dynamic-price/product-dynamic-price-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TIMED_PRICE],
    },
    {
        name: 'product-product-category',
        path: '/product/product-category',
        component: './product/product-category',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE],
    },
    {
        name: 'product-product-category',
        path: '/product/product-category-single',
        component: './product/product-category-location',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE],
    },
    {
        name: 'product-product-category',
        path: '/product/product-category/detail',
        component: './product/product-category/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE],
    },
    {
        name: 'product-product-category',
        path: '/product/product-category/product-category-sort',
        component: './product/product-category-sort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE],
    },
    {
        name: 'product-product-category-location',
        path: '/product/product-category-location',
        component: './product/product-category-location',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE_LOCATION],
    },
    {
        name: 'product-product-category-location',
        path: '/product/product-category-location/detail',
        component: './product/product-category-location/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE_LOCATION],
    },
    {
        name: 'product-product-category-location',
        path: '/product/product-category-location/product-category-sort',
        component: './product/product-category-sort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_TYPE_LOCATION],
    },
    {
        name: 'main-operations-goods-storeAttribute',
        path: '/main-operations/goods/storeAttribute',
        component: './main-operations/goods/goodsAttribute',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_PRODUCT_OPTION_LOCATION_METHOD,
            IPermissonCode.PERMISSION_PRODUCT_OPTION_LOCATION_ADD,
            IPermissonCode.PERMISSION_PRODUCT_OPTION_LOCATION_VARAINT,
            IPermissonCode.PERMISSION_PRODUCT_UNIT_LOCATION_UNIT,
        ],
    },
    {
        name: 'main-operations-goods-inventory',
        path: '/main-operations/goods/inventory',
        component: './main-operations/goods/inventory',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_INVENTORY],
    },
    {
        name: 'main-operations-goods-detailLogInventory',
        path: '/main-operations/goods/detailLogInventory',
        component: './main-operations/goods/detailLogInventory',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_INVENTORY],
    },
    {
        name: 'main-operations-goods-stockSync',
        path: '/main-operations/goods/stockSync',
        component: './main-operations/goods/stockSync',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_INVENTORY_SYNC],
    },
    {
        name: 'main-operations-goods-planInventory',
        path: '/main-operations/goods/planInventory',
        component: './main-operations/goods/planInventory',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PLAN_INVENTORY],
    },
    {
        name: 'main-operations-goods-productPrintConfig',
        path: '/main-operations/goods/productPrintConfig',
        component: './main-operations/goods/productPrintConfig',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_PRINT_CONFIGURATION],
    },
    {
        name: 'main-operations-goods-productionDepartment',
        path: '/main-operations/goods/productionDepartment',
        component: './main-operations/goods/productionDepartment',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_PRODUCT_TAG_HEADQUARTERS,
            IPermissonCode.PERMISSION_PRODUCT_TAG_LOCATION,
        ],
    },
    {
        name: 'main-operations-goods-productionDepartment',
        path: '/main-operations/goods/productionDepartment/edit/:id',
        component: './main-operations/goods/productionDepartment/head/components/CommodityMaintenance',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_PRODUCT_TAG_HEADQUARTERS,
            IPermissonCode.PERMISSION_PRODUCT_TAG_LOCATION,
        ],
    },
    {
        name: 'main-operations-goods-productionDepartment',
        path: '/main-operations/goods/productionDepartment/location/edit/:id/:location_id',
        component: './main-operations/goods/productionDepartment/location/components/CommodityMaintenance',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_PRODUCT_TAG_HEADQUARTERS,
            IPermissonCode.PERMISSION_PRODUCT_TAG_LOCATION,
        ],
    },
    {
        name: 'main-operations-crm',
        path: '/main-operations/crm',
        component: './main-operations/crm',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_APP_LIMIT_TIME_DISCOUNT,
            IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT,
            IPermissonCode.PERMISSION_APP_GIFT_GET_CARD,
            IPermissonCode.PERMISSION_APP_GIFT_CONSUME,
            IPermissonCode.PERMISSION_APP_GIFT_DEPOSIT,
            IPermissonCode.PERMISSION_APP_GIFT_LEVEL_UP,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE,
            IPermissonCode.PERMISSION_DISCOUNT_FULL_REDUCE,
            IPermissonCode.PERMISSION_APP_GIFT_BIRTHDAY,
            IPermissonCode.PERMISSION_APP_SECOND_HALF_DISCOUNT,
            IPermissonCode.PERMISSION_DISCOUNT_ANY_CHOICE,
            IPermissonCode.PERMISSION_DISCOUNT_FREIGHT_REDUCE,
            IPermissonCode.PERMISSION_DISCOUNT_FULL_GIFT,
            IPermissonCode.PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY,
            IPermissonCode.PERMISSION_DISCOUNT_GROUP_RELAY,
            IPermissonCode.PERMISSION_DISCOUNT_MARK_UP_PURCHASE,
            IPermissonCode.PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE,
            IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE,
            IPermissonCode.PERMISSION_DISCOUNT_RECOMMEND_PURCHASE,
            IPermissonCode.PERMISSION_DISCOUNT_SCAN_CODE_PAY,
            IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY,
            IPermissonCode.PERMISSION_DISCOUNT_TICKET,
            IPermissonCode.PERMISSION_DISCOUNT_TICKET_PACK,
            IPermissonCode.PERMISSION_GIFT_LUCKY_DRAW,
            IPermissonCode.PERMISSION_PROMOTION_AD_MGR,
            IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP,
            IPermissonCode.PERMISSION_PROMOTION_CUSTOMER_FISSION,
            IPermissonCode.PERMISSION_PROMOTION_FUN_GUESS,
            IPermissonCode.PERMISSION_PROMOTION_FUN_MATCH,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_INFO,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_THEME,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_TMPL,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_SIGN_IN,
            IPermissonCode.PERMISSION_PROMOTION_GROUP_BUYING,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_LOG,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY,
            IPermissonCode.PERMISSION_PROMOTION_POPUP_TICKET_MGR,
            IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY,
            IPermissonCode.PERMISSION_PROMOTION_RECOMMEND_PRODUCT_ACTIVITY,
            IPermissonCode.PERMISSION_PROMOTION_RIGHT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_SMS_GROUP_SEND,
            IPermissonCode.PERMISSION_PROMOTION_TIMED_GIFT_TICKET,
        ],
    },
    {
        name: 'main-operations-manageCrm',
        path: '/main-operations/manageCrm',
        component: './main-operations/manageCrm',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_ACTIVE_MANAGER],
    },
    {
        name: 'main-operations-promotion',
        path: '/main-operations/promotion',
        component: './main-operations/promotion',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_APP_LIMIT_TIME_DISCOUNT,
            IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT,
            IPermissonCode.PERMISSION_APP_GIFT_GET_CARD,
            IPermissonCode.PERMISSION_APP_GIFT_CONSUME,
            IPermissonCode.PERMISSION_APP_GIFT_DEPOSIT,
            IPermissonCode.PERMISSION_APP_GIFT_LEVEL_UP,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE,
            IPermissonCode.PERMISSION_DISCOUNT_FULL_REDUCE,
            IPermissonCode.PERMISSION_APP_GIFT_BIRTHDAY,
            IPermissonCode.PERMISSION_APP_SECOND_HALF_DISCOUNT,
            IPermissonCode.PERMISSION_DISCOUNT_ANY_CHOICE,
            IPermissonCode.PERMISSION_DISCOUNT_FREIGHT_REDUCE,
            IPermissonCode.PERMISSION_DISCOUNT_FULL_GIFT,
            IPermissonCode.PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY,
            IPermissonCode.PERMISSION_DISCOUNT_GROUP_RELAY,
            IPermissonCode.PERMISSION_DISCOUNT_MARK_UP_PURCHASE,
            IPermissonCode.PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE,
            IPermissonCode.PERMISSION_DISCOUNT_RANDOM_REDUCE,
            IPermissonCode.PERMISSION_DISCOUNT_RECOMMEND_PURCHASE,
            IPermissonCode.PERMISSION_DISCOUNT_SCAN_CODE_PAY,
            IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY,
            IPermissonCode.PERMISSION_DISCOUNT_TICKET,
            IPermissonCode.PERMISSION_DISCOUNT_TICKET_PACK,
            IPermissonCode.PERMISSION_GIFT_LUCKY_DRAW,
            IPermissonCode.PERMISSION_PROMOTION_AD_MGR,
            IPermissonCode.PERMISSION_PROMOTION_COLLECT_STAMP,
            IPermissonCode.PERMISSION_PROMOTION_CUSTOMER_FISSION,
            IPermissonCode.PERMISSION_PROMOTION_FUN_GUESS,
            IPermissonCode.PERMISSION_PROMOTION_FUN_MATCH,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_INFO,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_THEME,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_TMPL,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_SIGN_IN,
            IPermissonCode.PERMISSION_PROMOTION_GROUP_BUYING,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_LOG,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY,
            IPermissonCode.PERMISSION_PROMOTION_POPUP_TICKET_MGR,
            IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY,
            IPermissonCode.PERMISSION_PROMOTION_RECOMMEND_PRODUCT_ACTIVITY,
            IPermissonCode.PERMISSION_PROMOTION_RIGHT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_SMS_GROUP_SEND,
            IPermissonCode.PERMISSION_PROMOTION_TIMED_GIFT_TICKET,
        ],
    },
    {
        name: 'main-operations-managePromotion',
        path: '/main-operations/managePromotion',
        component: './main-operations/manageCrm',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PARENT_PERMISSION_PROMOTION_EVENT_MANAGER],
    },
    {
        name: 'main-operations-sharedMutex',
        path: '/main-operations/sharedMutex',
        component: './main-operations/sharedMutex',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_EXCLUSIVE_SHARE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-sharedMutex',
        path: '/main-operations/sharedMutex/:id',
        component: './main-operations/sharedMutex/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_EXCLUSIVE_SHARE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-taskActivity',
        path: '/main-operations/crm/marketingActivities/taskActivity',
        component: './main-operations/marketingActivities/taskActivity',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-taskActivity',
        path: '/main-operations/crm/marketingActivities/taskActivity/detail',
        component: './main-operations/marketingActivities/taskActivity/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-taskActivity',
        path: '/main-operations/crm/marketingActivities/taskActivity/setting',
        component: './main-operations/marketingActivities/taskActivity/setting',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-taskActivity',
        path: '/main-operations/crm/marketingActivities/taskActivity/data/:id',
        component: './main-operations/marketingActivities/taskActivity/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-taskActivity',
        path: '/main-operations/crm/marketingActivities/taskActivity/copy',
        component: './main-operations/marketingActivities/taskActivity/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-taskActivity',
        path: '/main-operations/crm/marketingActivities/taskActivity/read',
        component: './main-operations/marketingActivities/taskActivity/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TASK_ACTIVITY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftBirthday',
        path: '/main-operations/crm/marketingActivities/giftBirthday',
        component: './main-operations/marketingActivities/giftBirthday',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_BIRTHDAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftBirthday',
        path: '/main-operations/crm/marketingActivities/giftBirthday/detail',
        component: './main-operations/marketingActivities/giftBirthday/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_BIRTHDAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftBirthday',
        path: '/main-operations/crm/marketingActivities/giftBirthday/read',
        component: './main-operations/marketingActivities/giftBirthday/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_BIRTHDAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftBirthday',
        path: '/main-operations/crm/marketingActivities/giftBirthday/copy',
        component: './main-operations/marketingActivities/giftBirthday/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_BIRTHDAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftCard',
        path: '/main-operations/marketingActivities/giftCard',
        component: './main-operations/marketingActivities/giftCard',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_TMPL,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_INFO,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_THEME,
        ],
    },
    {
        name: 'main-operations-giftCard',
        path: '/main-operations/marketingActivities/giftCard/tmpls/:id',
        component: './main-operations/marketingActivities/giftCard/tmpls/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_TMPL,
        ],
    },
    {
        name: 'main-operations-giftCard',
        path: '/main-operations/marketingActivities/giftCard/batch/:id',
        component: './main-operations/marketingActivities/giftCard/batch/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER,
        ],
    },
    {
        name: 'main-operations-giftCard',
        path: '/main-operations/marketingActivities/giftCard/themes/:id',
        component: './main-operations/marketingActivities/giftCard/themes/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD,
            IPermissonCode.PERMISSION_PROMOTION_GIFT_CARD_THEME,
        ],
    },
    {
        name: 'main-operations-popUpCoupons',
        path: '/main-operations/crm/marketingActivities/popUpCoupons',
        component: './main-operations/marketingActivities/popUpCoupons',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_POPUP_TICKET_MGR],
    },
    {
        name: 'main-operations-popUpCoupons',
        path: '/main-operations/crm/marketingActivities/popUpCoupons/data/:id',
        component: './main-operations/marketingActivities/popUpCoupons/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_POPUP_TICKET_MGR],
    },
    {
        name: 'main-operations-popUpCoupons',
        path: '/main-operations/crm/marketingActivities/popUpCoupons/:id',
        component: './main-operations/marketingActivities/popUpCoupons/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_POPUP_TICKET_MGR],
    },
    {
        name: 'main-operations-getDiscount',
        path: '/main-operations/crm/marketingActivities/getDiscount',
        component: './main-operations/marketingActivities/getDiscount',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY],
    },
    {
        name: 'main-operations-getDiscount',
        path: '/main-operations/crm/marketingActivities/getDiscount/data/:id',
        component: './main-operations/marketingActivities/getDiscount/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY],
    },
    {
        name: 'main-operations-getDiscount',
        path: '/main-operations/crm/marketingActivities/getDiscount/:id',
        component: './main-operations/marketingActivities/getDiscount/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY],
    },
    {
        name: 'main-operations-discountPackage',
        path: '/main-operations/marketingActivities/discountPackage',
        component: './main-operations/marketingActivities/discountPackage',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET_PACK],
    },
    {
        name: 'main-operations-discountPackage',
        path: '/main-operations/marketingActivities/discountPackage/data/:id',
        component: './main-operations/marketingActivities/discountPackage/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET_PACK],
    },
    {
        name: 'main-operations-discountPackage',
        path: '/main-operations/marketingActivities/discountPackage/:id',
        component: './main-operations/marketingActivities/discountPackage/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET_PACK],
    },
    {
        name: 'main-operations-equityCard',
        path: '/main-operations/marketingActivities/equityCard',
        component: './main-operations/marketingActivities/equityCard',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_RIGHT_CARD],
    },
    {
        name: 'main-operations-equityCard',
        path: '/main-operations/marketingActivities/equityCard/:id',
        component: './main-operations/marketingActivities/equityCard/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_RIGHT_CARD],
    },
    {
        name: 'main-operations-collectCard',
        path: '/main-operations/crm/marketingActivities/collectCard',
        component: './main-operations/marketingActivities/collectCard',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_GET_CARD],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-collectCard',
        path: '/main-operations/crm/marketingActivities/collectCard/:id',
        component: './main-operations/marketingActivities/collectCard/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_GET_CARD],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-friendFission',
        path: '/main-operations/crm/marketingActivities/friendFission',
        component: './main-operations/marketingActivities/friendFission',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_CUSTOMER_FISSION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-friendFission',
        path: '/main-operations/crm/marketingActivities/friendFission/data/:id',
        component: './main-operations/marketingActivities/friendFission/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_CUSTOMER_FISSION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-friendFission',
        path: '/main-operations/crm/marketingActivities/friendFission/:id',
        component: './main-operations/marketingActivities/friendFission/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_CUSTOMER_FISSION],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-newCustomerExclusive',
        path: '/main-operations/crm/marketingActivities/newCustomerExclusive',
        component: './main-operations/marketingActivities/newCustomerExclusive',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-newCustomerExclusive',
        path: '/main-operations/crm/marketingActivities/newCustomerExclusive/data/:id',
        component: './main-operations/marketingActivities/newCustomerExclusive/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-newCustomerExclusive',
        path: '/main-operations/crm/marketingActivities/newCustomerExclusive/:id',
        component: './main-operations/marketingActivities/newCustomerExclusive/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-groupRelay',
        path: '/main-operations/crm/marketingActivities/groupRelay',
        component: './main-operations/marketingActivities/groupRelay',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_GROUP_RELAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-groupRelay',
        path: '/main-operations/crm/marketingActivities/groupRelay/data/:id',
        component: './main-operations/marketingActivities/groupRelay/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_GROUP_RELAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-groupRelay',
        path: '/main-operations/crm/marketingActivities/groupRelay/:id',
        component: './main-operations/marketingActivities/groupRelay/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_GROUP_RELAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-discounts',
        path: '/main-operations/marketingActivities/discounts',
        component: './main-operations/marketingActivities/discounts',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET],
    },
    {
        name: 'main-operations-discounts',
        path: '/main-operations/marketingActivities/discounts/tmpls/data/:id',
        component: './main-operations/marketingActivities/discounts/tmpls/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET],
    },
    {
        name: 'main-operations-discounts',
        path: '/main-operations/marketingActivities/discounts/tmpls/:id',
        component: './main-operations/marketingActivities/discounts/tmpls/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET],
    },
    {
        name: 'main-operations-discounts',
        path: '/main-operations/marketingActivities/discounts/batch/:id',
        component: './main-operations/marketingActivities/discounts/batch/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_TICKET],
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey',
        component: './main-operations/marketingActivities/questionnaireSurvey',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey/new',
        component: './main-operations/marketingActivities/questionnaireSurvey/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey/data/:id',
        component: './main-operations/marketingActivities/questionnaireSurvey/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey/:id',
        component: './main-operations/marketingActivities/questionnaireSurvey/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey/show/:showId',
        component: './main-operations/marketingActivities/questionnaireSurvey/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey/copy/:copyId',
        component: './main-operations/marketingActivities/questionnaireSurvey/modify',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-questionnaireSurvey',
        path: '/main-operations/crm/marketingActivities/questionnaireSurvey/data/record/:id/:recordId',
        component: './main-operations/marketingActivities/questionnaireSurvey/data/components/RecordDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-markUpPurchase',
        path: '/main-operations/promotion/marketingActivities/markUpPurchase',
        component: './main-operations/marketingActivities/markUpPurchase',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-markUpPurchase',
        path: '/main-operations/promotion/marketingActivities/markUpPurchase/new',
        component: './main-operations/marketingActivities/markUpPurchase/modify',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-markUpPurchase',
        path: '/main-operations/promotion/marketingActivities/markUpPurchase/data/:id',
        component: './main-operations/marketingActivities/markUpPurchase/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-markUpPurchase',
        path: '/main-operations/promotion/marketingActivities/markUpPurchase/:id',
        component: './main-operations/marketingActivities/markUpPurchase/modify',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-markUpPurchase',
        path: '/main-operations/promotion/marketingActivities/markUpPurchase/show/:showId',
        component: './main-operations/marketingActivities/markUpPurchase/modify',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-markUpPurchase',
        path: '/main-operations/promotion/marketingActivities/markUpPurchase/copy/:copyId',
        component: './main-operations/marketingActivities/markUpPurchase/modify',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-settings-locations',
        path: '/main-operations/settings/locations',
        component: './main-operations/settings/locations',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION],
    },
    {
        name: 'main-operations-settings-locations',
        path: '/main-operations/settings/locations/new',
        component: './main-operations/settings/locations/listNewDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION],
    },
    {
        name: 'main-operations-settings-locations',
        path: '/main-operations/settings/locations/detail',
        component: './main-operations/settings/locations/listDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION],
    },
    {
        name: 'main-operations-settings-locations',
        path: '/main-operations/settings/locations/detail/historyList',
        component: './main-operations/settings/locations/listDetail/historyList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION],
    },
    {
        name: 'main-operations-settings-locations',
        path: '/main-operations/settings/locations/historyDetail',
        component: './main-operations/settings/locations/listHistoryDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_LOCATION],
    },
    {
        name: 'main-operations-cardKind',
        path: '/main-operations/cardKind',
        component: './main-operations/cardKind',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CARD_TYPE],
    },
    {
        name: 'main-operations-cardKind',
        path: '/main-operations/cardKind/:id',
        component: './main-operations/cardKind/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CARD_TYPE],
    },
    {
        name: 'main-operations-deposit',
        path: '/main-operations/deposit',
        component: './main-operations/deposit',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_CUSTOMER_ASSET_DEPOSIT_MGR,
            IPermissonCode.PERMISSION_CUSTOMER_BALANCE_REFUND_ORDER,
        ],
    },
    {
        name: 'main-operations-deposit',
        path: '/main-operations/deposit/:id',
        component: './main-operations/deposit/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_CUSTOMER_ASSET_DEPOSIT_MGR,
            IPermissonCode.PERMISSION_CUSTOMER_BALANCE_REFUND_ORDER,
        ],
    },
    {
        name: 'main-operations-point',
        path: '/main-operations/point',
        component: './main-operations/point',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_ASSET_POINT_MGR],
    },
    {
        name: 'main-operations-vip',
        path: '/main-operations/vip',
        component: './main-operations/vip',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD,
            IPermissonCode.PERMISSION_CUSTOMER_MEMBER_RIGHT,
        ],
    },
    {
        name: 'main-operations-vip',
        path: '/main-operations/vip/card/:id',
        component: './main-operations/vip/cardDetail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD],
    },
    {
        name: 'main-operations-vip',
        path: '/main-operations/vip/growth',
        component: './main-operations/vip/growthDetail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD],
    },
    {
        name: 'main-operations-vip',
        path: '/main-operations/vip/right/:id',
        component: './main-operations/vip/rightDetail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_MEMBER_RIGHT],
    },
    {
        name: 'main-operations-dataDefinition',
        path: '/main-operations/dataDefinition',
        component: './main-operations/dataDefinition',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CUSTOM_CONDITION],
    },
    {
        name: 'main-operations-RFMAnalysis',
        path: '/main-operations/RFMAnalysis',
        component: './main-operations/RFMAnalysis',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_RFM_REPORT],
    },
    {
        name: 'main-operations-userPortrait',
        path: '/main-operations/userPortrait',
        component: './main-operations/userPortrait',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_PERSONA],
    },
    {
        name: 'main-operations-customers',
        path: '/main-operations/customers',
        component: './main-operations/customers',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER],
    },
    {
        name: 'main-operations-customers',
        path: '/main-operations/customers/:id',
        component: './main-operations/customers/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER],
    },
    {
        name: 'main-operations-wecom-customerTag',
        path: '/main-operations/wecom/customerTag',
        component: './main-operations/wecom/customerTag',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_TAG],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-cardImport',
        path: '/main-operations/cardImport',
        component: './main-operations/cardImport',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_IC_CARD],
    },
    {
        name: 'main-operations-clubCard',
        path: '/main-operations/clubCard',
        component: './main-operations/clubCard',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CARD_LIST],
    },
    {
        name: 'main-operations-clubCard',
        path: '/main-operations/clubCard/:id',
        component: './main-operations/clubCard/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_CUSTOMER_CARD_LIST],
    },
    {
        name: 'main-operations-wecom-groupOwnerList',
        path: '/main-operations/wecom/groupOwnerList',
        component: './main-operations/wecom/groupOwnerList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-groupTag',
        path: '/main-operations/wecom/groupTag',
        component: './main-operations/wecom/groupTag',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_TAG],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-staffList',
        path: '/main-operations/wecom/staffList',
        component: './main-operations/wecom/staffList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_STAFF_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-staffList',
        path: '/main-operations/wecom/staffList/detail',
        component: './main-operations/wecom/staffList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_STAFF_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-accountManage',
        path: '/main-operations/wecom/accountManage',
        component: './main-operations/wecom/accountManage',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        // code_key: [IPermissonCode.PERMISSION_WECOM_STAFF_LICENSE_MGR],
    },
    {
        name: 'main-operations-wecom-application',
        path: '/main-operations/wecom/application',
        component: './main-operations/wecom/application',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_APP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-application',
        path: '/main-operations/wecom/application/buyAndRenewal',
        component: './main-operations/wecom/application/buyAndRenewal',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_APP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-roleManage',
        path: '/main-operations/wecom/roleManage',
        component: './main-operations/wecom/roleManage',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_ROLE_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-roleManage',
        path: '/main-operations/wecom/roleManage/detail',
        component: './main-operations/wecom/roleManage/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_ROLE_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-overView',
        path: '/main-operations/wecom/overView',
        component: './main-operations/wecom/overView',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_OVERVIEW],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-sitDownOrder',
        path: '/main-operations/sitDownOrder',
        component: './main-operations/marsOrder/sitDownOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DINE_IN_ORDER],
    },
    {
        name: 'main-operations-sitDownOrder',
        path: '/main-operations/sitDownOrder/:order_id',
        component: './main-operations/marsOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DINE_IN_ORDER],
    },
    {
        name: 'main-operations-pickUpDistributionOrder',
        path: '/main-operations/pickUpDistributionOrder',
        component: './main-operations/marsOrder/pickUpDistributionOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_SELF_AND_DELIVER],
    },
    {
        name: 'main-operations-pickUpDistributionOrder',
        path: '/main-operations/pickUpDistributionOrder/:order_id',
        component: './main-operations/marsOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_SELF_AND_DELIVER],
    },
    {
        name: 'main-operations-thirdOrder',
        path: '/main-operations/thirdOrder',
        component: './main-operations/marsOrder/thirdOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_THIRD_PLATFORM],
    },
    {
        name: 'main-operations-thirdOrder',
        path: '/main-operations/thirdOrder/:order_id',
        component: './main-operations/marsOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_THIRD_PLATFORM],
    },
    {
        name: 'main-operations-productAppointmentOrder',
        path: '/main-operations/productAppointmentOrder',
        component: './main-operations/marsOrder/productAppointmentOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_PRODUCT_RESERVE],
    },
    {
        name: 'main-operations-productAppointmentOrder',
        path: '/main-operations/productAppointmentOrder/:order_id',
        component: './main-operations/marsOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_PRODUCT_RESERVE],
    },
    {
        name: 'main-operations-productMallOrder',
        path: '/main-operations/productMallOrder',
        component: './main-operations/marsOrder/productMallOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_SHOP],
    },
    {
        name: 'main-operations-productMallOrder',
        path: '/main-operations/productMallOrder/:order_id',
        component: './main-operations/marsOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_SHOP],
    },
    {
        name: 'main-operations-scanOrder',
        path: '/main-operations/scanOrder',
        component: './main-operations/marsOrder/scanOrder',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_PRODUCT_SCAN_CODE],
    },
    {
        name: 'main-operations-scanOrder',
        path: '/main-operations/scanOrder/:order_id',
        component: './main-operations/marsOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ORDER_PRODUCT_SCAN_CODE],
    },
    {
        name: 'main-operations-callNumberSetting',
        path: '/main-operations/callNumberSetting',
        component: './main-operations/callNumberSetting',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_CALL_NUMBER],
    },
    // 挂账管理
    {
        name: 'main-operations-accountManagement',
        path: '/main-operations/accountManagement',
        component: './main-operations/accountManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ENTERPRISE],
    },
    {
        name: 'main-operations-accountManagement',
        path: '/main-operations/accountManagement/new/:enterpriseType',
        component: './main-operations/accountManagement/modifyEnterpriseLedgerManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ENTERPRISE],
    },
    {
        name: 'main-operations-accountManagement',
        path: '/main-operations/accountManagement/:id',
        component: './main-operations/accountManagement/modifyEnterpriseLedgerManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ENTERPRISE],
    },
    {
        name: 'main-operations-accountManagement',
        path: '/main-operations/accountManagement/staff/:id',
        component: './main-operations/accountManagement/enterpriseStaff',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ENTERPRISE],
    },
    {
        name: 'main-operations-accountManagement',
        path: '/main-operations/accountManagement/enterpriseDetail/:id',
        component: './main-operations/accountManagement/enterpriseDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ENTERPRISE],
    },
    {
        name: 'main-operations-accountManagement',
        path: '/main-operations/accountManagement/repayAccountDetail/:id',
        component: './main-operations/accountManagement/repayAccountManagementDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_ENTERPRISE],
    },
    {
        name: 'main-operations-employeeBillingManagement',
        path: '/main-operations/employeeBillingManagement',
        component: './main-operations/employeeBillingManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PERSON_ARREARS],
    },
    {
        name: 'main-operations-employeeBillingManagement',
        path: '/main-operations/employeeBillingManagement/new/:staffType',
        component: './main-operations/employeeBillingManagement/modifyEnterpriseLedgerBillingManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PERSON_ARREARS],
    },
    {
        name: 'main-operations-employeeBillingManagement',
        path: '/main-operations/employeeBillingManagement/:id',
        component: './main-operations/employeeBillingManagement/modifyEnterpriseLedgerBillingManagement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PERSON_ARREARS],
    },
    {
        name: 'main-operations-employeeBillingManagement',
        path: '/main-operations/employeeBillingManagement/repayAccountDetail/:id',
        component: './main-operations/employeeBillingManagement/repayAccountDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PERSON_ARREARS],
    },
    {
        name: 'main-operations-employeeBillingManagement',
        path: '/main-operations/employeeBillingManagement/enterpriseBillingDetail/:id',
        component: './main-operations/employeeBillingManagement/enterpriseBillingDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PERSON_ARREARS],
    },
    {
        name: 'main-operations-wecom-channelCodeList',
        path: '/main-operations/wecom/channelCodeList',
        component: './main-operations/wecom/channelCodeList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_CHANNEL_CODE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-channelCodeList',
        path: '/main-operations/wecom/channelCodeList/detail',
        component: './main-operations/wecom/channelCodeList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_CHANNEL_CODE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-channelCodeList',
        path: '/main-operations/wecom/channelCodeList/statistics',
        component: './main-operations/wecom/channelCodeList/statistics',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_CUSTOMER_CHANNEL_CODE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-groupCodeList',
        path: '/main-operations/wecom/groupCodeList',
        component: './main-operations/wecom/groupCodeList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_CHANNEL_CODE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-groupCodeList',
        path: '/main-operations/wecom/groupCodeList/detail',
        component: './main-operations/wecom/groupCodeList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_CHANNEL_CODE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-groupCodeList',
        path: '/main-operations/wecom/groupCodeList/statistics',
        component: './main-operations/wecom/groupCodeList/statistics',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_GROUP_CHANNEL_CODE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsFriendList',
        path: '/main-operations/wecom/lbsFriendList',
        component: './main-operations/wecom/lbsFriendList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_FRIEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsFriendList',
        path: '/main-operations/wecom/lbsFriendList/detail',
        component: './main-operations/wecom/lbsFriendList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_FRIEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsFriendList',
        path: '/main-operations/wecom/lbsFriendList/locationFriendCodeList',
        component: './main-operations/wecom/lbsFriendList/locationFriendCodeList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_FRIEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsFriendList',
        path: '/main-operations/wecom/lbsFriendList/addFriendCode',
        component: './main-operations/wecom/lbsFriendList/addFriendCode',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_FRIEND],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsGroupList',
        path: '/main-operations/wecom/lbsGroupList',
        component: './main-operations/wecom/lbsGroupList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsGroupList',
        path: '/main-operations/wecom/lbsGroupList/detail',
        component: './main-operations/wecom/lbsGroupList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsGroupList',
        path: '/main-operations/wecom/lbsGroupList/locationGroupCodeList',
        component: './main-operations/wecom/lbsGroupList/locationGroupCodeList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsGroupList',
        path: '/main-operations/wecom/lbsGroupList/addGroupCode',
        component: './main-operations/wecom/lbsGroupList/addGroupCode',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-wecom-lbsGroupList',
        path: '/main-operations/wecom/lbsGroupList/addGroupCode',
        component: './main-operations/wecom/lbsGroupList/addGroupCode',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WECOM_LBS_GROUP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-operatingParameter-log',
        path: '/main-operations/systemLog',
        component: './main-operations/systemLog',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SET_SYSTEM_LOG],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregated_order',
        component: './main-operations/aggregatedOrder/orderList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_ORDER],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregatedDelivery/aggregated_order/:id',
        component: './main-operations/aggregatedOrder/orderDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_ORDER],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregatedDelivery/locationChannelSettings',
        component: './main-operations/aggregatedDelivery/components/locationChannelSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_ORDER],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregatedDelivery',
        component: './main-operations/aggregatedDelivery',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_RULE,
            IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_CHANNEL,
            IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_ORDER,
        ],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregatedDelivery/channelDetail',
        component: './main-operations/aggregatedDelivery/components/channelDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_CHANNEL],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregatedDelivery/locationChannelSettings',
        component: './main-operations/aggregatedDelivery/components/locationChannelSettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_RULE],
    },
    {
        name: 'main-operations-aggregatedDelivery',
        path: '/main-operations/aggregatedDelivery/locationDeliverySettings',
        component: './main-operations/aggregatedDelivery/components/locationDeliverySettings',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_AGGREGATE_TRANSFER_RULE],
    },
    // --------------------------------重构路由--------------------------------
    // 菜品库列表
    {
        name: 'product-standard',
        path: '/product/product-standard',
        component: './product/product-standard',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 单店菜品库列表
    {
        name: 'product-standard',
        path: '/product/product-standard-single',
        component: './product/product-standard-location',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 菜品新增
    {
        name: 'product-standard',
        path: '/product/product-standard/new',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 菜品批量改价
    {
        name: 'product-standard',
        path: '/product/product-standard/batch-price',
        component: './product/product-batch-price',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 菜品排序
    {
        name: 'product-standard',
        path: '/product/product-standard/sort',
        component: './product/product-sort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 菜品详情
    {
        name: 'product-standard',
        path: '/product/product-standard/:id',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 门店菜品管理
    {
        name: 'product-standard-location',
        path: '/product/product-standard-location',
        component: './product/product-standard-location',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 门店菜品新增
    {
        name: 'product-standard-location',
        path: '/product/product-standard-location/new',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 门店菜品批量改价
    {
        name: 'product-standard-location',
        path: '/product/product-standard-location/batch-price',
        component: './product/product-batch-price',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 门店菜品排序
    {
        name: 'product-standard-location',
        path: '/product/product-standard-location/sort',
        component: './product/product-sort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 门店菜品详情
    {
        name: 'product-standard-location',
        path: '/product/product-standard-location/:id',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 套餐商品创建（放到菜品库tab一起）
    {
        name: 'product-standard',
        path: '/product/product-kit/new',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 套餐商品详情（放到菜品库tab一起）
    {
        name: 'product-standard',
        path: '/product/product-kit/:id',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT],
    },
    // 门店套餐商品创建（放到门店菜品管理tab一起）
    {
        name: 'product-standard-location',
        path: '/product/product-kit-location/new',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 门店套餐商品详情（放到门店菜品管理tab一起）
    {
        name: 'product-standard-location',
        path: '/product/product-kit-location/:id',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_LOCATION],
    },
    // 商城商品列表
    {
        name: 'product-mall',
        path: '/product/product-mall',
        component: './product/product-mall',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_SHOP],
    },
    // 商城商品新增
    {
        name: 'product-mall',
        path: '/product/product-mall/new',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_SHOP],
    },
    // 商城商品详情
    {
        name: 'product-mall',
        path: '/product/product-mall/:id',
        component: './product/product-detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PRODUCT_SHOP],
    },
    // --------------------------------重构路由 end--------------------------------
    {
        name: 'main-operations-staffRole',
        path: '/main-operations/staffRole',
        component: './main-operations/staffRole',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_ROLE,
            IPermissonCode.PERMISSION_POS_WEB_STAFF_ROLE,
        ],
    },
    {
        name: 'main-operations-staffRole',
        path: '/main-operations/staffRole/detail',
        component: './main-operations/staffRole/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_ROLE,
            IPermissonCode.PERMISSION_POS_WEB_STAFF_ROLE,
        ],
    },
    {
        name: 'main-operations-staffManagement',
        path: '/main-operations/staffManagement',
        component: './main-operations/staffManagement',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_STAFF,
            IPermissonCode.PERMISSION_POS_WEB_STAFF_ROLE,
        ],
    },
    {
        name: 'main-operations-staffManagement',
        path: '/main-operations/staffManagement/detail',
        component: './main-operations/staffManagement/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_STAFF,
            IPermissonCode.PERMISSION_POS_WEB_STAFF_ROLE,
        ],
    },
    {
        name: 'main-operations-preDeposit',
        path: '/main-operations/preDeposit',
        component: './main-operations/preDeposit',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PRE_DEPOSITS],
    },
    {
        name: 'main-operations-preDeposit',
        path: '/main-operations/preDeposit/new',
        component: './main-operations/preDeposit/modifyPreDeposit',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PRE_DEPOSITS],
    },
    {
        name: 'main-operations-preDeposit',
        path: '/main-operations/preDeposit/:id',
        component: './main-operations/preDeposit/modifyPreDeposit',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PRE_DEPOSITS],
    },
    {
        name: 'main-operations-preDeposit',
        path: '/main-operations/preDeposit/show/:showId',
        component: './main-operations/preDeposit/modifyPreDeposit',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PRE_DEPOSITS],
    },
    {
        name: 'main-operations-preDeposit',
        path: '/main-operations/preDeposit/copy/:copyId',
        component: './main-operations/preDeposit/modifyPreDeposit',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_PRE_DEPOSITS],
    },
    {
        name: 'main-operations-member-price',
        path: '/main-operations/member-price',
        component: './main-operations/member-price',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_MEMBER_PRICE],
    },
    {
        name: 'main-operations-posRemark',
        path: '/main-operations/posRemark',
        component: './main-operations/posRemark',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_WEB_MEMO],
    },
    {
        name: 'main-operations-posPrintSort',
        path: '/main-operations/posPrintSort',
        component: './main-operations/posPrintSort',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_WEB_PRINT_ORDER],
    },
    {
        name: 'main-operations-salesman',
        path: '/main-operations/salesman',
        component: './main-operations/salesman',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_SALESMAN],
    },
    {
        name: 'main-operations-discountSetting',
        path: '/main-operations/promotion/discountSetting',
        component: './main-operations/discountSetting',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_WEB_FAST_DISCOUNT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-discountSetting',
        path: '/main-operations/promotion/discountSetting/detail',
        component: './main-operations/discountSetting/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_POS_WEB_FAST_DISCOUNT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-weapp-decorateNavigation',
        path: '/main-operations/weapp/decorateNavigation',
        component: './main-operations/weapp/decorateNavigation',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WESTORE_WECHAT_MP_AUTH_SETTING],
    },
    {
        name: 'main-operations-weapp-decorateNavigation',
        path: '/main-operations/weapp/miniprogram/wechat',
        component: './main-operations/weapp/miniprogramWechat',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WESTORE_WECHAT_MP_AUTH_SETTING],
    },
    {
        name: 'main-operations-weapp-miniprogram',
        path: '/main-operations/weapp/miniprogram/alipay',
        component: './main-operations/weapp/miniprogramAlipay',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WESTORE_WECHAT_MP_AUTH_SETTING],
    },
    {
        name: 'main-operations-weapp-popularize',
        path: '/main-operations/weapp/popularize',
        component: './main-operations/weapp/popularize',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WESTORE_WECHAT_MP_PAGE_QR_CODE],
    },
    {
        name: 'main-operations-weapp-userAgreement',
        path: '/main-operations/weapp/userAgreement',
        component: './main-operations/weapp/userAgreement',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_AGREEMENT],
    },
    {
        name: 'main-operations-weapp-userAgreement',
        path: '/main-operations/weapp/userAgreement/detail',
        component: './main-operations/weapp/userAgreement/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_AGREEMENT],
    },
    {
        name: 'main-operations-weapp-adviceFeedbacks',
        path: '/main-operations/weapp/adviceFeedbacks',
        component: './main-operations/weapp/adviceFeedbacks',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_WESTORE_ADVICE_FEEDBACK_LIST,
            IPermissonCode.PERMISSION_WESTORE_ADVICE_FEEDBACK_SET,
        ],
    },
    {
        name: 'main-operations-weapp-public',
        path: '/main-operations/weapp/public',
        component: './main-operations/weapp/public',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_WESTORE_WECHAT_MP_OFFICIAL_ACCOUNT],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting',
        component: './main-operations/posPrintSetting',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR,
            IPermissonCode.PERMISSION_SETTING_PRINT_LOCATION,
        ],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/templateDetail',
        component: './main-operations/posPrintSetting/templateDetail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/templateDetailBarb',
        component: './main-operations/posPrintSetting/templateDetailBarb',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/new',
        component: './main-operations/posPrintSetting/receipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/:id',
        component: './main-operations/posPrintSetting/receipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/deliver/new',
        component: './main-operations/posPrintSetting/deliverReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/deliver/:id',
        component: './main-operations/posPrintSetting/deliverReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/cardReceipt/new',
        component: './main-operations/posPrintSetting/cardReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/cardReceipt/:id',
        component: './main-operations/posPrintSetting/cardReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/shift/new',
        component: './main-operations/posPrintSetting/shiftReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/shift/:id',
        component: './main-operations/posPrintSetting/shiftReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/kitchenTotalAmountReceipt/new',
        component: './main-operations/posPrintSetting/kitchenTotalAmountReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/kitchenTotalAmountReceipt/:id',
        component: './main-operations/posPrintSetting/kitchenTotalAmountReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/kitchenDetailAmountReceipt/new',
        component: './main-operations/posPrintSetting/kitchenDetailAmountReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/kitchenDetailAmountReceipt/:id',
        component: './main-operations/posPrintSetting/kitchenDetailAmountReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/kitchenReturnReceipt/new',
        component: './main-operations/posPrintSetting/kitchenReturnReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/receiptSettings/design/kitchenReturnReceipt/:id',
        component: './main-operations/posPrintSetting/kitchenReturnReceipt/receiptDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/tagSettings/tag/new',
        component: './main-operations/posPrintSetting/tagSettings/tag/tagDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/tagSettings/design/tag/:id',
        component: './main-operations/posPrintSetting/tagSettings/tag/tagDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/tagSettings/priceTag/new',
        component: './main-operations/posPrintSetting/tagSettings/priceTag/tagDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/tagSettings/design/priceTag/:id',
        component: './main-operations/posPrintSetting/tagSettings/priceTag/tagDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/tagSettings/expiryTag/new',
        component: './main-operations/posPrintSetting/tagSettings/expiryTag/tagDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/tagSettings/design/expiryTag/:id',
        component: './main-operations/posPrintSetting/tagSettings/expiryTag/tagDesign',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-posPrintSetting',
        path: '/main-operations/posPrintSetting/barb/:id',
        component: './main-operations/posPrintSetting/barbEditTemp/editNewTemp',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_PRINT_MERCHANR],
    },
    {
        name: 'main-operations-mallSetting',
        path: '/main-operations/mallSetting',
        component: './main-operations/mallSetting',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_EXPRESS_SHOP_SETTING],
    },
    {
        name: 'main-operations-cashierRules',
        path: '/main-operations/cashierRules',
        component: './main-operations/cashierRules',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-cashierRules',
        path: '/main-operations/cashierRules/detail',
        component: './main-operations/cashierRules/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-cashierRules',
        path: '/main-operations/cashierRules/historyList',
        component: './main-operations/cashierRules/historyList',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-cashierRules',
        path: '/main-operations/cashierRules/history',
        component: './main-operations/cashierRules/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-tagRules',
        path: '/main-operations/tagRules',
        component: './main-operations/cashierRules',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-tagRules',
        path: '/main-operations/tagRules/detail',
        component: './main-operations/cashierRules/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-tagRules',
        path: '/main-operations/tagRules/historyList',
        component: './main-operations/cashierRules/historyList',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-tagRules',
        path: '/main-operations/tagRules/history',
        component: './main-operations/cashierRules/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-kitchenRules',
        path: '/main-operations/kitchenRules',
        component: './main-operations/cashierRules',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-kitchenRules',
        path: '/main-operations/kitchenRules/detail',
        component: './main-operations/cashierRules/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-kitchenRules',
        path: '/main-operations/kitchenRules/historyList',
        component: './main-operations/cashierRules/historyList',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-kitchenRules',
        path: '/main-operations/kitchenRules/history',
        component: './main-operations/cashierRules/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE,
            IPermissonCode.PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH,
        ],
    },
    {
        name: 'main-operations-userManagement',
        path: '/main-operations/userManagement',
        component: './main-operations/userManagement',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_SETTING_ACCOUNT,
            IPermissonCode.PERMISSION_SETTING_ACCOUNT_PERMISSION,
        ],
    },
    {
        name: 'main-operations-userManagement',
        path: '/main-operations/userManagement/detail',
        component: './main-operations/userManagement/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_SETTING_ACCOUNT,
            IPermissonCode.PERMISSION_SETTING_ACCOUNT_PERMISSION,
        ],
    },
    {
        name: 'main-operations-userRole',
        path: '/main-operations/userRole',
        component: './main-operations/userRole',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_SETTING_ROLE,
            IPermissonCode.PERMISSION_SETTING_ACCOUNT_PERMISSION,
        ],
    },
    {
        name: 'main-operations-userRole',
        path: '/main-operations/userRole/detail',
        component: './main-operations/userRole/detail',
        microApp: 'sale-app',
        code_key: [
            IPermissonCode.PERMISSION_SETTING_ROLE,
            IPermissonCode.PERMISSION_SETTING_ACCOUNT_PERMISSION,
        ],
    },
    {
        name: 'main-operations-metaField',
        path: '/main-operations/settings/metaField',
        component: './main-operations/metaField',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_METAFIELD],
    },
    {
        name: 'main-operations-metaField',
        path: '/main-operations/settings/metaField/:resourceId',
        component: './main-operations/metaField/metaFieldList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_SETTING_METAFIELD],
    },
    {
        name: 'main-operations-recommendAddPurchase',
        path: '/main-operations/crm/marketingActivities/recommendAddPurchase',
        component: './main-operations/marketingActivities/recommendAddPurchase',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RECOMMEND_PURCHASE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-recommendAddPurchase',
        path: '/main-operations/crm/marketingActivities/recommendAddPurchase/:id',
        component: './main-operations/marketingActivities/recommendAddPurchase/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_RECOMMEND_PURCHASE],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-discountedBuying',
        path: '/main-operations/promotion/marketingActivities/discountedBuying',
        component: './main-operations/marketingActivities/discountedBuying',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_SCAN_CODE_PAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-discountedBuying',
        path: '/main-operations/promotion/marketingActivities/discountedBuying/data/:id',
        component: './main-operations/marketingActivities/discountedBuying/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_SCAN_CODE_PAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-discountedBuying',
        path: '/main-operations/promotion/marketingActivities/discountedBuying/:id',
        component: './main-operations/marketingActivities/discountedBuying/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_DISCOUNT_SCAN_CODE_PAY],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-creditExchangeList',
        path: '/main-operations/marketingActivities/creditExchangeList',
        component: './main-operations/marketingActivities/creditExchangeList',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_LOG,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY,
        ],
    },
    {
        name: 'main-operations-creditExchangeList',
        path: '/main-operations/marketingActivities/creditExchangeList/:id',
        component: './main-operations/marketingActivities/creditExchangeList/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_LOG,
            IPermissonCode.PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY,
        ],
    },
    {
        name: 'main-operations-advertisingList',
        path: '/main-operations/crm/marketingActivities/advertisingList',
        component: './main-operations/marketingActivities/advertisingList',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_AD_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-advertisingList',
        path: '/main-operations/crm/marketingActivities/advertisingList/:id',
        component: './main-operations/marketingActivities/advertisingList/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_AD_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-advertisingList',
        path: '/main-operations/crm/marketingActivities/advertisingList/data/:id',
        component: './main-operations/marketingActivities/advertisingList/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_AD_MGR],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-sendDiscount',
        path: '/main-operations/crm/marketingActivities/sendDiscount',
        component: './main-operations/marketingActivities/sendDiscount',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_TIMED_GIFT_TICKET],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-sendDiscount',
        path: '/main-operations/crm/marketingActivities/sendDiscount/:id',
        component: './main-operations/marketingActivities/sendDiscount/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_TIMED_GIFT_TICKET],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-sendDiscount',
        path: '/main-operations/crm/marketingActivities/sendDiscount/data/:id',
        component: './main-operations/marketingActivities/sendDiscount/data',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_TIMED_GIFT_TICKET],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-secondHalf',
        path: '/main-operations/promotion/marketingActivities/secondHalf',
        component: './main-operations/marketingActivities/secondHalf',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT],
    },
    {
        name: 'main-operations-secondHalf',
        path: '/main-operations/promotion/marketingActivities/secondHalf/new',
        component: './main-operations/marketingActivities/secondHalf/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT],
    },
    {
        name: 'main-operations-secondHalf',
        path: '/main-operations/promotion/marketingActivities/secondHalf/:id',
        component: './main-operations/marketingActivities/secondHalf/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT],
    },
    {
        name: 'main-operations-secondHalf',
        path: '/main-operations/promotion/marketingActivities/secondHalf/show/:readId',
        component: './main-operations/marketingActivities/secondHalf/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT],
    },
    {
        name: 'main-operations-secondHalf',
        path: '/main-operations/promotion/marketingActivities/secondHalf/copy/:copyId',
        component: './main-operations/marketingActivities/secondHalf/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT],
    },
    {
        name: 'main-operations-secondHalf',
        path: '/main-operations/promotion/marketingActivities/secondHalf/data/:id',
        component: './main-operations/marketingActivities/secondHalf/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_SECOND_HALF_DISCOUNT],
    },
    {
        name: 'main-operations-giftLevel',
        path: '/main-operations/crm/marketingActivities/giftLevel',
        component: './main-operations/marketingActivities/giftLevel',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_LEVEL_UP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftLevel',
        path: '/main-operations/crm/marketingActivities/giftLevel/:id',
        component: './main-operations/marketingActivities/giftLevel/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_LEVEL_UP],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftConsume',
        path: '/main-operations/crm/marketingActivities/giftConsume',
        component: './main-operations/marketingActivities/giftConsume',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_CONSUME],
    },
    {
        name: 'main-operations-giftConsume',
        path: '/main-operations/crm/marketingActivities/giftConsume/:id',
        component: './main-operations/marketingActivities/giftConsume/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_CONSUME],
    },
    {
        name: 'main-operations-giftSignIn',
        path: '/main-operations/crm/marketingActivities/giftSignIn',
        component: './main-operations/marketingActivities/giftSignIn',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PROMOTION_GIFT_SIGN_IN],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftDeposit',
        path: '/main-operations/crm/marketingActivities/giftDeposit',
        component: './main-operations/marketingActivities/giftDeposit',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_DEPOSIT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-giftDeposit',
        path: '/main-operations/crm/marketingActivities/giftDeposit/:id',
        component: './main-operations/marketingActivities/giftDeposit/detail',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_APP_GIFT_DEPOSIT],
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-evaluationGift',
        path: '/main-operations/crm/marketingActivities/evaluationGift',
        component: './main-operations/marketingActivities/evaluationGift',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-evaluationGift',
        path: '/main-operations/crm/marketingActivities/evaluationGift/:id',
        component: './main-operations/marketingActivities/evaluationGift/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-groupBuying',
        path: '/main-operations/crm/marketingActivities/groupBuying',
        component: './main-operations/marketingActivities/groupBuying',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-groupBuying',
        path: '/main-operations/crm/marketingActivities/groupBuying/data/:id',
        component: './main-operations/marketingActivities/groupBuying/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-groupBuying',
        path: '/main-operations/crm/marketingActivities/groupBuying/:id',
        component: './main-operations/marketingActivities/groupBuying/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-fullGifts',
        path: '/main-operations/promotion/marketingActivities/fullGifts',
        component: './main-operations/marketingActivities/fullGifts',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-fullGifts',
        path: '/main-operations/promotion/marketingActivities/fullGifts/data/:id',
        component: './main-operations/marketingActivities/fullGifts/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-fullGifts',
        path: '/main-operations/promotion/marketingActivities/fullGifts/:id',
        component: './main-operations/marketingActivities/fullGifts/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-luckyDraw',
        path: '/main-operations/crm/marketingActivities/luckyDraw',
        component: './main-operations/marketingActivities/luckyDraw',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-luckyDraw',
        path: '/main-operations/crm/marketingActivities/luckyDraw/data/:id',
        component: './main-operations/marketingActivities/luckyDraw/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-luckyDraw',
        path: '/main-operations/crm/marketingActivities/luckyDraw/:id',
        component: './main-operations/marketingActivities/luckyDraw/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    // 平台小程序
    {
        name: 'main-operations-examine',
        path: '/main-operations/platform/examine',
        component: './main-operations/platform/examine',
        microApp: 'sale-app',
    },
    // {
    //   name: 'main-operations-platform-product',
    //   title: '平台小程序商品',
    //   path: '/main-operations/platform/product',
    //   component: './main-operations/platform/product',
    //   microApp: 'sale-app',
    // },
    // {
    //   name: 'main-operations-platform-product',
    //   title: '平台小程序商品',
    //   path: '/main-operations/platform/product/:id',
    //   component: './main-operations/platform/modifyLocationProduct',
    //   microApp: 'sale-app',
    // },
    {
        name: 'main-operations-platformlocation',
        path: '/main-operations/platform/location',
        component: './main-operations/platform/location',
        microApp: 'sale-app',
        code_key: [IPermissonCode.PERMISSION_PLATFORM_LOCATION],
    },
    // {
    //   name: 'main-operations-platform-product',
    //   title: '平台小程序门店套餐商品',
    //   path: '/main-operations/platform/combo/:id',
    //   component: './main-operations/platform/modifyLocationComboDetail',
    //   microApp: 'sale-app',
    // },
    // {
    //   name: 'main-operations-weapp-product',
    //   title: '小程序商品',
    //   path: '/main-operations/weapp/product',
    //   component: './main-operations/weapp/product',
    //   microApp: 'sale-app',
    // },
    // {
    //   name: 'main-operations-weapp-product',
    //   title: '小程序商品',
    //   path: '/main-operations/weapp/product/:id',
    //   component: './main-operations/platform/modifyLocationProduct',
    //   microApp: 'sale-app',
    // },
    {
        name: 'main-operations-weapp-product',
        path: '/main-operations/weapp/combo/:id',
        component: './main-operations/platform/modifyLocationComboDetail',
        microApp: 'sale-app',
    },
    // {
    //   name: 'main-operations-pos-product',
    //   title: 'POS门店商品',
    //   path: '/main-operations/pos/product',
    //   component: './main-operations/posBranchGoods',
    //   microApp: 'sale-app',
    // },
    // {
    //   name: 'main-operations-pos-product',
    //   title: 'POS门店商品',
    //   path: '/main-operations/pos/product/:id',
    //   component: './main-operations/platform/modifyLocationProduct',
    //   microApp: 'sale-app',
    // },
    {
        name: 'main-operations-pos-product',
        path: '/main-operations/pos/combo/:id',
        component: './main-operations/platform/modifyLocationComboDetail',
        microApp: 'sale-app',
    },
    {
        name: 'main-operations-fullReduce',
        path: '/main-operations/promotion/marketingActivities/fullReduce',
        component: './main-operations/marketingActivities/fullReduce',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-fullReduce',
        path: '/main-operations/promotion/marketingActivities/fullReduce/:id',
        component: './main-operations/marketingActivities/fullReduce/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-fullReduce',
        path: '/main-operations/promotion/marketingActivities/fullReduce/data/:id',
        component: './main-operations/marketingActivities/fullReduce/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-timeLimitDiscount',
        path: '/main-operations/promotion/marketingActivities/timeLimitDiscount',
        component: './main-operations/marketingActivities/timeLimitDiscount',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-timeLimitDiscount',
        path: '/main-operations/promotion/marketingActivities/timeLimitDiscount/:id',
        component: './main-operations/marketingActivities/timeLimitDiscount/detail',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
    {
        name: 'main-operations-timeLimitDiscount',
        path: '/main-operations/promotion/marketingActivities/timeLimitDiscount/data/:id',
        component: './main-operations/marketingActivities/timeLimitDiscount/data',
        microApp: 'sale-app',
        category: 'MARKETING_CENTER',
    },
];
const getRouteTabs$1 = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    code_key: code_key || item.code_key,
}));
var index$2 = getRouteTabs$1({
    routes: saleRoutes,
    category: 'OPERATION_CENTER',
});

/*
 * @Author: 毛和水
 * @Date: 2024-10-18 14:20:01
 * @LastEditors: rxw
 * @LastEditTime: 2025-09-11 16:45:07
 * @Description: file content
 */
const PAY_ROUTES = [
    {
        name: 'main-finance-financeCenter',
        path: '/main-finance/financeCenter/pay/:payNo',
        component: './financeCenter',
    },
    // 商户支付
    {
        name: 'main-finance-dashboard',
        path: '/main-finance/dashboard',
        component: './dashboard',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_DASHBOARD],
    },
    {
        name: 'main-finance-payTrade',
        path: '/main-finance/payTrade',
        component: './payTrade',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_TRADE],
    },
    {
        name: 'main-finance-appletPayTrade',
        path: '/main-finance/payTradeDetail/:id',
        component: './payTrade/detail',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_TRADE],
    },
    {
        name: 'main-finance-payRecord',
        path: '/main-finance/payRecord',
        component: './payRecord',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_RECORD],
    },
    {
        name: 'main-finance-payRecord',
        path: '/main-finance/payRecordDetail/:id',
        component: './payRecord/detail',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_RECORD],
    },
    {
        name: 'main-finance-payRefund',
        path: '/main-finance/payRefund',
        component: './payRefund',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_REFUND],
    },
    {
        name: 'main-finance-myApp',
        path: '/main-finance/myApp',
        component: './myApp',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_MY_APP],
    },
    {
        name: 'main-finance-myMerchant',
        path: '/main-finance/myMerchant',
        component: './myMerchant',
        code_key: [
            IPermissonCode.PERMISSION_MERCHANT_PAY_MY_MERCHANT,
            IPermissonCode.PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_MGR,
            IPermissonCode.PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_GROUP,
        ],
    },
    {
        name: 'main-finance-myMerchant',
        path: '/main-finance/myMerchant/:id',
        component: './myMerchant/detail',
        code_key: [
            IPermissonCode.PERMISSION_MERCHANT_PAY_MY_MERCHANT,
            IPermissonCode.PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_MGR,
            IPermissonCode.PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_GROUP,
        ],
    },
    {
        name: 'main-finance-channelConfig',
        path: '/main-finance/channelConfig',
        component: './channelConfig',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_CHANNEL_CONFIG],
    },
    {
        name: 'main-finance-channelConfig',
        path: '/main-finance/channelConfigDetail/:id?',
        component: './channelConfig/detail',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_CHANNEL_CONFIG],
    },
    {
        name: 'main-finance-location-sub-merchant-config',
        path: '/main-finance/locationSubMerchantConfig',
        component: './locationSubMerchantConfig',
        code_key: [IPermissonCode.PERMISSION_MERCHANT_PAY_LOCATION_SUB_APP],
    },
    // 平台小程序支付
    {
        name: 'main-finance-appletPayTrade',
        path: '/main-finance/appletPayTrade',
        component: './appletPayTrade',
        code_key: [IPermissonCode.PERMISSION_PLATFORM_PAY_TRADE],
    },
    {
        name: 'main-finance-appletPayTrade',
        path: '/main-finance/appletPayTradeDetail/:id',
        component: './appletPayTrade/detail',
        code_key: [IPermissonCode.PERMISSION_PLATFORM_PAY_TRADE],
    },
    {
        name: 'main-finance-appletPayRecord',
        path: '/main-finance/appletPayRecord',
        component: './appletPayRecord',
        code_key: [IPermissonCode.PERMISSION_PLATFORM_PAY_RECORD],
    },
    {
        name: 'main-finance-appletPayRecord',
        path: '/main-finance/appletPayRecordDetail/:id',
        component: './appletPayRecord/detail',
        code_key: [IPermissonCode.PERMISSION_PLATFORM_PAY_RECORD],
    },
    {
        name: 'main-finance-appletPayRefund',
        path: '/main-finance/appletPayRefund',
        component: './appletPayRefund',
        code_key: [IPermissonCode.PERMISSION_PLATFORM_PAY_REFUND],
    },
    // 加盟分账
    {
        name: 'main-finance-financialEntity',
        path: '/main-finance/financialEntity',
        component: './financialEntity',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY],
    },
    {
        name: 'main-finance-locationFinanceSetting',
        path: '/main-finance/locationFinanceSetting',
        component: './locationFinanceSetting',
        code_key: [IPermissonCode.PERMISSION_FINANCE_SUBJECT_LOCATION_CONFIG],
    },
    {
        name: 'main-finance-locationFinanceSetting',
        path: '/main-finance/locationFinanceSettingDetails',
        component: './locationFinanceSetting/detail',
        code_key: [IPermissonCode.PERMISSION_FINANCE_SUBJECT_LOCATION_CONFIG],
    },
    {
        name: 'main-finance-moneySetting',
        path: '/main-finance/moneySetting',
        component: './moneySetting',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_FEE_ITEM],
    },
    {
        name: 'main-finance-financialEntityChangeRecord',
        path: '/main-finance/financialEntityChangeRecord',
        component: './financialEntityChangeRecord',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY_CHANGE_RECORD],
    },
    {
        name: 'main-finance-summaryOfFlow',
        path: '/main-finance/summaryOfFlow',
        component: './summaryOfFlow',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_COMBINE_BALANCE_FLOW],
    },
    {
        name: 'main-finance-capitalFlow',
        path: '/main-finance/capitalFlow',
        component: './capitalFlow',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_FUND_ACCOUNT_FLOW],
    },
    {
        name: 'main-finance-recordAccountFlow',
        path: '/main-finance/recordAccountFlow',
        component: './recordAccountFlow',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_RECORD_ACCOUNT_FLOW],
    },
    {
        name: 'main-finance-paymentRecords',
        path: '/main-finance/paymentRecords/:orderId?',
        component: './paymentRecords',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD],
    },
    {
        name: 'main-finance-withdrawalRecords',
        path: '/main-finance/withdrawalRecords',
        component: './withdrawalRecords',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_WITHDRAWAL_RECORD],
    },
    {
        name: 'main-finance-distributionAudit',
        path: '/main-finance/distributionAudit',
        component: './distributionAudit',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_BATCH_SETTLEMENT_ORDER_CHECK],
    },
    {
        name: 'main-finance-streamSummary',
        path: '/main-finance/streamSummary',
        component: './streamSummary',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STREAM_SUMMARY],
    },
    {
        name: 'main-finance-paymentRecordSummary',
        path: '/main-finance/paymentRecordSummary',
        component: './paymentRecordSummary',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD_SUMMARY],
    },
    {
        name: 'main-finance-settlementOrder',
        path: '/main-finance/settlementOrder',
        component: './settlementOrder',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STATISTIC],
    },
    {
        name: 'main-finance-storedValueConsumptionLedger',
        path: '/main-finance/storedValueConsumptionLedger',
        component: './storedValueConsumptionLedger',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_LEDGER],
    },
    {
        name: 'main-finance-storedValueConsumptionSettlementForm',
        path: '/main-finance/storedValueConsumptionSettlementForm/id/:settleId?',
        component: './storedValueConsumptionSettlementForm',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-storedValueConsumptionSettlementForm',
        path: '/main-finance/storedValueConsumptionSettlementForm',
        component: './storedValueConsumptionSettlementForm',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-storedValueConsumptionSettlementForm',
        path: '/main-finance/storedValueConsumptionSettlementForm/batchDetail',
        component: './storedValueConsumptionSettlementForm/batchDetails',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-storedValueConsumptionSettlementForm',
        path: '/main-finance/storedValueConsumptionSettlementForm/settleDetail',
        component: './storedValueConsumptionSettlementForm/settlementDetails',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-giftCardConsumptionLedger',
        path: '/main-finance/giftCardConsumptionLedger',
        component: './giftCardConsumptionLedger',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_LEDGER],
    },
    {
        name: 'main-finance-giftCardConsumptionSettlementForm',
        path: '/main-finance/giftCardConsumptionSettlementForm/id/:settleId?',
        component: './giftCardConsumptionSettlementForm',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-giftCardConsumptionSettlementForm',
        path: '/main-finance/giftCardConsumptionSettlementForm',
        component: './giftCardConsumptionSettlementForm',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-giftCardConsumptionSettlementForm',
        path: '/main-finance/giftCardConsumptionSettlementForm/batchDetails',
        component: './giftCardConsumptionSettlementForm/batchDetails',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-giftCardConsumptionSettlementForm',
        path: '/main-finance/giftCardConsumptionSettlementForm/settlementDetails',
        component: './giftCardConsumptionSettlementForm/settlementDetails',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-voucherVerificationLedger',
        path: '/main-finance/voucherVerificationLedger',
        component: './voucherVerificationLedger',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_LEDGER],
    },
    {
        name: 'main-finance-voucherVerificationSettlementForm',
        path: '/main-finance/voucherVerificationSettlementForm/id/:settleId?',
        component: './voucherVerificationSettlementForm',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-voucherVerificationSettlementForm',
        path: '/main-finance/voucherVerificationSettlementForm',
        component: './voucherVerificationSettlementForm',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-voucherVerificationSettlementForm',
        path: '/main-finance/voucherVerificationSettlementForm/batchDetails',
        component: './voucherVerificationSettlementForm/batchDetails',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-voucherVerificationSettlementForm',
        path: '/main-finance/voucherVerificationSettlementForm/settlementDetails',
        component: './voucherVerificationSettlementForm/settlementDetails',
        code_key: [
            IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM,
        ],
    },
    {
        name: 'main-finance-headquartersLedger',
        path: '/main-finance/headquartersLedger',
        component: './headquartersLedger',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_LEDGER],
    },
    {
        name: 'main-finance-headquartersExpense',
        path: '/main-finance/headquartersExpense',
        component: './headquartersExpense',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_EXPENSE],
    },
    {
        name: 'main-finance-headquartersExpense',
        path: '/main-finance/headquartersExpenseDetails',
        component: './headquartersExpense/detail',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_EXPENSE],
    },
    {
        name: 'main-finance-headquartersSettlementForm',
        path: '/main-finance/headquartersSettlementForm/id/:settleId?',
        component: './headquartersSettlementForm',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-headquartersSettlementForm',
        path: '/main-finance/headquartersSettlementForm',
        component: './headquartersSettlementForm',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-headquartersSettlementForm',
        path: '/main-finance/headquartersSettlementForm/batchDetails',
        component: './headquartersSettlementForm/batchDetails',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-headquartersSettlementForm',
        path: '/main-finance/headquartersSettlementForm/settlementDetails',
        component: './headquartersSettlementForm/settlementDetails',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-locationLedger',
        path: '/main-finance/locationLedger',
        component: './locationLedger',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_LEDGER],
    },
    {
        name: 'main-finance-locationExpense',
        path: '/main-finance/locationExpense',
        component: './locationExpense',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_EXPENSE],
    },
    {
        name: 'main-finance-locationExpense',
        path: '/main-finance/locationExpenseDetails',
        component: './locationExpense/detail',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_EXPENSE],
    },
    {
        name: 'main-finance-locationSettlementForm',
        path: '/main-finance/locationSettlementForm/id/:settleId?',
        component: './locationSettlementForm',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-locationSettlementForm',
        path: '/main-finance/locationSettlementForm',
        component: './locationSettlementForm',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-locationSettlementForm',
        path: '/main-finance/locationSettlementForm/batchDetails',
        component: './locationSettlementForm/batchDetails',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-locationSettlementForm',
        path: '/main-finance/locationSettlementForm/settlementDetails',
        component: './locationSettlementForm/settlementDetails',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-customLedger',
        path: '/main-finance/customLedger',
        component: './customLedger',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_LEDGER],
    },
    {
        name: 'main-finance-fundParams',
        path: '/main-finance/fundParams',
        component: './fundParams',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_FINANCE_SETTING],
    },
    {
        name: 'main-finance-customSettlementForm',
        path: '/main-finance/customSettlementForm/id/:settleId?',
        component: './customSettlementForm',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-customSettlementForm',
        path: '/main-finance/customSettlementForm',
        component: './customSettlementForm',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_SETTLEMENT_FORM],
    },
    {
        name: 'main-finance-customSettlementForm',
        path: '/main-finance/customSettlementForm/batchDetails',
        component: './customSettlementForm/batchDetails',
        code_key: [IPermissonCode.PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_SETTLEMENT_FORM],
    },
].map((item) => ({
    ...item,
    microApp: 'pay-app',
}));
const getRouteTabs = ({ routes, prefix, category, code_key }) => routes.map((item) => ({
    ...item,
    name: prefix ? `${prefix}-${item.name}` : item.name,
    category: item.category || category,
    microApp: 'pay-app',
    code_key: code_key || item.code_key,
}));
var index$1 = getRouteTabs({ routes: PAY_ROUTES, category: 'FINANCE_CENTER' });

/*
 * @Author: CLKimi
 * @Date: 2021-04-14 11:34:52
 * @LastEditors: 王茂林
 * @LastEditTime: 2025-03-31 20:53:50
 * @Description: 装修路由
 */
var shoppage = [
    {
        name: 'decorateShoppageMerchantPageEditor',
        path: '/decorate/shoppage/merchantPage/editor/:id',
        component: './Decorate/shoppage/merchantPage/editor/index',
    },
    {
        name: 'decorateShoppageMerchantPage',
        path: '/decorate/shoppage/merchantPage',
        component: './Decorate/shoppage/merchantPage/editor/index',
    },
    {
        name: 'decorateShoppageMerchantPage',
        path: '/decorate/shoppage/customPage',
        component: './Decorate/shoppage/merchantPage/merchantPage',
    },
    {
        name: 'decorateShoppageSortpage',
        path: '/decorate/shoppage/sortpage',
        component: './Decorate/shoppage/sortpage/sortpage/index',
    },
    {
        name: 'decorateShoppageUserCenterPage',
        path: '/decorate/shoppage/userCenterPage',
        component: './Decorate/shoppage/userCenterPage/userCenterPage/index',
    },
    {
        name: 'decorateShoppageMemberStoredValue',
        path: '/decorate/shoppage/memberStoredValue',
        component: './Decorate/shoppage/memberStoredValue/index',
    },
    {
        name: 'decorateShoppageListPage',
        path: '/decorate/shoppage/listpage',
        component: './Decorate/shoppage/listpage/listpage/index',
    },
    {
        name: 'decorateShoppageGoodsPageEditor',
        path: '/decorate/shoppage/goodspage/editor',
        component: './Decorate/shoppage/goodspage/editor/index',
    },
    {
        name: 'decorateShoppageGoodsPage',
        path: '/decorate/shoppage/goodspage',
        component: './Decorate/shoppage/goodspage/goodspage/index',
    },
    {
        name: 'decorateShoppagePackagePage',
        path: '/decorate/shoppage/packagePage',
        component: './Decorate/shoppage/packagePage',
    },
    {
        name: 'decorateShoppageStoreNavigationPage',
        path: '/decorate/shoppage/storeNavigationPage',
        component: './Decorate/shoppage/storeNavigationPage/navigationpage/index',
    },
    {
        name: 'decorateShoppageSearchPages',
        path: '/decorate/shoppage/searchPages',
        component: './Decorate/shoppage/searchPages/searchPages/index',
    },
    {
        name: 'decorateShoppageSharePage',
        path: '/decorate/shoppage/sharePage',
        component: './Decorate/shoppage/sharePage/sharePage/index',
    },
    {
        name: 'decorateCustomLoading',
        path: '/decorate/shoppage/customLoading',
        component: './Decorate/shoppage/customLoading/customLoading/index',
    },
    {
        name: 'decorateShoppageCopyrightLogo',
        path: '/decorate/shoppage/copyrightLogo',
        component: './Decorate/shoppage/copyrightLogo/copyrightLogo/index',
    },
    {
        name: 'decorateShoppageAppletPage',
        path: '/decorate/shoppage/appletPage',
        component: './Decorate/shoppage/appletPage/index',
    },
    {
        name: 'decorateShoppageOrderDetail',
        path: '/decorate/shoppage/orderDetail',
        component: './Decorate/shoppage/orderDetail/index',
    },
    {
        name: 'decorateShoppageCustomizPageEditor',
        path: '/decorate/shoppage/customizPage/editor/:id',
        component: './Decorate/shoppage/customizPage/editor/index',
    },
    {
        name: 'decorateShoppageCustomPage',
        path: '/decorate/shoppage/customizPage',
        component: './Decorate/shoppage/customizPage/customPage/index',
    },
    {
        name: 'decorateShoppageFloatingWindows',
        path: '/decorate/shoppage/floatingWindows',
        component: './Decorate/shoppage/floatingWindows/list/index',
    },
    {
        name: 'decorateShoppagePointShops',
        path: '/decorate/shoppage/pointShops',
        component: './Decorate/shoppage/pointShops/list/index',
    },
    {
        name: 'decorateShoppageSystemStyle',
        path: '/decorate/shoppage/systemStyle',
        component: './Decorate/shoppage/systemStyle/index',
    },
    {
        name: 'decorateShoppageBootPage',
        path: '/decorate/shoppage/bootPage',
        component: './Decorate/shoppage/bootPage/bootPage/index',
    },
    {
        name: 'decorateShoppageGiftCards',
        path: '/decorate/shoppage/giftCards',
        component: './Decorate/shoppage/giftCards/list/index',
    },
    {
        name: 'decorateShoppageReceiveCouponCenter',
        path: '/decorate/shoppage/receiveCouponCenter',
        component: './Decorate/shoppage/receiveCouponCenter/index',
    },
    {
        name: 'decorateShoppageGetDiscountActivity',
        path: '/decorate/shoppage/getDiscountActivity',
        component: './Decorate/shoppage/getDiscountActivity/index',
    },
    {
        name: 'decorateShoppageCollectStamp',
        path: '/decorate/shoppage/collectStamp',
        component: './Decorate/shoppage/collectStamp/index',
    },
    {
        name: 'decorateShoppageMallPage',
        path: '/decorate/shoppage/mallPage',
        component: './Decorate/shoppage/mallPage/index',
    },
    {
        name: 'decorateShoppageLimitedDiscountPage',
        path: '/decorate/shoppage/limitedDiscount',
        component: './Decorate/shoppage/limitedDiscountPage/index',
    },
    {
        name: 'decorateShoppageScanCode',
        path: '/decorate/shoppage/scanCode',
        component: './Decorate/shoppage/scanCode/index',
    },
    {
        name: 'decorateShoppageCustomerCount',
        path: '/decorate/shoppage/customerCount',
        component: './Decorate/shoppage/customerCount/index',
    },
    {
        name: 'decorateShoppageDineOrder',
        path: '/decorate/shoppage/dineOrder',
        component: './Decorate/shoppage/dineOrder/index',
    },
    {
        name: 'decorateShoppageOrderConfirm',
        path: '/decorate/shoppage/orderConfirm',
        component: './Decorate/shoppage/orderConfirm/index',
    },
    {
        name: 'decorateShoppageOrderSuccess',
        path: '/decorate/shoppage/orderSuccess',
        component: './Decorate/shoppage/orderSuccess/index',
    },
    {
        name: 'decorateShoppageProductPreOrder',
        path: '/decorate/shoppage/productPreOrder',
        component: './Decorate/shoppage/productPreOrder/index',
    },
    {
        name: 'decorateShoppageOrderList',
        path: '/decorate/shoppage/orderList',
        component: './Decorate/shoppage/orderList/index',
    },
    {
        name: 'decorateShoppageGiftLuckyDrawPage',
        path: '/decorate/shoppage/giftLuckyDraw',
        component: './Decorate/shoppage/giftLuckyDrawPage/index',
    },
];

/*
 * @Author: CLKimi
 * @Date: 2021-04-14 11:34:52
 * @LastEditors: 王茂林
 * @LastEditTime: 2024-01-29 20:44:51
 * @Description: 装修配置页路由
 */
var shoppageEditor = [
    {
        name: 'decorateShoppageSortpageEditor',
        path: '/decorate/shoppage/sortpage/editor/:id',
        component: './Decorate/shoppage/sortpage/editor/index',
    },
    {
        name: 'decorateShoppageUserCenterPageEditor',
        path: '/decorate/shoppage/userCenterPage/editor/:id',
        component: './Decorate/shoppage/userCenterPage/editor/index',
    },
    {
        name: 'decorateShoppageListPageEditor',
        path: '/decorate/shoppage/listpage/editor',
        component: './Decorate/shoppage/listpage/editor/index',
    },
    {
        name: 'decorateShoppageStoreNavigationPage',
        path: '/decorate/shoppage/storeNavigationPage/editor',
        component: './Decorate/shoppage/storeNavigationPage/editor/index',
    },
    {
        name: 'decorateShoppageSearchPages',
        path: '/decorate/shoppage/searchPages/editor',
        component: './Decorate/shoppage/searchPages/editor/index',
    },
    {
        name: 'decorateCustomLoading',
        path: '/decorate/shoppage/customLoading/editor',
        component: './Decorate/shoppage/customLoading/editor/index',
    },
    {
        name: 'decorateShoppageCopyrightLogo',
        path: '/decorate/shoppage/copyrightLogo/editor',
        component: './Decorate/shoppage/copyrightLogo/editor/index',
    },
    {
        name: 'decorateShoppageFloatingWindows',
        path: '/decorate/shoppage/floatingWindows/editor',
        component: './Decorate/shoppage/floatingWindows/editor/index',
    },
    {
        name: 'decorateShoppagePointShops',
        path: '/decorate/shoppage/pointShops/editor/:id',
        component: './Decorate/shoppage/pointShops/editor/index',
    },
    {
        name: 'decorateShoppageBootPage',
        path: '/decorate/shoppage/bootPage/editor/:id',
        component: './Decorate/shoppage/bootPage/editor/index',
    },
    {
        name: 'decorateShoppageGiftCards',
        path: '/decorate/shoppage/giftCards/editor',
        component: './Decorate/shoppage/giftCards/editor/index',
    },
    {
        name: 'decorateShoppageMallPage',
        path: '/decorate/shoppage/mallPage/editor/:id',
        component: './Decorate/shoppage/mallPage/editor/index',
    },
    {
        name: 'decorateShoppageProductPreOrder',
        path: '/decorate/shoppage/productPreOrder/editor/:id',
        component: './Decorate/shoppage/productPreOrder/editor/index',
    },
];

/*
 * @Author: wangrt
 * @Date: 2021-05-25 11:19:33
 * @LastEditors: wangrt
 * @LastEditTime: 2021-06-29 14:40:43
 * @Description: file content
 */
var contentManage = [
    {
        name: 'decorateContentManage',
        path: '/decorate/shoppage/contentManage',
        component: './Decorate/shoppage/contentManage',
    },
];

/*
 * @Author: CLKimi
 * @Date: 2021-04-14 11:34:36
 * @LastEditors: wangrt
 * @LastEditTime: 2021-05-25 16:52:17
 * @Description: file content
 */
var index = {
    path: '/decorate',
    routes: [
        {
            path: '/decorate',
            component: '../layouts/authority-layout',
            routes: [
                ...shoppageEditor,
                {
                    path: '/decorate',
                    component: '../layouts/decorate-layout',
                    routes: [...shoppage, ...contentManage],
                },
            ],
        },
    ],
};

var city = [
    {
        name: '北京市',
        code: '110000',
        children: [
            {
                name: '市辖区',
                code: '110100',
                children: [
                    {
                        name: '东城区',
                        code: '110101',
                    },
                    {
                        name: '西城区',
                        code: '110102',
                    },
                    {
                        name: '朝阳区',
                        code: '110105',
                    },
                    {
                        name: '丰台区',
                        code: '110106',
                    },
                    {
                        name: '石景山区',
                        code: '110107',
                    },
                    {
                        name: '海淀区',
                        code: '110108',
                    },
                    {
                        name: '门头沟区',
                        code: '110109',
                    },
                    {
                        name: '房山区',
                        code: '110111',
                    },
                    {
                        name: '通州区',
                        code: '110112',
                    },
                    {
                        name: '顺义区',
                        code: '110113',
                    },
                    {
                        name: '昌平区',
                        code: '110114',
                    },
                    {
                        name: '大兴区',
                        code: '110115',
                    },
                    {
                        name: '怀柔区',
                        code: '110116',
                    },
                    {
                        name: '平谷区',
                        code: '110117',
                    },
                    {
                        name: '密云区',
                        code: '110118',
                    },
                    {
                        name: '延庆区',
                        code: '110119',
                    },
                ],
            },
        ],
    },
    {
        name: '天津市',
        code: '120000',
        children: [
            {
                name: '市辖区',
                code: '120100',
                children: [
                    {
                        name: '和平区',
                        code: '120101',
                    },
                    {
                        name: '河东区',
                        code: '120102',
                    },
                    {
                        name: '河西区',
                        code: '120103',
                    },
                    {
                        name: '南开区',
                        code: '120104',
                    },
                    {
                        name: '河北区',
                        code: '120105',
                    },
                    {
                        name: '红桥区',
                        code: '120106',
                    },
                    {
                        name: '东丽区',
                        code: '120110',
                    },
                    {
                        name: '西青区',
                        code: '120111',
                    },
                    {
                        name: '津南区',
                        code: '120112',
                    },
                    {
                        name: '北辰区',
                        code: '120113',
                    },
                    {
                        name: '武清区',
                        code: '120114',
                    },
                    {
                        name: '宝坻区',
                        code: '120115',
                    },
                    {
                        name: '滨海新区',
                        code: '120116',
                    },
                    {
                        name: '宁河区',
                        code: '120117',
                    },
                    {
                        name: '静海区',
                        code: '120118',
                    },
                    {
                        name: '蓟州区',
                        code: '120119',
                    },
                ],
            },
        ],
    },
    {
        name: '河北省',
        code: '130000',
        children: [
            {
                name: '石家庄市',
                code: '130100',
                children: [
                    {
                        name: '长安区',
                        code: '130102',
                    },
                    {
                        name: '桥西区',
                        code: '130104',
                    },
                    {
                        name: '新华区',
                        code: '130105',
                    },
                    {
                        name: '井陉矿区',
                        code: '130107',
                    },
                    {
                        name: '裕华区',
                        code: '130108',
                    },
                    {
                        name: '藁城区',
                        code: '130109',
                    },
                    {
                        name: '鹿泉区',
                        code: '130110',
                    },
                    {
                        name: '栾城区',
                        code: '130111',
                    },
                    {
                        name: '井陉县',
                        code: '130121',
                    },
                    {
                        name: '正定县',
                        code: '130123',
                    },
                    {
                        name: '行唐县',
                        code: '130125',
                    },
                    {
                        name: '灵寿县',
                        code: '130126',
                    },
                    {
                        name: '高邑县',
                        code: '130127',
                    },
                    {
                        name: '深泽县',
                        code: '130128',
                    },
                    {
                        name: '赞皇县',
                        code: '130129',
                    },
                    {
                        name: '无极县',
                        code: '130130',
                    },
                    {
                        name: '平山县',
                        code: '130131',
                    },
                    {
                        name: '元氏县',
                        code: '130132',
                    },
                    {
                        name: '赵县',
                        code: '130133',
                    },
                    {
                        name: '石家庄高新技术产业开发区',
                        code: '130171',
                    },
                    {
                        name: '石家庄循环化工园区',
                        code: '130172',
                    },
                    {
                        name: '辛集市',
                        code: '130181',
                    },
                    {
                        name: '晋州市',
                        code: '130183',
                    },
                    {
                        name: '新乐市',
                        code: '130184',
                    },
                ],
            },
            {
                name: '唐山市',
                code: '130200',
                children: [
                    {
                        name: '路南区',
                        code: '130202',
                    },
                    {
                        name: '路北区',
                        code: '130203',
                    },
                    {
                        name: '古冶区',
                        code: '130204',
                    },
                    {
                        name: '开平区',
                        code: '130205',
                    },
                    {
                        name: '丰南区',
                        code: '130207',
                    },
                    {
                        name: '丰润区',
                        code: '130208',
                    },
                    {
                        name: '曹妃甸区',
                        code: '130209',
                    },
                    {
                        name: '滦南县',
                        code: '130224',
                    },
                    {
                        name: '乐亭县',
                        code: '130225',
                    },
                    {
                        name: '迁西县',
                        code: '130227',
                    },
                    {
                        name: '玉田县',
                        code: '130229',
                    },
                    {
                        name: '河北唐山芦台经济开发区',
                        code: '130271',
                    },
                    {
                        name: '唐山市汉沽管理区',
                        code: '130272',
                    },
                    {
                        name: '唐山高新技术产业开发区',
                        code: '130273',
                    },
                    {
                        name: '河北唐山海港经济开发区',
                        code: '130274',
                    },
                    {
                        name: '遵化市',
                        code: '130281',
                    },
                    {
                        name: '迁安市',
                        code: '130283',
                    },
                    {
                        name: '滦州市',
                        code: '130284',
                    },
                ],
            },
            {
                name: '秦皇岛市',
                code: '130300',
                children: [
                    {
                        name: '海港区',
                        code: '130302',
                    },
                    {
                        name: '山海关区',
                        code: '130303',
                    },
                    {
                        name: '北戴河区',
                        code: '130304',
                    },
                    {
                        name: '抚宁区',
                        code: '130306',
                    },
                    {
                        name: '青龙满族自治县',
                        code: '130321',
                    },
                    {
                        name: '昌黎县',
                        code: '130322',
                    },
                    {
                        name: '卢龙县',
                        code: '130324',
                    },
                    {
                        name: '秦皇岛市经济技术开发区',
                        code: '130371',
                    },
                    {
                        name: '北戴河新区',
                        code: '130372',
                    },
                ],
            },
            {
                name: '邯郸市',
                code: '130400',
                children: [
                    {
                        name: '邯山区',
                        code: '130402',
                    },
                    {
                        name: '丛台区',
                        code: '130403',
                    },
                    {
                        name: '复兴区',
                        code: '130404',
                    },
                    {
                        name: '峰峰矿区',
                        code: '130406',
                    },
                    {
                        name: '肥乡区',
                        code: '130407',
                    },
                    {
                        name: '永年区',
                        code: '130408',
                    },
                    {
                        name: '临漳县',
                        code: '130423',
                    },
                    {
                        name: '成安县',
                        code: '130424',
                    },
                    {
                        name: '大名县',
                        code: '130425',
                    },
                    {
                        name: '涉县',
                        code: '130426',
                    },
                    {
                        name: '磁县',
                        code: '130427',
                    },
                    {
                        name: '邱县',
                        code: '130430',
                    },
                    {
                        name: '鸡泽县',
                        code: '130431',
                    },
                    {
                        name: '广平县',
                        code: '130432',
                    },
                    {
                        name: '馆陶县',
                        code: '130433',
                    },
                    {
                        name: '魏县',
                        code: '130434',
                    },
                    {
                        name: '曲周县',
                        code: '130435',
                    },
                    {
                        name: '邯郸经济技术开发区',
                        code: '130471',
                    },
                    {
                        name: '邯郸冀南新区',
                        code: '130473',
                    },
                    {
                        name: '武安市',
                        code: '130481',
                    },
                ],
            },
            {
                name: '邢台市',
                code: '130500',
                children: [
                    {
                        name: '襄都区',
                        code: '130502',
                    },
                    {
                        name: '信都区',
                        code: '130503',
                    },
                    {
                        name: '任泽区',
                        code: '130505',
                    },
                    {
                        name: '南和区',
                        code: '130506',
                    },
                    {
                        name: '临城县',
                        code: '130522',
                    },
                    {
                        name: '内丘县',
                        code: '130523',
                    },
                    {
                        name: '柏乡县',
                        code: '130524',
                    },
                    {
                        name: '隆尧县',
                        code: '130525',
                    },
                    {
                        name: '宁晋县',
                        code: '130528',
                    },
                    {
                        name: '巨鹿县',
                        code: '130529',
                    },
                    {
                        name: '新河县',
                        code: '130530',
                    },
                    {
                        name: '广宗县',
                        code: '130531',
                    },
                    {
                        name: '平乡县',
                        code: '130532',
                    },
                    {
                        name: '威县',
                        code: '130533',
                    },
                    {
                        name: '清河县',
                        code: '130534',
                    },
                    {
                        name: '临西县',
                        code: '130535',
                    },
                    {
                        name: '河北邢台经济开发区',
                        code: '130571',
                    },
                    {
                        name: '南宫市',
                        code: '130581',
                    },
                    {
                        name: '沙河市',
                        code: '130582',
                    },
                ],
            },
            {
                name: '保定市',
                code: '130600',
                children: [
                    {
                        name: '竞秀区',
                        code: '130602',
                    },
                    {
                        name: '莲池区',
                        code: '130606',
                    },
                    {
                        name: '满城区',
                        code: '130607',
                    },
                    {
                        name: '清苑区',
                        code: '130608',
                    },
                    {
                        name: '徐水区',
                        code: '130609',
                    },
                    {
                        name: '涞水县',
                        code: '130623',
                    },
                    {
                        name: '阜平县',
                        code: '130624',
                    },
                    {
                        name: '定兴县',
                        code: '130626',
                    },
                    {
                        name: '唐县',
                        code: '130627',
                    },
                    {
                        name: '高阳县',
                        code: '130628',
                    },
                    {
                        name: '容城县',
                        code: '130629',
                    },
                    {
                        name: '涞源县',
                        code: '130630',
                    },
                    {
                        name: '望都县',
                        code: '130631',
                    },
                    {
                        name: '安新县',
                        code: '130632',
                    },
                    {
                        name: '易县',
                        code: '130633',
                    },
                    {
                        name: '曲阳县',
                        code: '130634',
                    },
                    {
                        name: '蠡县',
                        code: '130635',
                    },
                    {
                        name: '顺平县',
                        code: '130636',
                    },
                    {
                        name: '博野县',
                        code: '130637',
                    },
                    {
                        name: '雄县',
                        code: '130638',
                    },
                    {
                        name: '保定高新技术产业开发区',
                        code: '130671',
                    },
                    {
                        name: '保定白沟新城',
                        code: '130672',
                    },
                    {
                        name: '涿州市',
                        code: '130681',
                    },
                    {
                        name: '定州市',
                        code: '130682',
                    },
                    {
                        name: '安国市',
                        code: '130683',
                    },
                    {
                        name: '高碑店市',
                        code: '130684',
                    },
                ],
            },
            {
                name: '张家口市',
                code: '130700',
                children: [
                    {
                        name: '桥东区',
                        code: '130702',
                    },
                    {
                        name: '桥西区',
                        code: '130703',
                    },
                    {
                        name: '宣化区',
                        code: '130705',
                    },
                    {
                        name: '下花园区',
                        code: '130706',
                    },
                    {
                        name: '万全区',
                        code: '130708',
                    },
                    {
                        name: '崇礼区',
                        code: '130709',
                    },
                    {
                        name: '张北县',
                        code: '130722',
                    },
                    {
                        name: '康保县',
                        code: '130723',
                    },
                    {
                        name: '沽源县',
                        code: '130724',
                    },
                    {
                        name: '尚义县',
                        code: '130725',
                    },
                    {
                        name: '蔚县',
                        code: '130726',
                    },
                    {
                        name: '阳原县',
                        code: '130727',
                    },
                    {
                        name: '怀安县',
                        code: '130728',
                    },
                    {
                        name: '怀来县',
                        code: '130730',
                    },
                    {
                        name: '涿鹿县',
                        code: '130731',
                    },
                    {
                        name: '赤城县',
                        code: '130732',
                    },
                    {
                        name: '张家口经济开发区',
                        code: '130771',
                    },
                    {
                        name: '张家口市察北管理区',
                        code: '130772',
                    },
                    {
                        name: '张家口市塞北管理区',
                        code: '130773',
                    },
                ],
            },
            {
                name: '承德市',
                code: '130800',
                children: [
                    {
                        name: '双桥区',
                        code: '130802',
                    },
                    {
                        name: '双滦区',
                        code: '130803',
                    },
                    {
                        name: '鹰手营子矿区',
                        code: '130804',
                    },
                    {
                        name: '承德县',
                        code: '130821',
                    },
                    {
                        name: '兴隆县',
                        code: '130822',
                    },
                    {
                        name: '滦平县',
                        code: '130824',
                    },
                    {
                        name: '隆化县',
                        code: '130825',
                    },
                    {
                        name: '丰宁满族自治县',
                        code: '130826',
                    },
                    {
                        name: '宽城满族自治县',
                        code: '130827',
                    },
                    {
                        name: '围场满族蒙古族自治县',
                        code: '130828',
                    },
                    {
                        name: '承德高新技术产业开发区',
                        code: '130871',
                    },
                    {
                        name: '平泉市',
                        code: '130881',
                    },
                ],
            },
            {
                name: '沧州市',
                code: '130900',
                children: [
                    {
                        name: '新华区',
                        code: '130902',
                    },
                    {
                        name: '运河区',
                        code: '130903',
                    },
                    {
                        name: '沧县',
                        code: '130921',
                    },
                    {
                        name: '青县',
                        code: '130922',
                    },
                    {
                        name: '东光县',
                        code: '130923',
                    },
                    {
                        name: '海兴县',
                        code: '130924',
                    },
                    {
                        name: '盐山县',
                        code: '130925',
                    },
                    {
                        name: '肃宁县',
                        code: '130926',
                    },
                    {
                        name: '南皮县',
                        code: '130927',
                    },
                    {
                        name: '吴桥县',
                        code: '130928',
                    },
                    {
                        name: '献县',
                        code: '130929',
                    },
                    {
                        name: '孟村回族自治县',
                        code: '130930',
                    },
                    {
                        name: '河北沧州经济开发区',
                        code: '130971',
                    },
                    {
                        name: '沧州高新技术产业开发区',
                        code: '130972',
                    },
                    {
                        name: '沧州渤海新区',
                        code: '130973',
                    },
                    {
                        name: '泊头市',
                        code: '130981',
                    },
                    {
                        name: '任丘市',
                        code: '130982',
                    },
                    {
                        name: '黄骅市',
                        code: '130983',
                    },
                    {
                        name: '河间市',
                        code: '130984',
                    },
                ],
            },
            {
                name: '廊坊市',
                code: '131000',
                children: [
                    {
                        name: '安次区',
                        code: '131002',
                    },
                    {
                        name: '广阳区',
                        code: '131003',
                    },
                    {
                        name: '固安县',
                        code: '131022',
                    },
                    {
                        name: '永清县',
                        code: '131023',
                    },
                    {
                        name: '香河县',
                        code: '131024',
                    },
                    {
                        name: '大城县',
                        code: '131025',
                    },
                    {
                        name: '文安县',
                        code: '131026',
                    },
                    {
                        name: '大厂回族自治县',
                        code: '131028',
                    },
                    {
                        name: '廊坊经济技术开发区',
                        code: '131071',
                    },
                    {
                        name: '霸州市',
                        code: '131081',
                    },
                    {
                        name: '三河市',
                        code: '131082',
                    },
                ],
            },
            {
                name: '衡水市',
                code: '131100',
                children: [
                    {
                        name: '桃城区',
                        code: '131102',
                    },
                    {
                        name: '冀州区',
                        code: '131103',
                    },
                    {
                        name: '枣强县',
                        code: '131121',
                    },
                    {
                        name: '武邑县',
                        code: '131122',
                    },
                    {
                        name: '武强县',
                        code: '131123',
                    },
                    {
                        name: '饶阳县',
                        code: '131124',
                    },
                    {
                        name: '安平县',
                        code: '131125',
                    },
                    {
                        name: '故城县',
                        code: '131126',
                    },
                    {
                        name: '景县',
                        code: '131127',
                    },
                    {
                        name: '阜城县',
                        code: '131128',
                    },
                    {
                        name: '河北衡水高新技术产业开发区',
                        code: '131171',
                    },
                    {
                        name: '衡水滨湖新区',
                        code: '131172',
                    },
                    {
                        name: '深州市',
                        code: '131182',
                    },
                ],
            },
        ],
    },
    {
        name: '山西省',
        code: '140000',
        children: [
            {
                name: '太原市',
                code: '140100',
                children: [
                    {
                        name: '小店区',
                        code: '140105',
                    },
                    {
                        name: '迎泽区',
                        code: '140106',
                    },
                    {
                        name: '杏花岭区',
                        code: '140107',
                    },
                    {
                        name: '尖草坪区',
                        code: '140108',
                    },
                    {
                        name: '万柏林区',
                        code: '140109',
                    },
                    {
                        name: '晋源区',
                        code: '140110',
                    },
                    {
                        name: '清徐县',
                        code: '140121',
                    },
                    {
                        name: '阳曲县',
                        code: '140122',
                    },
                    {
                        name: '娄烦县',
                        code: '140123',
                    },
                    {
                        name: '山西转型综合改革示范区',
                        code: '140171',
                    },
                    {
                        name: '古交市',
                        code: '140181',
                    },
                ],
            },
            {
                name: '大同市',
                code: '140200',
                children: [
                    {
                        name: '新荣区',
                        code: '140212',
                    },
                    {
                        name: '平城区',
                        code: '140213',
                    },
                    {
                        name: '云冈区',
                        code: '140214',
                    },
                    {
                        name: '云州区',
                        code: '140215',
                    },
                    {
                        name: '阳高县',
                        code: '140221',
                    },
                    {
                        name: '天镇县',
                        code: '140222',
                    },
                    {
                        name: '广灵县',
                        code: '140223',
                    },
                    {
                        name: '灵丘县',
                        code: '140224',
                    },
                    {
                        name: '浑源县',
                        code: '140225',
                    },
                    {
                        name: '左云县',
                        code: '140226',
                    },
                    {
                        name: '山西大同经济开发区',
                        code: '140271',
                    },
                ],
            },
            {
                name: '阳泉市',
                code: '140300',
                children: [
                    {
                        name: '城区',
                        code: '140302',
                    },
                    {
                        name: '矿区',
                        code: '140303',
                    },
                    {
                        name: '郊区',
                        code: '140311',
                    },
                    {
                        name: '平定县',
                        code: '140321',
                    },
                    {
                        name: '盂县',
                        code: '140322',
                    },
                ],
            },
            {
                name: '长治市',
                code: '140400',
                children: [
                    {
                        name: '潞州区',
                        code: '140403',
                    },
                    {
                        name: '上党区',
                        code: '140404',
                    },
                    {
                        name: '屯留区',
                        code: '140405',
                    },
                    {
                        name: '潞城区',
                        code: '140406',
                    },
                    {
                        name: '襄垣县',
                        code: '140423',
                    },
                    {
                        name: '平顺县',
                        code: '140425',
                    },
                    {
                        name: '黎城县',
                        code: '140426',
                    },
                    {
                        name: '壶关县',
                        code: '140427',
                    },
                    {
                        name: '长子县',
                        code: '140428',
                    },
                    {
                        name: '武乡县',
                        code: '140429',
                    },
                    {
                        name: '沁县',
                        code: '140430',
                    },
                    {
                        name: '沁源县',
                        code: '140431',
                    },
                    {
                        name: '山西长治高新技术产业园区',
                        code: '140471',
                    },
                ],
            },
            {
                name: '晋城市',
                code: '140500',
                children: [
                    {
                        name: '城区',
                        code: '140502',
                    },
                    {
                        name: '沁水县',
                        code: '140521',
                    },
                    {
                        name: '阳城县',
                        code: '140522',
                    },
                    {
                        name: '陵川县',
                        code: '140524',
                    },
                    {
                        name: '泽州县',
                        code: '140525',
                    },
                    {
                        name: '高平市',
                        code: '140581',
                    },
                ],
            },
            {
                name: '朔州市',
                code: '140600',
                children: [
                    {
                        name: '朔城区',
                        code: '140602',
                    },
                    {
                        name: '平鲁区',
                        code: '140603',
                    },
                    {
                        name: '山阴县',
                        code: '140621',
                    },
                    {
                        name: '应县',
                        code: '140622',
                    },
                    {
                        name: '右玉县',
                        code: '140623',
                    },
                    {
                        name: '山西朔州经济开发区',
                        code: '140671',
                    },
                    {
                        name: '怀仁市',
                        code: '140681',
                    },
                ],
            },
            {
                name: '晋中市',
                code: '140700',
                children: [
                    {
                        name: '榆次区',
                        code: '140702',
                    },
                    {
                        name: '太谷区',
                        code: '140703',
                    },
                    {
                        name: '榆社县',
                        code: '140721',
                    },
                    {
                        name: '左权县',
                        code: '140722',
                    },
                    {
                        name: '和顺县',
                        code: '140723',
                    },
                    {
                        name: '昔阳县',
                        code: '140724',
                    },
                    {
                        name: '寿阳县',
                        code: '140725',
                    },
                    {
                        name: '祁县',
                        code: '140727',
                    },
                    {
                        name: '平遥县',
                        code: '140728',
                    },
                    {
                        name: '灵石县',
                        code: '140729',
                    },
                    {
                        name: '介休市',
                        code: '140781',
                    },
                ],
            },
            {
                name: '运城市',
                code: '140800',
                children: [
                    {
                        name: '盐湖区',
                        code: '140802',
                    },
                    {
                        name: '临猗县',
                        code: '140821',
                    },
                    {
                        name: '万荣县',
                        code: '140822',
                    },
                    {
                        name: '闻喜县',
                        code: '140823',
                    },
                    {
                        name: '稷山县',
                        code: '140824',
                    },
                    {
                        name: '新绛县',
                        code: '140825',
                    },
                    {
                        name: '绛县',
                        code: '140826',
                    },
                    {
                        name: '垣曲县',
                        code: '140827',
                    },
                    {
                        name: '夏县',
                        code: '140828',
                    },
                    {
                        name: '平陆县',
                        code: '140829',
                    },
                    {
                        name: '芮城县',
                        code: '140830',
                    },
                    {
                        name: '永济市',
                        code: '140881',
                    },
                    {
                        name: '河津市',
                        code: '140882',
                    },
                ],
            },
            {
                name: '忻州市',
                code: '140900',
                children: [
                    {
                        name: '忻府区',
                        code: '140902',
                    },
                    {
                        name: '定襄县',
                        code: '140921',
                    },
                    {
                        name: '五台县',
                        code: '140922',
                    },
                    {
                        name: '代县',
                        code: '140923',
                    },
                    {
                        name: '繁峙县',
                        code: '140924',
                    },
                    {
                        name: '宁武县',
                        code: '140925',
                    },
                    {
                        name: '静乐县',
                        code: '140926',
                    },
                    {
                        name: '神池县',
                        code: '140927',
                    },
                    {
                        name: '五寨县',
                        code: '140928',
                    },
                    {
                        name: '岢岚县',
                        code: '140929',
                    },
                    {
                        name: '河曲县',
                        code: '140930',
                    },
                    {
                        name: '保德县',
                        code: '140931',
                    },
                    {
                        name: '偏关县',
                        code: '140932',
                    },
                    {
                        name: '五台山风景名胜区',
                        code: '140971',
                    },
                    {
                        name: '原平市',
                        code: '140981',
                    },
                ],
            },
            {
                name: '临汾市',
                code: '141000',
                children: [
                    {
                        name: '尧都区',
                        code: '141002',
                    },
                    {
                        name: '曲沃县',
                        code: '141021',
                    },
                    {
                        name: '翼城县',
                        code: '141022',
                    },
                    {
                        name: '襄汾县',
                        code: '141023',
                    },
                    {
                        name: '洪洞县',
                        code: '141024',
                    },
                    {
                        name: '古县',
                        code: '141025',
                    },
                    {
                        name: '安泽县',
                        code: '141026',
                    },
                    {
                        name: '浮山县',
                        code: '141027',
                    },
                    {
                        name: '吉县',
                        code: '141028',
                    },
                    {
                        name: '乡宁县',
                        code: '141029',
                    },
                    {
                        name: '大宁县',
                        code: '141030',
                    },
                    {
                        name: '隰县',
                        code: '141031',
                    },
                    {
                        name: '永和县',
                        code: '141032',
                    },
                    {
                        name: '蒲县',
                        code: '141033',
                    },
                    {
                        name: '汾西县',
                        code: '141034',
                    },
                    {
                        name: '侯马市',
                        code: '141081',
                    },
                    {
                        name: '霍州市',
                        code: '141082',
                    },
                ],
            },
            {
                name: '吕梁市',
                code: '141100',
                children: [
                    {
                        name: '离石区',
                        code: '141102',
                    },
                    {
                        name: '文水县',
                        code: '141121',
                    },
                    {
                        name: '交城县',
                        code: '141122',
                    },
                    {
                        name: '兴县',
                        code: '141123',
                    },
                    {
                        name: '临县',
                        code: '141124',
                    },
                    {
                        name: '柳林县',
                        code: '141125',
                    },
                    {
                        name: '石楼县',
                        code: '141126',
                    },
                    {
                        name: '岚县',
                        code: '141127',
                    },
                    {
                        name: '方山县',
                        code: '141128',
                    },
                    {
                        name: '中阳县',
                        code: '141129',
                    },
                    {
                        name: '交口县',
                        code: '141130',
                    },
                    {
                        name: '孝义市',
                        code: '141181',
                    },
                    {
                        name: '汾阳市',
                        code: '141182',
                    },
                ],
            },
        ],
    },
    {
        name: '内蒙古自治区',
        code: '150000',
        children: [
            {
                name: '呼和浩特市',
                code: '150100',
                children: [
                    {
                        name: '新城区',
                        code: '150102',
                    },
                    {
                        name: '回民区',
                        code: '150103',
                    },
                    {
                        name: '玉泉区',
                        code: '150104',
                    },
                    {
                        name: '赛罕区',
                        code: '150105',
                    },
                    {
                        name: '土默特左旗',
                        code: '150121',
                    },
                    {
                        name: '托克托县',
                        code: '150122',
                    },
                    {
                        name: '和林格尔县',
                        code: '150123',
                    },
                    {
                        name: '清水河县',
                        code: '150124',
                    },
                    {
                        name: '武川县',
                        code: '150125',
                    },
                    {
                        name: '呼和浩特经济技术开发区',
                        code: '150172',
                    },
                ],
            },
            {
                name: '包头市',
                code: '150200',
                children: [
                    {
                        name: '东河区',
                        code: '150202',
                    },
                    {
                        name: '昆都仑区',
                        code: '150203',
                    },
                    {
                        name: '青山区',
                        code: '150204',
                    },
                    {
                        name: '石拐区',
                        code: '150205',
                    },
                    {
                        name: '白云鄂博矿区',
                        code: '150206',
                    },
                    {
                        name: '九原区',
                        code: '150207',
                    },
                    {
                        name: '土默特右旗',
                        code: '150221',
                    },
                    {
                        name: '固阳县',
                        code: '150222',
                    },
                    {
                        name: '达尔罕茂明安联合旗',
                        code: '150223',
                    },
                    {
                        name: '包头稀土高新技术产业开发区',
                        code: '150271',
                    },
                ],
            },
            {
                name: '乌海市',
                code: '150300',
                children: [
                    {
                        name: '海勃湾区',
                        code: '150302',
                    },
                    {
                        name: '海南区',
                        code: '150303',
                    },
                    {
                        name: '乌达区',
                        code: '150304',
                    },
                ],
            },
            {
                name: '赤峰市',
                code: '150400',
                children: [
                    {
                        name: '红山区',
                        code: '150402',
                    },
                    {
                        name: '元宝山区',
                        code: '150403',
                    },
                    {
                        name: '松山区',
                        code: '150404',
                    },
                    {
                        name: '阿鲁科尔沁旗',
                        code: '150421',
                    },
                    {
                        name: '巴林左旗',
                        code: '150422',
                    },
                    {
                        name: '巴林右旗',
                        code: '150423',
                    },
                    {
                        name: '林西县',
                        code: '150424',
                    },
                    {
                        name: '克什克腾旗',
                        code: '150425',
                    },
                    {
                        name: '翁牛特旗',
                        code: '150426',
                    },
                    {
                        name: '喀喇沁旗',
                        code: '150428',
                    },
                    {
                        name: '宁城县',
                        code: '150429',
                    },
                    {
                        name: '敖汉旗',
                        code: '150430',
                    },
                ],
            },
            {
                name: '通辽市',
                code: '150500',
                children: [
                    {
                        name: '科尔沁区',
                        code: '150502',
                    },
                    {
                        name: '科尔沁左翼中旗',
                        code: '150521',
                    },
                    {
                        name: '科尔沁左翼后旗',
                        code: '150522',
                    },
                    {
                        name: '开鲁县',
                        code: '150523',
                    },
                    {
                        name: '库伦旗',
                        code: '150524',
                    },
                    {
                        name: '奈曼旗',
                        code: '150525',
                    },
                    {
                        name: '扎鲁特旗',
                        code: '150526',
                    },
                    {
                        name: '通辽经济技术开发区',
                        code: '150571',
                    },
                    {
                        name: '霍林郭勒市',
                        code: '150581',
                    },
                ],
            },
            {
                name: '鄂尔多斯市',
                code: '150600',
                children: [
                    {
                        name: '东胜区',
                        code: '150602',
                    },
                    {
                        name: '康巴什区',
                        code: '150603',
                    },
                    {
                        name: '达拉特旗',
                        code: '150621',
                    },
                    {
                        name: '准格尔旗',
                        code: '150622',
                    },
                    {
                        name: '鄂托克前旗',
                        code: '150623',
                    },
                    {
                        name: '鄂托克旗',
                        code: '150624',
                    },
                    {
                        name: '杭锦旗',
                        code: '150625',
                    },
                    {
                        name: '乌审旗',
                        code: '150626',
                    },
                    {
                        name: '伊金霍洛旗',
                        code: '150627',
                    },
                ],
            },
            {
                name: '呼伦贝尔市',
                code: '150700',
                children: [
                    {
                        name: '海拉尔区',
                        code: '150702',
                    },
                    {
                        name: '扎赉诺尔区',
                        code: '150703',
                    },
                    {
                        name: '阿荣旗',
                        code: '150721',
                    },
                    {
                        name: '莫力达瓦达斡尔族自治旗',
                        code: '150722',
                    },
                    {
                        name: '鄂伦春自治旗',
                        code: '150723',
                    },
                    {
                        name: '鄂温克族自治旗',
                        code: '150724',
                    },
                    {
                        name: '陈巴尔虎旗',
                        code: '150725',
                    },
                    {
                        name: '新巴尔虎左旗',
                        code: '150726',
                    },
                    {
                        name: '新巴尔虎右旗',
                        code: '150727',
                    },
                    {
                        name: '满洲里市',
                        code: '150781',
                    },
                    {
                        name: '牙克石市',
                        code: '150782',
                    },
                    {
                        name: '扎兰屯市',
                        code: '150783',
                    },
                    {
                        name: '额尔古纳市',
                        code: '150784',
                    },
                    {
                        name: '根河市',
                        code: '150785',
                    },
                ],
            },
            {
                name: '巴彦淖尔市',
                code: '150800',
                children: [
                    {
                        name: '临河区',
                        code: '150802',
                    },
                    {
                        name: '五原县',
                        code: '150821',
                    },
                    {
                        name: '磴口县',
                        code: '150822',
                    },
                    {
                        name: '乌拉特前旗',
                        code: '150823',
                    },
                    {
                        name: '乌拉特中旗',
                        code: '150824',
                    },
                    {
                        name: '乌拉特后旗',
                        code: '150825',
                    },
                    {
                        name: '杭锦后旗',
                        code: '150826',
                    },
                ],
            },
            {
                name: '乌兰察布市',
                code: '150900',
                children: [
                    {
                        name: '集宁区',
                        code: '150902',
                    },
                    {
                        name: '卓资县',
                        code: '150921',
                    },
                    {
                        name: '化德县',
                        code: '150922',
                    },
                    {
                        name: '商都县',
                        code: '150923',
                    },
                    {
                        name: '兴和县',
                        code: '150924',
                    },
                    {
                        name: '凉城县',
                        code: '150925',
                    },
                    {
                        name: '察哈尔右翼前旗',
                        code: '150926',
                    },
                    {
                        name: '察哈尔右翼中旗',
                        code: '150927',
                    },
                    {
                        name: '察哈尔右翼后旗',
                        code: '150928',
                    },
                    {
                        name: '四子王旗',
                        code: '150929',
                    },
                    {
                        name: '丰镇市',
                        code: '150981',
                    },
                ],
            },
            {
                name: '兴安盟',
                code: '152200',
                children: [
                    {
                        name: '乌兰浩特市',
                        code: '152201',
                    },
                    {
                        name: '阿尔山市',
                        code: '152202',
                    },
                    {
                        name: '科尔沁右翼前旗',
                        code: '152221',
                    },
                    {
                        name: '科尔沁右翼中旗',
                        code: '152222',
                    },
                    {
                        name: '扎赉特旗',
                        code: '152223',
                    },
                    {
                        name: '突泉县',
                        code: '152224',
                    },
                ],
            },
            {
                name: '锡林郭勒盟',
                code: '152500',
                children: [
                    {
                        name: '二连浩特市',
                        code: '152501',
                    },
                    {
                        name: '锡林浩特市',
                        code: '152502',
                    },
                    {
                        name: '阿巴嘎旗',
                        code: '152522',
                    },
                    {
                        name: '苏尼特左旗',
                        code: '152523',
                    },
                    {
                        name: '苏尼特右旗',
                        code: '152524',
                    },
                    {
                        name: '东乌珠穆沁旗',
                        code: '152525',
                    },
                    {
                        name: '西乌珠穆沁旗',
                        code: '152526',
                    },
                    {
                        name: '太仆寺旗',
                        code: '152527',
                    },
                    {
                        name: '镶黄旗',
                        code: '152528',
                    },
                    {
                        name: '正镶白旗',
                        code: '152529',
                    },
                    {
                        name: '正蓝旗',
                        code: '152530',
                    },
                    {
                        name: '多伦县',
                        code: '152531',
                    },
                    {
                        name: '乌拉盖管委会',
                        code: '152571',
                    },
                ],
            },
            {
                name: '阿拉善盟',
                code: '152900',
                children: [
                    {
                        name: '阿拉善左旗',
                        code: '152921',
                    },
                    {
                        name: '阿拉善右旗',
                        code: '152922',
                    },
                    {
                        name: '额济纳旗',
                        code: '152923',
                    },
                    {
                        name: '内蒙古阿拉善经济开发区',
                        code: '152971',
                    },
                ],
            },
        ],
    },
    {
        name: '辽宁省',
        code: '210000',
        children: [
            {
                name: '沈阳市',
                code: '210100',
                children: [
                    {
                        name: '和平区',
                        code: '210102',
                    },
                    {
                        name: '沈河区',
                        code: '210103',
                    },
                    {
                        name: '大东区',
                        code: '210104',
                    },
                    {
                        name: '皇姑区',
                        code: '210105',
                    },
                    {
                        name: '铁西区',
                        code: '210106',
                    },
                    {
                        name: '苏家屯区',
                        code: '210111',
                    },
                    {
                        name: '浑南区',
                        code: '210112',
                    },
                    {
                        name: '沈北新区',
                        code: '210113',
                    },
                    {
                        name: '于洪区',
                        code: '210114',
                    },
                    {
                        name: '辽中区',
                        code: '210115',
                    },
                    {
                        name: '康平县',
                        code: '210123',
                    },
                    {
                        name: '法库县',
                        code: '210124',
                    },
                    {
                        name: '新民市',
                        code: '210181',
                    },
                ],
            },
            {
                name: '大连市',
                code: '210200',
                children: [
                    {
                        name: '中山区',
                        code: '210202',
                    },
                    {
                        name: '西岗区',
                        code: '210203',
                    },
                    {
                        name: '沙河口区',
                        code: '210204',
                    },
                    {
                        name: '甘井子区',
                        code: '210211',
                    },
                    {
                        name: '旅顺口区',
                        code: '210212',
                    },
                    {
                        name: '金州区',
                        code: '210213',
                    },
                    {
                        name: '普兰店区',
                        code: '210214',
                    },
                    {
                        name: '长海县',
                        code: '210224',
                    },
                    {
                        name: '瓦房店市',
                        code: '210281',
                    },
                    {
                        name: '庄河市',
                        code: '210283',
                    },
                ],
            },
            {
                name: '鞍山市',
                code: '210300',
                children: [
                    {
                        name: '铁东区',
                        code: '210302',
                    },
                    {
                        name: '铁西区',
                        code: '210303',
                    },
                    {
                        name: '立山区',
                        code: '210304',
                    },
                    {
                        name: '千山区',
                        code: '210311',
                    },
                    {
                        name: '台安县',
                        code: '210321',
                    },
                    {
                        name: '岫岩满族自治县',
                        code: '210323',
                    },
                    {
                        name: '海城市',
                        code: '210381',
                    },
                ],
            },
            {
                name: '抚顺市',
                code: '210400',
                children: [
                    {
                        name: '新抚区',
                        code: '210402',
                    },
                    {
                        name: '东洲区',
                        code: '210403',
                    },
                    {
                        name: '望花区',
                        code: '210404',
                    },
                    {
                        name: '顺城区',
                        code: '210411',
                    },
                    {
                        name: '抚顺县',
                        code: '210421',
                    },
                    {
                        name: '新宾满族自治县',
                        code: '210422',
                    },
                    {
                        name: '清原满族自治县',
                        code: '210423',
                    },
                ],
            },
            {
                name: '本溪市',
                code: '210500',
                children: [
                    {
                        name: '平山区',
                        code: '210502',
                    },
                    {
                        name: '溪湖区',
                        code: '210503',
                    },
                    {
                        name: '明山区',
                        code: '210504',
                    },
                    {
                        name: '南芬区',
                        code: '210505',
                    },
                    {
                        name: '本溪满族自治县',
                        code: '210521',
                    },
                    {
                        name: '桓仁满族自治县',
                        code: '210522',
                    },
                ],
            },
            {
                name: '丹东市',
                code: '210600',
                children: [
                    {
                        name: '元宝区',
                        code: '210602',
                    },
                    {
                        name: '振兴区',
                        code: '210603',
                    },
                    {
                        name: '振安区',
                        code: '210604',
                    },
                    {
                        name: '宽甸满族自治县',
                        code: '210624',
                    },
                    {
                        name: '东港市',
                        code: '210681',
                    },
                    {
                        name: '凤城市',
                        code: '210682',
                    },
                ],
            },
            {
                name: '锦州市',
                code: '210700',
                children: [
                    {
                        name: '古塔区',
                        code: '210702',
                    },
                    {
                        name: '凌河区',
                        code: '210703',
                    },
                    {
                        name: '太和区',
                        code: '210711',
                    },
                    {
                        name: '黑山县',
                        code: '210726',
                    },
                    {
                        name: '义县',
                        code: '210727',
                    },
                    {
                        name: '凌海市',
                        code: '210781',
                    },
                    {
                        name: '北镇市',
                        code: '210782',
                    },
                ],
            },
            {
                name: '营口市',
                code: '210800',
                children: [
                    {
                        name: '站前区',
                        code: '210802',
                    },
                    {
                        name: '西市区',
                        code: '210803',
                    },
                    {
                        name: '鲅鱼圈区',
                        code: '210804',
                    },
                    {
                        name: '老边区',
                        code: '210811',
                    },
                    {
                        name: '盖州市',
                        code: '210881',
                    },
                    {
                        name: '大石桥市',
                        code: '210882',
                    },
                ],
            },
            {
                name: '阜新市',
                code: '210900',
                children: [
                    {
                        name: '海州区',
                        code: '210902',
                    },
                    {
                        name: '新邱区',
                        code: '210903',
                    },
                    {
                        name: '太平区',
                        code: '210904',
                    },
                    {
                        name: '清河门区',
                        code: '210905',
                    },
                    {
                        name: '细河区',
                        code: '210911',
                    },
                    {
                        name: '阜新蒙古族自治县',
                        code: '210921',
                    },
                    {
                        name: '彰武县',
                        code: '210922',
                    },
                ],
            },
            {
                name: '辽阳市',
                code: '211000',
                children: [
                    {
                        name: '白塔区',
                        code: '211002',
                    },
                    {
                        name: '文圣区',
                        code: '211003',
                    },
                    {
                        name: '宏伟区',
                        code: '211004',
                    },
                    {
                        name: '弓长岭区',
                        code: '211005',
                    },
                    {
                        name: '太子河区',
                        code: '211011',
                    },
                    {
                        name: '辽阳县',
                        code: '211021',
                    },
                    {
                        name: '灯塔市',
                        code: '211081',
                    },
                ],
            },
            {
                name: '盘锦市',
                code: '211100',
                children: [
                    {
                        name: '双台子区',
                        code: '211102',
                    },
                    {
                        name: '兴隆台区',
                        code: '211103',
                    },
                    {
                        name: '大洼区',
                        code: '211104',
                    },
                    {
                        name: '盘山县',
                        code: '211122',
                    },
                ],
            },
            {
                name: '铁岭市',
                code: '211200',
                children: [
                    {
                        name: '银州区',
                        code: '211202',
                    },
                    {
                        name: '清河区',
                        code: '211204',
                    },
                    {
                        name: '铁岭县',
                        code: '211221',
                    },
                    {
                        name: '西丰县',
                        code: '211223',
                    },
                    {
                        name: '昌图县',
                        code: '211224',
                    },
                    {
                        name: '调兵山市',
                        code: '211281',
                    },
                    {
                        name: '开原市',
                        code: '211282',
                    },
                ],
            },
            {
                name: '朝阳市',
                code: '211300',
                children: [
                    {
                        name: '双塔区',
                        code: '211302',
                    },
                    {
                        name: '龙城区',
                        code: '211303',
                    },
                    {
                        name: '朝阳县',
                        code: '211321',
                    },
                    {
                        name: '建平县',
                        code: '211322',
                    },
                    {
                        name: '喀喇沁左翼蒙古族自治县',
                        code: '211324',
                    },
                    {
                        name: '北票市',
                        code: '211381',
                    },
                    {
                        name: '凌源市',
                        code: '211382',
                    },
                ],
            },
            {
                name: '葫芦岛市',
                code: '211400',
                children: [
                    {
                        name: '连山区',
                        code: '211402',
                    },
                    {
                        name: '龙港区',
                        code: '211403',
                    },
                    {
                        name: '南票区',
                        code: '211404',
                    },
                    {
                        name: '绥中县',
                        code: '211421',
                    },
                    {
                        name: '建昌县',
                        code: '211422',
                    },
                    {
                        name: '兴城市',
                        code: '211481',
                    },
                ],
            },
        ],
    },
    {
        name: '吉林省',
        code: '220000',
        children: [
            {
                name: '长春市',
                code: '220100',
                children: [
                    {
                        name: '南关区',
                        code: '220102',
                    },
                    {
                        name: '宽城区',
                        code: '220103',
                    },
                    {
                        name: '朝阳区',
                        code: '220104',
                    },
                    {
                        name: '二道区',
                        code: '220105',
                    },
                    {
                        name: '绿园区',
                        code: '220106',
                    },
                    {
                        name: '双阳区',
                        code: '220112',
                    },
                    {
                        name: '九台区',
                        code: '220113',
                    },
                    {
                        name: '农安县',
                        code: '220122',
                    },
                    {
                        name: '长春经济技术开发区',
                        code: '220171',
                    },
                    {
                        name: '长春净月高新技术产业开发区',
                        code: '220172',
                    },
                    {
                        name: '长春高新技术产业开发区',
                        code: '220173',
                    },
                    {
                        name: '长春汽车经济技术开发区',
                        code: '220174',
                    },
                    {
                        name: '榆树市',
                        code: '220182',
                    },
                    {
                        name: '德惠市',
                        code: '220183',
                    },
                    {
                        name: '公主岭市',
                        code: '220184',
                    },
                ],
            },
            {
                name: '吉林市',
                code: '220200',
                children: [
                    {
                        name: '昌邑区',
                        code: '220202',
                    },
                    {
                        name: '龙潭区',
                        code: '220203',
                    },
                    {
                        name: '船营区',
                        code: '220204',
                    },
                    {
                        name: '丰满区',
                        code: '220211',
                    },
                    {
                        name: '永吉县',
                        code: '220221',
                    },
                    {
                        name: '吉林经济开发区',
                        code: '220271',
                    },
                    {
                        name: '吉林高新技术产业开发区',
                        code: '220272',
                    },
                    {
                        name: '吉林中国新加坡食品区',
                        code: '220273',
                    },
                    {
                        name: '蛟河市',
                        code: '220281',
                    },
                    {
                        name: '桦甸市',
                        code: '220282',
                    },
                    {
                        name: '舒兰市',
                        code: '220283',
                    },
                    {
                        name: '磐石市',
                        code: '220284',
                    },
                ],
            },
            {
                name: '四平市',
                code: '220300',
                children: [
                    {
                        name: '铁西区',
                        code: '220302',
                    },
                    {
                        name: '铁东区',
                        code: '220303',
                    },
                    {
                        name: '梨树县',
                        code: '220322',
                    },
                    {
                        name: '伊通满族自治县',
                        code: '220323',
                    },
                    {
                        name: '双辽市',
                        code: '220382',
                    },
                ],
            },
            {
                name: '辽源市',
                code: '220400',
                children: [
                    {
                        name: '龙山区',
                        code: '220402',
                    },
                    {
                        name: '西安区',
                        code: '220403',
                    },
                    {
                        name: '东丰县',
                        code: '220421',
                    },
                    {
                        name: '东辽县',
                        code: '220422',
                    },
                ],
            },
            {
                name: '通化市',
                code: '220500',
                children: [
                    {
                        name: '东昌区',
                        code: '220502',
                    },
                    {
                        name: '二道江区',
                        code: '220503',
                    },
                    {
                        name: '通化县',
                        code: '220521',
                    },
                    {
                        name: '辉南县',
                        code: '220523',
                    },
                    {
                        name: '柳河县',
                        code: '220524',
                    },
                    {
                        name: '梅河口市',
                        code: '220581',
                    },
                    {
                        name: '集安市',
                        code: '220582',
                    },
                ],
            },
            {
                name: '白山市',
                code: '220600',
                children: [
                    {
                        name: '浑江区',
                        code: '220602',
                    },
                    {
                        name: '江源区',
                        code: '220605',
                    },
                    {
                        name: '抚松县',
                        code: '220621',
                    },
                    {
                        name: '靖宇县',
                        code: '220622',
                    },
                    {
                        name: '长白朝鲜族自治县',
                        code: '220623',
                    },
                    {
                        name: '临江市',
                        code: '220681',
                    },
                ],
            },
            {
                name: '松原市',
                code: '220700',
                children: [
                    {
                        name: '宁江区',
                        code: '220702',
                    },
                    {
                        name: '前郭尔罗斯蒙古族自治县',
                        code: '220721',
                    },
                    {
                        name: '长岭县',
                        code: '220722',
                    },
                    {
                        name: '乾安县',
                        code: '220723',
                    },
                    {
                        name: '吉林松原经济开发区',
                        code: '220771',
                    },
                    {
                        name: '扶余市',
                        code: '220781',
                    },
                ],
            },
            {
                name: '白城市',
                code: '220800',
                children: [
                    {
                        name: '洮北区',
                        code: '220802',
                    },
                    {
                        name: '镇赉县',
                        code: '220821',
                    },
                    {
                        name: '通榆县',
                        code: '220822',
                    },
                    {
                        name: '吉林白城经济开发区',
                        code: '220871',
                    },
                    {
                        name: '洮南市',
                        code: '220881',
                    },
                    {
                        name: '大安市',
                        code: '220882',
                    },
                ],
            },
            {
                name: '延边朝鲜族自治州',
                code: '222400',
                children: [
                    {
                        name: '延吉市',
                        code: '222401',
                    },
                    {
                        name: '图们市',
                        code: '222402',
                    },
                    {
                        name: '敦化市',
                        code: '222403',
                    },
                    {
                        name: '珲春市',
                        code: '222404',
                    },
                    {
                        name: '龙井市',
                        code: '222405',
                    },
                    {
                        name: '和龙市',
                        code: '222406',
                    },
                    {
                        name: '汪清县',
                        code: '222424',
                    },
                    {
                        name: '安图县',
                        code: '222426',
                    },
                ],
            },
        ],
    },
    {
        name: '黑龙江省',
        code: '230000',
        children: [
            {
                name: '哈尔滨市',
                code: '230100',
                children: [
                    {
                        name: '道里区',
                        code: '230102',
                    },
                    {
                        name: '南岗区',
                        code: '230103',
                    },
                    {
                        name: '道外区',
                        code: '230104',
                    },
                    {
                        name: '平房区',
                        code: '230108',
                    },
                    {
                        name: '松北区',
                        code: '230109',
                    },
                    {
                        name: '香坊区',
                        code: '230110',
                    },
                    {
                        name: '呼兰区',
                        code: '230111',
                    },
                    {
                        name: '阿城区',
                        code: '230112',
                    },
                    {
                        name: '双城区',
                        code: '230113',
                    },
                    {
                        name: '依兰县',
                        code: '230123',
                    },
                    {
                        name: '方正县',
                        code: '230124',
                    },
                    {
                        name: '宾县',
                        code: '230125',
                    },
                    {
                        name: '巴彦县',
                        code: '230126',
                    },
                    {
                        name: '木兰县',
                        code: '230127',
                    },
                    {
                        name: '通河县',
                        code: '230128',
                    },
                    {
                        name: '延寿县',
                        code: '230129',
                    },
                    {
                        name: '尚志市',
                        code: '230183',
                    },
                    {
                        name: '五常市',
                        code: '230184',
                    },
                ],
            },
            {
                name: '齐齐哈尔市',
                code: '230200',
                children: [
                    {
                        name: '龙沙区',
                        code: '230202',
                    },
                    {
                        name: '建华区',
                        code: '230203',
                    },
                    {
                        name: '铁锋区',
                        code: '230204',
                    },
                    {
                        name: '昂昂溪区',
                        code: '230205',
                    },
                    {
                        name: '富拉尔基区',
                        code: '230206',
                    },
                    {
                        name: '碾子山区',
                        code: '230207',
                    },
                    {
                        name: '梅里斯达斡尔族区',
                        code: '230208',
                    },
                    {
                        name: '龙江县',
                        code: '230221',
                    },
                    {
                        name: '依安县',
                        code: '230223',
                    },
                    {
                        name: '泰来县',
                        code: '230224',
                    },
                    {
                        name: '甘南县',
                        code: '230225',
                    },
                    {
                        name: '富裕县',
                        code: '230227',
                    },
                    {
                        name: '克山县',
                        code: '230229',
                    },
                    {
                        name: '克东县',
                        code: '230230',
                    },
                    {
                        name: '拜泉县',
                        code: '230231',
                    },
                    {
                        name: '讷河市',
                        code: '230281',
                    },
                ],
            },
            {
                name: '鸡西市',
                code: '230300',
                children: [
                    {
                        name: '鸡冠区',
                        code: '230302',
                    },
                    {
                        name: '恒山区',
                        code: '230303',
                    },
                    {
                        name: '滴道区',
                        code: '230304',
                    },
                    {
                        name: '梨树区',
                        code: '230305',
                    },
                    {
                        name: '城子河区',
                        code: '230306',
                    },
                    {
                        name: '麻山区',
                        code: '230307',
                    },
                    {
                        name: '鸡东县',
                        code: '230321',
                    },
                    {
                        name: '虎林市',
                        code: '230381',
                    },
                    {
                        name: '密山市',
                        code: '230382',
                    },
                ],
            },
            {
                name: '鹤岗市',
                code: '230400',
                children: [
                    {
                        name: '向阳区',
                        code: '230402',
                    },
                    {
                        name: '工农区',
                        code: '230403',
                    },
                    {
                        name: '南山区',
                        code: '230404',
                    },
                    {
                        name: '兴安区',
                        code: '230405',
                    },
                    {
                        name: '东山区',
                        code: '230406',
                    },
                    {
                        name: '兴山区',
                        code: '230407',
                    },
                    {
                        name: '萝北县',
                        code: '230421',
                    },
                    {
                        name: '绥滨县',
                        code: '230422',
                    },
                ],
            },
            {
                name: '双鸭山市',
                code: '230500',
                children: [
                    {
                        name: '尖山区',
                        code: '230502',
                    },
                    {
                        name: '岭东区',
                        code: '230503',
                    },
                    {
                        name: '四方台区',
                        code: '230505',
                    },
                    {
                        name: '宝山区',
                        code: '230506',
                    },
                    {
                        name: '集贤县',
                        code: '230521',
                    },
                    {
                        name: '友谊县',
                        code: '230522',
                    },
                    {
                        name: '宝清县',
                        code: '230523',
                    },
                    {
                        name: '饶河县',
                        code: '230524',
                    },
                ],
            },
            {
                name: '大庆市',
                code: '230600',
                children: [
                    {
                        name: '萨尔图区',
                        code: '230602',
                    },
                    {
                        name: '龙凤区',
                        code: '230603',
                    },
                    {
                        name: '让胡路区',
                        code: '230604',
                    },
                    {
                        name: '红岗区',
                        code: '230605',
                    },
                    {
                        name: '大同区',
                        code: '230606',
                    },
                    {
                        name: '肇州县',
                        code: '230621',
                    },
                    {
                        name: '肇源县',
                        code: '230622',
                    },
                    {
                        name: '林甸县',
                        code: '230623',
                    },
                    {
                        name: '杜尔伯特蒙古族自治县',
                        code: '230624',
                    },
                    {
                        name: '大庆高新技术产业开发区',
                        code: '230671',
                    },
                ],
            },
            {
                name: '伊春市',
                code: '230700',
                children: [
                    {
                        name: '伊美区',
                        code: '230717',
                    },
                    {
                        name: '乌翠区',
                        code: '230718',
                    },
                    {
                        name: '友好区',
                        code: '230719',
                    },
                    {
                        name: '嘉荫县',
                        code: '230722',
                    },
                    {
                        name: '汤旺县',
                        code: '230723',
                    },
                    {
                        name: '丰林县',
                        code: '230724',
                    },
                    {
                        name: '大箐山县',
                        code: '230725',
                    },
                    {
                        name: '南岔县',
                        code: '230726',
                    },
                    {
                        name: '金林区',
                        code: '230751',
                    },
                    {
                        name: '铁力市',
                        code: '230781',
                    },
                ],
            },
            {
                name: '佳木斯市',
                code: '230800',
                children: [
                    {
                        name: '向阳区',
                        code: '230803',
                    },
                    {
                        name: '前进区',
                        code: '230804',
                    },
                    {
                        name: '东风区',
                        code: '230805',
                    },
                    {
                        name: '郊区',
                        code: '230811',
                    },
                    {
                        name: '桦南县',
                        code: '230822',
                    },
                    {
                        name: '桦川县',
                        code: '230826',
                    },
                    {
                        name: '汤原县',
                        code: '230828',
                    },
                    {
                        name: '同江市',
                        code: '230881',
                    },
                    {
                        name: '富锦市',
                        code: '230882',
                    },
                    {
                        name: '抚远市',
                        code: '230883',
                    },
                ],
            },
            {
                name: '七台河市',
                code: '230900',
                children: [
                    {
                        name: '新兴区',
                        code: '230902',
                    },
                    {
                        name: '桃山区',
                        code: '230903',
                    },
                    {
                        name: '茄子河区',
                        code: '230904',
                    },
                    {
                        name: '勃利县',
                        code: '230921',
                    },
                ],
            },
            {
                name: '牡丹江市',
                code: '231000',
                children: [
                    {
                        name: '东安区',
                        code: '231002',
                    },
                    {
                        name: '阳明区',
                        code: '231003',
                    },
                    {
                        name: '爱民区',
                        code: '231004',
                    },
                    {
                        name: '西安区',
                        code: '231005',
                    },
                    {
                        name: '林口县',
                        code: '231025',
                    },
                    {
                        name: '牡丹江经济技术开发区',
                        code: '231071',
                    },
                    {
                        name: '绥芬河市',
                        code: '231081',
                    },
                    {
                        name: '海林市',
                        code: '231083',
                    },
                    {
                        name: '宁安市',
                        code: '231084',
                    },
                    {
                        name: '穆棱市',
                        code: '231085',
                    },
                    {
                        name: '东宁市',
                        code: '231086',
                    },
                ],
            },
            {
                name: '黑河市',
                code: '231100',
                children: [
                    {
                        name: '爱辉区',
                        code: '231102',
                    },
                    {
                        name: '逊克县',
                        code: '231123',
                    },
                    {
                        name: '孙吴县',
                        code: '231124',
                    },
                    {
                        name: '北安市',
                        code: '231181',
                    },
                    {
                        name: '五大连池市',
                        code: '231182',
                    },
                    {
                        name: '嫩江市',
                        code: '231183',
                    },
                ],
            },
            {
                name: '绥化市',
                code: '231200',
                children: [
                    {
                        name: '北林区',
                        code: '231202',
                    },
                    {
                        name: '望奎县',
                        code: '231221',
                    },
                    {
                        name: '兰西县',
                        code: '231222',
                    },
                    {
                        name: '青冈县',
                        code: '231223',
                    },
                    {
                        name: '庆安县',
                        code: '231224',
                    },
                    {
                        name: '明水县',
                        code: '231225',
                    },
                    {
                        name: '绥棱县',
                        code: '231226',
                    },
                    {
                        name: '安达市',
                        code: '231281',
                    },
                    {
                        name: '肇东市',
                        code: '231282',
                    },
                    {
                        name: '海伦市',
                        code: '231283',
                    },
                ],
            },
            {
                name: '大兴安岭地区',
                code: '232700',
                children: [
                    {
                        name: '漠河市',
                        code: '232701',
                    },
                    {
                        name: '呼玛县',
                        code: '232721',
                    },
                    {
                        name: '塔河县',
                        code: '232722',
                    },
                    {
                        name: '加格达奇区',
                        code: '232761',
                    },
                    {
                        name: '松岭区',
                        code: '232762',
                    },
                    {
                        name: '新林区',
                        code: '232763',
                    },
                    {
                        name: '呼中区',
                        code: '232764',
                    },
                ],
            },
        ],
    },
    {
        name: '上海市',
        code: '310000',
        children: [
            {
                name: '市辖区',
                code: '310100',
                children: [
                    {
                        name: '黄浦区',
                        code: '310101',
                    },
                    {
                        name: '徐汇区',
                        code: '310104',
                    },
                    {
                        name: '长宁区',
                        code: '310105',
                    },
                    {
                        name: '静安区',
                        code: '310106',
                    },
                    {
                        name: '普陀区',
                        code: '310107',
                    },
                    {
                        name: '虹口区',
                        code: '310109',
                    },
                    {
                        name: '杨浦区',
                        code: '310110',
                    },
                    {
                        name: '闵行区',
                        code: '310112',
                    },
                    {
                        name: '宝山区',
                        code: '310113',
                    },
                    {
                        name: '嘉定区',
                        code: '310114',
                    },
                    {
                        name: '浦东新区',
                        code: '310115',
                    },
                    {
                        name: '金山区',
                        code: '310116',
                    },
                    {
                        name: '松江区',
                        code: '310117',
                    },
                    {
                        name: '青浦区',
                        code: '310118',
                    },
                    {
                        name: '奉贤区',
                        code: '310120',
                    },
                    {
                        name: '崇明区',
                        code: '310151',
                    },
                ],
            },
        ],
    },
    {
        name: '江苏省',
        code: '320000',
        children: [
            {
                name: '南京市',
                code: '320100',
                children: [
                    {
                        name: '玄武区',
                        code: '320102',
                    },
                    {
                        name: '秦淮区',
                        code: '320104',
                    },
                    {
                        name: '建邺区',
                        code: '320105',
                    },
                    {
                        name: '鼓楼区',
                        code: '320106',
                    },
                    {
                        name: '浦口区',
                        code: '320111',
                    },
                    {
                        name: '栖霞区',
                        code: '320113',
                    },
                    {
                        name: '雨花台区',
                        code: '320114',
                    },
                    {
                        name: '江宁区',
                        code: '320115',
                    },
                    {
                        name: '六合区',
                        code: '320116',
                    },
                    {
                        name: '溧水区',
                        code: '320117',
                    },
                    {
                        name: '高淳区',
                        code: '320118',
                    },
                ],
            },
            {
                name: '无锡市',
                code: '320200',
                children: [
                    {
                        name: '锡山区',
                        code: '320205',
                    },
                    {
                        name: '惠山区',
                        code: '320206',
                    },
                    {
                        name: '滨湖区',
                        code: '320211',
                    },
                    {
                        name: '梁溪区',
                        code: '320213',
                    },
                    {
                        name: '新吴区',
                        code: '320214',
                    },
                    {
                        name: '江阴市',
                        code: '320281',
                    },
                    {
                        name: '宜兴市',
                        code: '320282',
                    },
                ],
            },
            {
                name: '徐州市',
                code: '320300',
                children: [
                    {
                        name: '鼓楼区',
                        code: '320302',
                    },
                    {
                        name: '云龙区',
                        code: '320303',
                    },
                    {
                        name: '贾汪区',
                        code: '320305',
                    },
                    {
                        name: '泉山区',
                        code: '320311',
                    },
                    {
                        name: '铜山区',
                        code: '320312',
                    },
                    {
                        name: '丰县',
                        code: '320321',
                    },
                    {
                        name: '沛县',
                        code: '320322',
                    },
                    {
                        name: '睢宁县',
                        code: '320324',
                    },
                    {
                        name: '徐州经济技术开发区',
                        code: '320371',
                    },
                    {
                        name: '新沂市',
                        code: '320381',
                    },
                    {
                        name: '邳州市',
                        code: '320382',
                    },
                ],
            },
            {
                name: '常州市',
                code: '320400',
                children: [
                    {
                        name: '天宁区',
                        code: '320402',
                    },
                    {
                        name: '钟楼区',
                        code: '320404',
                    },
                    {
                        name: '新北区',
                        code: '320411',
                    },
                    {
                        name: '武进区',
                        code: '320412',
                    },
                    {
                        name: '金坛区',
                        code: '320413',
                    },
                    {
                        name: '溧阳市',
                        code: '320481',
                    },
                ],
            },
            {
                name: '苏州市',
                code: '320500',
                children: [
                    {
                        name: '虎丘区',
                        code: '320505',
                    },
                    {
                        name: '吴中区',
                        code: '320506',
                    },
                    {
                        name: '相城区',
                        code: '320507',
                    },
                    {
                        name: '姑苏区',
                        code: '320508',
                    },
                    {
                        name: '吴江区',
                        code: '320509',
                    },
                    {
                        name: '苏州工业园区',
                        code: '320571',
                    },
                    {
                        name: '常熟市',
                        code: '320581',
                    },
                    {
                        name: '张家港市',
                        code: '320582',
                    },
                    {
                        name: '昆山市',
                        code: '320583',
                    },
                    {
                        name: '太仓市',
                        code: '320585',
                    },
                ],
            },
            {
                name: '南通市',
                code: '320600',
                children: [
                    {
                        name: '崇川区',
                        code: '320602',
                    },
                    {
                        name: '港闸区',
                        code: '320611',
                    },
                    {
                        name: '通州区',
                        code: '320612',
                    },
                    {
                        name: '如东县',
                        code: '320623',
                    },
                    {
                        name: '南通经济技术开发区',
                        code: '320671',
                    },
                    {
                        name: '启东市',
                        code: '320681',
                    },
                    {
                        name: '如皋市',
                        code: '320682',
                    },
                    {
                        name: '海门市',
                        code: '320684',
                    },
                    {
                        name: '海安市',
                        code: '320685',
                    },
                ],
            },
            {
                name: '连云港市',
                code: '320700',
                children: [
                    {
                        name: '连云区',
                        code: '320703',
                    },
                    {
                        name: '海州区',
                        code: '320706',
                    },
                    {
                        name: '赣榆区',
                        code: '320707',
                    },
                    {
                        name: '东海县',
                        code: '320722',
                    },
                    {
                        name: '灌云县',
                        code: '320723',
                    },
                    {
                        name: '灌南县',
                        code: '320724',
                    },
                    {
                        name: '连云港经济技术开发区',
                        code: '320771',
                    },
                    {
                        name: '连云港高新技术产业开发区',
                        code: '320772',
                    },
                ],
            },
            {
                name: '淮安市',
                code: '320800',
                children: [
                    {
                        name: '淮安区',
                        code: '320803',
                    },
                    {
                        name: '淮阴区',
                        code: '320804',
                    },
                    {
                        name: '清江浦区',
                        code: '320812',
                    },
                    {
                        name: '洪泽区',
                        code: '320813',
                    },
                    {
                        name: '涟水县',
                        code: '320826',
                    },
                    {
                        name: '盱眙县',
                        code: '320830',
                    },
                    {
                        name: '金湖县',
                        code: '320831',
                    },
                    {
                        name: '淮安经济技术开发区',
                        code: '320871',
                    },
                ],
            },
            {
                name: '盐城市',
                code: '320900',
                children: [
                    {
                        name: '亭湖区',
                        code: '320902',
                    },
                    {
                        name: '盐都区',
                        code: '320903',
                    },
                    {
                        name: '大丰区',
                        code: '320904',
                    },
                    {
                        name: '响水县',
                        code: '320921',
                    },
                    {
                        name: '滨海县',
                        code: '320922',
                    },
                    {
                        name: '阜宁县',
                        code: '320923',
                    },
                    {
                        name: '射阳县',
                        code: '320924',
                    },
                    {
                        name: '建湖县',
                        code: '320925',
                    },
                    {
                        name: '盐城经济技术开发区',
                        code: '320971',
                    },
                    {
                        name: '东台市',
                        code: '320981',
                    },
                ],
            },
            {
                name: '扬州市',
                code: '321000',
                children: [
                    {
                        name: '广陵区',
                        code: '321002',
                    },
                    {
                        name: '邗江区',
                        code: '321003',
                    },
                    {
                        name: '江都区',
                        code: '321012',
                    },
                    {
                        name: '宝应县',
                        code: '321023',
                    },
                    {
                        name: '扬州经济技术开发区',
                        code: '321071',
                    },
                    {
                        name: '仪征市',
                        code: '321081',
                    },
                    {
                        name: '高邮市',
                        code: '321084',
                    },
                ],
            },
            {
                name: '镇江市',
                code: '321100',
                children: [
                    {
                        name: '京口区',
                        code: '321102',
                    },
                    {
                        name: '润州区',
                        code: '321111',
                    },
                    {
                        name: '丹徒区',
                        code: '321112',
                    },
                    {
                        name: '镇江新区',
                        code: '321171',
                    },
                    {
                        name: '丹阳市',
                        code: '321181',
                    },
                    {
                        name: '扬中市',
                        code: '321182',
                    },
                    {
                        name: '句容市',
                        code: '321183',
                    },
                ],
            },
            {
                name: '泰州市',
                code: '321200',
                children: [
                    {
                        name: '海陵区',
                        code: '321202',
                    },
                    {
                        name: '高港区',
                        code: '321203',
                    },
                    {
                        name: '姜堰区',
                        code: '321204',
                    },
                    {
                        name: '泰州医药高新技术产业开发区',
                        code: '321271',
                    },
                    {
                        name: '兴化市',
                        code: '321281',
                    },
                    {
                        name: '靖江市',
                        code: '321282',
                    },
                    {
                        name: '泰兴市',
                        code: '321283',
                    },
                ],
            },
            {
                name: '宿迁市',
                code: '321300',
                children: [
                    {
                        name: '宿城区',
                        code: '321302',
                    },
                    {
                        name: '宿豫区',
                        code: '321311',
                    },
                    {
                        name: '沭阳县',
                        code: '321322',
                    },
                    {
                        name: '泗阳县',
                        code: '321323',
                    },
                    {
                        name: '泗洪县',
                        code: '321324',
                    },
                    {
                        name: '宿迁经济技术开发区',
                        code: '321371',
                    },
                ],
            },
        ],
    },
    {
        name: '浙江省',
        code: '330000',
        children: [
            {
                name: '杭州市',
                code: '330100',
                children: [
                    {
                        name: '上城区',
                        code: '330102',
                    },
                    {
                        name: '下城区',
                        code: '330103',
                    },
                    {
                        name: '江干区',
                        code: '330104',
                    },
                    {
                        name: '拱墅区',
                        code: '330105',
                    },
                    {
                        name: '西湖区',
                        code: '330106',
                    },
                    {
                        name: '滨江区',
                        code: '330108',
                    },
                    {
                        name: '萧山区',
                        code: '330109',
                    },
                    {
                        name: '余杭区',
                        code: '330110',
                    },
                    {
                        name: '富阳区',
                        code: '330111',
                    },
                    {
                        name: '临安区',
                        code: '330112',
                    },
                    {
                        name: '临平区',
                        code: '330113',
                    },
                    {
                        name: '桐庐县',
                        code: '330122',
                    },
                    {
                        name: '淳安县',
                        code: '330127',
                    },
                    {
                        name: '建德市',
                        code: '330182',
                    },
                ],
            },
            {
                name: '宁波市',
                code: '330200',
                children: [
                    {
                        name: '海曙区',
                        code: '330203',
                    },
                    {
                        name: '江北区',
                        code: '330205',
                    },
                    {
                        name: '北仑区',
                        code: '330206',
                    },
                    {
                        name: '镇海区',
                        code: '330211',
                    },
                    {
                        name: '鄞州区',
                        code: '330212',
                    },
                    {
                        name: '奉化区',
                        code: '330213',
                    },
                    {
                        name: '象山县',
                        code: '330225',
                    },
                    {
                        name: '宁海县',
                        code: '330226',
                    },
                    {
                        name: '余姚市',
                        code: '330281',
                    },
                    {
                        name: '慈溪市',
                        code: '330282',
                    },
                ],
            },
            {
                name: '温州市',
                code: '330300',
                children: [
                    {
                        name: '鹿城区',
                        code: '330302',
                    },
                    {
                        name: '龙湾区',
                        code: '330303',
                    },
                    {
                        name: '瓯海区',
                        code: '330304',
                    },
                    {
                        name: '洞头区',
                        code: '330305',
                    },
                    {
                        name: '永嘉县',
                        code: '330324',
                    },
                    {
                        name: '平阳县',
                        code: '330326',
                    },
                    {
                        name: '苍南县',
                        code: '330327',
                    },
                    {
                        name: '文成县',
                        code: '330328',
                    },
                    {
                        name: '泰顺县',
                        code: '330329',
                    },
                    {
                        name: '温州经济技术开发区',
                        code: '330371',
                    },
                    {
                        name: '瑞安市',
                        code: '330381',
                    },
                    {
                        name: '乐清市',
                        code: '330382',
                    },
                    {
                        name: '龙港市',
                        code: '330383',
                    },
                ],
            },
            {
                name: '嘉兴市',
                code: '330400',
                children: [
                    {
                        name: '南湖区',
                        code: '330402',
                    },
                    {
                        name: '秀洲区',
                        code: '330411',
                    },
                    {
                        name: '嘉善县',
                        code: '330421',
                    },
                    {
                        name: '海盐县',
                        code: '330424',
                    },
                    {
                        name: '海宁市',
                        code: '330481',
                    },
                    {
                        name: '平湖市',
                        code: '330482',
                    },
                    {
                        name: '桐乡市',
                        code: '330483',
                    },
                ],
            },
            {
                name: '湖州市',
                code: '330500',
                children: [
                    {
                        name: '吴兴区',
                        code: '330502',
                    },
                    {
                        name: '南浔区',
                        code: '330503',
                    },
                    {
                        name: '德清县',
                        code: '330521',
                    },
                    {
                        name: '长兴县',
                        code: '330522',
                    },
                    {
                        name: '安吉县',
                        code: '330523',
                    },
                ],
            },
            {
                name: '绍兴市',
                code: '330600',
                children: [
                    {
                        name: '越城区',
                        code: '330602',
                    },
                    {
                        name: '柯桥区',
                        code: '330603',
                    },
                    {
                        name: '上虞区',
                        code: '330604',
                    },
                    {
                        name: '新昌县',
                        code: '330624',
                    },
                    {
                        name: '诸暨市',
                        code: '330681',
                    },
                    {
                        name: '嵊州市',
                        code: '330683',
                    },
                ],
            },
            {
                name: '金华市',
                code: '330700',
                children: [
                    {
                        name: '婺城区',
                        code: '330702',
                    },
                    {
                        name: '金东区',
                        code: '330703',
                    },
                    {
                        name: '武义县',
                        code: '330723',
                    },
                    {
                        name: '浦江县',
                        code: '330726',
                    },
                    {
                        name: '磐安县',
                        code: '330727',
                    },
                    {
                        name: '兰溪市',
                        code: '330781',
                    },
                    {
                        name: '义乌市',
                        code: '330782',
                    },
                    {
                        name: '东阳市',
                        code: '330783',
                    },
                    {
                        name: '永康市',
                        code: '330784',
                    },
                ],
            },
            {
                name: '衢州市',
                code: '330800',
                children: [
                    {
                        name: '柯城区',
                        code: '330802',
                    },
                    {
                        name: '衢江区',
                        code: '330803',
                    },
                    {
                        name: '常山县',
                        code: '330822',
                    },
                    {
                        name: '开化县',
                        code: '330824',
                    },
                    {
                        name: '龙游县',
                        code: '330825',
                    },
                    {
                        name: '江山市',
                        code: '330881',
                    },
                ],
            },
            {
                name: '舟山市',
                code: '330900',
                children: [
                    {
                        name: '定海区',
                        code: '330902',
                    },
                    {
                        name: '普陀区',
                        code: '330903',
                    },
                    {
                        name: '岱山县',
                        code: '330921',
                    },
                    {
                        name: '嵊泗县',
                        code: '330922',
                    },
                ],
            },
            {
                name: '台州市',
                code: '331000',
                children: [
                    {
                        name: '椒江区',
                        code: '331002',
                    },
                    {
                        name: '黄岩区',
                        code: '331003',
                    },
                    {
                        name: '路桥区',
                        code: '331004',
                    },
                    {
                        name: '三门县',
                        code: '331022',
                    },
                    {
                        name: '天台县',
                        code: '331023',
                    },
                    {
                        name: '仙居县',
                        code: '331024',
                    },
                    {
                        name: '温岭市',
                        code: '331081',
                    },
                    {
                        name: '临海市',
                        code: '331082',
                    },
                    {
                        name: '玉环市',
                        code: '331083',
                    },
                ],
            },
            {
                name: '丽水市',
                code: '331100',
                children: [
                    {
                        name: '莲都区',
                        code: '331102',
                    },
                    {
                        name: '青田县',
                        code: '331121',
                    },
                    {
                        name: '缙云县',
                        code: '331122',
                    },
                    {
                        name: '遂昌县',
                        code: '331123',
                    },
                    {
                        name: '松阳县',
                        code: '331124',
                    },
                    {
                        name: '云和县',
                        code: '331125',
                    },
                    {
                        name: '庆元县',
                        code: '331126',
                    },
                    {
                        name: '景宁畲族自治县',
                        code: '331127',
                    },
                    {
                        name: '龙泉市',
                        code: '331181',
                    },
                ],
            },
        ],
    },
    {
        name: '安徽省',
        code: '340000',
        children: [
            {
                name: '合肥市',
                code: '340100',
                children: [
                    {
                        name: '瑶海区',
                        code: '340102',
                    },
                    {
                        name: '庐阳区',
                        code: '340103',
                    },
                    {
                        name: '蜀山区',
                        code: '340104',
                    },
                    {
                        name: '包河区',
                        code: '340111',
                    },
                    {
                        name: '长丰县',
                        code: '340121',
                    },
                    {
                        name: '肥东县',
                        code: '340122',
                    },
                    {
                        name: '肥西县',
                        code: '340123',
                    },
                    {
                        name: '庐江县',
                        code: '340124',
                    },
                    {
                        name: '合肥高新技术产业开发区',
                        code: '340171',
                    },
                    {
                        name: '合肥经济技术开发区',
                        code: '340172',
                    },
                    {
                        name: '合肥新站高新技术产业开发区',
                        code: '340173',
                    },
                    {
                        name: '巢湖市',
                        code: '340181',
                    },
                ],
            },
            {
                name: '芜湖市',
                code: '340200',
                children: [
                    {
                        name: '镜湖区',
                        code: '340202',
                    },
                    {
                        name: '弋江区',
                        code: '340203',
                    },
                    {
                        name: '鸠江区',
                        code: '340207',
                    },
                    {
                        name: '三山区',
                        code: '340208',
                    },
                    {
                        name: '芜湖县',
                        code: '340221',
                    },
                    {
                        name: '繁昌县',
                        code: '340222',
                    },
                    {
                        name: '南陵县',
                        code: '340223',
                    },
                    {
                        name: '芜湖经济技术开发区',
                        code: '340271',
                    },
                    {
                        name: '安徽芜湖长江大桥经济开发区',
                        code: '340272',
                    },
                    {
                        name: '无为市',
                        code: '340281',
                    },
                ],
            },
            {
                name: '蚌埠市',
                code: '340300',
                children: [
                    {
                        name: '龙子湖区',
                        code: '340302',
                    },
                    {
                        name: '蚌山区',
                        code: '340303',
                    },
                    {
                        name: '禹会区',
                        code: '340304',
                    },
                    {
                        name: '淮上区',
                        code: '340311',
                    },
                    {
                        name: '怀远县',
                        code: '340321',
                    },
                    {
                        name: '五河县',
                        code: '340322',
                    },
                    {
                        name: '固镇县',
                        code: '340323',
                    },
                    {
                        name: '蚌埠市高新技术开发区',
                        code: '340371',
                    },
                    {
                        name: '蚌埠市经济开发区',
                        code: '340372',
                    },
                ],
            },
            {
                name: '淮南市',
                code: '340400',
                children: [
                    {
                        name: '大通区',
                        code: '340402',
                    },
                    {
                        name: '田家庵区',
                        code: '340403',
                    },
                    {
                        name: '谢家集区',
                        code: '340404',
                    },
                    {
                        name: '八公山区',
                        code: '340405',
                    },
                    {
                        name: '潘集区',
                        code: '340406',
                    },
                    {
                        name: '凤台县',
                        code: '340421',
                    },
                    {
                        name: '寿县',
                        code: '340422',
                    },
                ],
            },
            {
                name: '马鞍山市',
                code: '340500',
                children: [
                    {
                        name: '花山区',
                        code: '340503',
                    },
                    {
                        name: '雨山区',
                        code: '340504',
                    },
                    {
                        name: '博望区',
                        code: '340506',
                    },
                    {
                        name: '当涂县',
                        code: '340521',
                    },
                    {
                        name: '含山县',
                        code: '340522',
                    },
                    {
                        name: '和县',
                        code: '340523',
                    },
                ],
            },
            {
                name: '淮北市',
                code: '340600',
                children: [
                    {
                        name: '杜集区',
                        code: '340602',
                    },
                    {
                        name: '相山区',
                        code: '340603',
                    },
                    {
                        name: '烈山区',
                        code: '340604',
                    },
                    {
                        name: '濉溪县',
                        code: '340621',
                    },
                ],
            },
            {
                name: '铜陵市',
                code: '340700',
                children: [
                    {
                        name: '铜官区',
                        code: '340705',
                    },
                    {
                        name: '义安区',
                        code: '340706',
                    },
                    {
                        name: '郊区',
                        code: '340711',
                    },
                    {
                        name: '枞阳县',
                        code: '340722',
                    },
                ],
            },
            {
                name: '安庆市',
                code: '340800',
                children: [
                    {
                        name: '迎江区',
                        code: '340802',
                    },
                    {
                        name: '大观区',
                        code: '340803',
                    },
                    {
                        name: '宜秀区',
                        code: '340811',
                    },
                    {
                        name: '怀宁县',
                        code: '340822',
                    },
                    {
                        name: '太湖县',
                        code: '340825',
                    },
                    {
                        name: '宿松县',
                        code: '340826',
                    },
                    {
                        name: '望江县',
                        code: '340827',
                    },
                    {
                        name: '岳西县',
                        code: '340828',
                    },
                    {
                        name: '安徽安庆经济开发区',
                        code: '340871',
                    },
                    {
                        name: '桐城市',
                        code: '340881',
                    },
                    {
                        name: '潜山市',
                        code: '340882',
                    },
                ],
            },
            {
                name: '黄山市',
                code: '341000',
                children: [
                    {
                        name: '屯溪区',
                        code: '341002',
                    },
                    {
                        name: '黄山区',
                        code: '341003',
                    },
                    {
                        name: '徽州区',
                        code: '341004',
                    },
                    {
                        name: '歙县',
                        code: '341021',
                    },
                    {
                        name: '休宁县',
                        code: '341022',
                    },
                    {
                        name: '黟县',
                        code: '341023',
                    },
                    {
                        name: '祁门县',
                        code: '341024',
                    },
                ],
            },
            {
                name: '滁州市',
                code: '341100',
                children: [
                    {
                        name: '琅琊区',
                        code: '341102',
                    },
                    {
                        name: '南谯区',
                        code: '341103',
                    },
                    {
                        name: '来安县',
                        code: '341122',
                    },
                    {
                        name: '全椒县',
                        code: '341124',
                    },
                    {
                        name: '定远县',
                        code: '341125',
                    },
                    {
                        name: '凤阳县',
                        code: '341126',
                    },
                    {
                        name: '苏滁现代产业园',
                        code: '341171',
                    },
                    {
                        name: '滁州经济技术开发区',
                        code: '341172',
                    },
                    {
                        name: '天长市',
                        code: '341181',
                    },
                    {
                        name: '明光市',
                        code: '341182',
                    },
                ],
            },
            {
                name: '阜阳市',
                code: '341200',
                children: [
                    {
                        name: '颍州区',
                        code: '341202',
                    },
                    {
                        name: '颍东区',
                        code: '341203',
                    },
                    {
                        name: '颍泉区',
                        code: '341204',
                    },
                    {
                        name: '临泉县',
                        code: '341221',
                    },
                    {
                        name: '太和县',
                        code: '341222',
                    },
                    {
                        name: '阜南县',
                        code: '341225',
                    },
                    {
                        name: '颍上县',
                        code: '341226',
                    },
                    {
                        name: '阜阳合肥现代产业园区',
                        code: '341271',
                    },
                    {
                        name: '阜阳经济技术开发区',
                        code: '341272',
                    },
                    {
                        name: '界首市',
                        code: '341282',
                    },
                ],
            },
            {
                name: '宿州市',
                code: '341300',
                children: [
                    {
                        name: '埇桥区',
                        code: '341302',
                    },
                    {
                        name: '砀山县',
                        code: '341321',
                    },
                    {
                        name: '萧县',
                        code: '341322',
                    },
                    {
                        name: '灵璧县',
                        code: '341323',
                    },
                    {
                        name: '泗县',
                        code: '341324',
                    },
                    {
                        name: '宿州马鞍山现代产业园区',
                        code: '341371',
                    },
                    {
                        name: '宿州经济技术开发区',
                        code: '341372',
                    },
                ],
            },
            {
                name: '六安市',
                code: '341500',
                children: [
                    {
                        name: '金安区',
                        code: '341502',
                    },
                    {
                        name: '裕安区',
                        code: '341503',
                    },
                    {
                        name: '叶集区',
                        code: '341504',
                    },
                    {
                        name: '霍邱县',
                        code: '341522',
                    },
                    {
                        name: '舒城县',
                        code: '341523',
                    },
                    {
                        name: '金寨县',
                        code: '341524',
                    },
                    {
                        name: '霍山县',
                        code: '341525',
                    },
                ],
            },
            {
                name: '亳州市',
                code: '341600',
                children: [
                    {
                        name: '谯城区',
                        code: '341602',
                    },
                    {
                        name: '涡阳县',
                        code: '341621',
                    },
                    {
                        name: '蒙城县',
                        code: '341622',
                    },
                    {
                        name: '利辛县',
                        code: '341623',
                    },
                ],
            },
            {
                name: '池州市',
                code: '341700',
                children: [
                    {
                        name: '贵池区',
                        code: '341702',
                    },
                    {
                        name: '东至县',
                        code: '341721',
                    },
                    {
                        name: '石台县',
                        code: '341722',
                    },
                    {
                        name: '青阳县',
                        code: '341723',
                    },
                ],
            },
            {
                name: '宣城市',
                code: '341800',
                children: [
                    {
                        name: '宣州区',
                        code: '341802',
                    },
                    {
                        name: '郎溪县',
                        code: '341821',
                    },
                    {
                        name: '泾县',
                        code: '341823',
                    },
                    {
                        name: '绩溪县',
                        code: '341824',
                    },
                    {
                        name: '旌德县',
                        code: '341825',
                    },
                    {
                        name: '宣城市经济开发区',
                        code: '341871',
                    },
                    {
                        name: '宁国市',
                        code: '341881',
                    },
                    {
                        name: '广德市',
                        code: '341882',
                    },
                ],
            },
        ],
    },
    {
        name: '福建省',
        code: '350000',
        children: [
            {
                name: '福州市',
                code: '350100',
                children: [
                    {
                        name: '鼓楼区',
                        code: '350102',
                    },
                    {
                        name: '台江区',
                        code: '350103',
                    },
                    {
                        name: '仓山区',
                        code: '350104',
                    },
                    {
                        name: '马尾区',
                        code: '350105',
                    },
                    {
                        name: '晋安区',
                        code: '350111',
                    },
                    {
                        name: '长乐区',
                        code: '350112',
                    },
                    {
                        name: '闽侯县',
                        code: '350121',
                    },
                    {
                        name: '连江县',
                        code: '350122',
                    },
                    {
                        name: '罗源县',
                        code: '350123',
                    },
                    {
                        name: '闽清县',
                        code: '350124',
                    },
                    {
                        name: '永泰县',
                        code: '350125',
                    },
                    {
                        name: '平潭县',
                        code: '350128',
                    },
                    {
                        name: '福清市',
                        code: '350181',
                    },
                ],
            },
            {
                name: '厦门市',
                code: '350200',
                children: [
                    {
                        name: '思明区',
                        code: '350203',
                    },
                    {
                        name: '海沧区',
                        code: '350205',
                    },
                    {
                        name: '湖里区',
                        code: '350206',
                    },
                    {
                        name: '集美区',
                        code: '350211',
                    },
                    {
                        name: '同安区',
                        code: '350212',
                    },
                    {
                        name: '翔安区',
                        code: '350213',
                    },
                ],
            },
            {
                name: '莆田市',
                code: '350300',
                children: [
                    {
                        name: '城厢区',
                        code: '350302',
                    },
                    {
                        name: '涵江区',
                        code: '350303',
                    },
                    {
                        name: '荔城区',
                        code: '350304',
                    },
                    {
                        name: '秀屿区',
                        code: '350305',
                    },
                    {
                        name: '仙游县',
                        code: '350322',
                    },
                ],
            },
            {
                name: '三明市',
                code: '350400',
                children: [
                    {
                        name: '梅列区',
                        code: '350402',
                    },
                    {
                        name: '三元区',
                        code: '350403',
                    },
                    {
                        name: '明溪县',
                        code: '350421',
                    },
                    {
                        name: '清流县',
                        code: '350423',
                    },
                    {
                        name: '宁化县',
                        code: '350424',
                    },
                    {
                        name: '大田县',
                        code: '350425',
                    },
                    {
                        name: '尤溪县',
                        code: '350426',
                    },
                    {
                        name: '沙县',
                        code: '350427',
                    },
                    {
                        name: '将乐县',
                        code: '350428',
                    },
                    {
                        name: '泰宁县',
                        code: '350429',
                    },
                    {
                        name: '建宁县',
                        code: '350430',
                    },
                    {
                        name: '永安市',
                        code: '350481',
                    },
                ],
            },
            {
                name: '泉州市',
                code: '350500',
                children: [
                    {
                        name: '鲤城区',
                        code: '350502',
                    },
                    {
                        name: '丰泽区',
                        code: '350503',
                    },
                    {
                        name: '洛江区',
                        code: '350504',
                    },
                    {
                        name: '泉港区',
                        code: '350505',
                    },
                    {
                        name: '惠安县',
                        code: '350521',
                    },
                    {
                        name: '安溪县',
                        code: '350524',
                    },
                    {
                        name: '永春县',
                        code: '350525',
                    },
                    {
                        name: '德化县',
                        code: '350526',
                    },
                    {
                        name: '石狮市',
                        code: '350581',
                    },
                    {
                        name: '晋江市',
                        code: '350582',
                    },
                    {
                        name: '南安市',
                        code: '350583',
                    },
                ],
            },
            {
                name: '漳州市',
                code: '350600',
                children: [
                    {
                        name: '芗城区',
                        code: '350602',
                    },
                    {
                        name: '龙文区',
                        code: '350603',
                    },
                    {
                        name: '云霄县',
                        code: '350622',
                    },
                    {
                        name: '漳浦县',
                        code: '350623',
                    },
                    {
                        name: '诏安县',
                        code: '350624',
                    },
                    {
                        name: '长泰县',
                        code: '350625',
                    },
                    {
                        name: '东山县',
                        code: '350626',
                    },
                    {
                        name: '南靖县',
                        code: '350627',
                    },
                    {
                        name: '平和县',
                        code: '350628',
                    },
                    {
                        name: '华安县',
                        code: '350629',
                    },
                    {
                        name: '龙海市',
                        code: '350681',
                    },
                ],
            },
            {
                name: '南平市',
                code: '350700',
                children: [
                    {
                        name: '延平区',
                        code: '350702',
                    },
                    {
                        name: '建阳区',
                        code: '350703',
                    },
                    {
                        name: '顺昌县',
                        code: '350721',
                    },
                    {
                        name: '浦城县',
                        code: '350722',
                    },
                    {
                        name: '光泽县',
                        code: '350723',
                    },
                    {
                        name: '松溪县',
                        code: '350724',
                    },
                    {
                        name: '政和县',
                        code: '350725',
                    },
                    {
                        name: '邵武市',
                        code: '350781',
                    },
                    {
                        name: '武夷山市',
                        code: '350782',
                    },
                    {
                        name: '建瓯市',
                        code: '350783',
                    },
                ],
            },
            {
                name: '龙岩市',
                code: '350800',
                children: [
                    {
                        name: '新罗区',
                        code: '350802',
                    },
                    {
                        name: '永定区',
                        code: '350803',
                    },
                    {
                        name: '长汀县',
                        code: '350821',
                    },
                    {
                        name: '上杭县',
                        code: '350823',
                    },
                    {
                        name: '武平县',
                        code: '350824',
                    },
                    {
                        name: '连城县',
                        code: '350825',
                    },
                    {
                        name: '漳平市',
                        code: '350881',
                    },
                ],
            },
            {
                name: '宁德市',
                code: '350900',
                children: [
                    {
                        name: '蕉城区',
                        code: '350902',
                    },
                    {
                        name: '霞浦县',
                        code: '350921',
                    },
                    {
                        name: '古田县',
                        code: '350922',
                    },
                    {
                        name: '屏南县',
                        code: '350923',
                    },
                    {
                        name: '寿宁县',
                        code: '350924',
                    },
                    {
                        name: '周宁县',
                        code: '350925',
                    },
                    {
                        name: '柘荣县',
                        code: '350926',
                    },
                    {
                        name: '福安市',
                        code: '350981',
                    },
                    {
                        name: '福鼎市',
                        code: '350982',
                    },
                ],
            },
        ],
    },
    {
        name: '江西省',
        code: '360000',
        children: [
            {
                name: '南昌市',
                code: '360100',
                children: [
                    {
                        name: '东湖区',
                        code: '360102',
                    },
                    {
                        name: '西湖区',
                        code: '360103',
                    },
                    {
                        name: '青云谱区',
                        code: '360104',
                    },
                    {
                        name: '青山湖区',
                        code: '360111',
                    },
                    {
                        name: '新建区',
                        code: '360112',
                    },
                    {
                        name: '红谷滩区',
                        code: '360113',
                    },
                    {
                        name: '南昌县',
                        code: '360121',
                    },
                    {
                        name: '安义县',
                        code: '360123',
                    },
                    {
                        name: '进贤县',
                        code: '360124',
                    },
                ],
            },
            {
                name: '景德镇市',
                code: '360200',
                children: [
                    {
                        name: '昌江区',
                        code: '360202',
                    },
                    {
                        name: '珠山区',
                        code: '360203',
                    },
                    {
                        name: '浮梁县',
                        code: '360222',
                    },
                    {
                        name: '乐平市',
                        code: '360281',
                    },
                ],
            },
            {
                name: '萍乡市',
                code: '360300',
                children: [
                    {
                        name: '安源区',
                        code: '360302',
                    },
                    {
                        name: '湘东区',
                        code: '360313',
                    },
                    {
                        name: '莲花县',
                        code: '360321',
                    },
                    {
                        name: '上栗县',
                        code: '360322',
                    },
                    {
                        name: '芦溪县',
                        code: '360323',
                    },
                ],
            },
            {
                name: '九江市',
                code: '360400',
                children: [
                    {
                        name: '濂溪区',
                        code: '360402',
                    },
                    {
                        name: '浔阳区',
                        code: '360403',
                    },
                    {
                        name: '柴桑区',
                        code: '360404',
                    },
                    {
                        name: '武宁县',
                        code: '360423',
                    },
                    {
                        name: '修水县',
                        code: '360424',
                    },
                    {
                        name: '永修县',
                        code: '360425',
                    },
                    {
                        name: '德安县',
                        code: '360426',
                    },
                    {
                        name: '都昌县',
                        code: '360428',
                    },
                    {
                        name: '湖口县',
                        code: '360429',
                    },
                    {
                        name: '彭泽县',
                        code: '360430',
                    },
                    {
                        name: '瑞昌市',
                        code: '360481',
                    },
                    {
                        name: '共青城市',
                        code: '360482',
                    },
                    {
                        name: '庐山市',
                        code: '360483',
                    },
                ],
            },
            {
                name: '新余市',
                code: '360500',
                children: [
                    {
                        name: '渝水区',
                        code: '360502',
                    },
                    {
                        name: '分宜县',
                        code: '360521',
                    },
                ],
            },
            {
                name: '鹰潭市',
                code: '360600',
                children: [
                    {
                        name: '月湖区',
                        code: '360602',
                    },
                    {
                        name: '余江区',
                        code: '360603',
                    },
                    {
                        name: '贵溪市',
                        code: '360681',
                    },
                ],
            },
            {
                name: '赣州市',
                code: '360700',
                children: [
                    {
                        name: '章贡区',
                        code: '360702',
                    },
                    {
                        name: '南康区',
                        code: '360703',
                    },
                    {
                        name: '赣县区',
                        code: '360704',
                    },
                    {
                        name: '信丰县',
                        code: '360722',
                    },
                    {
                        name: '大余县',
                        code: '360723',
                    },
                    {
                        name: '上犹县',
                        code: '360724',
                    },
                    {
                        name: '崇义县',
                        code: '360725',
                    },
                    {
                        name: '安远县',
                        code: '360726',
                    },
                    {
                        name: '定南县',
                        code: '360728',
                    },
                    {
                        name: '全南县',
                        code: '360729',
                    },
                    {
                        name: '宁都县',
                        code: '360730',
                    },
                    {
                        name: '于都县',
                        code: '360731',
                    },
                    {
                        name: '兴国县',
                        code: '360732',
                    },
                    {
                        name: '会昌县',
                        code: '360733',
                    },
                    {
                        name: '寻乌县',
                        code: '360734',
                    },
                    {
                        name: '石城县',
                        code: '360735',
                    },
                    {
                        name: '瑞金市',
                        code: '360781',
                    },
                    {
                        name: '龙南市',
                        code: '360783',
                    },
                ],
            },
            {
                name: '吉安市',
                code: '360800',
                children: [
                    {
                        name: '吉州区',
                        code: '360802',
                    },
                    {
                        name: '青原区',
                        code: '360803',
                    },
                    {
                        name: '吉安县',
                        code: '360821',
                    },
                    {
                        name: '吉水县',
                        code: '360822',
                    },
                    {
                        name: '峡江县',
                        code: '360823',
                    },
                    {
                        name: '新干县',
                        code: '360824',
                    },
                    {
                        name: '永丰县',
                        code: '360825',
                    },
                    {
                        name: '泰和县',
                        code: '360826',
                    },
                    {
                        name: '遂川县',
                        code: '360827',
                    },
                    {
                        name: '万安县',
                        code: '360828',
                    },
                    {
                        name: '安福县',
                        code: '360829',
                    },
                    {
                        name: '永新县',
                        code: '360830',
                    },
                    {
                        name: '井冈山市',
                        code: '360881',
                    },
                ],
            },
            {
                name: '宜春市',
                code: '360900',
                children: [
                    {
                        name: '袁州区',
                        code: '360902',
                    },
                    {
                        name: '奉新县',
                        code: '360921',
                    },
                    {
                        name: '万载县',
                        code: '360922',
                    },
                    {
                        name: '上高县',
                        code: '360923',
                    },
                    {
                        name: '宜丰县',
                        code: '360924',
                    },
                    {
                        name: '靖安县',
                        code: '360925',
                    },
                    {
                        name: '铜鼓县',
                        code: '360926',
                    },
                    {
                        name: '丰城市',
                        code: '360981',
                    },
                    {
                        name: '樟树市',
                        code: '360982',
                    },
                    {
                        name: '高安市',
                        code: '360983',
                    },
                ],
            },
            {
                name: '抚州市',
                code: '361000',
                children: [
                    {
                        name: '临川区',
                        code: '361002',
                    },
                    {
                        name: '东乡区',
                        code: '361003',
                    },
                    {
                        name: '南城县',
                        code: '361021',
                    },
                    {
                        name: '黎川县',
                        code: '361022',
                    },
                    {
                        name: '南丰县',
                        code: '361023',
                    },
                    {
                        name: '崇仁县',
                        code: '361024',
                    },
                    {
                        name: '乐安县',
                        code: '361025',
                    },
                    {
                        name: '宜黄县',
                        code: '361026',
                    },
                    {
                        name: '金溪县',
                        code: '361027',
                    },
                    {
                        name: '资溪县',
                        code: '361028',
                    },
                    {
                        name: '广昌县',
                        code: '361030',
                    },
                ],
            },
            {
                name: '上饶市',
                code: '361100',
                children: [
                    {
                        name: '信州区',
                        code: '361102',
                    },
                    {
                        name: '广丰区',
                        code: '361103',
                    },
                    {
                        name: '广信区',
                        code: '361104',
                    },
                    {
                        name: '玉山县',
                        code: '361123',
                    },
                    {
                        name: '铅山县',
                        code: '361124',
                    },
                    {
                        name: '横峰县',
                        code: '361125',
                    },
                    {
                        name: '弋阳县',
                        code: '361126',
                    },
                    {
                        name: '余干县',
                        code: '361127',
                    },
                    {
                        name: '鄱阳县',
                        code: '361128',
                    },
                    {
                        name: '万年县',
                        code: '361129',
                    },
                    {
                        name: '婺源县',
                        code: '361130',
                    },
                    {
                        name: '德兴市',
                        code: '361181',
                    },
                ],
            },
        ],
    },
    {
        name: '山东省',
        code: '370000',
        children: [
            {
                name: '济南市',
                code: '370100',
                children: [
                    {
                        name: '历下区',
                        code: '370102',
                    },
                    {
                        name: '市中区',
                        code: '370103',
                    },
                    {
                        name: '槐荫区',
                        code: '370104',
                    },
                    {
                        name: '天桥区',
                        code: '370105',
                    },
                    {
                        name: '历城区',
                        code: '370112',
                    },
                    {
                        name: '长清区',
                        code: '370113',
                    },
                    {
                        name: '章丘区',
                        code: '370114',
                    },
                    {
                        name: '济阳区',
                        code: '370115',
                    },
                    {
                        name: '莱芜区',
                        code: '370116',
                    },
                    {
                        name: '钢城区',
                        code: '370117',
                    },
                    {
                        name: '平阴县',
                        code: '370124',
                    },
                    {
                        name: '商河县',
                        code: '370126',
                    },
                    {
                        name: '济南高新技术产业开发区',
                        code: '370171',
                    },
                ],
            },
            {
                name: '青岛市',
                code: '370200',
                children: [
                    {
                        name: '市南区',
                        code: '370202',
                    },
                    {
                        name: '市北区',
                        code: '370203',
                    },
                    {
                        name: '黄岛区',
                        code: '370211',
                    },
                    {
                        name: '崂山区',
                        code: '370212',
                    },
                    {
                        name: '李沧区',
                        code: '370213',
                    },
                    {
                        name: '城阳区',
                        code: '370214',
                    },
                    {
                        name: '即墨区',
                        code: '370215',
                    },
                    {
                        name: '青岛高新技术产业开发区',
                        code: '370271',
                    },
                    {
                        name: '胶州市',
                        code: '370281',
                    },
                    {
                        name: '平度市',
                        code: '370283',
                    },
                    {
                        name: '莱西市',
                        code: '370285',
                    },
                ],
            },
            {
                name: '淄博市',
                code: '370300',
                children: [
                    {
                        name: '淄川区',
                        code: '370302',
                    },
                    {
                        name: '张店区',
                        code: '370303',
                    },
                    {
                        name: '博山区',
                        code: '370304',
                    },
                    {
                        name: '临淄区',
                        code: '370305',
                    },
                    {
                        name: '周村区',
                        code: '370306',
                    },
                    {
                        name: '桓台县',
                        code: '370321',
                    },
                    {
                        name: '高青县',
                        code: '370322',
                    },
                    {
                        name: '沂源县',
                        code: '370323',
                    },
                ],
            },
            {
                name: '枣庄市',
                code: '370400',
                children: [
                    {
                        name: '市中区',
                        code: '370402',
                    },
                    {
                        name: '薛城区',
                        code: '370403',
                    },
                    {
                        name: '峄城区',
                        code: '370404',
                    },
                    {
                        name: '台儿庄区',
                        code: '370405',
                    },
                    {
                        name: '山亭区',
                        code: '370406',
                    },
                    {
                        name: '滕州市',
                        code: '370481',
                    },
                ],
            },
            {
                name: '东营市',
                code: '370500',
                children: [
                    {
                        name: '东营区',
                        code: '370502',
                    },
                    {
                        name: '河口区',
                        code: '370503',
                    },
                    {
                        name: '垦利区',
                        code: '370505',
                    },
                    {
                        name: '利津县',
                        code: '370522',
                    },
                    {
                        name: '广饶县',
                        code: '370523',
                    },
                    {
                        name: '东营经济技术开发区',
                        code: '370571',
                    },
                    {
                        name: '东营港经济开发区',
                        code: '370572',
                    },
                ],
            },
            {
                name: '烟台市',
                code: '370600',
                children: [
                    {
                        name: '芝罘区',
                        code: '370602',
                    },
                    {
                        name: '福山区',
                        code: '370611',
                    },
                    {
                        name: '牟平区',
                        code: '370612',
                    },
                    {
                        name: '莱山区',
                        code: '370613',
                    },
                    {
                        name: '蓬莱区',
                        code: '370614',
                    },
                    {
                        name: '烟台高新技术产业开发区',
                        code: '370671',
                    },
                    {
                        name: '烟台经济技术开发区',
                        code: '370672',
                    },
                    {
                        name: '龙口市',
                        code: '370681',
                    },
                    {
                        name: '莱阳市',
                        code: '370682',
                    },
                    {
                        name: '莱州市',
                        code: '370683',
                    },
                    {
                        name: '招远市',
                        code: '370685',
                    },
                    {
                        name: '栖霞市',
                        code: '370686',
                    },
                    {
                        name: '海阳市',
                        code: '370687',
                    },
                ],
            },
            {
                name: '潍坊市',
                code: '370700',
                children: [
                    {
                        name: '潍城区',
                        code: '370702',
                    },
                    {
                        name: '寒亭区',
                        code: '370703',
                    },
                    {
                        name: '坊子区',
                        code: '370704',
                    },
                    {
                        name: '奎文区',
                        code: '370705',
                    },
                    {
                        name: '临朐县',
                        code: '370724',
                    },
                    {
                        name: '昌乐县',
                        code: '370725',
                    },
                    {
                        name: '潍坊滨海经济技术开发区',
                        code: '370772',
                    },
                    {
                        name: '青州市',
                        code: '370781',
                    },
                    {
                        name: '诸城市',
                        code: '370782',
                    },
                    {
                        name: '寿光市',
                        code: '370783',
                    },
                    {
                        name: '安丘市',
                        code: '370784',
                    },
                    {
                        name: '高密市',
                        code: '370785',
                    },
                    {
                        name: '昌邑市',
                        code: '370786',
                    },
                ],
            },
            {
                name: '济宁市',
                code: '370800',
                children: [
                    {
                        name: '任城区',
                        code: '370811',
                    },
                    {
                        name: '兖州区',
                        code: '370812',
                    },
                    {
                        name: '微山县',
                        code: '370826',
                    },
                    {
                        name: '鱼台县',
                        code: '370827',
                    },
                    {
                        name: '金乡县',
                        code: '370828',
                    },
                    {
                        name: '嘉祥县',
                        code: '370829',
                    },
                    {
                        name: '汶上县',
                        code: '370830',
                    },
                    {
                        name: '泗水县',
                        code: '370831',
                    },
                    {
                        name: '梁山县',
                        code: '370832',
                    },
                    {
                        name: '济宁高新技术产业开发区',
                        code: '370871',
                    },
                    {
                        name: '曲阜市',
                        code: '370881',
                    },
                    {
                        name: '邹城市',
                        code: '370883',
                    },
                ],
            },
            {
                name: '泰安市',
                code: '370900',
                children: [
                    {
                        name: '泰山区',
                        code: '370902',
                    },
                    {
                        name: '岱岳区',
                        code: '370911',
                    },
                    {
                        name: '宁阳县',
                        code: '370921',
                    },
                    {
                        name: '东平县',
                        code: '370923',
                    },
                    {
                        name: '新泰市',
                        code: '370982',
                    },
                    {
                        name: '肥城市',
                        code: '370983',
                    },
                ],
            },
            {
                name: '威海市',
                code: '371000',
                children: [
                    {
                        name: '环翠区',
                        code: '371002',
                    },
                    {
                        name: '文登区',
                        code: '371003',
                    },
                    {
                        name: '威海火炬高技术产业开发区',
                        code: '371071',
                    },
                    {
                        name: '威海经济技术开发区',
                        code: '371072',
                    },
                    {
                        name: '威海临港经济技术开发区',
                        code: '371073',
                    },
                    {
                        name: '荣成市',
                        code: '371082',
                    },
                    {
                        name: '乳山市',
                        code: '371083',
                    },
                ],
            },
            {
                name: '日照市',
                code: '371100',
                children: [
                    {
                        name: '东港区',
                        code: '371102',
                    },
                    {
                        name: '岚山区',
                        code: '371103',
                    },
                    {
                        name: '五莲县',
                        code: '371121',
                    },
                    {
                        name: '莒县',
                        code: '371122',
                    },
                    {
                        name: '日照经济技术开发区',
                        code: '371171',
                    },
                ],
            },
            {
                name: '临沂市',
                code: '371300',
                children: [
                    {
                        name: '兰山区',
                        code: '371302',
                    },
                    {
                        name: '罗庄区',
                        code: '371311',
                    },
                    {
                        name: '河东区',
                        code: '371312',
                    },
                    {
                        name: '沂南县',
                        code: '371321',
                    },
                    {
                        name: '郯城县',
                        code: '371322',
                    },
                    {
                        name: '沂水县',
                        code: '371323',
                    },
                    {
                        name: '兰陵县',
                        code: '371324',
                    },
                    {
                        name: '费县',
                        code: '371325',
                    },
                    {
                        name: '平邑县',
                        code: '371326',
                    },
                    {
                        name: '莒南县',
                        code: '371327',
                    },
                    {
                        name: '蒙阴县',
                        code: '371328',
                    },
                    {
                        name: '临沭县',
                        code: '371329',
                    },
                    {
                        name: '临沂高新技术产业开发区',
                        code: '371371',
                    },
                ],
            },
            {
                name: '德州市',
                code: '371400',
                children: [
                    {
                        name: '德城区',
                        code: '371402',
                    },
                    {
                        name: '陵城区',
                        code: '371403',
                    },
                    {
                        name: '宁津县',
                        code: '371422',
                    },
                    {
                        name: '庆云县',
                        code: '371423',
                    },
                    {
                        name: '临邑县',
                        code: '371424',
                    },
                    {
                        name: '齐河县',
                        code: '371425',
                    },
                    {
                        name: '平原县',
                        code: '371426',
                    },
                    {
                        name: '夏津县',
                        code: '371427',
                    },
                    {
                        name: '武城县',
                        code: '371428',
                    },
                    {
                        name: '德州经济技术开发区',
                        code: '371471',
                    },
                    {
                        name: '德州运河经济开发区',
                        code: '371472',
                    },
                    {
                        name: '乐陵市',
                        code: '371481',
                    },
                    {
                        name: '禹城市',
                        code: '371482',
                    },
                ],
            },
            {
                name: '聊城市',
                code: '371500',
                children: [
                    {
                        name: '东昌府区',
                        code: '371502',
                    },
                    {
                        name: '茌平区',
                        code: '371503',
                    },
                    {
                        name: '阳谷县',
                        code: '371521',
                    },
                    {
                        name: '莘县',
                        code: '371522',
                    },
                    {
                        name: '东阿县',
                        code: '371524',
                    },
                    {
                        name: '冠县',
                        code: '371525',
                    },
                    {
                        name: '高唐县',
                        code: '371526',
                    },
                    {
                        name: '临清市',
                        code: '371581',
                    },
                ],
            },
            {
                name: '滨州市',
                code: '371600',
                children: [
                    {
                        name: '滨城区',
                        code: '371602',
                    },
                    {
                        name: '沾化区',
                        code: '371603',
                    },
                    {
                        name: '惠民县',
                        code: '371621',
                    },
                    {
                        name: '阳信县',
                        code: '371622',
                    },
                    {
                        name: '无棣县',
                        code: '371623',
                    },
                    {
                        name: '博兴县',
                        code: '371625',
                    },
                    {
                        name: '邹平市',
                        code: '371681',
                    },
                ],
            },
            {
                name: '菏泽市',
                code: '371700',
                children: [
                    {
                        name: '牡丹区',
                        code: '371702',
                    },
                    {
                        name: '定陶区',
                        code: '371703',
                    },
                    {
                        name: '曹县',
                        code: '371721',
                    },
                    {
                        name: '单县',
                        code: '371722',
                    },
                    {
                        name: '成武县',
                        code: '371723',
                    },
                    {
                        name: '巨野县',
                        code: '371724',
                    },
                    {
                        name: '郓城县',
                        code: '371725',
                    },
                    {
                        name: '鄄城县',
                        code: '371726',
                    },
                    {
                        name: '东明县',
                        code: '371728',
                    },
                    {
                        name: '菏泽经济技术开发区',
                        code: '371771',
                    },
                    {
                        name: '菏泽高新技术开发区',
                        code: '371772',
                    },
                ],
            },
        ],
    },
    {
        name: '河南省',
        code: '410000',
        children: [
            {
                name: '郑州市',
                code: '410100',
                children: [
                    {
                        name: '中原区',
                        code: '410102',
                    },
                    {
                        name: '二七区',
                        code: '410103',
                    },
                    {
                        name: '管城回族区',
                        code: '410104',
                    },
                    {
                        name: '金水区',
                        code: '410105',
                    },
                    {
                        name: '上街区',
                        code: '410106',
                    },
                    {
                        name: '惠济区',
                        code: '410108',
                    },
                    {
                        name: '中牟县',
                        code: '410122',
                    },
                    {
                        name: '郑州经济技术开发区',
                        code: '410171',
                    },
                    {
                        name: '郑州高新技术产业开发区',
                        code: '410172',
                    },
                    {
                        name: '郑州航空港经济综合实验区',
                        code: '410173',
                    },
                    {
                        name: '巩义市',
                        code: '410181',
                    },
                    {
                        name: '荥阳市',
                        code: '410182',
                    },
                    {
                        name: '新密市',
                        code: '410183',
                    },
                    {
                        name: '新郑市',
                        code: '410184',
                    },
                    {
                        name: '登封市',
                        code: '410185',
                    },
                ],
            },
            {
                name: '开封市',
                code: '410200',
                children: [
                    {
                        name: '龙亭区',
                        code: '410202',
                    },
                    {
                        name: '顺河回族区',
                        code: '410203',
                    },
                    {
                        name: '鼓楼区',
                        code: '410204',
                    },
                    {
                        name: '禹王台区',
                        code: '410205',
                    },
                    {
                        name: '祥符区',
                        code: '410212',
                    },
                    {
                        name: '杞县',
                        code: '410221',
                    },
                    {
                        name: '通许县',
                        code: '410222',
                    },
                    {
                        name: '尉氏县',
                        code: '410223',
                    },
                    {
                        name: '兰考县',
                        code: '410225',
                    },
                ],
            },
            {
                name: '洛阳市',
                code: '410300',
                children: [
                    {
                        name: '老城区',
                        code: '410302',
                    },
                    {
                        name: '西工区',
                        code: '410303',
                    },
                    {
                        name: '瀍河回族区',
                        code: '410304',
                    },
                    {
                        name: '涧西区',
                        code: '410305',
                    },
                    {
                        name: '吉利区',
                        code: '410306',
                    },
                    {
                        name: '洛龙区',
                        code: '410311',
                    },
                    {
                        name: '孟津县',
                        code: '410322',
                    },
                    {
                        name: '新安县',
                        code: '410323',
                    },
                    {
                        name: '栾川县',
                        code: '410324',
                    },
                    {
                        name: '嵩县',
                        code: '410325',
                    },
                    {
                        name: '汝阳县',
                        code: '410326',
                    },
                    {
                        name: '宜阳县',
                        code: '410327',
                    },
                    {
                        name: '洛宁县',
                        code: '410328',
                    },
                    {
                        name: '伊川县',
                        code: '410329',
                    },
                    {
                        name: '洛阳高新技术产业开发区',
                        code: '410371',
                    },
                    {
                        name: '偃师市',
                        code: '410381',
                    },
                ],
            },
            {
                name: '平顶山市',
                code: '410400',
                children: [
                    {
                        name: '新华区',
                        code: '410402',
                    },
                    {
                        name: '卫东区',
                        code: '410403',
                    },
                    {
                        name: '石龙区',
                        code: '410404',
                    },
                    {
                        name: '湛河区',
                        code: '410411',
                    },
                    {
                        name: '宝丰县',
                        code: '410421',
                    },
                    {
                        name: '叶县',
                        code: '410422',
                    },
                    {
                        name: '鲁山县',
                        code: '410423',
                    },
                    {
                        name: '郏县',
                        code: '410425',
                    },
                    {
                        name: '平顶山高新技术产业开发区',
                        code: '410471',
                    },
                    {
                        name: '平顶山市城乡一体化示范区',
                        code: '410472',
                    },
                    {
                        name: '舞钢市',
                        code: '410481',
                    },
                    {
                        name: '汝州市',
                        code: '410482',
                    },
                ],
            },
            {
                name: '安阳市',
                code: '410500',
                children: [
                    {
                        name: '文峰区',
                        code: '410502',
                    },
                    {
                        name: '北关区',
                        code: '410503',
                    },
                    {
                        name: '殷都区',
                        code: '410505',
                    },
                    {
                        name: '龙安区',
                        code: '410506',
                    },
                    {
                        name: '安阳县',
                        code: '410522',
                    },
                    {
                        name: '汤阴县',
                        code: '410523',
                    },
                    {
                        name: '滑县',
                        code: '410526',
                    },
                    {
                        name: '内黄县',
                        code: '410527',
                    },
                    {
                        name: '安阳高新技术产业开发区',
                        code: '410571',
                    },
                    {
                        name: '林州市',
                        code: '410581',
                    },
                ],
            },
            {
                name: '鹤壁市',
                code: '410600',
                children: [
                    {
                        name: '鹤山区',
                        code: '410602',
                    },
                    {
                        name: '山城区',
                        code: '410603',
                    },
                    {
                        name: '淇滨区',
                        code: '410611',
                    },
                    {
                        name: '浚县',
                        code: '410621',
                    },
                    {
                        name: '淇县',
                        code: '410622',
                    },
                    {
                        name: '鹤壁经济技术开发区',
                        code: '410671',
                    },
                ],
            },
            {
                name: '新乡市',
                code: '410700',
                children: [
                    {
                        name: '红旗区',
                        code: '410702',
                    },
                    {
                        name: '卫滨区',
                        code: '410703',
                    },
                    {
                        name: '凤泉区',
                        code: '410704',
                    },
                    {
                        name: '牧野区',
                        code: '410711',
                    },
                    {
                        name: '新乡县',
                        code: '410721',
                    },
                    {
                        name: '获嘉县',
                        code: '410724',
                    },
                    {
                        name: '原阳县',
                        code: '410725',
                    },
                    {
                        name: '延津县',
                        code: '410726',
                    },
                    {
                        name: '封丘县',
                        code: '410727',
                    },
                    {
                        name: '新乡高新技术产业开发区',
                        code: '410771',
                    },
                    {
                        name: '新乡经济技术开发区',
                        code: '410772',
                    },
                    {
                        name: '新乡市平原城乡一体化示范区',
                        code: '410773',
                    },
                    {
                        name: '卫辉市',
                        code: '410781',
                    },
                    {
                        name: '辉县市',
                        code: '410782',
                    },
                    {
                        name: '长垣市',
                        code: '410783',
                    },
                ],
            },
            {
                name: '焦作市',
                code: '410800',
                children: [
                    {
                        name: '解放区',
                        code: '410802',
                    },
                    {
                        name: '中站区',
                        code: '410803',
                    },
                    {
                        name: '马村区',
                        code: '410804',
                    },
                    {
                        name: '山阳区',
                        code: '410811',
                    },
                    {
                        name: '修武县',
                        code: '410821',
                    },
                    {
                        name: '博爱县',
                        code: '410822',
                    },
                    {
                        name: '武陟县',
                        code: '410823',
                    },
                    {
                        name: '温县',
                        code: '410825',
                    },
                    {
                        name: '焦作城乡一体化示范区',
                        code: '410871',
                    },
                    {
                        name: '沁阳市',
                        code: '410882',
                    },
                    {
                        name: '孟州市',
                        code: '410883',
                    },
                ],
            },
            {
                name: '濮阳市',
                code: '410900',
                children: [
                    {
                        name: '华龙区',
                        code: '410902',
                    },
                    {
                        name: '清丰县',
                        code: '410922',
                    },
                    {
                        name: '南乐县',
                        code: '410923',
                    },
                    {
                        name: '范县',
                        code: '410926',
                    },
                    {
                        name: '台前县',
                        code: '410927',
                    },
                    {
                        name: '濮阳县',
                        code: '410928',
                    },
                    {
                        name: '河南濮阳工业园区',
                        code: '410971',
                    },
                    {
                        name: '濮阳经济技术开发区',
                        code: '410972',
                    },
                ],
            },
            {
                name: '许昌市',
                code: '411000',
                children: [
                    {
                        name: '魏都区',
                        code: '411002',
                    },
                    {
                        name: '建安区',
                        code: '411003',
                    },
                    {
                        name: '鄢陵县',
                        code: '411024',
                    },
                    {
                        name: '襄城县',
                        code: '411025',
                    },
                    {
                        name: '许昌经济技术开发区',
                        code: '411071',
                    },
                    {
                        name: '禹州市',
                        code: '411081',
                    },
                    {
                        name: '长葛市',
                        code: '411082',
                    },
                ],
            },
            {
                name: '漯河市',
                code: '411100',
                children: [
                    {
                        name: '源汇区',
                        code: '411102',
                    },
                    {
                        name: '郾城区',
                        code: '411103',
                    },
                    {
                        name: '召陵区',
                        code: '411104',
                    },
                    {
                        name: '舞阳县',
                        code: '411121',
                    },
                    {
                        name: '临颍县',
                        code: '411122',
                    },
                    {
                        name: '漯河经济技术开发区',
                        code: '411171',
                    },
                ],
            },
            {
                name: '三门峡市',
                code: '411200',
                children: [
                    {
                        name: '湖滨区',
                        code: '411202',
                    },
                    {
                        name: '陕州区',
                        code: '411203',
                    },
                    {
                        name: '渑池县',
                        code: '411221',
                    },
                    {
                        name: '卢氏县',
                        code: '411224',
                    },
                    {
                        name: '河南三门峡经济开发区',
                        code: '411271',
                    },
                    {
                        name: '义马市',
                        code: '411281',
                    },
                    {
                        name: '灵宝市',
                        code: '411282',
                    },
                ],
            },
            {
                name: '南阳市',
                code: '411300',
                children: [
                    {
                        name: '宛城区',
                        code: '411302',
                    },
                    {
                        name: '卧龙区',
                        code: '411303',
                    },
                    {
                        name: '南召县',
                        code: '411321',
                    },
                    {
                        name: '方城县',
                        code: '411322',
                    },
                    {
                        name: '西峡县',
                        code: '411323',
                    },
                    {
                        name: '镇平县',
                        code: '411324',
                    },
                    {
                        name: '内乡县',
                        code: '411325',
                    },
                    {
                        name: '淅川县',
                        code: '411326',
                    },
                    {
                        name: '社旗县',
                        code: '411327',
                    },
                    {
                        name: '唐河县',
                        code: '411328',
                    },
                    {
                        name: '新野县',
                        code: '411329',
                    },
                    {
                        name: '桐柏县',
                        code: '411330',
                    },
                    {
                        name: '南阳高新技术产业开发区',
                        code: '411371',
                    },
                    {
                        name: '南阳市城乡一体化示范区',
                        code: '411372',
                    },
                    {
                        name: '邓州市',
                        code: '411381',
                    },
                ],
            },
            {
                name: '商丘市',
                code: '411400',
                children: [
                    {
                        name: '梁园区',
                        code: '411402',
                    },
                    {
                        name: '睢阳区',
                        code: '411403',
                    },
                    {
                        name: '民权县',
                        code: '411421',
                    },
                    {
                        name: '睢县',
                        code: '411422',
                    },
                    {
                        name: '宁陵县',
                        code: '411423',
                    },
                    {
                        name: '柘城县',
                        code: '411424',
                    },
                    {
                        name: '虞城县',
                        code: '411425',
                    },
                    {
                        name: '夏邑县',
                        code: '411426',
                    },
                    {
                        name: '豫东综合物流产业聚集区',
                        code: '411471',
                    },
                    {
                        name: '河南商丘经济开发区',
                        code: '411472',
                    },
                    {
                        name: '永城市',
                        code: '411481',
                    },
                ],
            },
            {
                name: '信阳市',
                code: '411500',
                children: [
                    {
                        name: '浉河区',
                        code: '411502',
                    },
                    {
                        name: '平桥区',
                        code: '411503',
                    },
                    {
                        name: '罗山县',
                        code: '411521',
                    },
                    {
                        name: '光山县',
                        code: '411522',
                    },
                    {
                        name: '新县',
                        code: '411523',
                    },
                    {
                        name: '商城县',
                        code: '411524',
                    },
                    {
                        name: '固始县',
                        code: '411525',
                    },
                    {
                        name: '潢川县',
                        code: '411526',
                    },
                    {
                        name: '淮滨县',
                        code: '411527',
                    },
                    {
                        name: '息县',
                        code: '411528',
                    },
                    {
                        name: '信阳高新技术产业开发区',
                        code: '411571',
                    },
                ],
            },
            {
                name: '周口市',
                code: '411600',
                children: [
                    {
                        name: '川汇区',
                        code: '411602',
                    },
                    {
                        name: '淮阳区',
                        code: '411603',
                    },
                    {
                        name: '扶沟县',
                        code: '411621',
                    },
                    {
                        name: '西华县',
                        code: '411622',
                    },
                    {
                        name: '商水县',
                        code: '411623',
                    },
                    {
                        name: '沈丘县',
                        code: '411624',
                    },
                    {
                        name: '郸城县',
                        code: '411625',
                    },
                    {
                        name: '太康县',
                        code: '411627',
                    },
                    {
                        name: '鹿邑县',
                        code: '411628',
                    },
                    {
                        name: '河南周口经济开发区',
                        code: '411671',
                    },
                    {
                        name: '项城市',
                        code: '411681',
                    },
                ],
            },
            {
                name: '驻马店市',
                code: '411700',
                children: [
                    {
                        name: '驿城区',
                        code: '411702',
                    },
                    {
                        name: '西平县',
                        code: '411721',
                    },
                    {
                        name: '上蔡县',
                        code: '411722',
                    },
                    {
                        name: '平舆县',
                        code: '411723',
                    },
                    {
                        name: '正阳县',
                        code: '411724',
                    },
                    {
                        name: '确山县',
                        code: '411725',
                    },
                    {
                        name: '泌阳县',
                        code: '411726',
                    },
                    {
                        name: '汝南县',
                        code: '411727',
                    },
                    {
                        name: '遂平县',
                        code: '411728',
                    },
                    {
                        name: '新蔡县',
                        code: '411729',
                    },
                    {
                        name: '河南驻马店经济开发区',
                        code: '411771',
                    },
                ],
            },
            {
                name: '省直辖县级行政区划',
                code: '419000',
                children: [
                    {
                        name: '济源市',
                        code: '419001',
                    },
                ],
            },
        ],
    },
    {
        name: '湖北省',
        code: '420000',
        children: [
            {
                name: '武汉市',
                code: '420100',
                children: [
                    {
                        name: '江岸区',
                        code: '420102',
                    },
                    {
                        name: '江汉区',
                        code: '420103',
                    },
                    {
                        name: '硚口区',
                        code: '420104',
                    },
                    {
                        name: '汉阳区',
                        code: '420105',
                    },
                    {
                        name: '武昌区',
                        code: '420106',
                    },
                    {
                        name: '青山区',
                        code: '420107',
                    },
                    {
                        name: '洪山区',
                        code: '420111',
                    },
                    {
                        name: '东西湖区',
                        code: '420112',
                    },
                    {
                        name: '汉南区',
                        code: '420113',
                    },
                    {
                        name: '蔡甸区',
                        code: '420114',
                    },
                    {
                        name: '江夏区',
                        code: '420115',
                    },
                    {
                        name: '黄陂区',
                        code: '420116',
                    },
                    {
                        name: '新洲区',
                        code: '420117',
                    },
                ],
            },
            {
                name: '黄石市',
                code: '420200',
                children: [
                    {
                        name: '黄石港区',
                        code: '420202',
                    },
                    {
                        name: '西塞山区',
                        code: '420203',
                    },
                    {
                        name: '下陆区',
                        code: '420204',
                    },
                    {
                        name: '铁山区',
                        code: '420205',
                    },
                    {
                        name: '阳新县',
                        code: '420222',
                    },
                    {
                        name: '大冶市',
                        code: '420281',
                    },
                ],
            },
            {
                name: '十堰市',
                code: '420300',
                children: [
                    {
                        name: '茅箭区',
                        code: '420302',
                    },
                    {
                        name: '张湾区',
                        code: '420303',
                    },
                    {
                        name: '郧阳区',
                        code: '420304',
                    },
                    {
                        name: '郧西县',
                        code: '420322',
                    },
                    {
                        name: '竹山县',
                        code: '420323',
                    },
                    {
                        name: '竹溪县',
                        code: '420324',
                    },
                    {
                        name: '房县',
                        code: '420325',
                    },
                    {
                        name: '丹江口市',
                        code: '420381',
                    },
                ],
            },
            {
                name: '宜昌市',
                code: '420500',
                children: [
                    {
                        name: '西陵区',
                        code: '420502',
                    },
                    {
                        name: '伍家岗区',
                        code: '420503',
                    },
                    {
                        name: '点军区',
                        code: '420504',
                    },
                    {
                        name: '猇亭区',
                        code: '420505',
                    },
                    {
                        name: '夷陵区',
                        code: '420506',
                    },
                    {
                        name: '远安县',
                        code: '420525',
                    },
                    {
                        name: '兴山县',
                        code: '420526',
                    },
                    {
                        name: '秭归县',
                        code: '420527',
                    },
                    {
                        name: '长阳土家族自治县',
                        code: '420528',
                    },
                    {
                        name: '五峰土家族自治县',
                        code: '420529',
                    },
                    {
                        name: '宜都市',
                        code: '420581',
                    },
                    {
                        name: '当阳市',
                        code: '420582',
                    },
                    {
                        name: '枝江市',
                        code: '420583',
                    },
                ],
            },
            {
                name: '襄阳市',
                code: '420600',
                children: [
                    {
                        name: '襄城区',
                        code: '420602',
                    },
                    {
                        name: '樊城区',
                        code: '420606',
                    },
                    {
                        name: '襄州区',
                        code: '420607',
                    },
                    {
                        name: '南漳县',
                        code: '420624',
                    },
                    {
                        name: '谷城县',
                        code: '420625',
                    },
                    {
                        name: '保康县',
                        code: '420626',
                    },
                    {
                        name: '老河口市',
                        code: '420682',
                    },
                    {
                        name: '枣阳市',
                        code: '420683',
                    },
                    {
                        name: '宜城市',
                        code: '420684',
                    },
                ],
            },
            {
                name: '鄂州市',
                code: '420700',
                children: [
                    {
                        name: '梁子湖区',
                        code: '420702',
                    },
                    {
                        name: '华容区',
                        code: '420703',
                    },
                    {
                        name: '鄂城区',
                        code: '420704',
                    },
                ],
            },
            {
                name: '荆门市',
                code: '420800',
                children: [
                    {
                        name: '东宝区',
                        code: '420802',
                    },
                    {
                        name: '掇刀区',
                        code: '420804',
                    },
                    {
                        name: '沙洋县',
                        code: '420822',
                    },
                    {
                        name: '钟祥市',
                        code: '420881',
                    },
                    {
                        name: '京山市',
                        code: '420882',
                    },
                ],
            },
            {
                name: '孝感市',
                code: '420900',
                children: [
                    {
                        name: '孝南区',
                        code: '420902',
                    },
                    {
                        name: '孝昌县',
                        code: '420921',
                    },
                    {
                        name: '大悟县',
                        code: '420922',
                    },
                    {
                        name: '云梦县',
                        code: '420923',
                    },
                    {
                        name: '应城市',
                        code: '420981',
                    },
                    {
                        name: '安陆市',
                        code: '420982',
                    },
                    {
                        name: '汉川市',
                        code: '420984',
                    },
                ],
            },
            {
                name: '荆州市',
                code: '421000',
                children: [
                    {
                        name: '沙市区',
                        code: '421002',
                    },
                    {
                        name: '荆州区',
                        code: '421003',
                    },
                    {
                        name: '公安县',
                        code: '421022',
                    },
                    {
                        name: '监利县',
                        code: '421023',
                    },
                    {
                        name: '江陵县',
                        code: '421024',
                    },
                    {
                        name: '荆州经济技术开发区',
                        code: '421071',
                    },
                    {
                        name: '石首市',
                        code: '421081',
                    },
                    {
                        name: '洪湖市',
                        code: '421083',
                    },
                    {
                        name: '松滋市',
                        code: '421087',
                    },
                ],
            },
            {
                name: '黄冈市',
                code: '421100',
                children: [
                    {
                        name: '黄州区',
                        code: '421102',
                    },
                    {
                        name: '团风县',
                        code: '421121',
                    },
                    {
                        name: '红安县',
                        code: '421122',
                    },
                    {
                        name: '罗田县',
                        code: '421123',
                    },
                    {
                        name: '英山县',
                        code: '421124',
                    },
                    {
                        name: '浠水县',
                        code: '421125',
                    },
                    {
                        name: '蕲春县',
                        code: '421126',
                    },
                    {
                        name: '黄梅县',
                        code: '421127',
                    },
                    {
                        name: '龙感湖管理区',
                        code: '421171',
                    },
                    {
                        name: '麻城市',
                        code: '421181',
                    },
                    {
                        name: '武穴市',
                        code: '421182',
                    },
                ],
            },
            {
                name: '咸宁市',
                code: '421200',
                children: [
                    {
                        name: '咸安区',
                        code: '421202',
                    },
                    {
                        name: '嘉鱼县',
                        code: '421221',
                    },
                    {
                        name: '通城县',
                        code: '421222',
                    },
                    {
                        name: '崇阳县',
                        code: '421223',
                    },
                    {
                        name: '通山县',
                        code: '421224',
                    },
                    {
                        name: '赤壁市',
                        code: '421281',
                    },
                ],
            },
            {
                name: '随州市',
                code: '421300',
                children: [
                    {
                        name: '曾都区',
                        code: '421303',
                    },
                    {
                        name: '随县',
                        code: '421321',
                    },
                    {
                        name: '广水市',
                        code: '421381',
                    },
                ],
            },
            {
                name: '恩施土家族苗族自治州',
                code: '422800',
                children: [
                    {
                        name: '恩施市',
                        code: '422801',
                    },
                    {
                        name: '利川市',
                        code: '422802',
                    },
                    {
                        name: '建始县',
                        code: '422822',
                    },
                    {
                        name: '巴东县',
                        code: '422823',
                    },
                    {
                        name: '宣恩县',
                        code: '422825',
                    },
                    {
                        name: '咸丰县',
                        code: '422826',
                    },
                    {
                        name: '来凤县',
                        code: '422827',
                    },
                    {
                        name: '鹤峰县',
                        code: '422828',
                    },
                ],
            },
            {
                name: '省直辖县级行政区划',
                code: '429000',
                children: [
                    {
                        name: '仙桃市',
                        code: '429004',
                    },
                    {
                        name: '潜江市',
                        code: '429005',
                    },
                    {
                        name: '天门市',
                        code: '429006',
                    },
                    {
                        name: '神农架林区',
                        code: '429021',
                    },
                ],
            },
        ],
    },
    {
        name: '湖南省',
        code: '430000',
        children: [
            {
                name: '长沙市',
                code: '430100',
                children: [
                    {
                        name: '芙蓉区',
                        code: '430102',
                    },
                    {
                        name: '天心区',
                        code: '430103',
                    },
                    {
                        name: '岳麓区',
                        code: '430104',
                    },
                    {
                        name: '开福区',
                        code: '430105',
                    },
                    {
                        name: '雨花区',
                        code: '430111',
                    },
                    {
                        name: '望城区',
                        code: '430112',
                    },
                    {
                        name: '长沙县',
                        code: '430121',
                    },
                    {
                        name: '浏阳市',
                        code: '430181',
                    },
                    {
                        name: '宁乡市',
                        code: '430182',
                    },
                ],
            },
            {
                name: '株洲市',
                code: '430200',
                children: [
                    {
                        name: '荷塘区',
                        code: '430202',
                    },
                    {
                        name: '芦淞区',
                        code: '430203',
                    },
                    {
                        name: '石峰区',
                        code: '430204',
                    },
                    {
                        name: '天元区',
                        code: '430211',
                    },
                    {
                        name: '渌口区',
                        code: '430212',
                    },
                    {
                        name: '攸县',
                        code: '430223',
                    },
                    {
                        name: '茶陵县',
                        code: '430224',
                    },
                    {
                        name: '炎陵县',
                        code: '430225',
                    },
                    {
                        name: '云龙示范区',
                        code: '430271',
                    },
                    {
                        name: '醴陵市',
                        code: '430281',
                    },
                ],
            },
            {
                name: '湘潭市',
                code: '430300',
                children: [
                    {
                        name: '雨湖区',
                        code: '430302',
                    },
                    {
                        name: '岳塘区',
                        code: '430304',
                    },
                    {
                        name: '湘潭县',
                        code: '430321',
                    },
                    {
                        name: '湖南湘潭高新技术产业园区',
                        code: '430371',
                    },
                    {
                        name: '湘潭昭山示范区',
                        code: '430372',
                    },
                    {
                        name: '湘潭九华示范区',
                        code: '430373',
                    },
                    {
                        name: '湘乡市',
                        code: '430381',
                    },
                    {
                        name: '韶山市',
                        code: '430382',
                    },
                ],
            },
            {
                name: '衡阳市',
                code: '430400',
                children: [
                    {
                        name: '珠晖区',
                        code: '430405',
                    },
                    {
                        name: '雁峰区',
                        code: '430406',
                    },
                    {
                        name: '石鼓区',
                        code: '430407',
                    },
                    {
                        name: '蒸湘区',
                        code: '430408',
                    },
                    {
                        name: '南岳区',
                        code: '430412',
                    },
                    {
                        name: '衡阳县',
                        code: '430421',
                    },
                    {
                        name: '衡南县',
                        code: '430422',
                    },
                    {
                        name: '衡山县',
                        code: '430423',
                    },
                    {
                        name: '衡东县',
                        code: '430424',
                    },
                    {
                        name: '祁东县',
                        code: '430426',
                    },
                    {
                        name: '衡阳综合保税区',
                        code: '430471',
                    },
                    {
                        name: '湖南衡阳高新技术产业园区',
                        code: '430472',
                    },
                    {
                        name: '湖南衡阳松木经济开发区',
                        code: '430473',
                    },
                    {
                        name: '耒阳市',
                        code: '430481',
                    },
                    {
                        name: '常宁市',
                        code: '430482',
                    },
                ],
            },
            {
                name: '邵阳市',
                code: '430500',
                children: [
                    {
                        name: '双清区',
                        code: '430502',
                    },
                    {
                        name: '大祥区',
                        code: '430503',
                    },
                    {
                        name: '北塔区',
                        code: '430511',
                    },
                    {
                        name: '新邵县',
                        code: '430522',
                    },
                    {
                        name: '邵阳县',
                        code: '430523',
                    },
                    {
                        name: '隆回县',
                        code: '430524',
                    },
                    {
                        name: '洞口县',
                        code: '430525',
                    },
                    {
                        name: '绥宁县',
                        code: '430527',
                    },
                    {
                        name: '新宁县',
                        code: '430528',
                    },
                    {
                        name: '城步苗族自治县',
                        code: '430529',
                    },
                    {
                        name: '武冈市',
                        code: '430581',
                    },
                    {
                        name: '邵东市',
                        code: '430582',
                    },
                ],
            },
            {
                name: '岳阳市',
                code: '430600',
                children: [
                    {
                        name: '岳阳楼区',
                        code: '430602',
                    },
                    {
                        name: '云溪区',
                        code: '430603',
                    },
                    {
                        name: '君山区',
                        code: '430611',
                    },
                    {
                        name: '岳阳县',
                        code: '430621',
                    },
                    {
                        name: '华容县',
                        code: '430623',
                    },
                    {
                        name: '湘阴县',
                        code: '430624',
                    },
                    {
                        name: '平江县',
                        code: '430626',
                    },
                    {
                        name: '岳阳市屈原管理区',
                        code: '430671',
                    },
                    {
                        name: '汨罗市',
                        code: '430681',
                    },
                    {
                        name: '临湘市',
                        code: '430682',
                    },
                ],
            },
            {
                name: '常德市',
                code: '430700',
                children: [
                    {
                        name: '武陵区',
                        code: '430702',
                    },
                    {
                        name: '鼎城区',
                        code: '430703',
                    },
                    {
                        name: '安乡县',
                        code: '430721',
                    },
                    {
                        name: '汉寿县',
                        code: '430722',
                    },
                    {
                        name: '澧县',
                        code: '430723',
                    },
                    {
                        name: '临澧县',
                        code: '430724',
                    },
                    {
                        name: '桃源县',
                        code: '430725',
                    },
                    {
                        name: '石门县',
                        code: '430726',
                    },
                    {
                        name: '常德市西洞庭管理区',
                        code: '430771',
                    },
                    {
                        name: '津市市',
                        code: '430781',
                    },
                ],
            },
            {
                name: '张家界市',
                code: '430800',
                children: [
                    {
                        name: '永定区',
                        code: '430802',
                    },
                    {
                        name: '武陵源区',
                        code: '430811',
                    },
                    {
                        name: '慈利县',
                        code: '430821',
                    },
                    {
                        name: '桑植县',
                        code: '430822',
                    },
                ],
            },
            {
                name: '益阳市',
                code: '430900',
                children: [
                    {
                        name: '资阳区',
                        code: '430902',
                    },
                    {
                        name: '赫山区',
                        code: '430903',
                    },
                    {
                        name: '南县',
                        code: '430921',
                    },
                    {
                        name: '桃江县',
                        code: '430922',
                    },
                    {
                        name: '安化县',
                        code: '430923',
                    },
                    {
                        name: '益阳市大通湖管理区',
                        code: '430971',
                    },
                    {
                        name: '湖南益阳高新技术产业园区',
                        code: '430972',
                    },
                    {
                        name: '沅江市',
                        code: '430981',
                    },
                ],
            },
            {
                name: '郴州市',
                code: '431000',
                children: [
                    {
                        name: '北湖区',
                        code: '431002',
                    },
                    {
                        name: '苏仙区',
                        code: '431003',
                    },
                    {
                        name: '桂阳县',
                        code: '431021',
                    },
                    {
                        name: '宜章县',
                        code: '431022',
                    },
                    {
                        name: '永兴县',
                        code: '431023',
                    },
                    {
                        name: '嘉禾县',
                        code: '431024',
                    },
                    {
                        name: '临武县',
                        code: '431025',
                    },
                    {
                        name: '汝城县',
                        code: '431026',
                    },
                    {
                        name: '桂东县',
                        code: '431027',
                    },
                    {
                        name: '安仁县',
                        code: '431028',
                    },
                    {
                        name: '资兴市',
                        code: '431081',
                    },
                ],
            },
            {
                name: '永州市',
                code: '431100',
                children: [
                    {
                        name: '零陵区',
                        code: '431102',
                    },
                    {
                        name: '冷水滩区',
                        code: '431103',
                    },
                    {
                        name: '祁阳县',
                        code: '431121',
                    },
                    {
                        name: '东安县',
                        code: '431122',
                    },
                    {
                        name: '双牌县',
                        code: '431123',
                    },
                    {
                        name: '道县',
                        code: '431124',
                    },
                    {
                        name: '江永县',
                        code: '431125',
                    },
                    {
                        name: '宁远县',
                        code: '431126',
                    },
                    {
                        name: '蓝山县',
                        code: '431127',
                    },
                    {
                        name: '新田县',
                        code: '431128',
                    },
                    {
                        name: '江华瑶族自治县',
                        code: '431129',
                    },
                    {
                        name: '永州经济技术开发区',
                        code: '431171',
                    },
                    {
                        name: '永州市金洞管理区',
                        code: '431172',
                    },
                    {
                        name: '永州市回龙圩管理区',
                        code: '431173',
                    },
                ],
            },
            {
                name: '怀化市',
                code: '431200',
                children: [
                    {
                        name: '鹤城区',
                        code: '431202',
                    },
                    {
                        name: '中方县',
                        code: '431221',
                    },
                    {
                        name: '沅陵县',
                        code: '431222',
                    },
                    {
                        name: '辰溪县',
                        code: '431223',
                    },
                    {
                        name: '溆浦县',
                        code: '431224',
                    },
                    {
                        name: '会同县',
                        code: '431225',
                    },
                    {
                        name: '麻阳苗族自治县',
                        code: '431226',
                    },
                    {
                        name: '新晃侗族自治县',
                        code: '431227',
                    },
                    {
                        name: '芷江侗族自治县',
                        code: '431228',
                    },
                    {
                        name: '靖州苗族侗族自治县',
                        code: '431229',
                    },
                    {
                        name: '通道侗族自治县',
                        code: '431230',
                    },
                    {
                        name: '怀化市洪江管理区',
                        code: '431271',
                    },
                    {
                        name: '洪江市',
                        code: '431281',
                    },
                ],
            },
            {
                name: '娄底市',
                code: '431300',
                children: [
                    {
                        name: '娄星区',
                        code: '431302',
                    },
                    {
                        name: '双峰县',
                        code: '431321',
                    },
                    {
                        name: '新化县',
                        code: '431322',
                    },
                    {
                        name: '冷水江市',
                        code: '431381',
                    },
                    {
                        name: '涟源市',
                        code: '431382',
                    },
                ],
            },
            {
                name: '湘西土家族苗族自治州',
                code: '433100',
                children: [
                    {
                        name: '吉首市',
                        code: '433101',
                    },
                    {
                        name: '泸溪县',
                        code: '433122',
                    },
                    {
                        name: '凤凰县',
                        code: '433123',
                    },
                    {
                        name: '花垣县',
                        code: '433124',
                    },
                    {
                        name: '保靖县',
                        code: '433125',
                    },
                    {
                        name: '古丈县',
                        code: '433126',
                    },
                    {
                        name: '永顺县',
                        code: '433127',
                    },
                    {
                        name: '龙山县',
                        code: '433130',
                    },
                ],
            },
        ],
    },
    {
        name: '广东省',
        code: '440000',
        children: [
            {
                name: '广州市',
                code: '440100',
                children: [
                    {
                        name: '荔湾区',
                        code: '440103',
                    },
                    {
                        name: '越秀区',
                        code: '440104',
                    },
                    {
                        name: '海珠区',
                        code: '440105',
                    },
                    {
                        name: '天河区',
                        code: '440106',
                    },
                    {
                        name: '白云区',
                        code: '440111',
                    },
                    {
                        name: '黄埔区',
                        code: '440112',
                    },
                    {
                        name: '番禺区',
                        code: '440113',
                    },
                    {
                        name: '花都区',
                        code: '440114',
                    },
                    {
                        name: '南沙区',
                        code: '440115',
                    },
                    {
                        name: '从化区',
                        code: '440117',
                    },
                    {
                        name: '增城区',
                        code: '440118',
                    },
                ],
            },
            {
                name: '韶关市',
                code: '440200',
                children: [
                    {
                        name: '武江区',
                        code: '440203',
                    },
                    {
                        name: '浈江区',
                        code: '440204',
                    },
                    {
                        name: '曲江区',
                        code: '440205',
                    },
                    {
                        name: '始兴县',
                        code: '440222',
                    },
                    {
                        name: '仁化县',
                        code: '440224',
                    },
                    {
                        name: '翁源县',
                        code: '440229',
                    },
                    {
                        name: '乳源瑶族自治县',
                        code: '440232',
                    },
                    {
                        name: '新丰县',
                        code: '440233',
                    },
                    {
                        name: '乐昌市',
                        code: '440281',
                    },
                    {
                        name: '南雄市',
                        code: '440282',
                    },
                ],
            },
            {
                name: '深圳市',
                code: '440300',
                children: [
                    {
                        name: '罗湖区',
                        code: '440303',
                    },
                    {
                        name: '福田区',
                        code: '440304',
                    },
                    {
                        name: '南山区',
                        code: '440305',
                    },
                    {
                        name: '宝安区',
                        code: '440306',
                    },
                    {
                        name: '龙岗区',
                        code: '440307',
                    },
                    {
                        name: '盐田区',
                        code: '440308',
                    },
                    {
                        name: '龙华区',
                        code: '440309',
                    },
                    {
                        name: '坪山区',
                        code: '440310',
                    },
                    {
                        name: '光明区',
                        code: '440311',
                    },
                ],
            },
            {
                name: '珠海市',
                code: '440400',
                children: [
                    {
                        name: '香洲区',
                        code: '440402',
                    },
                    {
                        name: '斗门区',
                        code: '440403',
                    },
                    {
                        name: '金湾区',
                        code: '440404',
                    },
                ],
            },
            {
                name: '汕头市',
                code: '440500',
                children: [
                    {
                        name: '龙湖区',
                        code: '440507',
                    },
                    {
                        name: '金平区',
                        code: '440511',
                    },
                    {
                        name: '濠江区',
                        code: '440512',
                    },
                    {
                        name: '潮阳区',
                        code: '440513',
                    },
                    {
                        name: '潮南区',
                        code: '440514',
                    },
                    {
                        name: '澄海区',
                        code: '440515',
                    },
                    {
                        name: '南澳县',
                        code: '440523',
                    },
                ],
            },
            {
                name: '佛山市',
                code: '440600',
                children: [
                    {
                        name: '禅城区',
                        code: '440604',
                    },
                    {
                        name: '南海区',
                        code: '440605',
                    },
                    {
                        name: '顺德区',
                        code: '440606',
                    },
                    {
                        name: '三水区',
                        code: '440607',
                    },
                    {
                        name: '高明区',
                        code: '440608',
                    },
                ],
            },
            {
                name: '江门市',
                code: '440700',
                children: [
                    {
                        name: '蓬江区',
                        code: '440703',
                    },
                    {
                        name: '江海区',
                        code: '440704',
                    },
                    {
                        name: '新会区',
                        code: '440705',
                    },
                    {
                        name: '台山市',
                        code: '440781',
                    },
                    {
                        name: '开平市',
                        code: '440783',
                    },
                    {
                        name: '鹤山市',
                        code: '440784',
                    },
                    {
                        name: '恩平市',
                        code: '440785',
                    },
                ],
            },
            {
                name: '湛江市',
                code: '440800',
                children: [
                    {
                        name: '赤坎区',
                        code: '440802',
                    },
                    {
                        name: '霞山区',
                        code: '440803',
                    },
                    {
                        name: '坡头区',
                        code: '440804',
                    },
                    {
                        name: '麻章区',
                        code: '440811',
                    },
                    {
                        name: '遂溪县',
                        code: '440823',
                    },
                    {
                        name: '徐闻县',
                        code: '440825',
                    },
                    {
                        name: '廉江市',
                        code: '440881',
                    },
                    {
                        name: '雷州市',
                        code: '440882',
                    },
                    {
                        name: '吴川市',
                        code: '440883',
                    },
                ],
            },
            {
                name: '茂名市',
                code: '440900',
                children: [
                    {
                        name: '茂南区',
                        code: '440902',
                    },
                    {
                        name: '电白区',
                        code: '440904',
                    },
                    {
                        name: '高州市',
                        code: '440981',
                    },
                    {
                        name: '化州市',
                        code: '440982',
                    },
                    {
                        name: '信宜市',
                        code: '440983',
                    },
                ],
            },
            {
                name: '肇庆市',
                code: '441200',
                children: [
                    {
                        name: '端州区',
                        code: '441202',
                    },
                    {
                        name: '鼎湖区',
                        code: '441203',
                    },
                    {
                        name: '高要区',
                        code: '441204',
                    },
                    {
                        name: '广宁县',
                        code: '441223',
                    },
                    {
                        name: '怀集县',
                        code: '441224',
                    },
                    {
                        name: '封开县',
                        code: '441225',
                    },
                    {
                        name: '德庆县',
                        code: '441226',
                    },
                    {
                        name: '四会市',
                        code: '441284',
                    },
                ],
            },
            {
                name: '惠州市',
                code: '441300',
                children: [
                    {
                        name: '惠城区',
                        code: '441302',
                    },
                    {
                        name: '惠阳区',
                        code: '441303',
                    },
                    {
                        name: '博罗县',
                        code: '441322',
                    },
                    {
                        name: '惠东县',
                        code: '441323',
                    },
                    {
                        name: '龙门县',
                        code: '441324',
                    },
                ],
            },
            {
                name: '梅州市',
                code: '441400',
                children: [
                    {
                        name: '梅江区',
                        code: '441402',
                    },
                    {
                        name: '梅县区',
                        code: '441403',
                    },
                    {
                        name: '大埔县',
                        code: '441422',
                    },
                    {
                        name: '丰顺县',
                        code: '441423',
                    },
                    {
                        name: '五华县',
                        code: '441424',
                    },
                    {
                        name: '平远县',
                        code: '441426',
                    },
                    {
                        name: '蕉岭县',
                        code: '441427',
                    },
                    {
                        name: '兴宁市',
                        code: '441481',
                    },
                ],
            },
            {
                name: '汕尾市',
                code: '441500',
                children: [
                    {
                        name: '城区',
                        code: '441502',
                    },
                    {
                        name: '海丰县',
                        code: '441521',
                    },
                    {
                        name: '陆河县',
                        code: '441523',
                    },
                    {
                        name: '陆丰市',
                        code: '441581',
                    },
                ],
            },
            {
                name: '河源市',
                code: '441600',
                children: [
                    {
                        name: '源城区',
                        code: '441602',
                    },
                    {
                        name: '紫金县',
                        code: '441621',
                    },
                    {
                        name: '龙川县',
                        code: '441622',
                    },
                    {
                        name: '连平县',
                        code: '441623',
                    },
                    {
                        name: '和平县',
                        code: '441624',
                    },
                    {
                        name: '东源县',
                        code: '441625',
                    },
                ],
            },
            {
                name: '阳江市',
                code: '441700',
                children: [
                    {
                        name: '江城区',
                        code: '441702',
                    },
                    {
                        name: '阳东区',
                        code: '441704',
                    },
                    {
                        name: '阳西县',
                        code: '441721',
                    },
                    {
                        name: '阳春市',
                        code: '441781',
                    },
                ],
            },
            {
                name: '清远市',
                code: '441800',
                children: [
                    {
                        name: '清城区',
                        code: '441802',
                    },
                    {
                        name: '清新区',
                        code: '441803',
                    },
                    {
                        name: '佛冈县',
                        code: '441821',
                    },
                    {
                        name: '阳山县',
                        code: '441823',
                    },
                    {
                        name: '连山壮族瑶族自治县',
                        code: '441825',
                    },
                    {
                        name: '连南瑶族自治县',
                        code: '441826',
                    },
                    {
                        name: '英德市',
                        code: '441881',
                    },
                    {
                        name: '连州市',
                        code: '441882',
                    },
                ],
            },
            {
                name: '东莞市',
                code: '441900',
                children: [
                    {
                        name: '东城街道',
                        code: '441900003',
                    },
                    {
                        name: '南城街道',
                        code: '441900004',
                    },
                    {
                        name: '万江街道',
                        code: '441900005',
                    },
                    {
                        name: '莞城街道',
                        code: '441900006',
                    },
                    {
                        name: '石碣镇',
                        code: '441900101',
                    },
                    {
                        name: '石龙镇',
                        code: '441900102',
                    },
                    {
                        name: '茶山镇',
                        code: '441900103',
                    },
                    {
                        name: '石排镇',
                        code: '441900104',
                    },
                    {
                        name: '企石镇',
                        code: '441900105',
                    },
                    {
                        name: '横沥镇',
                        code: '441900106',
                    },
                    {
                        name: '桥头镇',
                        code: '441900107',
                    },
                    {
                        name: '谢岗镇',
                        code: '441900108',
                    },
                    {
                        name: '东坑镇',
                        code: '441900109',
                    },
                    {
                        name: '常平镇',
                        code: '44190011',
                    },
                    {
                        name: '寮步镇',
                        code: '441900111',
                    },
                    {
                        name: '樟木头镇',
                        code: '441900112',
                    },
                    {
                        name: '大朗镇',
                        code: '441900113',
                    },
                    {
                        name: '黄江镇',
                        code: '441900114',
                    },
                    {
                        name: '清溪镇',
                        code: '441900115',
                    },
                    {
                        name: '塘厦镇',
                        code: '441900116',
                    },
                    {
                        name: '凤岗镇',
                        code: '441900117',
                    },
                    {
                        name: '大岭山镇',
                        code: '441900118',
                    },
                    {
                        name: '长安镇',
                        code: '441900119',
                    },
                    {
                        name: '虎门镇',
                        code: '441900121',
                    },
                    {
                        name: '厚街镇',
                        code: '441900122',
                    },
                    {
                        name: '沙田镇',
                        code: '441900123',
                    },
                    {
                        name: '道滘镇',
                        code: '441900124',
                    },
                    {
                        name: '洪梅镇',
                        code: '441900125',
                    },
                    {
                        name: '麻涌镇',
                        code: '441900126',
                    },
                    {
                        name: '望牛墩镇',
                        code: '441900127',
                    },
                    {
                        name: '中堂镇',
                        code: '441900128',
                    },
                    {
                        name: '高埗镇',
                        code: '441900129',
                    },
                    {
                        name: '松山湖',
                        code: '441900401',
                    },
                    {
                        name: '东莞港',
                        code: '441900402',
                    },
                    {
                        name: '东莞生态园',
                        code: '441900403',
                    },
                ],
            },
            {
                name: '中山市',
                code: '442000',
                children: [
                    {
                        name: '石岐街道',
                        code: '442000001',
                    },
                    {
                        name: '东区街道',
                        code: '442000002',
                    },
                    {
                        name: '中山港街道',
                        code: '442000003',
                    },
                    {
                        name: '西区街道',
                        code: '442000004',
                    },
                    {
                        name: '南区街道',
                        code: '442000005',
                    },
                    {
                        name: '五桂山街道',
                        code: '442000006',
                    },
                    {
                        name: '小榄镇',
                        code: '4420001',
                    },
                    {
                        name: '黄圃镇',
                        code: '442000101',
                    },
                    {
                        name: '民众镇',
                        code: '442000102',
                    },
                    {
                        name: '东凤镇',
                        code: '442000103',
                    },
                    {
                        name: '东升镇',
                        code: '442000104',
                    },
                    {
                        name: '古镇镇',
                        code: '442000105',
                    },
                    {
                        name: '沙溪镇',
                        code: '442000106',
                    },
                    {
                        name: '坦洲镇',
                        code: '442000107',
                    },
                    {
                        name: '港口镇',
                        code: '442000108',
                    },
                    {
                        name: '三角镇',
                        code: '442000109',
                    },
                    {
                        name: '横栏镇',
                        code: '44200011',
                    },
                    {
                        name: '南头镇',
                        code: '442000111',
                    },
                    {
                        name: '阜沙镇',
                        code: '442000112',
                    },
                    {
                        name: '南朗镇',
                        code: '442000113',
                    },
                    {
                        name: '三乡镇',
                        code: '442000114',
                    },
                    {
                        name: '板芙镇',
                        code: '442000115',
                    },
                    {
                        name: '大涌镇',
                        code: '442000116',
                    },
                    {
                        name: '神湾镇',
                        code: '442000117',
                    },
                ],
            },
            {
                name: '潮州市',
                code: '445100',
                children: [
                    {
                        name: '湘桥区',
                        code: '445102',
                    },
                    {
                        name: '潮安区',
                        code: '445103',
                    },
                    {
                        name: '饶平县',
                        code: '445122',
                    },
                ],
            },
            {
                name: '揭阳市',
                code: '445200',
                children: [
                    {
                        name: '榕城区',
                        code: '445202',
                    },
                    {
                        name: '揭东区',
                        code: '445203',
                    },
                    {
                        name: '揭西县',
                        code: '445222',
                    },
                    {
                        name: '惠来县',
                        code: '445224',
                    },
                    {
                        name: '普宁市',
                        code: '445281',
                    },
                ],
            },
            {
                name: '云浮市',
                code: '445300',
                children: [
                    {
                        name: '云城区',
                        code: '445302',
                    },
                    {
                        name: '云安区',
                        code: '445303',
                    },
                    {
                        name: '新兴县',
                        code: '445321',
                    },
                    {
                        name: '郁南县',
                        code: '445322',
                    },
                    {
                        name: '罗定市',
                        code: '445381',
                    },
                ],
            },
        ],
    },
    {
        name: '广西壮族自治区',
        code: '450000',
        children: [
            {
                name: '南宁市',
                code: '450100',
                children: [
                    {
                        name: '兴宁区',
                        code: '450102',
                    },
                    {
                        name: '青秀区',
                        code: '450103',
                    },
                    {
                        name: '江南区',
                        code: '450105',
                    },
                    {
                        name: '西乡塘区',
                        code: '450107',
                    },
                    {
                        name: '良庆区',
                        code: '450108',
                    },
                    {
                        name: '邕宁区',
                        code: '450109',
                    },
                    {
                        name: '武鸣区',
                        code: '450110',
                    },
                    {
                        name: '隆安县',
                        code: '450123',
                    },
                    {
                        name: '马山县',
                        code: '450124',
                    },
                    {
                        name: '上林县',
                        code: '450125',
                    },
                    {
                        name: '宾阳县',
                        code: '450126',
                    },
                    {
                        name: '横县',
                        code: '450127',
                    },
                ],
            },
            {
                name: '柳州市',
                code: '450200',
                children: [
                    {
                        name: '城中区',
                        code: '450202',
                    },
                    {
                        name: '鱼峰区',
                        code: '450203',
                    },
                    {
                        name: '柳南区',
                        code: '450204',
                    },
                    {
                        name: '柳北区',
                        code: '450205',
                    },
                    {
                        name: '柳江区',
                        code: '450206',
                    },
                    {
                        name: '柳城县',
                        code: '450222',
                    },
                    {
                        name: '鹿寨县',
                        code: '450223',
                    },
                    {
                        name: '融安县',
                        code: '450224',
                    },
                    {
                        name: '融水苗族自治县',
                        code: '450225',
                    },
                    {
                        name: '三江侗族自治县',
                        code: '450226',
                    },
                ],
            },
            {
                name: '桂林市',
                code: '450300',
                children: [
                    {
                        name: '秀峰区',
                        code: '450302',
                    },
                    {
                        name: '叠彩区',
                        code: '450303',
                    },
                    {
                        name: '象山区',
                        code: '450304',
                    },
                    {
                        name: '七星区',
                        code: '450305',
                    },
                    {
                        name: '雁山区',
                        code: '450311',
                    },
                    {
                        name: '临桂区',
                        code: '450312',
                    },
                    {
                        name: '阳朔县',
                        code: '450321',
                    },
                    {
                        name: '灵川县',
                        code: '450323',
                    },
                    {
                        name: '全州县',
                        code: '450324',
                    },
                    {
                        name: '兴安县',
                        code: '450325',
                    },
                    {
                        name: '永福县',
                        code: '450326',
                    },
                    {
                        name: '灌阳县',
                        code: '450327',
                    },
                    {
                        name: '龙胜各族自治县',
                        code: '450328',
                    },
                    {
                        name: '资源县',
                        code: '450329',
                    },
                    {
                        name: '平乐县',
                        code: '450330',
                    },
                    {
                        name: '恭城瑶族自治县',
                        code: '450332',
                    },
                    {
                        name: '荔浦市',
                        code: '450381',
                    },
                ],
            },
            {
                name: '梧州市',
                code: '450400',
                children: [
                    {
                        name: '万秀区',
                        code: '450403',
                    },
                    {
                        name: '长洲区',
                        code: '450405',
                    },
                    {
                        name: '龙圩区',
                        code: '450406',
                    },
                    {
                        name: '苍梧县',
                        code: '450421',
                    },
                    {
                        name: '藤县',
                        code: '450422',
                    },
                    {
                        name: '蒙山县',
                        code: '450423',
                    },
                    {
                        name: '岑溪市',
                        code: '450481',
                    },
                ],
            },
            {
                name: '北海市',
                code: '450500',
                children: [
                    {
                        name: '海城区',
                        code: '450502',
                    },
                    {
                        name: '银海区',
                        code: '450503',
                    },
                    {
                        name: '铁山港区',
                        code: '450512',
                    },
                    {
                        name: '合浦县',
                        code: '450521',
                    },
                ],
            },
            {
                name: '防城港市',
                code: '450600',
                children: [
                    {
                        name: '港口区',
                        code: '450602',
                    },
                    {
                        name: '防城区',
                        code: '450603',
                    },
                    {
                        name: '上思县',
                        code: '450621',
                    },
                    {
                        name: '东兴市',
                        code: '450681',
                    },
                ],
            },
            {
                name: '钦州市',
                code: '450700',
                children: [
                    {
                        name: '钦南区',
                        code: '450702',
                    },
                    {
                        name: '钦北区',
                        code: '450703',
                    },
                    {
                        name: '灵山县',
                        code: '450721',
                    },
                    {
                        name: '浦北县',
                        code: '450722',
                    },
                ],
            },
            {
                name: '贵港市',
                code: '450800',
                children: [
                    {
                        name: '港北区',
                        code: '450802',
                    },
                    {
                        name: '港南区',
                        code: '450803',
                    },
                    {
                        name: '覃塘区',
                        code: '450804',
                    },
                    {
                        name: '平南县',
                        code: '450821',
                    },
                    {
                        name: '桂平市',
                        code: '450881',
                    },
                ],
            },
            {
                name: '玉林市',
                code: '450900',
                children: [
                    {
                        name: '玉州区',
                        code: '450902',
                    },
                    {
                        name: '福绵区',
                        code: '450903',
                    },
                    {
                        name: '容县',
                        code: '450921',
                    },
                    {
                        name: '陆川县',
                        code: '450922',
                    },
                    {
                        name: '博白县',
                        code: '450923',
                    },
                    {
                        name: '兴业县',
                        code: '450924',
                    },
                    {
                        name: '北流市',
                        code: '450981',
                    },
                ],
            },
            {
                name: '百色市',
                code: '451000',
                children: [
                    {
                        name: '右江区',
                        code: '451002',
                    },
                    {
                        name: '田阳区',
                        code: '451003',
                    },
                    {
                        name: '田东县',
                        code: '451022',
                    },
                    {
                        name: '德保县',
                        code: '451024',
                    },
                    {
                        name: '那坡县',
                        code: '451026',
                    },
                    {
                        name: '凌云县',
                        code: '451027',
                    },
                    {
                        name: '乐业县',
                        code: '451028',
                    },
                    {
                        name: '田林县',
                        code: '451029',
                    },
                    {
                        name: '西林县',
                        code: '451030',
                    },
                    {
                        name: '隆林各族自治县',
                        code: '451031',
                    },
                    {
                        name: '靖西市',
                        code: '451081',
                    },
                    {
                        name: '平果市',
                        code: '451082',
                    },
                ],
            },
            {
                name: '贺州市',
                code: '451100',
                children: [
                    {
                        name: '八步区',
                        code: '451102',
                    },
                    {
                        name: '平桂区',
                        code: '451103',
                    },
                    {
                        name: '昭平县',
                        code: '451121',
                    },
                    {
                        name: '钟山县',
                        code: '451122',
                    },
                    {
                        name: '富川瑶族自治县',
                        code: '451123',
                    },
                ],
            },
            {
                name: '河池市',
                code: '451200',
                children: [
                    {
                        name: '金城江区',
                        code: '451202',
                    },
                    {
                        name: '宜州区',
                        code: '451203',
                    },
                    {
                        name: '南丹县',
                        code: '451221',
                    },
                    {
                        name: '天峨县',
                        code: '451222',
                    },
                    {
                        name: '凤山县',
                        code: '451223',
                    },
                    {
                        name: '东兰县',
                        code: '451224',
                    },
                    {
                        name: '罗城仫佬族自治县',
                        code: '451225',
                    },
                    {
                        name: '环江毛南族自治县',
                        code: '451226',
                    },
                    {
                        name: '巴马瑶族自治县',
                        code: '451227',
                    },
                    {
                        name: '都安瑶族自治县',
                        code: '451228',
                    },
                    {
                        name: '大化瑶族自治县',
                        code: '451229',
                    },
                ],
            },
            {
                name: '来宾市',
                code: '451300',
                children: [
                    {
                        name: '兴宾区',
                        code: '451302',
                    },
                    {
                        name: '忻城县',
                        code: '451321',
                    },
                    {
                        name: '象州县',
                        code: '451322',
                    },
                    {
                        name: '武宣县',
                        code: '451323',
                    },
                    {
                        name: '金秀瑶族自治县',
                        code: '451324',
                    },
                    {
                        name: '合山市',
                        code: '451381',
                    },
                ],
            },
            {
                name: '崇左市',
                code: '451400',
                children: [
                    {
                        name: '江州区',
                        code: '451402',
                    },
                    {
                        name: '扶绥县',
                        code: '451421',
                    },
                    {
                        name: '宁明县',
                        code: '451422',
                    },
                    {
                        name: '龙州县',
                        code: '451423',
                    },
                    {
                        name: '大新县',
                        code: '451424',
                    },
                    {
                        name: '天等县',
                        code: '451425',
                    },
                    {
                        name: '凭祥市',
                        code: '451481',
                    },
                ],
            },
        ],
    },
    {
        name: '海南省',
        code: '460000',
        children: [
            {
                name: '海口市',
                code: '460100',
                children: [
                    {
                        name: '秀英区',
                        code: '460105',
                    },
                    {
                        name: '龙华区',
                        code: '460106',
                    },
                    {
                        name: '琼山区',
                        code: '460107',
                    },
                    {
                        name: '美兰区',
                        code: '460108',
                    },
                ],
            },
            {
                name: '三亚市',
                code: '460200',
                children: [
                    {
                        name: '海棠区',
                        code: '460202',
                    },
                    {
                        name: '吉阳区',
                        code: '460203',
                    },
                    {
                        name: '天涯区',
                        code: '460204',
                    },
                    {
                        name: '崖州区',
                        code: '460205',
                    },
                ],
            },
            {
                name: '三沙市',
                code: '460300',
                children: [
                    {
                        name: '西沙群岛',
                        code: '460321',
                    },
                    {
                        name: '南沙群岛',
                        code: '460322',
                    },
                    {
                        name: '中沙群岛的岛礁及其海域',
                        code: '460323',
                    },
                ],
            },
            {
                name: '儋州市',
                code: '460400',
                children: [
                    {
                        name: '那大镇',
                        code: '4604001',
                    },
                    {
                        name: '和庆镇',
                        code: '460400101',
                    },
                    {
                        name: '南丰镇',
                        code: '460400102',
                    },
                    {
                        name: '大成镇',
                        code: '460400103',
                    },
                    {
                        name: '雅星镇',
                        code: '460400104',
                    },
                    {
                        name: '兰洋镇',
                        code: '460400105',
                    },
                    {
                        name: '光村镇',
                        code: '460400106',
                    },
                    {
                        name: '木棠镇',
                        code: '460400107',
                    },
                    {
                        name: '海头镇',
                        code: '460400108',
                    },
                    {
                        name: '峨蔓镇',
                        code: '460400109',
                    },
                    {
                        name: '王五镇',
                        code: '460400111',
                    },
                    {
                        name: '白马井镇',
                        code: '460400112',
                    },
                    {
                        name: '中和镇',
                        code: '460400113',
                    },
                    {
                        name: '排浦镇',
                        code: '460400114',
                    },
                    {
                        name: '东成镇',
                        code: '460400115',
                    },
                    {
                        name: '新州镇',
                        code: '460400116',
                    },
                    {
                        name: '洋浦经济开发区',
                        code: '460400499',
                    },
                    {
                        name: '华南热作学院',
                        code: '4604005',
                    },
                ],
            },
            {
                name: '省直辖县级行政区划',
                code: '469000',
                children: [
                    {
                        name: '五指山市',
                        code: '469001',
                    },
                    {
                        name: '琼海市',
                        code: '469002',
                    },
                    {
                        name: '文昌市',
                        code: '469005',
                    },
                    {
                        name: '万宁市',
                        code: '469006',
                    },
                    {
                        name: '东方市',
                        code: '469007',
                    },
                    {
                        name: '定安县',
                        code: '469021',
                    },
                    {
                        name: '屯昌县',
                        code: '469022',
                    },
                    {
                        name: '澄迈县',
                        code: '469023',
                    },
                    {
                        name: '临高县',
                        code: '469024',
                    },
                    {
                        name: '白沙黎族自治县',
                        code: '469025',
                    },
                    {
                        name: '昌江黎族自治县',
                        code: '469026',
                    },
                    {
                        name: '乐东黎族自治县',
                        code: '469027',
                    },
                    {
                        name: '陵水黎族自治县',
                        code: '469028',
                    },
                    {
                        name: '保亭黎族苗族自治县',
                        code: '469029',
                    },
                    {
                        name: '琼中黎族苗族自治县',
                        code: '469030',
                    },
                ],
            },
        ],
    },
    {
        name: '重庆市',
        code: '500000',
        children: [
            {
                name: '市辖区',
                code: '500100',
                children: [
                    {
                        name: '万州区',
                        code: '500101',
                    },
                    {
                        name: '涪陵区',
                        code: '500102',
                    },
                    {
                        name: '渝中区',
                        code: '500103',
                    },
                    {
                        name: '大渡口区',
                        code: '500104',
                    },
                    {
                        name: '江北区',
                        code: '500105',
                    },
                    {
                        name: '沙坪坝区',
                        code: '500106',
                    },
                    {
                        name: '九龙坡区',
                        code: '500107',
                    },
                    {
                        name: '南岸区',
                        code: '500108',
                    },
                    {
                        name: '北碚区',
                        code: '500109',
                    },
                    {
                        name: '綦江区',
                        code: '500110',
                    },
                    {
                        name: '大足区',
                        code: '500111',
                    },
                    {
                        name: '渝北区',
                        code: '500112',
                    },
                    {
                        name: '巴南区',
                        code: '500113',
                    },
                    {
                        name: '黔江区',
                        code: '500114',
                    },
                    {
                        name: '长寿区',
                        code: '500115',
                    },
                    {
                        name: '江津区',
                        code: '500116',
                    },
                    {
                        name: '合川区',
                        code: '500117',
                    },
                    {
                        name: '永川区',
                        code: '500118',
                    },
                    {
                        name: '南川区',
                        code: '500119',
                    },
                    {
                        name: '璧山区',
                        code: '500120',
                    },
                    {
                        name: '铜梁区',
                        code: '500151',
                    },
                    {
                        name: '潼南区',
                        code: '500152',
                    },
                    {
                        name: '荣昌区',
                        code: '500153',
                    },
                    {
                        name: '开州区',
                        code: '500154',
                    },
                    {
                        name: '梁平区',
                        code: '500155',
                    },
                    {
                        name: '武隆区',
                        code: '500156',
                    },
                ],
            },
            {
                name: '县',
                code: '500200',
                children: [
                    {
                        name: '城口县',
                        code: '500229',
                    },
                    {
                        name: '丰都县',
                        code: '500230',
                    },
                    {
                        name: '垫江县',
                        code: '500231',
                    },
                    {
                        name: '忠县',
                        code: '500233',
                    },
                    {
                        name: '云阳县',
                        code: '500235',
                    },
                    {
                        name: '奉节县',
                        code: '500236',
                    },
                    {
                        name: '巫山县',
                        code: '500237',
                    },
                    {
                        name: '巫溪县',
                        code: '500238',
                    },
                    {
                        name: '石柱土家族自治县',
                        code: '500240',
                    },
                    {
                        name: '秀山土家族苗族自治县',
                        code: '500241',
                    },
                    {
                        name: '酉阳土家族苗族自治县',
                        code: '500242',
                    },
                    {
                        name: '彭水苗族土家族自治县',
                        code: '500243',
                    },
                ],
            },
        ],
    },
    {
        name: '四川省',
        code: '510000',
        children: [
            {
                name: '成都市',
                code: '510100',
                children: [
                    {
                        name: '锦江区',
                        code: '510104',
                    },
                    {
                        name: '青羊区',
                        code: '510105',
                    },
                    {
                        name: '金牛区',
                        code: '510106',
                    },
                    {
                        name: '武侯区',
                        code: '510107',
                    },
                    {
                        name: '成华区',
                        code: '510108',
                    },
                    {
                        name: '龙泉驿区',
                        code: '510112',
                    },
                    {
                        name: '青白江区',
                        code: '510113',
                    },
                    {
                        name: '新都区',
                        code: '510114',
                    },
                    {
                        name: '温江区',
                        code: '510115',
                    },
                    {
                        name: '双流区',
                        code: '510116',
                    },
                    {
                        name: '郫都区',
                        code: '510117',
                    },
                    {
                        name: '新津区',
                        code: '510118',
                    },
                    {
                        name: '金堂县',
                        code: '510121',
                    },
                    {
                        name: '大邑县',
                        code: '510129',
                    },
                    {
                        name: '蒲江县',
                        code: '510131',
                    },
                    {
                        name: '都江堰市',
                        code: '510181',
                    },
                    {
                        name: '彭州市',
                        code: '510182',
                    },
                    {
                        name: '邛崃市',
                        code: '510183',
                    },
                    {
                        name: '崇州市',
                        code: '510184',
                    },
                    {
                        name: '简阳市',
                        code: '510185',
                    },
                ],
            },
            {
                name: '自贡市',
                code: '510300',
                children: [
                    {
                        name: '自流井区',
                        code: '510302',
                    },
                    {
                        name: '贡井区',
                        code: '510303',
                    },
                    {
                        name: '大安区',
                        code: '510304',
                    },
                    {
                        name: '沿滩区',
                        code: '510311',
                    },
                    {
                        name: '荣县',
                        code: '510321',
                    },
                    {
                        name: '富顺县',
                        code: '510322',
                    },
                ],
            },
            {
                name: '攀枝花市',
                code: '510400',
                children: [
                    {
                        name: '东区',
                        code: '510402',
                    },
                    {
                        name: '西区',
                        code: '510403',
                    },
                    {
                        name: '仁和区',
                        code: '510411',
                    },
                    {
                        name: '米易县',
                        code: '510421',
                    },
                    {
                        name: '盐边县',
                        code: '510422',
                    },
                ],
            },
            {
                name: '泸州市',
                code: '510500',
                children: [
                    {
                        name: '江阳区',
                        code: '510502',
                    },
                    {
                        name: '纳溪区',
                        code: '510503',
                    },
                    {
                        name: '龙马潭区',
                        code: '510504',
                    },
                    {
                        name: '泸县',
                        code: '510521',
                    },
                    {
                        name: '合江县',
                        code: '510522',
                    },
                    {
                        name: '叙永县',
                        code: '510524',
                    },
                    {
                        name: '古蔺县',
                        code: '510525',
                    },
                ],
            },
            {
                name: '德阳市',
                code: '510600',
                children: [
                    {
                        name: '旌阳区',
                        code: '510603',
                    },
                    {
                        name: '罗江区',
                        code: '510604',
                    },
                    {
                        name: '中江县',
                        code: '510623',
                    },
                    {
                        name: '广汉市',
                        code: '510681',
                    },
                    {
                        name: '什邡市',
                        code: '510682',
                    },
                    {
                        name: '绵竹市',
                        code: '510683',
                    },
                ],
            },
            {
                name: '绵阳市',
                code: '510700',
                children: [
                    {
                        name: '涪城区',
                        code: '510703',
                    },
                    {
                        name: '游仙区',
                        code: '510704',
                    },
                    {
                        name: '安州区',
                        code: '510705',
                    },
                    {
                        name: '三台县',
                        code: '510722',
                    },
                    {
                        name: '盐亭县',
                        code: '510723',
                    },
                    {
                        name: '梓潼县',
                        code: '510725',
                    },
                    {
                        name: '北川羌族自治县',
                        code: '510726',
                    },
                    {
                        name: '平武县',
                        code: '510727',
                    },
                    {
                        name: '江油市',
                        code: '510781',
                    },
                ],
            },
            {
                name: '广元市',
                code: '510800',
                children: [
                    {
                        name: '利州区',
                        code: '510802',
                    },
                    {
                        name: '昭化区',
                        code: '510811',
                    },
                    {
                        name: '朝天区',
                        code: '510812',
                    },
                    {
                        name: '旺苍县',
                        code: '510821',
                    },
                    {
                        name: '青川县',
                        code: '510822',
                    },
                    {
                        name: '剑阁县',
                        code: '510823',
                    },
                    {
                        name: '苍溪县',
                        code: '510824',
                    },
                ],
            },
            {
                name: '遂宁市',
                code: '510900',
                children: [
                    {
                        name: '船山区',
                        code: '510903',
                    },
                    {
                        name: '安居区',
                        code: '510904',
                    },
                    {
                        name: '蓬溪县',
                        code: '510921',
                    },
                    {
                        name: '大英县',
                        code: '510923',
                    },
                    {
                        name: '射洪市',
                        code: '510981',
                    },
                ],
            },
            {
                name: '内江市',
                code: '511000',
                children: [
                    {
                        name: '市中区',
                        code: '511002',
                    },
                    {
                        name: '东兴区',
                        code: '511011',
                    },
                    {
                        name: '威远县',
                        code: '511024',
                    },
                    {
                        name: '资中县',
                        code: '511025',
                    },
                    {
                        name: '内江经济开发区',
                        code: '511071',
                    },
                    {
                        name: '隆昌市',
                        code: '511083',
                    },
                ],
            },
            {
                name: '乐山市',
                code: '511100',
                children: [
                    {
                        name: '市中区',
                        code: '511102',
                    },
                    {
                        name: '沙湾区',
                        code: '511111',
                    },
                    {
                        name: '五通桥区',
                        code: '511112',
                    },
                    {
                        name: '金口河区',
                        code: '511113',
                    },
                    {
                        name: '犍为县',
                        code: '511123',
                    },
                    {
                        name: '井研县',
                        code: '511124',
                    },
                    {
                        name: '夹江县',
                        code: '511126',
                    },
                    {
                        name: '沐川县',
                        code: '511129',
                    },
                    {
                        name: '峨边彝族自治县',
                        code: '511132',
                    },
                    {
                        name: '马边彝族自治县',
                        code: '511133',
                    },
                    {
                        name: '峨眉山市',
                        code: '511181',
                    },
                ],
            },
            {
                name: '南充市',
                code: '511300',
                children: [
                    {
                        name: '顺庆区',
                        code: '511302',
                    },
                    {
                        name: '高坪区',
                        code: '511303',
                    },
                    {
                        name: '嘉陵区',
                        code: '511304',
                    },
                    {
                        name: '南部县',
                        code: '511321',
                    },
                    {
                        name: '营山县',
                        code: '511322',
                    },
                    {
                        name: '蓬安县',
                        code: '511323',
                    },
                    {
                        name: '仪陇县',
                        code: '511324',
                    },
                    {
                        name: '西充县',
                        code: '511325',
                    },
                    {
                        name: '阆中市',
                        code: '511381',
                    },
                ],
            },
            {
                name: '眉山市',
                code: '511400',
                children: [
                    {
                        name: '东坡区',
                        code: '511402',
                    },
                    {
                        name: '彭山区',
                        code: '511403',
                    },
                    {
                        name: '仁寿县',
                        code: '511421',
                    },
                    {
                        name: '洪雅县',
                        code: '511423',
                    },
                    {
                        name: '丹棱县',
                        code: '511424',
                    },
                    {
                        name: '青神县',
                        code: '511425',
                    },
                ],
            },
            {
                name: '宜宾市',
                code: '511500',
                children: [
                    {
                        name: '翠屏区',
                        code: '511502',
                    },
                    {
                        name: '南溪区',
                        code: '511503',
                    },
                    {
                        name: '叙州区',
                        code: '511504',
                    },
                    {
                        name: '江安县',
                        code: '511523',
                    },
                    {
                        name: '长宁县',
                        code: '511524',
                    },
                    {
                        name: '高县',
                        code: '511525',
                    },
                    {
                        name: '珙县',
                        code: '511526',
                    },
                    {
                        name: '筠连县',
                        code: '511527',
                    },
                    {
                        name: '兴文县',
                        code: '511528',
                    },
                    {
                        name: '屏山县',
                        code: '511529',
                    },
                ],
            },
            {
                name: '广安市',
                code: '511600',
                children: [
                    {
                        name: '广安区',
                        code: '511602',
                    },
                    {
                        name: '前锋区',
                        code: '511603',
                    },
                    {
                        name: '岳池县',
                        code: '511621',
                    },
                    {
                        name: '武胜县',
                        code: '511622',
                    },
                    {
                        name: '邻水县',
                        code: '511623',
                    },
                    {
                        name: '华蓥市',
                        code: '511681',
                    },
                ],
            },
            {
                name: '达州市',
                code: '511700',
                children: [
                    {
                        name: '通川区',
                        code: '511702',
                    },
                    {
                        name: '达川区',
                        code: '511703',
                    },
                    {
                        name: '宣汉县',
                        code: '511722',
                    },
                    {
                        name: '开江县',
                        code: '511723',
                    },
                    {
                        name: '大竹县',
                        code: '511724',
                    },
                    {
                        name: '渠县',
                        code: '511725',
                    },
                    {
                        name: '达州经济开发区',
                        code: '511771',
                    },
                    {
                        name: '万源市',
                        code: '511781',
                    },
                ],
            },
            {
                name: '雅安市',
                code: '511800',
                children: [
                    {
                        name: '雨城区',
                        code: '511802',
                    },
                    {
                        name: '名山区',
                        code: '511803',
                    },
                    {
                        name: '荥经县',
                        code: '511822',
                    },
                    {
                        name: '汉源县',
                        code: '511823',
                    },
                    {
                        name: '石棉县',
                        code: '511824',
                    },
                    {
                        name: '天全县',
                        code: '511825',
                    },
                    {
                        name: '芦山县',
                        code: '511826',
                    },
                    {
                        name: '宝兴县',
                        code: '511827',
                    },
                ],
            },
            {
                name: '巴中市',
                code: '511900',
                children: [
                    {
                        name: '巴州区',
                        code: '511902',
                    },
                    {
                        name: '恩阳区',
                        code: '511903',
                    },
                    {
                        name: '通江县',
                        code: '511921',
                    },
                    {
                        name: '南江县',
                        code: '511922',
                    },
                    {
                        name: '平昌县',
                        code: '511923',
                    },
                    {
                        name: '巴中经济开发区',
                        code: '511971',
                    },
                ],
            },
            {
                name: '资阳市',
                code: '512000',
                children: [
                    {
                        name: '雁江区',
                        code: '512002',
                    },
                    {
                        name: '安岳县',
                        code: '512021',
                    },
                    {
                        name: '乐至县',
                        code: '512022',
                    },
                ],
            },
            {
                name: '阿坝藏族羌族自治州',
                code: '513200',
                children: [
                    {
                        name: '马尔康市',
                        code: '513201',
                    },
                    {
                        name: '汶川县',
                        code: '513221',
                    },
                    {
                        name: '理县',
                        code: '513222',
                    },
                    {
                        name: '茂县',
                        code: '513223',
                    },
                    {
                        name: '松潘县',
                        code: '513224',
                    },
                    {
                        name: '九寨沟县',
                        code: '513225',
                    },
                    {
                        name: '金川县',
                        code: '513226',
                    },
                    {
                        name: '小金县',
                        code: '513227',
                    },
                    {
                        name: '黑水县',
                        code: '513228',
                    },
                    {
                        name: '壤塘县',
                        code: '513230',
                    },
                    {
                        name: '阿坝县',
                        code: '513231',
                    },
                    {
                        name: '若尔盖县',
                        code: '513232',
                    },
                    {
                        name: '红原县',
                        code: '513233',
                    },
                ],
            },
            {
                name: '甘孜藏族自治州',
                code: '513300',
                children: [
                    {
                        name: '康定市',
                        code: '513301',
                    },
                    {
                        name: '泸定县',
                        code: '513322',
                    },
                    {
                        name: '丹巴县',
                        code: '513323',
                    },
                    {
                        name: '九龙县',
                        code: '513324',
                    },
                    {
                        name: '雅江县',
                        code: '513325',
                    },
                    {
                        name: '道孚县',
                        code: '513326',
                    },
                    {
                        name: '炉霍县',
                        code: '513327',
                    },
                    {
                        name: '甘孜县',
                        code: '513328',
                    },
                    {
                        name: '新龙县',
                        code: '513329',
                    },
                    {
                        name: '德格县',
                        code: '513330',
                    },
                    {
                        name: '白玉县',
                        code: '513331',
                    },
                    {
                        name: '石渠县',
                        code: '513332',
                    },
                    {
                        name: '色达县',
                        code: '513333',
                    },
                    {
                        name: '理塘县',
                        code: '513334',
                    },
                    {
                        name: '巴塘县',
                        code: '513335',
                    },
                    {
                        name: '乡城县',
                        code: '513336',
                    },
                    {
                        name: '稻城县',
                        code: '513337',
                    },
                    {
                        name: '得荣县',
                        code: '513338',
                    },
                ],
            },
            {
                name: '凉山彝族自治州',
                code: '513400',
                children: [
                    {
                        name: '西昌市',
                        code: '513401',
                    },
                    {
                        name: '木里藏族自治县',
                        code: '513422',
                    },
                    {
                        name: '盐源县',
                        code: '513423',
                    },
                    {
                        name: '德昌县',
                        code: '513424',
                    },
                    {
                        name: '会理县',
                        code: '513425',
                    },
                    {
                        name: '会东县',
                        code: '513426',
                    },
                    {
                        name: '宁南县',
                        code: '513427',
                    },
                    {
                        name: '普格县',
                        code: '513428',
                    },
                    {
                        name: '布拖县',
                        code: '513429',
                    },
                    {
                        name: '金阳县',
                        code: '513430',
                    },
                    {
                        name: '昭觉县',
                        code: '513431',
                    },
                    {
                        name: '喜德县',
                        code: '513432',
                    },
                    {
                        name: '冕宁县',
                        code: '513433',
                    },
                    {
                        name: '越西县',
                        code: '513434',
                    },
                    {
                        name: '甘洛县',
                        code: '513435',
                    },
                    {
                        name: '美姑县',
                        code: '513436',
                    },
                    {
                        name: '雷波县',
                        code: '513437',
                    },
                ],
            },
        ],
    },
    {
        name: '贵州省',
        code: '520000',
        children: [
            {
                name: '贵阳市',
                code: '520100',
                children: [
                    {
                        name: '南明区',
                        code: '520102',
                    },
                    {
                        name: '云岩区',
                        code: '520103',
                    },
                    {
                        name: '花溪区',
                        code: '520111',
                    },
                    {
                        name: '乌当区',
                        code: '520112',
                    },
                    {
                        name: '白云区',
                        code: '520113',
                    },
                    {
                        name: '观山湖区',
                        code: '520115',
                    },
                    {
                        name: '开阳县',
                        code: '520121',
                    },
                    {
                        name: '息烽县',
                        code: '520122',
                    },
                    {
                        name: '修文县',
                        code: '520123',
                    },
                    {
                        name: '清镇市',
                        code: '520181',
                    },
                ],
            },
            {
                name: '六盘水市',
                code: '520200',
                children: [
                    {
                        name: '钟山区',
                        code: '520201',
                    },
                    {
                        name: '六枝特区',
                        code: '520203',
                    },
                    {
                        name: '水城县',
                        code: '520221',
                    },
                    {
                        name: '盘州市',
                        code: '520281',
                    },
                ],
            },
            {
                name: '遵义市',
                code: '520300',
                children: [
                    {
                        name: '红花岗区',
                        code: '520302',
                    },
                    {
                        name: '汇川区',
                        code: '520303',
                    },
                    {
                        name: '播州区',
                        code: '520304',
                    },
                    {
                        name: '桐梓县',
                        code: '520322',
                    },
                    {
                        name: '绥阳县',
                        code: '520323',
                    },
                    {
                        name: '正安县',
                        code: '520324',
                    },
                    {
                        name: '道真仡佬族苗族自治县',
                        code: '520325',
                    },
                    {
                        name: '务川仡佬族苗族自治县',
                        code: '520326',
                    },
                    {
                        name: '凤冈县',
                        code: '520327',
                    },
                    {
                        name: '湄潭县',
                        code: '520328',
                    },
                    {
                        name: '余庆县',
                        code: '520329',
                    },
                    {
                        name: '习水县',
                        code: '520330',
                    },
                    {
                        name: '赤水市',
                        code: '520381',
                    },
                    {
                        name: '仁怀市',
                        code: '520382',
                    },
                ],
            },
            {
                name: '安顺市',
                code: '520400',
                children: [
                    {
                        name: '西秀区',
                        code: '520402',
                    },
                    {
                        name: '平坝区',
                        code: '520403',
                    },
                    {
                        name: '普定县',
                        code: '520422',
                    },
                    {
                        name: '镇宁布依族苗族自治县',
                        code: '520423',
                    },
                    {
                        name: '关岭布依族苗族自治县',
                        code: '520424',
                    },
                    {
                        name: '紫云苗族布依族自治县',
                        code: '520425',
                    },
                ],
            },
            {
                name: '毕节市',
                code: '520500',
                children: [
                    {
                        name: '七星关区',
                        code: '520502',
                    },
                    {
                        name: '大方县',
                        code: '520521',
                    },
                    {
                        name: '黔西县',
                        code: '520522',
                    },
                    {
                        name: '金沙县',
                        code: '520523',
                    },
                    {
                        name: '织金县',
                        code: '520524',
                    },
                    {
                        name: '纳雍县',
                        code: '520525',
                    },
                    {
                        name: '威宁彝族回族苗族自治县',
                        code: '520526',
                    },
                    {
                        name: '赫章县',
                        code: '520527',
                    },
                ],
            },
            {
                name: '铜仁市',
                code: '520600',
                children: [
                    {
                        name: '碧江区',
                        code: '520602',
                    },
                    {
                        name: '万山区',
                        code: '520603',
                    },
                    {
                        name: '江口县',
                        code: '520621',
                    },
                    {
                        name: '玉屏侗族自治县',
                        code: '520622',
                    },
                    {
                        name: '石阡县',
                        code: '520623',
                    },
                    {
                        name: '思南县',
                        code: '520624',
                    },
                    {
                        name: '印江土家族苗族自治县',
                        code: '520625',
                    },
                    {
                        name: '德江县',
                        code: '520626',
                    },
                    {
                        name: '沿河土家族自治县',
                        code: '520627',
                    },
                    {
                        name: '松桃苗族自治县',
                        code: '520628',
                    },
                ],
            },
            {
                name: '黔西南布依族苗族自治州',
                code: '522300',
                children: [
                    {
                        name: '兴义市',
                        code: '522301',
                    },
                    {
                        name: '兴仁市',
                        code: '522302',
                    },
                    {
                        name: '普安县',
                        code: '522323',
                    },
                    {
                        name: '晴隆县',
                        code: '522324',
                    },
                    {
                        name: '贞丰县',
                        code: '522325',
                    },
                    {
                        name: '望谟县',
                        code: '522326',
                    },
                    {
                        name: '册亨县',
                        code: '522327',
                    },
                    {
                        name: '安龙县',
                        code: '522328',
                    },
                ],
            },
            {
                name: '黔东南苗族侗族自治州',
                code: '522600',
                children: [
                    {
                        name: '凯里市',
                        code: '522601',
                    },
                    {
                        name: '黄平县',
                        code: '522622',
                    },
                    {
                        name: '施秉县',
                        code: '522623',
                    },
                    {
                        name: '三穗县',
                        code: '522624',
                    },
                    {
                        name: '镇远县',
                        code: '522625',
                    },
                    {
                        name: '岑巩县',
                        code: '522626',
                    },
                    {
                        name: '天柱县',
                        code: '522627',
                    },
                    {
                        name: '锦屏县',
                        code: '522628',
                    },
                    {
                        name: '剑河县',
                        code: '522629',
                    },
                    {
                        name: '台江县',
                        code: '522630',
                    },
                    {
                        name: '黎平县',
                        code: '522631',
                    },
                    {
                        name: '榕江县',
                        code: '522632',
                    },
                    {
                        name: '从江县',
                        code: '522633',
                    },
                    {
                        name: '雷山县',
                        code: '522634',
                    },
                    {
                        name: '麻江县',
                        code: '522635',
                    },
                    {
                        name: '丹寨县',
                        code: '522636',
                    },
                ],
            },
            {
                name: '黔南布依族苗族自治州',
                code: '522700',
                children: [
                    {
                        name: '都匀市',
                        code: '522701',
                    },
                    {
                        name: '福泉市',
                        code: '522702',
                    },
                    {
                        name: '荔波县',
                        code: '522722',
                    },
                    {
                        name: '贵定县',
                        code: '522723',
                    },
                    {
                        name: '瓮安县',
                        code: '522725',
                    },
                    {
                        name: '独山县',
                        code: '522726',
                    },
                    {
                        name: '平塘县',
                        code: '522727',
                    },
                    {
                        name: '罗甸县',
                        code: '522728',
                    },
                    {
                        name: '长顺县',
                        code: '522729',
                    },
                    {
                        name: '龙里县',
                        code: '522730',
                    },
                    {
                        name: '惠水县',
                        code: '522731',
                    },
                    {
                        name: '三都水族自治县',
                        code: '522732',
                    },
                ],
            },
        ],
    },
    {
        name: '云南省',
        code: '530000',
        children: [
            {
                name: '昆明市',
                code: '530100',
                children: [
                    {
                        name: '五华区',
                        code: '530102',
                    },
                    {
                        name: '盘龙区',
                        code: '530103',
                    },
                    {
                        name: '官渡区',
                        code: '530111',
                    },
                    {
                        name: '西山区',
                        code: '530112',
                    },
                    {
                        name: '东川区',
                        code: '530113',
                    },
                    {
                        name: '呈贡区',
                        code: '530114',
                    },
                    {
                        name: '晋宁区',
                        code: '530115',
                    },
                    {
                        name: '富民县',
                        code: '530124',
                    },
                    {
                        name: '宜良县',
                        code: '530125',
                    },
                    {
                        name: '石林彝族自治县',
                        code: '530126',
                    },
                    {
                        name: '嵩明县',
                        code: '530127',
                    },
                    {
                        name: '禄劝彝族苗族自治县',
                        code: '530128',
                    },
                    {
                        name: '寻甸回族彝族自治县',
                        code: '530129',
                    },
                    {
                        name: '安宁市',
                        code: '530181',
                    },
                ],
            },
            {
                name: '曲靖市',
                code: '530300',
                children: [
                    {
                        name: '麒麟区',
                        code: '530302',
                    },
                    {
                        name: '沾益区',
                        code: '530303',
                    },
                    {
                        name: '马龙区',
                        code: '530304',
                    },
                    {
                        name: '陆良县',
                        code: '530322',
                    },
                    {
                        name: '师宗县',
                        code: '530323',
                    },
                    {
                        name: '罗平县',
                        code: '530324',
                    },
                    {
                        name: '富源县',
                        code: '530325',
                    },
                    {
                        name: '会泽县',
                        code: '530326',
                    },
                    {
                        name: '宣威市',
                        code: '530381',
                    },
                ],
            },
            {
                name: '玉溪市',
                code: '530400',
                children: [
                    {
                        name: '红塔区',
                        code: '530402',
                    },
                    {
                        name: '江川区',
                        code: '530403',
                    },
                    {
                        name: '通海县',
                        code: '530423',
                    },
                    {
                        name: '华宁县',
                        code: '530424',
                    },
                    {
                        name: '易门县',
                        code: '530425',
                    },
                    {
                        name: '峨山彝族自治县',
                        code: '530426',
                    },
                    {
                        name: '新平彝族傣族自治县',
                        code: '530427',
                    },
                    {
                        name: '元江哈尼族彝族傣族自治县',
                        code: '530428',
                    },
                    {
                        name: '澄江市',
                        code: '530481',
                    },
                ],
            },
            {
                name: '保山市',
                code: '530500',
                children: [
                    {
                        name: '隆阳区',
                        code: '530502',
                    },
                    {
                        name: '施甸县',
                        code: '530521',
                    },
                    {
                        name: '龙陵县',
                        code: '530523',
                    },
                    {
                        name: '昌宁县',
                        code: '530524',
                    },
                    {
                        name: '腾冲市',
                        code: '530581',
                    },
                ],
            },
            {
                name: '昭通市',
                code: '530600',
                children: [
                    {
                        name: '昭阳区',
                        code: '530602',
                    },
                    {
                        name: '鲁甸县',
                        code: '530621',
                    },
                    {
                        name: '巧家县',
                        code: '530622',
                    },
                    {
                        name: '盐津县',
                        code: '530623',
                    },
                    {
                        name: '大关县',
                        code: '530624',
                    },
                    {
                        name: '永善县',
                        code: '530625',
                    },
                    {
                        name: '绥江县',
                        code: '530626',
                    },
                    {
                        name: '镇雄县',
                        code: '530627',
                    },
                    {
                        name: '彝良县',
                        code: '530628',
                    },
                    {
                        name: '威信县',
                        code: '530629',
                    },
                    {
                        name: '水富市',
                        code: '530681',
                    },
                ],
            },
            {
                name: '丽江市',
                code: '530700',
                children: [
                    {
                        name: '古城区',
                        code: '530702',
                    },
                    {
                        name: '玉龙纳西族自治县',
                        code: '530721',
                    },
                    {
                        name: '永胜县',
                        code: '530722',
                    },
                    {
                        name: '华坪县',
                        code: '530723',
                    },
                    {
                        name: '宁蒗彝族自治县',
                        code: '530724',
                    },
                ],
            },
            {
                name: '普洱市',
                code: '530800',
                children: [
                    {
                        name: '思茅区',
                        code: '530802',
                    },
                    {
                        name: '宁洱哈尼族彝族自治县',
                        code: '530821',
                    },
                    {
                        name: '墨江哈尼族自治县',
                        code: '530822',
                    },
                    {
                        name: '景东彝族自治县',
                        code: '530823',
                    },
                    {
                        name: '景谷傣族彝族自治县',
                        code: '530824',
                    },
                    {
                        name: '镇沅彝族哈尼族拉祜族自治县',
                        code: '530825',
                    },
                    {
                        name: '江城哈尼族彝族自治县',
                        code: '530826',
                    },
                    {
                        name: '孟连傣族拉祜族佤族自治县',
                        code: '530827',
                    },
                    {
                        name: '澜沧拉祜族自治县',
                        code: '530828',
                    },
                    {
                        name: '西盟佤族自治县',
                        code: '530829',
                    },
                ],
            },
            {
                name: '临沧市',
                code: '530900',
                children: [
                    {
                        name: '临翔区',
                        code: '530902',
                    },
                    {
                        name: '凤庆县',
                        code: '530921',
                    },
                    {
                        name: '云县',
                        code: '530922',
                    },
                    {
                        name: '永德县',
                        code: '530923',
                    },
                    {
                        name: '镇康县',
                        code: '530924',
                    },
                    {
                        name: '双江拉祜族佤族布朗族傣族自治县',
                        code: '530925',
                    },
                    {
                        name: '耿马傣族佤族自治县',
                        code: '530926',
                    },
                    {
                        name: '沧源佤族自治县',
                        code: '530927',
                    },
                ],
            },
            {
                name: '楚雄彝族自治州',
                code: '532300',
                children: [
                    {
                        name: '楚雄市',
                        code: '532301',
                    },
                    {
                        name: '双柏县',
                        code: '532322',
                    },
                    {
                        name: '牟定县',
                        code: '532323',
                    },
                    {
                        name: '南华县',
                        code: '532324',
                    },
                    {
                        name: '姚安县',
                        code: '532325',
                    },
                    {
                        name: '大姚县',
                        code: '532326',
                    },
                    {
                        name: '永仁县',
                        code: '532327',
                    },
                    {
                        name: '元谋县',
                        code: '532328',
                    },
                    {
                        name: '武定县',
                        code: '532329',
                    },
                    {
                        name: '禄丰县',
                        code: '532331',
                    },
                ],
            },
            {
                name: '红河哈尼族彝族自治州',
                code: '532500',
                children: [
                    {
                        name: '个旧市',
                        code: '532501',
                    },
                    {
                        name: '开远市',
                        code: '532502',
                    },
                    {
                        name: '蒙自市',
                        code: '532503',
                    },
                    {
                        name: '弥勒市',
                        code: '532504',
                    },
                    {
                        name: '屏边苗族自治县',
                        code: '532523',
                    },
                    {
                        name: '建水县',
                        code: '532524',
                    },
                    {
                        name: '石屏县',
                        code: '532525',
                    },
                    {
                        name: '泸西县',
                        code: '532527',
                    },
                    {
                        name: '元阳县',
                        code: '532528',
                    },
                    {
                        name: '红河县',
                        code: '532529',
                    },
                    {
                        name: '金平苗族瑶族傣族自治县',
                        code: '532530',
                    },
                    {
                        name: '绿春县',
                        code: '532531',
                    },
                    {
                        name: '河口瑶族自治县',
                        code: '532532',
                    },
                ],
            },
            {
                name: '文山壮族苗族自治州',
                code: '532600',
                children: [
                    {
                        name: '文山市',
                        code: '532601',
                    },
                    {
                        name: '砚山县',
                        code: '532622',
                    },
                    {
                        name: '西畴县',
                        code: '532623',
                    },
                    {
                        name: '麻栗坡县',
                        code: '532624',
                    },
                    {
                        name: '马关县',
                        code: '532625',
                    },
                    {
                        name: '丘北县',
                        code: '532626',
                    },
                    {
                        name: '广南县',
                        code: '532627',
                    },
                    {
                        name: '富宁县',
                        code: '532628',
                    },
                ],
            },
            {
                name: '西双版纳傣族自治州',
                code: '532800',
                children: [
                    {
                        name: '景洪市',
                        code: '532801',
                    },
                    {
                        name: '勐海县',
                        code: '532822',
                    },
                    {
                        name: '勐腊县',
                        code: '532823',
                    },
                ],
            },
            {
                name: '大理白族自治州',
                code: '532900',
                children: [
                    {
                        name: '大理市',
                        code: '532901',
                    },
                    {
                        name: '漾濞彝族自治县',
                        code: '532922',
                    },
                    {
                        name: '祥云县',
                        code: '532923',
                    },
                    {
                        name: '宾川县',
                        code: '532924',
                    },
                    {
                        name: '弥渡县',
                        code: '532925',
                    },
                    {
                        name: '南涧彝族自治县',
                        code: '532926',
                    },
                    {
                        name: '巍山彝族回族自治县',
                        code: '532927',
                    },
                    {
                        name: '永平县',
                        code: '532928',
                    },
                    {
                        name: '云龙县',
                        code: '532929',
                    },
                    {
                        name: '洱源县',
                        code: '532930',
                    },
                    {
                        name: '剑川县',
                        code: '532931',
                    },
                    {
                        name: '鹤庆县',
                        code: '532932',
                    },
                ],
            },
            {
                name: '德宏傣族景颇族自治州',
                code: '533100',
                children: [
                    {
                        name: '瑞丽市',
                        code: '533102',
                    },
                    {
                        name: '芒市',
                        code: '533103',
                    },
                    {
                        name: '梁河县',
                        code: '533122',
                    },
                    {
                        name: '盈江县',
                        code: '533123',
                    },
                    {
                        name: '陇川县',
                        code: '533124',
                    },
                ],
            },
            {
                name: '怒江傈僳族自治州',
                code: '533300',
                children: [
                    {
                        name: '泸水市',
                        code: '533301',
                    },
                    {
                        name: '福贡县',
                        code: '533323',
                    },
                    {
                        name: '贡山独龙族怒族自治县',
                        code: '533324',
                    },
                    {
                        name: '兰坪白族普米族自治县',
                        code: '533325',
                    },
                ],
            },
            {
                name: '迪庆藏族自治州',
                code: '533400',
                children: [
                    {
                        name: '香格里拉市',
                        code: '533401',
                    },
                    {
                        name: '德钦县',
                        code: '533422',
                    },
                    {
                        name: '维西傈僳族自治县',
                        code: '533423',
                    },
                ],
            },
        ],
    },
    {
        name: '西藏自治区',
        code: '540000',
        children: [
            {
                name: '拉萨市',
                code: '540100',
                children: [
                    {
                        name: '城关区',
                        code: '540102',
                    },
                    {
                        name: '堆龙德庆区',
                        code: '540103',
                    },
                    {
                        name: '达孜区',
                        code: '540104',
                    },
                    {
                        name: '林周县',
                        code: '540121',
                    },
                    {
                        name: '当雄县',
                        code: '540122',
                    },
                    {
                        name: '尼木县',
                        code: '540123',
                    },
                    {
                        name: '曲水县',
                        code: '540124',
                    },
                    {
                        name: '墨竹工卡县',
                        code: '540127',
                    },
                    {
                        name: '格尔木藏青工业园区',
                        code: '540171',
                    },
                    {
                        name: '拉萨经济技术开发区',
                        code: '540172',
                    },
                    {
                        name: '西藏文化旅游创意园区',
                        code: '540173',
                    },
                    {
                        name: '达孜工业园区',
                        code: '540174',
                    },
                ],
            },
            {
                name: '日喀则市',
                code: '540200',
                children: [
                    {
                        name: '桑珠孜区',
                        code: '540202',
                    },
                    {
                        name: '南木林县',
                        code: '540221',
                    },
                    {
                        name: '江孜县',
                        code: '540222',
                    },
                    {
                        name: '定日县',
                        code: '540223',
                    },
                    {
                        name: '萨迦县',
                        code: '540224',
                    },
                    {
                        name: '拉孜县',
                        code: '540225',
                    },
                    {
                        name: '昂仁县',
                        code: '540226',
                    },
                    {
                        name: '谢通门县',
                        code: '540227',
                    },
                    {
                        name: '白朗县',
                        code: '540228',
                    },
                    {
                        name: '仁布县',
                        code: '540229',
                    },
                    {
                        name: '康马县',
                        code: '540230',
                    },
                    {
                        name: '定结县',
                        code: '540231',
                    },
                    {
                        name: '仲巴县',
                        code: '540232',
                    },
                    {
                        name: '亚东县',
                        code: '540233',
                    },
                    {
                        name: '吉隆县',
                        code: '540234',
                    },
                    {
                        name: '聂拉木县',
                        code: '540235',
                    },
                    {
                        name: '萨嘎县',
                        code: '540236',
                    },
                    {
                        name: '岗巴县',
                        code: '540237',
                    },
                ],
            },
            {
                name: '昌都市',
                code: '540300',
                children: [
                    {
                        name: '卡若区',
                        code: '540302',
                    },
                    {
                        name: '江达县',
                        code: '540321',
                    },
                    {
                        name: '贡觉县',
                        code: '540322',
                    },
                    {
                        name: '类乌齐县',
                        code: '540323',
                    },
                    {
                        name: '丁青县',
                        code: '540324',
                    },
                    {
                        name: '察雅县',
                        code: '540325',
                    },
                    {
                        name: '八宿县',
                        code: '540326',
                    },
                    {
                        name: '左贡县',
                        code: '540327',
                    },
                    {
                        name: '芒康县',
                        code: '540328',
                    },
                    {
                        name: '洛隆县',
                        code: '540329',
                    },
                    {
                        name: '边坝县',
                        code: '540330',
                    },
                ],
            },
            {
                name: '林芝市',
                code: '540400',
                children: [
                    {
                        name: '巴宜区',
                        code: '540402',
                    },
                    {
                        name: '工布江达县',
                        code: '540421',
                    },
                    {
                        name: '米林县',
                        code: '540422',
                    },
                    {
                        name: '墨脱县',
                        code: '540423',
                    },
                    {
                        name: '波密县',
                        code: '540424',
                    },
                    {
                        name: '察隅县',
                        code: '540425',
                    },
                    {
                        name: '朗县',
                        code: '540426',
                    },
                ],
            },
            {
                name: '山南市',
                code: '540500',
                children: [
                    {
                        name: '乃东区',
                        code: '540502',
                    },
                    {
                        name: '扎囊县',
                        code: '540521',
                    },
                    {
                        name: '贡嘎县',
                        code: '540522',
                    },
                    {
                        name: '桑日县',
                        code: '540523',
                    },
                    {
                        name: '琼结县',
                        code: '540524',
                    },
                    {
                        name: '曲松县',
                        code: '540525',
                    },
                    {
                        name: '措美县',
                        code: '540526',
                    },
                    {
                        name: '洛扎县',
                        code: '540527',
                    },
                    {
                        name: '加查县',
                        code: '540528',
                    },
                    {
                        name: '隆子县',
                        code: '540529',
                    },
                    {
                        name: '错那县',
                        code: '540530',
                    },
                    {
                        name: '浪卡子县',
                        code: '540531',
                    },
                ],
            },
            {
                name: '那曲市',
                code: '540600',
                children: [
                    {
                        name: '色尼区',
                        code: '540602',
                    },
                    {
                        name: '嘉黎县',
                        code: '540621',
                    },
                    {
                        name: '比如县',
                        code: '540622',
                    },
                    {
                        name: '聂荣县',
                        code: '540623',
                    },
                    {
                        name: '安多县',
                        code: '540624',
                    },
                    {
                        name: '申扎县',
                        code: '540625',
                    },
                    {
                        name: '索县',
                        code: '540626',
                    },
                    {
                        name: '班戈县',
                        code: '540627',
                    },
                    {
                        name: '巴青县',
                        code: '540628',
                    },
                    {
                        name: '尼玛县',
                        code: '540629',
                    },
                    {
                        name: '双湖县',
                        code: '540630',
                    },
                ],
            },
            {
                name: '阿里地区',
                code: '542500',
                children: [
                    {
                        name: '普兰县',
                        code: '542521',
                    },
                    {
                        name: '札达县',
                        code: '542522',
                    },
                    {
                        name: '噶尔县',
                        code: '542523',
                    },
                    {
                        name: '日土县',
                        code: '542524',
                    },
                    {
                        name: '革吉县',
                        code: '542525',
                    },
                    {
                        name: '改则县',
                        code: '542526',
                    },
                    {
                        name: '措勤县',
                        code: '542527',
                    },
                ],
            },
        ],
    },
    {
        name: '陕西省',
        code: '610000',
        children: [
            {
                name: '西安市',
                code: '610100',
                children: [
                    {
                        name: '新城区',
                        code: '610102',
                    },
                    {
                        name: '碑林区',
                        code: '610103',
                    },
                    {
                        name: '莲湖区',
                        code: '610104',
                    },
                    {
                        name: '灞桥区',
                        code: '610111',
                    },
                    {
                        name: '未央区',
                        code: '610112',
                    },
                    {
                        name: '雁塔区',
                        code: '610113',
                    },
                    {
                        name: '阎良区',
                        code: '610114',
                    },
                    {
                        name: '临潼区',
                        code: '610115',
                    },
                    {
                        name: '长安区',
                        code: '610116',
                    },
                    {
                        name: '高陵区',
                        code: '610117',
                    },
                    {
                        name: '鄠邑区',
                        code: '610118',
                    },
                    {
                        name: '蓝田县',
                        code: '610122',
                    },
                    {
                        name: '周至县',
                        code: '610124',
                    },
                ],
            },
            {
                name: '铜川市',
                code: '610200',
                children: [
                    {
                        name: '王益区',
                        code: '610202',
                    },
                    {
                        name: '印台区',
                        code: '610203',
                    },
                    {
                        name: '耀州区',
                        code: '610204',
                    },
                    {
                        name: '宜君县',
                        code: '610222',
                    },
                ],
            },
            {
                name: '宝鸡市',
                code: '610300',
                children: [
                    {
                        name: '渭滨区',
                        code: '610302',
                    },
                    {
                        name: '金台区',
                        code: '610303',
                    },
                    {
                        name: '陈仓区',
                        code: '610304',
                    },
                    {
                        name: '凤翔县',
                        code: '610322',
                    },
                    {
                        name: '岐山县',
                        code: '610323',
                    },
                    {
                        name: '扶风县',
                        code: '610324',
                    },
                    {
                        name: '眉县',
                        code: '610326',
                    },
                    {
                        name: '陇县',
                        code: '610327',
                    },
                    {
                        name: '千阳县',
                        code: '610328',
                    },
                    {
                        name: '麟游县',
                        code: '610329',
                    },
                    {
                        name: '凤县',
                        code: '610330',
                    },
                    {
                        name: '太白县',
                        code: '610331',
                    },
                ],
            },
            {
                name: '咸阳市',
                code: '610400',
                children: [
                    {
                        name: '秦都区',
                        code: '610402',
                    },
                    {
                        name: '杨陵区',
                        code: '610403',
                    },
                    {
                        name: '渭城区',
                        code: '610404',
                    },
                    {
                        name: '三原县',
                        code: '610422',
                    },
                    {
                        name: '泾阳县',
                        code: '610423',
                    },
                    {
                        name: '乾县',
                        code: '610424',
                    },
                    {
                        name: '礼泉县',
                        code: '610425',
                    },
                    {
                        name: '永寿县',
                        code: '610426',
                    },
                    {
                        name: '长武县',
                        code: '610428',
                    },
                    {
                        name: '旬邑县',
                        code: '610429',
                    },
                    {
                        name: '淳化县',
                        code: '610430',
                    },
                    {
                        name: '武功县',
                        code: '610431',
                    },
                    {
                        name: '兴平市',
                        code: '610481',
                    },
                    {
                        name: '彬州市',
                        code: '610482',
                    },
                ],
            },
            {
                name: '渭南市',
                code: '610500',
                children: [
                    {
                        name: '临渭区',
                        code: '610502',
                    },
                    {
                        name: '华州区',
                        code: '610503',
                    },
                    {
                        name: '潼关县',
                        code: '610522',
                    },
                    {
                        name: '大荔县',
                        code: '610523',
                    },
                    {
                        name: '合阳县',
                        code: '610524',
                    },
                    {
                        name: '澄城县',
                        code: '610525',
                    },
                    {
                        name: '蒲城县',
                        code: '610526',
                    },
                    {
                        name: '白水县',
                        code: '610527',
                    },
                    {
                        name: '富平县',
                        code: '610528',
                    },
                    {
                        name: '韩城市',
                        code: '610581',
                    },
                    {
                        name: '华阴市',
                        code: '610582',
                    },
                ],
            },
            {
                name: '延安市',
                code: '610600',
                children: [
                    {
                        name: '宝塔区',
                        code: '610602',
                    },
                    {
                        name: '安塞区',
                        code: '610603',
                    },
                    {
                        name: '延长县',
                        code: '610621',
                    },
                    {
                        name: '延川县',
                        code: '610622',
                    },
                    {
                        name: '志丹县',
                        code: '610625',
                    },
                    {
                        name: '吴起县',
                        code: '610626',
                    },
                    {
                        name: '甘泉县',
                        code: '610627',
                    },
                    {
                        name: '富县',
                        code: '610628',
                    },
                    {
                        name: '洛川县',
                        code: '610629',
                    },
                    {
                        name: '宜川县',
                        code: '610630',
                    },
                    {
                        name: '黄龙县',
                        code: '610631',
                    },
                    {
                        name: '黄陵县',
                        code: '610632',
                    },
                    {
                        name: '子长市',
                        code: '610681',
                    },
                ],
            },
            {
                name: '汉中市',
                code: '610700',
                children: [
                    {
                        name: '汉台区',
                        code: '610702',
                    },
                    {
                        name: '南郑区',
                        code: '610703',
                    },
                    {
                        name: '城固县',
                        code: '610722',
                    },
                    {
                        name: '洋县',
                        code: '610723',
                    },
                    {
                        name: '西乡县',
                        code: '610724',
                    },
                    {
                        name: '勉县',
                        code: '610725',
                    },
                    {
                        name: '宁强县',
                        code: '610726',
                    },
                    {
                        name: '略阳县',
                        code: '610727',
                    },
                    {
                        name: '镇巴县',
                        code: '610728',
                    },
                    {
                        name: '留坝县',
                        code: '610729',
                    },
                    {
                        name: '佛坪县',
                        code: '610730',
                    },
                ],
            },
            {
                name: '榆林市',
                code: '610800',
                children: [
                    {
                        name: '榆阳区',
                        code: '610802',
                    },
                    {
                        name: '横山区',
                        code: '610803',
                    },
                    {
                        name: '府谷县',
                        code: '610822',
                    },
                    {
                        name: '靖边县',
                        code: '610824',
                    },
                    {
                        name: '定边县',
                        code: '610825',
                    },
                    {
                        name: '绥德县',
                        code: '610826',
                    },
                    {
                        name: '米脂县',
                        code: '610827',
                    },
                    {
                        name: '佳县',
                        code: '610828',
                    },
                    {
                        name: '吴堡县',
                        code: '610829',
                    },
                    {
                        name: '清涧县',
                        code: '610830',
                    },
                    {
                        name: '子洲县',
                        code: '610831',
                    },
                    {
                        name: '神木市',
                        code: '610881',
                    },
                ],
            },
            {
                name: '安康市',
                code: '610900',
                children: [
                    {
                        name: '汉滨区',
                        code: '610902',
                    },
                    {
                        name: '汉阴县',
                        code: '610921',
                    },
                    {
                        name: '石泉县',
                        code: '610922',
                    },
                    {
                        name: '宁陕县',
                        code: '610923',
                    },
                    {
                        name: '紫阳县',
                        code: '610924',
                    },
                    {
                        name: '岚皋县',
                        code: '610925',
                    },
                    {
                        name: '平利县',
                        code: '610926',
                    },
                    {
                        name: '镇坪县',
                        code: '610927',
                    },
                    {
                        name: '旬阳县',
                        code: '610928',
                    },
                    {
                        name: '白河县',
                        code: '610929',
                    },
                ],
            },
            {
                name: '商洛市',
                code: '611000',
                children: [
                    {
                        name: '商州区',
                        code: '611002',
                    },
                    {
                        name: '洛南县',
                        code: '611021',
                    },
                    {
                        name: '丹凤县',
                        code: '611022',
                    },
                    {
                        name: '商南县',
                        code: '611023',
                    },
                    {
                        name: '山阳县',
                        code: '611024',
                    },
                    {
                        name: '镇安县',
                        code: '611025',
                    },
                    {
                        name: '柞水县',
                        code: '611026',
                    },
                ],
            },
        ],
    },
    {
        name: '甘肃省',
        code: '620000',
        children: [
            {
                name: '兰州市',
                code: '620100',
                children: [
                    {
                        name: '城关区',
                        code: '620102',
                    },
                    {
                        name: '七里河区',
                        code: '620103',
                    },
                    {
                        name: '西固区',
                        code: '620104',
                    },
                    {
                        name: '安宁区',
                        code: '620105',
                    },
                    {
                        name: '红古区',
                        code: '620111',
                    },
                    {
                        name: '永登县',
                        code: '620121',
                    },
                    {
                        name: '皋兰县',
                        code: '620122',
                    },
                    {
                        name: '榆中县',
                        code: '620123',
                    },
                    {
                        name: '兰州新区',
                        code: '620171',
                    },
                ],
            },
            {
                name: '嘉峪关市',
                code: '620200',
                children: [
                    {
                        name: '市辖区',
                        code: '620201',
                    },
                ],
            },
            {
                name: '金昌市',
                code: '620300',
                children: [
                    {
                        name: '金川区',
                        code: '620302',
                    },
                    {
                        name: '永昌县',
                        code: '620321',
                    },
                ],
            },
            {
                name: '白银市',
                code: '620400',
                children: [
                    {
                        name: '白银区',
                        code: '620402',
                    },
                    {
                        name: '平川区',
                        code: '620403',
                    },
                    {
                        name: '靖远县',
                        code: '620421',
                    },
                    {
                        name: '会宁县',
                        code: '620422',
                    },
                    {
                        name: '景泰县',
                        code: '620423',
                    },
                ],
            },
            {
                name: '天水市',
                code: '620500',
                children: [
                    {
                        name: '秦州区',
                        code: '620502',
                    },
                    {
                        name: '麦积区',
                        code: '620503',
                    },
                    {
                        name: '清水县',
                        code: '620521',
                    },
                    {
                        name: '秦安县',
                        code: '620522',
                    },
                    {
                        name: '甘谷县',
                        code: '620523',
                    },
                    {
                        name: '武山县',
                        code: '620524',
                    },
                    {
                        name: '张家川回族自治县',
                        code: '620525',
                    },
                ],
            },
            {
                name: '武威市',
                code: '620600',
                children: [
                    {
                        name: '凉州区',
                        code: '620602',
                    },
                    {
                        name: '民勤县',
                        code: '620621',
                    },
                    {
                        name: '古浪县',
                        code: '620622',
                    },
                    {
                        name: '天祝藏族自治县',
                        code: '620623',
                    },
                ],
            },
            {
                name: '张掖市',
                code: '620700',
                children: [
                    {
                        name: '甘州区',
                        code: '620702',
                    },
                    {
                        name: '肃南裕固族自治县',
                        code: '620721',
                    },
                    {
                        name: '民乐县',
                        code: '620722',
                    },
                    {
                        name: '临泽县',
                        code: '620723',
                    },
                    {
                        name: '高台县',
                        code: '620724',
                    },
                    {
                        name: '山丹县',
                        code: '620725',
                    },
                ],
            },
            {
                name: '平凉市',
                code: '620800',
                children: [
                    {
                        name: '崆峒区',
                        code: '620802',
                    },
                    {
                        name: '泾川县',
                        code: '620821',
                    },
                    {
                        name: '灵台县',
                        code: '620822',
                    },
                    {
                        name: '崇信县',
                        code: '620823',
                    },
                    {
                        name: '庄浪县',
                        code: '620825',
                    },
                    {
                        name: '静宁县',
                        code: '620826',
                    },
                    {
                        name: '华亭市',
                        code: '620881',
                    },
                ],
            },
            {
                name: '酒泉市',
                code: '620900',
                children: [
                    {
                        name: '肃州区',
                        code: '620902',
                    },
                    {
                        name: '金塔县',
                        code: '620921',
                    },
                    {
                        name: '瓜州县',
                        code: '620922',
                    },
                    {
                        name: '肃北蒙古族自治县',
                        code: '620923',
                    },
                    {
                        name: '阿克塞哈萨克族自治县',
                        code: '620924',
                    },
                    {
                        name: '玉门市',
                        code: '620981',
                    },
                    {
                        name: '敦煌市',
                        code: '620982',
                    },
                ],
            },
            {
                name: '庆阳市',
                code: '621000',
                children: [
                    {
                        name: '西峰区',
                        code: '621002',
                    },
                    {
                        name: '庆城县',
                        code: '621021',
                    },
                    {
                        name: '环县',
                        code: '621022',
                    },
                    {
                        name: '华池县',
                        code: '621023',
                    },
                    {
                        name: '合水县',
                        code: '621024',
                    },
                    {
                        name: '正宁县',
                        code: '621025',
                    },
                    {
                        name: '宁县',
                        code: '621026',
                    },
                    {
                        name: '镇原县',
                        code: '621027',
                    },
                ],
            },
            {
                name: '定西市',
                code: '621100',
                children: [
                    {
                        name: '安定区',
                        code: '621102',
                    },
                    {
                        name: '通渭县',
                        code: '621121',
                    },
                    {
                        name: '陇西县',
                        code: '621122',
                    },
                    {
                        name: '渭源县',
                        code: '621123',
                    },
                    {
                        name: '临洮县',
                        code: '621124',
                    },
                    {
                        name: '漳县',
                        code: '621125',
                    },
                    {
                        name: '岷县',
                        code: '621126',
                    },
                ],
            },
            {
                name: '陇南市',
                code: '621200',
                children: [
                    {
                        name: '武都区',
                        code: '621202',
                    },
                    {
                        name: '成县',
                        code: '621221',
                    },
                    {
                        name: '文县',
                        code: '621222',
                    },
                    {
                        name: '宕昌县',
                        code: '621223',
                    },
                    {
                        name: '康县',
                        code: '621224',
                    },
                    {
                        name: '西和县',
                        code: '621225',
                    },
                    {
                        name: '礼县',
                        code: '621226',
                    },
                    {
                        name: '徽县',
                        code: '621227',
                    },
                    {
                        name: '两当县',
                        code: '621228',
                    },
                ],
            },
            {
                name: '临夏回族自治州',
                code: '622900',
                children: [
                    {
                        name: '临夏市',
                        code: '622901',
                    },
                    {
                        name: '临夏县',
                        code: '622921',
                    },
                    {
                        name: '康乐县',
                        code: '622922',
                    },
                    {
                        name: '永靖县',
                        code: '622923',
                    },
                    {
                        name: '广河县',
                        code: '622924',
                    },
                    {
                        name: '和政县',
                        code: '622925',
                    },
                    {
                        name: '东乡族自治县',
                        code: '622926',
                    },
                    {
                        name: '积石山保安族东乡族撒拉族自治县',
                        code: '622927',
                    },
                ],
            },
            {
                name: '甘南藏族自治州',
                code: '623000',
                children: [
                    {
                        name: '合作市',
                        code: '623001',
                    },
                    {
                        name: '临潭县',
                        code: '623021',
                    },
                    {
                        name: '卓尼县',
                        code: '623022',
                    },
                    {
                        name: '舟曲县',
                        code: '623023',
                    },
                    {
                        name: '迭部县',
                        code: '623024',
                    },
                    {
                        name: '玛曲县',
                        code: '623025',
                    },
                    {
                        name: '碌曲县',
                        code: '623026',
                    },
                    {
                        name: '夏河县',
                        code: '623027',
                    },
                ],
            },
        ],
    },
    {
        name: '青海省',
        code: '630000',
        children: [
            {
                name: '西宁市',
                code: '630100',
                children: [
                    {
                        name: '城东区',
                        code: '630102',
                    },
                    {
                        name: '城中区',
                        code: '630103',
                    },
                    {
                        name: '城西区',
                        code: '630104',
                    },
                    {
                        name: '城北区',
                        code: '630105',
                    },
                    {
                        name: '湟中区',
                        code: '630106',
                    },
                    {
                        name: '大通回族土族自治县',
                        code: '630121',
                    },
                    {
                        name: '湟源县',
                        code: '630123',
                    },
                ],
            },
            {
                name: '海东市',
                code: '630200',
                children: [
                    {
                        name: '乐都区',
                        code: '630202',
                    },
                    {
                        name: '平安区',
                        code: '630203',
                    },
                    {
                        name: '民和回族土族自治县',
                        code: '630222',
                    },
                    {
                        name: '互助土族自治县',
                        code: '630223',
                    },
                    {
                        name: '化隆回族自治县',
                        code: '630224',
                    },
                    {
                        name: '循化撒拉族自治县',
                        code: '630225',
                    },
                ],
            },
            {
                name: '海北藏族自治州',
                code: '632200',
                children: [
                    {
                        name: '门源回族自治县',
                        code: '632221',
                    },
                    {
                        name: '祁连县',
                        code: '632222',
                    },
                    {
                        name: '海晏县',
                        code: '632223',
                    },
                    {
                        name: '刚察县',
                        code: '632224',
                    },
                ],
            },
            {
                name: '黄南藏族自治州',
                code: '632300',
                children: [
                    {
                        name: '同仁县',
                        code: '632321',
                    },
                    {
                        name: '尖扎县',
                        code: '632322',
                    },
                    {
                        name: '泽库县',
                        code: '632323',
                    },
                    {
                        name: '河南蒙古族自治县',
                        code: '632324',
                    },
                ],
            },
            {
                name: '海南藏族自治州',
                code: '632500',
                children: [
                    {
                        name: '共和县',
                        code: '632521',
                    },
                    {
                        name: '同德县',
                        code: '632522',
                    },
                    {
                        name: '贵德县',
                        code: '632523',
                    },
                    {
                        name: '兴海县',
                        code: '632524',
                    },
                    {
                        name: '贵南县',
                        code: '632525',
                    },
                ],
            },
            {
                name: '果洛藏族自治州',
                code: '632600',
                children: [
                    {
                        name: '玛沁县',
                        code: '632621',
                    },
                    {
                        name: '班玛县',
                        code: '632622',
                    },
                    {
                        name: '甘德县',
                        code: '632623',
                    },
                    {
                        name: '达日县',
                        code: '632624',
                    },
                    {
                        name: '久治县',
                        code: '632625',
                    },
                    {
                        name: '玛多县',
                        code: '632626',
                    },
                ],
            },
            {
                name: '玉树藏族自治州',
                code: '632700',
                children: [
                    {
                        name: '玉树市',
                        code: '632701',
                    },
                    {
                        name: '杂多县',
                        code: '632722',
                    },
                    {
                        name: '称多县',
                        code: '632723',
                    },
                    {
                        name: '治多县',
                        code: '632724',
                    },
                    {
                        name: '囊谦县',
                        code: '632725',
                    },
                    {
                        name: '曲麻莱县',
                        code: '632726',
                    },
                ],
            },
            {
                name: '海西蒙古族藏族自治州',
                code: '632800',
                children: [
                    {
                        name: '格尔木市',
                        code: '632801',
                    },
                    {
                        name: '德令哈市',
                        code: '632802',
                    },
                    {
                        name: '茫崖市',
                        code: '632803',
                    },
                    {
                        name: '乌兰县',
                        code: '632821',
                    },
                    {
                        name: '都兰县',
                        code: '632822',
                    },
                    {
                        name: '天峻县',
                        code: '632823',
                    },
                    {
                        name: '大柴旦行政委员会',
                        code: '632857',
                    },
                ],
            },
        ],
    },
    {
        name: '宁夏回族自治区',
        code: '640000',
        children: [
            {
                name: '银川市',
                code: '640100',
                children: [
                    {
                        name: '兴庆区',
                        code: '640104',
                    },
                    {
                        name: '西夏区',
                        code: '640105',
                    },
                    {
                        name: '金凤区',
                        code: '640106',
                    },
                    {
                        name: '永宁县',
                        code: '640121',
                    },
                    {
                        name: '贺兰县',
                        code: '640122',
                    },
                    {
                        name: '灵武市',
                        code: '640181',
                    },
                ],
            },
            {
                name: '石嘴山市',
                code: '640200',
                children: [
                    {
                        name: '大武口区',
                        code: '640202',
                    },
                    {
                        name: '惠农区',
                        code: '640205',
                    },
                    {
                        name: '平罗县',
                        code: '640221',
                    },
                ],
            },
            {
                name: '吴忠市',
                code: '640300',
                children: [
                    {
                        name: '利通区',
                        code: '640302',
                    },
                    {
                        name: '红寺堡区',
                        code: '640303',
                    },
                    {
                        name: '盐池县',
                        code: '640323',
                    },
                    {
                        name: '同心县',
                        code: '640324',
                    },
                    {
                        name: '青铜峡市',
                        code: '640381',
                    },
                ],
            },
            {
                name: '固原市',
                code: '640400',
                children: [
                    {
                        name: '原州区',
                        code: '640402',
                    },
                    {
                        name: '西吉县',
                        code: '640422',
                    },
                    {
                        name: '隆德县',
                        code: '640423',
                    },
                    {
                        name: '泾源县',
                        code: '640424',
                    },
                    {
                        name: '彭阳县',
                        code: '640425',
                    },
                ],
            },
            {
                name: '中卫市',
                code: '640500',
                children: [
                    {
                        name: '沙坡头区',
                        code: '640502',
                    },
                    {
                        name: '中宁县',
                        code: '640521',
                    },
                    {
                        name: '海原县',
                        code: '640522',
                    },
                ],
            },
        ],
    },
    {
        name: '新疆维吾尔自治区',
        code: '650000',
        children: [
            {
                name: '乌鲁木齐市',
                code: '650100',
                children: [
                    {
                        name: '天山区',
                        code: '650102',
                    },
                    {
                        name: '沙依巴克区',
                        code: '650103',
                    },
                    {
                        name: '新市区',
                        code: '650104',
                    },
                    {
                        name: '水磨沟区',
                        code: '650105',
                    },
                    {
                        name: '头屯河区',
                        code: '650106',
                    },
                    {
                        name: '达坂城区',
                        code: '650107',
                    },
                    {
                        name: '米东区',
                        code: '650109',
                    },
                    {
                        name: '乌鲁木齐县',
                        code: '650121',
                    },
                ],
            },
            {
                name: '克拉玛依市',
                code: '650200',
                children: [
                    {
                        name: '独山子区',
                        code: '650202',
                    },
                    {
                        name: '克拉玛依区',
                        code: '650203',
                    },
                    {
                        name: '白碱滩区',
                        code: '650204',
                    },
                    {
                        name: '乌尔禾区',
                        code: '650205',
                    },
                ],
            },
            {
                name: '吐鲁番市',
                code: '650400',
                children: [
                    {
                        name: '高昌区',
                        code: '650402',
                    },
                    {
                        name: '鄯善县',
                        code: '650421',
                    },
                    {
                        name: '托克逊县',
                        code: '650422',
                    },
                ],
            },
            {
                name: '哈密市',
                code: '650500',
                children: [
                    {
                        name: '伊州区',
                        code: '650502',
                    },
                    {
                        name: '巴里坤哈萨克自治县',
                        code: '650521',
                    },
                    {
                        name: '伊吾县',
                        code: '650522',
                    },
                ],
            },
            {
                name: '昌吉回族自治州',
                code: '652300',
                children: [
                    {
                        name: '昌吉市',
                        code: '652301',
                    },
                    {
                        name: '阜康市',
                        code: '652302',
                    },
                    {
                        name: '呼图壁县',
                        code: '652323',
                    },
                    {
                        name: '玛纳斯县',
                        code: '652324',
                    },
                    {
                        name: '奇台县',
                        code: '652325',
                    },
                    {
                        name: '吉木萨尔县',
                        code: '652327',
                    },
                    {
                        name: '木垒哈萨克自治县',
                        code: '652328',
                    },
                ],
            },
            {
                name: '博尔塔拉蒙古自治州',
                code: '652700',
                children: [
                    {
                        name: '博乐市',
                        code: '652701',
                    },
                    {
                        name: '阿拉山口市',
                        code: '652702',
                    },
                    {
                        name: '精河县',
                        code: '652722',
                    },
                    {
                        name: '温泉县',
                        code: '652723',
                    },
                ],
            },
            {
                name: '巴音郭楞蒙古自治州',
                code: '652800',
                children: [
                    {
                        name: '库尔勒市',
                        code: '652801',
                    },
                    {
                        name: '轮台县',
                        code: '652822',
                    },
                    {
                        name: '尉犁县',
                        code: '652823',
                    },
                    {
                        name: '若羌县',
                        code: '652824',
                    },
                    {
                        name: '且末县',
                        code: '652825',
                    },
                    {
                        name: '焉耆回族自治县',
                        code: '652826',
                    },
                    {
                        name: '和静县',
                        code: '652827',
                    },
                    {
                        name: '和硕县',
                        code: '652828',
                    },
                    {
                        name: '博湖县',
                        code: '652829',
                    },
                    {
                        name: '库尔勒经济技术开发区',
                        code: '652871',
                    },
                ],
            },
            {
                name: '阿克苏地区',
                code: '652900',
                children: [
                    {
                        name: '阿克苏市',
                        code: '652901',
                    },
                    {
                        name: '库车市',
                        code: '652902',
                    },
                    {
                        name: '温宿县',
                        code: '652922',
                    },
                    {
                        name: '沙雅县',
                        code: '652924',
                    },
                    {
                        name: '新和县',
                        code: '652925',
                    },
                    {
                        name: '拜城县',
                        code: '652926',
                    },
                    {
                        name: '乌什县',
                        code: '652927',
                    },
                    {
                        name: '阿瓦提县',
                        code: '652928',
                    },
                    {
                        name: '柯坪县',
                        code: '652929',
                    },
                ],
            },
            {
                name: '克孜勒苏柯尔克孜自治州',
                code: '653000',
                children: [
                    {
                        name: '阿图什市',
                        code: '653001',
                    },
                    {
                        name: '阿克陶县',
                        code: '653022',
                    },
                    {
                        name: '阿合奇县',
                        code: '653023',
                    },
                    {
                        name: '乌恰县',
                        code: '653024',
                    },
                ],
            },
            {
                name: '喀什地区',
                code: '653100',
                children: [
                    {
                        name: '喀什市',
                        code: '653101',
                    },
                    {
                        name: '疏附县',
                        code: '653121',
                    },
                    {
                        name: '疏勒县',
                        code: '653122',
                    },
                    {
                        name: '英吉沙县',
                        code: '653123',
                    },
                    {
                        name: '泽普县',
                        code: '653124',
                    },
                    {
                        name: '莎车县',
                        code: '653125',
                    },
                    {
                        name: '叶城县',
                        code: '653126',
                    },
                    {
                        name: '麦盖提县',
                        code: '653127',
                    },
                    {
                        name: '岳普湖县',
                        code: '653128',
                    },
                    {
                        name: '伽师县',
                        code: '653129',
                    },
                    {
                        name: '巴楚县',
                        code: '653130',
                    },
                    {
                        name: '塔什库尔干塔吉克自治县',
                        code: '653131',
                    },
                ],
            },
            {
                name: '和田地区',
                code: '653200',
                children: [
                    {
                        name: '和田市',
                        code: '653201',
                    },
                    {
                        name: '和田县',
                        code: '653221',
                    },
                    {
                        name: '墨玉县',
                        code: '653222',
                    },
                    {
                        name: '皮山县',
                        code: '653223',
                    },
                    {
                        name: '洛浦县',
                        code: '653224',
                    },
                    {
                        name: '策勒县',
                        code: '653225',
                    },
                    {
                        name: '于田县',
                        code: '653226',
                    },
                    {
                        name: '民丰县',
                        code: '653227',
                    },
                ],
            },
            {
                name: '伊犁哈萨克自治州',
                code: '654000',
                children: [
                    {
                        name: '伊宁市',
                        code: '654002',
                    },
                    {
                        name: '奎屯市',
                        code: '654003',
                    },
                    {
                        name: '霍尔果斯市',
                        code: '654004',
                    },
                    {
                        name: '伊宁县',
                        code: '654021',
                    },
                    {
                        name: '察布查尔锡伯自治县',
                        code: '654022',
                    },
                    {
                        name: '霍城县',
                        code: '654023',
                    },
                    {
                        name: '巩留县',
                        code: '654024',
                    },
                    {
                        name: '新源县',
                        code: '654025',
                    },
                    {
                        name: '昭苏县',
                        code: '654026',
                    },
                    {
                        name: '特克斯县',
                        code: '654027',
                    },
                    {
                        name: '尼勒克县',
                        code: '654028',
                    },
                ],
            },
            {
                name: '塔城地区',
                code: '654200',
                children: [
                    {
                        name: '塔城市',
                        code: '654201',
                    },
                    {
                        name: '乌苏市',
                        code: '654202',
                    },
                    {
                        name: '额敏县',
                        code: '654221',
                    },
                    {
                        name: '沙湾县',
                        code: '654223',
                    },
                    {
                        name: '托里县',
                        code: '654224',
                    },
                    {
                        name: '裕民县',
                        code: '654225',
                    },
                    {
                        name: '和布克赛尔蒙古自治县',
                        code: '654226',
                    },
                ],
            },
            {
                name: '阿勒泰地区',
                code: '654300',
                children: [
                    {
                        name: '阿勒泰市',
                        code: '654301',
                    },
                    {
                        name: '布尔津县',
                        code: '654321',
                    },
                    {
                        name: '富蕴县',
                        code: '654322',
                    },
                    {
                        name: '福海县',
                        code: '654323',
                    },
                    {
                        name: '哈巴河县',
                        code: '654324',
                    },
                    {
                        name: '青河县',
                        code: '654325',
                    },
                    {
                        name: '吉木乃县',
                        code: '654326',
                    },
                ],
            },
            {
                name: '自治区直辖县级行政区划',
                code: '659000',
                children: [
                    {
                        name: '石河子市',
                        code: '659001',
                    },
                    {
                        name: '阿拉尔市',
                        code: '659002',
                    },
                    {
                        name: '图木舒克市',
                        code: '659003',
                    },
                    {
                        name: '五家渠市',
                        code: '659004',
                    },
                    {
                        name: '北屯市',
                        code: '659005',
                    },
                    {
                        name: '铁门关市',
                        code: '659006',
                    },
                    {
                        name: '双河市',
                        code: '659007',
                    },
                    {
                        name: '可克达拉市',
                        code: '659008',
                    },
                    {
                        name: '昆玉市',
                        code: '659009',
                    },
                    {
                        name: '胡杨河市',
                        code: '659010',
                    },
                ],
            },
        ],
    },
];

// 常用功能路由匹配
const COMMON_FUNCTION_ROUTER_URL = {
    PERMISSION_CUSTOMER: '/main-operations/customers', // 客户	客户
    PERMISSION_ORDER: 'main-operations/sitDownOrder', // 订单	堂食订单
    PERMISSION_ORDER_SELF_AND_DELIVER: 'main-operations/pickUpDistributionOrder', // 订单	自提配送订单
    PERMISSION_ORDER_THIRD_PLATFORM: 'main-operations/thirdOrder', // 订单	三方订单
    PERMISSION_ORDER_PRODUCT_RESERVE: 'main-operations/productAppointmentOrder', // 订单	商品预约订单
    PERMISSION_ORDER_SHOP: 'main-operations/productMallOrder', // 订单	商城订单
    PERMISSION_ORDER_PRODUCT_SCAN_CODE: 'main-operations/scanOrder', // 订单	扫码订单
    /** 接单异常 */
    PERMISSION_EXCEPTION_ORDER_ACCEPT: 'main-operations/abnormalOrders', // 订单	扫码订单
    /** 配送异常 */
    PERMISSION_EXCEPTION_ORDER_FULFILL: 'main-operations/abnormalOrders', // 订单	扫码订单
    /** 支付异常 */
    PERMISSION_EXCEPTION_ORDER_PAY: 'main-operations/abnormalOrders', // 订单	扫码订单
    /**储值异常 */
    PERMISSION_EXCEPTION_DEPOSIT_ORDER: 'main-operations/abnormalOrders', // 订单	扫码订单
    PERMISSION_AFTER_SALE_CARD_ORDER: 'main-operations/cardCouponAfterSalesOrders', // 卡券售后订单
    PERMISSION_CARD_ORDER: 'main-operations/cardorders', // 订单 卡订单
    /** 总部收银 */
    PERMISSION_POS_WEB_CASHIER_PRINT_RULE: '/main-operations/cashierRules',
    /** 门店收银 */
    PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH: '/main-operations/cashierRules',
    /** 总部后厨 */
    PERMISSION_POS_WEB_KITCHEN_PRINT_RULE: '/main-operations/kitchenRules',
    /** 门店后厨 */
    PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH: '/main-operations/kitchenRules',
    /** 总部标签 */
    PERMISSION_POS_WEB_LABEL_PRINT_RULE: '/main-operations/tagRules',
    /** 门店标签 */
    PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH: '/main-operations/tagRules',
    PERMISSION_POS_WEB_POS_TERMINAL: '/main-operations/equipmentSettings', // POS设备	POS后台
    PERMISSION_TV_DEVICE: '/main-operations/tvScreenDevice', // TV屏设备
    PERMISSION_KDS_DEVICE: '/main-operations/kdsDeviceManagement', // KDS设备管理
    PERMISSION_PRINT_DEVICE: '/main-operations/printerManagement', // 打印机管理
    /** 设备分组管理 */
    PERMISSION_DEVICE_GROUP: '/main-operations/cloud-speaker/cloud-speaker-group',
    /** 语音播报规则 */
    PERMISSION_VOICE_BROADCAST_RULE: '/main-operations/cloud-speaker/cloud-speaker-rule',
    /** 门店设备分组详情 */
    PERMISSION_DEVICE_GROUP_DETAIL: '/main-operations/cloud-speaker/cloud-speaker-group?tab=storeDetail',
    /** 门店语音播放设置详情 */
    PERMISSION_VOICE_BROADCAST_DETAIL: '/main-operations/cloud-speaker/cloud-speaker-rule?tab=storeDetail',
    PERMISSION_SETTING_LOCATION_DUPLICATE: '/main-operations/locationCopy', // 门店复制
    PERMISSION_POS_WEB_PRODUCT: '/main-operations/pos/product', // 商品	POS后台
    PERMISSION_POS_WEB_STAFF: '/main-operations/staffManagement', // POS角色	POS后台
    PERMISSION_POS_WEB_MEMO: '/main-operations/posRemark', // 备注	POS后台
    // 折扣减免
    PERMISSION_POS_WEB_FAST_DISCOUNT: '/main-operations/promotion/discountSetting', // 备注	POS后台
    PERMISSION_POS_SECOND_DISPLAY_SETTING: '/main-operations/screenSetting',
    PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING: '/main-operations/screenSetting', // 轮播图文案
    PERMISSION_PRODUCT: '/product/product-standard', // 菜品库
    PERMISSION_PRODUCT_COLLECT: '/main-operations/goods/collections', // 系列	商品
    PERMISSION_PRODUCT_INCOME_SUBJECT: '/main-operations/goods/incomeSubject', // 收入科目
    PERMISSION_PRODUCT_INVENTORY: '/main-operations/goods/inventory', // 库存	商品
    PERMISSION_PRODUCT_INVENTORY_LOG: '/main-operations/goods/detailLogInventory', // 库存变动明细	商品
    PERMISSION_PRODUCT_INVENTORY_SYNC: '/main-operations/goods/stockSync', // 库存同步	商品
    PERMISSION_SETTING_ACCOUNT: '/main-operations/userManagement', // 账号管理	设置
    PERMISSION_SETTING_MERCHANT_SETTING: '/main-operations/settings/generalSettings', // 店铺信息 设置
    PERMISSION_SETTING_VALIE_ADD: '/main-serviceMarket/equityAccountList', // 增值服务-短信
    PERMISSION_SETTING_FILES: '/main-operations/fileSettings', // 素材中心	设置
    PERMISSION_SERVICE_MARKET: '/main-serviceMarket/settings/lemonServices', // 乐檬服务-服务市场  设置
    PERMISSION_SERVICE_FINANCE: '/main-serviceMarket/expense/order', // 服务市场-费用订单
    PERMISSION_INVOICE_MANAGEMENT: '/main-serviceMarket/expense/invoice', // 服务市场-发票管理
    PERMISSION_SETTING_LOCATION: '/main-operations/settings/locations', // 门店	设置
    PERMISSION_SETTING_LOCATION_TAG: '/main-operations/settings/locations?tabName:tag', // 门店标签	设置
    PERMISSION_SETTING_NOTIFY: '/main-operations/notifySettings', // 通知	设置
    PERMISSION_SETTING_PAY: '/main-operations/settings/payType', // 收款	设置
    PERMISSION_SETTING_ROLE: '/main-operations/userRole', // 角色管理	设置
    PERMISSION_SETTING_SHIPPING_COMMON: '/main-operations/operatingParameter', // 门店设置	通用设置
    PERMISSION_SETTING_SHIPPING_TABLE: '/main-operations/stagepositionSettings', // 门店设置	台位设置
    PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE: '/main-operations/queueSettings', // 门店设置	排队设置
    // PERMISSION_SETTING_TAKE_SCREEN : 'admin/settings/takeScreenSettings', // 取餐屏设置	设置
    PERMISSION_PROMOTION_POINT_EXCHANGE: '/main-operations/marketingActivities/creditExchangeList', // 积分兑换 *
    PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY: '/main-operations/marketingActivities/creditExchangeList?tab:0', // 积分兑换活动
    PERMISSION_PROMOTION_POINT_EXCHANGE_LOG: '/main-operations/marketingActivities/creditExchangeList?tab:1', // 积分兑换记录
    PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY: '/main-operations/marketingActivities/creditExchangeList?tab:0', // 积分兑换参数
    PERMISSION_PROMOTION_COLLECT_STAMP: '/main-operations/crm/marketingActivities/collectStampList', // 集点卡
    PERMISSION_AFTER_SALE_ORDER: '/main-operations/afterSaleOrders', // 订单	售后订单
    PERMISSION_ORDER_EVALUATION: '/main-operations/orderComment', // 订单评价
    PERMISSION_ORDER_EVALUATION_ANALYZE: '/main-operations/commentsAnalysis', //评价分析
    PERMISSION_SETTING_PRINT_MERCHANR: '/main-operations/posPrintSetting', // 票据商户模板	设置
    PERMISSION_SETTING_PRINT_LOCATION: '/main-operations/posPrintSetting', // 门店打印设置	设置
    // PERMISSION_POS_WEB_PRINT_ORDER : 'admin/pos/printSort', // pos打印排序
    PERMISSION_POS_WEB_PRINT_ORDER: '/main-operations/posPrintSort', // pos打印排序
    // PERMISSION_PLAN_INVENTORY : 'admin/planInventory', // 计划库存
    PERMISSION_PLAN_INVENTORY: '/main-operations/goods/planInventory', // 计划库存
    PERMISSION_PRODUCT_TYPE_LOCATION: '/product/product-category-location', //门店菜品分类
    PERMISSION_PRODUCT_OPTION_LOCATION_VARAINT: '/main-operations/goods/storeAttribute?tab:VARIANT', //门店菜品属性-规格
    PERMISSION_PRODUCT_OPTION_LOCATION_METHOD: '/main-operations/goods/storeAttribute?tab:METHOD', //门店菜品属性-做法
    PERMISSION_PRODUCT_OPTION_LOCATION_ADD: '/main-operations/goods/storeAttribute?tab:FEED', //门店菜品属性-加料
    PERMISSION_PRODUCT_UNIT_LOCATION_UNIT: '/main-operations/goods/storeAttribute?tab:UNIT', //门店菜品属性-单位
    PERMISSION_PRODUCT_KIT_LOCATION: '/main-operations/storeCombo',
    PERMISSION_PRODUCT_LOCATION: '/product/product-standard-location', // 门店菜品管理
    /** 微店铺 */
    PERMISSION_WESTORE_PRODUCT: '/main-operations/weapp/product', // 商品	微店铺
    PERMISSION_WESTORE_DECORATION: '/main-operations/weapp/decorateNavigation', // 店铺装修
    PERMISSION_WESTORE_ADVICE_FEEDBACK_LIST: '/main-operations/weapp/adviceFeedbacks', // 建议反馈列表
    PERMISSION_WESTORE_ADVICE_FEEDBACK_SET: '/main-operations/weapp/adviceFeedbacks?tabName:setting', // 建议反馈设置
    /** 店铺装修 start */
    PERMISSION_WESTORE_SHOP_DECORATION_FEATURE: 'decorate/shoppage/merchantPage', // 店铺页面
    PERMISSION_WESTORE_SHOP_DECORATION_TAXON_TEMPLATE: 'decorate/shoppage/sortpage', // 分类模板
    PERMISSION_WESTORE_SHOP_DECORATION_LISTING_TEMPLATE: 'decorate/shoppage/listpage', // 列表模板
    PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_CONTENT: 'decorate/shoppage/contentManage', // 内容管理
    PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_PAGE_TEMPLATE: 'decorate/shoppage/goodspage', // 商品页模板
    PERMISSION_WESTORE_SHOP_DECORATION_KIT_DETAIL: 'decorate/shoppage/packagePage', // 套餐页面装修
    PERMISSION_WESTORE_SHOP_DECORATION_NAVIGATION: 'decorate/shoppage/storeNavigationPage', // 店铺导航
    PERMISSION_WESTORE_SHOP_DECORATION_PERSONAL_CENTER_PAGE: 'decorate/shoppage/userCenterPage', // 用户中心
    PERMISSION_WESTORE_SHOP_DECORATION_MEMBER_STORED_VALUE: 'decorate/shoppage/memberStoredValue', // 会员储值
    PERMISSION_WESTORE_SHOP_DECORATION_ORDER_LIST: 'decorate/shoppage/orderList', //订单列表
    PERMISSION_WESTORE_SHOP_DECORATION_SEARCH_PAGE: 'decorate/shoppage/searchPages', // 搜索页
    PERMISSION_WESTORE_SHOP_DECORATION_COPYRIGHT_LOGO: 'decorate/shoppage/copyrightLogo', // 版权logo
    PERMISSION_WESTORE_SHOP_DECORATION_CUSTOM_COMPONENT: 'decorate/shoppage/customizPage', //自定义模块
    PERMISSION_WESTORE_SHOP_DECORATION_FLOATING_WINDOW: 'decorate/shoppage/floatingWindows', // 悬浮窗
    PERMISSION_WESTORE_SHOP_DECORATION_POINT_EXCHANGE_SHOP: 'decorate/shoppage/pointShops', // 积分商城
    PERMISSION_WESTORE_CARD_SHARING: 'decorate/shoppage/sharePage', //分享页
    PERMISSION_WESTORE_SHOP_LOADING_ANIMATION: 'decorate/shoppage/customLoading', //加载动画
    PERMISSION_WESTORE_SHOP_DECORATION_TABLE_MEAL: 'PERMISSION_WESTORE_SHOP_DECORATION_TABLE_MEAL', // 台位点餐
    PERMISSION_WESTORE_SHOP_DECORATION_MP_PAGE: 'decorate/shoppage/appletPage', //小程序页面
    PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_RESERVE: 'decorate/shoppage/productPreOrder', // 商品预订
    /** 店铺装修 end */
    /** 微信小程序 授权设置 */
    PERMISSION_WESTORE_WECHAT_MP_AUTH_SETTING: '/main-operations/weapp/decorateNavigation',
    PERMISSION_WESTORE_SHOP_DECORATION_PERSONAL_CENTER: 'decorate/shoppage/userCenterPage', // 个人中心	微店铺
    PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT: 'decorate/shoppage/contentManage', // 商品装修	微店铺
    PERMISSION_WESTORE_SHOP_DECORATION_SHOP_STYLE: 'decorate/shoppage/systemStyle', // 全店风格	微店铺
    PERMISSION_WESTORE_WECHAT_MP: 'PERMISSION_WESTORE_WECHAT_MP', // 微信小程序	微店铺
    PERMISSION_POS_WEB_ROLE: '/main-operations/staffRole', // POS角色	POS后台
    PERMISSION_PRODUCT_OPTION_VARAINT: '/main-operations/goods/goodsAttribute?tab:VARIANT', // 菜品属性-规格
    PERMISSION_PRODUCT_OPTION_METHOD: '/main-operations/goods/goodsAttribute?tab:METHOD', // 菜品属性-做法
    PERMISSION_PRODUCT_OPTION_ADD: '/main-operations/goods/goodsAttribute?tab:FEED', // 菜品属性-加料
    /** 菜品属性-包装盒 */
    PERMISSION_PACKAGE_BOX: '/main-operations/goods/goodsAttribute?tab:BOX',
    /** 菜品属性-单位 */
    PERMISSION_PRODUCT_UNIT: '/main-operations/goods/goodsAttribute?tab:UNIT',
    /** 菜品属性-标签 */
    PERMISSION_PRODUCT_CORNER_MARK: '/main-operations/goods/goodsAttribute?tab:LABEL',
    PERMISSION_PRODUCT_TYPE: '/product/product-category', // 菜品分类
    PERMISSION_ANALYZE_CUSTOMER_MEMBER_DATA: '/main-report/vip-data-report', // 分析 会员数据一览
    PERMISSION_WESTORE_TRAFFIC_OVERVIEW: '/main-report/mall-traffic-overview-report', // 分析 商城流量概况
    PERMISSION_ANALYZE_POS_STAFF: '/main-report/salesperson-statistics-report', // 分析 销售员分析
    PERMISSION_ANALYZE_DEPOSIT: '/main-report/deposit-report', // 分析 储值分析
    PERMISSION_ANALYZE_CONSUMPTION_ANALYSIS: '/main-report/consumption-analysis', // 分析 消费分析
    PERMISSION_ANALYZE_BUSINESS_DISCOUNT: '/main-report/business-discount-report', // 营业优惠
    PERMISSION_ANALYZE_BUSINESS_REFUND_STATISTICS: '/main-report/business-refund-statistic', // 营业退款
    PERMISSION_ANALYZE_BUSINESS_PAYMENT: '/main-report/business-payment-report', // 营业收入构成
    PERMISSION_ANALYZE_BUSINESS_INCOME_DISCOUNT: '/main-report/business-income-discount-report', // 收入优惠统计
    PERMISSION_ANALYZE_BUSINESS_DETAIL: '/main-report/business-detail-report', // 营业明细
    PERMISSION_ANALYZE_CATEGORY_SALES_RANKING: '/main-report/category-sales-ranking-report', // 类别销售排行
    PERMISSION_ANALYZE_PRODUCT_SALES_RANKING: '/main-report/product-sales-ranking-report', // 商品销售排行
    PERMISSION_ANALYZE_PRODUCT_SALES_SUMMARY: '/main-report/product-sales-summary-report', // 商品销售汇总
    PERMISSION_ANALYZE_PRODUCT_SALES_DETAIL: '/main-report/product-sales-details-report', // 商品销售明细
    PERMISSION_ANALYZE_BUSINESS_RECEIPT_STATISTICS: '/main-report/business-receipt-statistics', // 营业收款统计
    PERMISSION_ANALYZE_BUSINESS_RECEIPT_DETAIL: '/main-report/business-receipt-detail', // 营业收款明细
    PERMISSION_ANALYZE_CASHIER_STATISTICS: '/main-report/cashier-statistics', // 收银员统计
    PERMISSION_ANALYZE_GIFT_CARD: '/main-report/gift-card-analysis',
    PERMISSION_ANALYZE_RIGHT_CARD: '/main-report/equity-card-stat',
    PERMISSION_ANALYZE_TICKET_PACKAGE_SALE: '/main-report/ticket-package-sale-statistics',
    PERMISSION_ANALYZE_TICKET: '/main-report/coupon-template-analysis',
    PERMISSION_ANALYZE_TICKET_INCOME_STATISTICS: '/main-report/ticket-income-statistics-report',
    PERMISSION_ANALYZE_POINT: '/main-report/point-analysis-report',
    PERMISSION_ANALYZE_GIFT_CARD_BALANCE_LOG: '/main-report/gift-card-balance-log',
    PERMISSION_ANALYZE_SHIFT_HANDOVER_STATISTICS: '/main-report/shift-handover-statistics', // 交班统计
    PERMISSION_ANALYZE_SALES_CONSUMPTION: '/main-report/sales-consumption', // 原材料销售消耗报
    PERMISSION_ANALYZE_EXPRESS_MALL_STATISTICS: '/main-report/express-mall-statistics', // 快递商城统计
    PERMISSION_ANALYZE_ORDER_BUSINESS_REPORT_ANALYSIS: '/main-report/channel-business-statistics-report',
    PERMISSION_ANALYZE_TABLE_BUSINESS_STATISTICS: '/main-report/table-business-statistics-report',
    /**营业概览 */
    PERMISSION_ANALYZE_BUSINESS_OVERVIEW: '/main-report/busincess-analysis-report',
    /**营业统计 */
    PERMISSION_ANALYZE_BUSINESS_STATISTICS: '/main-report/business-statistics-report',
    /**商品分析 */
    PERMISSION_ANALYZE_PRODUCT_SUMMARY: '/main-report/product-summary-statistics',
    /**营业收款对账 */
    PERMISSION_ANALYZE_BUSINESS_PAY_VERIFY: '/main-report/business-collection-reconciliation',
    /**营业外统计 */
    PERMISSION_ANALYZE_BUSINESS_BEYOND_STATISTICS: '/main-report/business-beyond-statistic',
    /** 商品门店销售分析 */
    PERMISSION_ANALYZE_PRODUCT_LOCATION_SALES: '/main-report/product-location-sales-report',
    /**用户业绩 */
    PERMISSION_ANALYZE_CUSTOMER_PERFORMANCE: '/main-report/customer-performance',
    /**会员复购汇总 */
    PERMISSION_ANALYZE_CUSTOMER_REPURCHASE: '/main-report/customer-repurchase',
    /**会员商品复购 */
    PERMISSION_ANALYZE_CUSTOMER_REPURCHASE_PRODUCT_DETAIL: '/main-report/customer-repurchase-product',
    /**会员消费占比 */
    PERMISSION_ANALYZE_CUSTOMER_CONSUME_RATE: '/main-report/customer-consume-ratio',
    /**卡券销售明细 */
    PERMISSION_ANALYZE_BUSINESS_CARD_ORDER_DETAIL_ANALYSIS: '/main-report/card-sales-detail',
    /**商品成本毛利 */
    PERMISSION_ANALYZE_PRODUCT_COST_GROSS: '/main-report/product-cost-gross',
    /** 三方对账结果明细 */
    PERMISSION_OMS_RECONCILE_DETAIL: '/main-report/third-party-reconciliation-result-detail',
    /** 三方对账结果汇总 */
    PERMISSION_OMS_RECONCILE_SUMMARY: '/main-report/third-party-reconciliation-result-summary',
    /** 三方对账日历 */
    // PERMISSION_OMS_RECONCILE_CALENDAR: '/main-report/third-party-reconciliation-calendar',
    /** 挂账明细 */
    PERMISSION_ANALYZE_SIGN_PAYMENT_DETAIL: '/main-report/sign-payment-detail',
    /** 订金/押金统计 */
    PERMISSION_ANALYZE_DOWN_PAYMENT: '/main-report/deposit-pledge-statistics',
    /** 注册有礼 */
    PERMISSION_APP_GIFT_GET_CARD: '/main-operations/crm/marketingActivities/collectCard', // 注册有礼
    /** 消费有礼 */
    PERMISSION_APP_GIFT_CONSUME: '/main-operations/crm/marketingActivities/giftConsume', // 消费有礼
    /** 储值活动 */
    PERMISSION_APP_GIFT_DEPOSIT: '/main-operations/crm/marketingActivities/giftDeposit', // 储值活动
    /** 升级有礼 */
    PERMISSION_APP_GIFT_LEVEL_UP: '/main-operations/crm/marketingActivities/giftLevel', // 升级有礼
    /** 条件标签 */
    PERMISSION_CUSTOMER_CONDITION_TAG: '/main-operations/customer-group?tab:condition', // 条件标签
    /** 系统标签 */
    PERMISSION_CUSTOMER_SYSTEM_TAG: '/main-operations/customer-group?tab:system', // 系统标签
    /** 手动标签 */
    PERMISSION_CUSTOMER_MANUAL_TAG: '/main-operations/tags?tab:manual', // 手动标签
    /** 等级会员卡 */
    PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD: '/main-operations/vip', // 等级会员卡
    /** 等级会员卡等级规则 */
    PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD_LEVEL_RULE: '/main-operations/vip', // 等级会员卡等级规则
    /** 等级会员卡成长值 */
    PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD_GROWTH: '/main-operations/vip', // 等级会员卡成长值
    /** 会员权益库 */
    PERMISSION_CUSTOMER_MEMBER_RIGHT: '/main-operations/vip?tab:1', // 会员权益库
    /** 积分管理 */
    PERMISSION_CUSTOMER_ASSET_POINT_MGR: '/main-operations/point',
    /** 储值管理 */
    PERMISSION_CUSTOMER_ASSET_DEPOSIT_MGR: '/main-operations/deposit', // 储值管理
    /** 退余额管理 */
    PERMISSION_CUSTOMER_BALANCE_REFUND_ORDER: '/main-operations/deposit?tab:1', // 退余额管理
    /** 优惠券 */
    PERMISSION_DISCOUNT_TICKET: '/main-operations/marketingActivities/discounts', // 优惠券
    /** 满减满折 */
    PERMISSION_DISCOUNT_FULL_REDUCE: '/main-operations/promotion/marketingActivities/fullReduce', // 满减满折
    /** 拼团 */
    PERMISSION_PROMOTION_GROUP_BUYING: '/main-operations/crm/marketingActivities/groupBuying', // 拼团
    /** 限时折扣 */
    PERMISSION_APP_LIMIT_TIME_DISCOUNT: '/main-operations/promotion/marketingActivities/timeLimitDiscount', // 限时折扣
    /** 元字段 */
    PERMISSION_SETTING_METAFIELD: '/main-operations/settings/metaField',
    /**客单分析报表 */
    PERMISSION_ANALYZE_CUSTOMER_ORDER_PRICE: '/main-report/customer-price-report',
    /** 促销活动效果分析 */
    PERMISSION_ANALYZE_DISCOUNT_EFFECT: '/main-report/promotion-effect-analysis',
    /** 营销活动效果分析 */
    PERMISSION_ANALYZE_DISCOUNT_PROMOTION: '/main-report/marketing-activity-effect-analysis',
    /** 零销量菜品分析 */
    PERMISSION_ANALYZE_PRODUCT_ZERO_SALE: '/main-report/zero-sales-product-report',
    /** 菜品关联推荐 */
    PERMISSION_ANALYZE_PRODUCT_RELATE_SUGGEST: '/main-report/product-association-recommendation',
    /**平台订单分析 */
    PERMISSION_ANALYZE_CUSTOMER_PHONE_ANALYSIS: '/main-report/platform-order-report',
    /**客户储值明细报表 */
    PERMISSION_ANALYZE_CUSTOMER_DEPOSIT_DETAIL_ANALYSIS: '/main-report/customer-stored-value-report',
    /**会员扣款明细报表 */
    PERMISSION_ANALYZE_CUSTOMER_CONSUME_DETAIL_ANALYSIS: '/main-report/customer-deduction-report',
    /**储值消费店间结算  */
    PERMISSION_ANALYZE_CROSS_LOCATION_CONSUME: '/main-report/customer-consume-analysis',
    /**储值支付方式明细报表 */
    PERMISSION_ANALYZE_DEPOSIT_PAYMENT_TYPE_DETAIL_ANALYSIS: '/main-report/deposite-payment-method-detail',
    /** 群接龙 */
    PERMISSION_DISCOUNT_GROUP_RELAY: '/main-operations/crm/marketingActivities/groupRelay',
    /**抽奖有礼 */
    PERMISSION_GIFT_LUCKY_DRAW: '/main-operations/crm/marketingActivities/luckyDraw',
    /**随机立减 */
    PERMISSION_DISCOUNT_RANDOM_REDUCE: '/main-operations/promotion/marketingActivities/randomFullReduce',
    /**推荐加购 */
    PERMISSION_DISCOUNT_RECOMMEND_PURCHASE: '/main-operations/crm/marketingActivities/recommendAddPurchase',
    /**优惠买单 */
    PERMISSION_DISCOUNT_SCAN_CODE_PAY: '/main-operations/promotion/marketingActivities/discountedBuying',
    /**消息群发 */
    PERMISSION_PROMOTION_SMS_GROUP_SEND: '/main-operations/marketingActivities/smsGroupSend',
    /**N元任选 */
    PERMISSION_DISCOUNT_ANY_CHOICE: '/main-operations/promotion/marketingActivities/anyChoice',
    /** 第二件半价 */
    PERMISSION_APP_SECOND_HALF_DISCOUNT: 'main-operations/promotion/marketingActivities/secondHalf',
    /** 授权管理 */
    PERMISSION_OMS_EL_AUTHROIZE_MANAGE: '/main-operations/oms/elm/manager',
    /** 饿了吗 门店设置 */
    PERMISSION_OMS_EL_LOCATION_SET: '/main-operations/oms/elm/settings',
    /** 饿了吗 门店商品 */
    PERMISSION_OMS_EL_LOCATION_PRODUCT: '/main-operations/oms/elm/settings',
    /**  美团外卖 授权管理 */
    PERMISSION_OMS_MT_AUTHROIZE_MANAGE: '/main-operations/oms/mt/manager',
    /** 美团外卖 门店商品 */
    PERMISSION_OMS_MT_LOCATION_PRODUCT: '/main-operations/oms/mt/product',
    // PERMISSION_OMS_MT_LOCATION_PRODUCT : 'admin/oms/mt/product',
    /**  美团外卖 授权管理 */
    PERMISSION_OMS_JD_AUTHROIZE_MANAGE: 'admin/oms/jd/manager',
    /** 美团外卖 门店商品 */
    PERMISSION_OMS_JD_LOCATION_PRODUCT: 'admin/oms/jd/product',
    /** 淘宝闪购·零售授权管理 */
    PERMISSION_OMS_EB_AUTHROIZE_MANAGE: '/main-operations/oms/ebls/manager',
    /** 淘宝闪购·零售门店列表 */
    PERMISSION_OMS_EB_LOCATION_SET: '/main-operations/oms/ebls/settings',
    /** 淘宝闪购·零售门店商品 */
    PERMISSION_OMS_EB_LOCATION_PRODUCT: '/main-operations/oms/ebls/product',
    /** 抖音外卖授权管理 */
    PERMISSION_OMS_TIKTOK_AUTHROIZE_MANAGE: '/main-operations/oms/dy/manager',
    /** 抖音外卖门店列表 */
    PERMISSION_OMS_TIKTOK_LOCATION_SET: '/main-operations/oms/dy/location',
    /** 抖音外卖门店商品 */
    PERMISSION_OMS_TIKTOK_LOCATION_PRODUCT: '/main-operations/oms/dy/product',
    /** 抖音自助核销授权管理 */
    PERMISSION_OMS_TIKTOK_SELF_CHECK_AUTHROIZE_MANAGE: '/main-operations/oms/tiktokSelf/manager',
    /** 抖音自助核销门店列表 */
    PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_SET: '/main-operations/oms/tiktokSelf/location',
    /** 抖音自助核销门店商品 */
    PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_PRODUCT: '/main-operations/oms/tiktokSelf/product',
    /**系统日志 */
    PERMISSION_SET_SYSTEM_LOG: '/main-operations/systemLog',
    /** 定时赠券 */
    PERMISSION_PROMOTION_TIMED_GIFT_TICKET: '/main-operations/crm/marketingActivities/sendDiscount',
    /** 满赠 */
    PERMISSION_DISCOUNT_FULL_GIFT: '/main-operations/promotion/marketingActivities/fullGifts',
    /** 加价购 */
    PERMISSION_DISCOUNT_MARK_UP_PURCHASE: '/main-operations/promotion/marketingActivities/markUpPurchase',
    /** 签到有礼 */
    PERMISSION_PROMOTION_GIFT_SIGN_IN: '/main-operations/crm/marketingActivities/giftSignIn',
    /** 好友裂变 */
    PERMISSION_PROMOTION_CUSTOMER_FISSION: '/main-operations/crm/marketingActivities/friendFission',
    /** 礼品卡 */
    PERMISSION_PROMOTION_GIFT_CARD: '/main-operations/marketingActivities/giftCard',
    /**生日有礼 */
    PERMISSION_APP_GIFT_BIRTHDAY: '/main-operations/crm/marketingActivities/giftBirthday',
    /**广告管理 */
    PERMISSION_PROMOTION_AD_MGR: '/main-operations/crm/marketingActivities/advertisingList',
    /** 首屏启动页 */
    PERMISSION_WESTORE_SHOP_DECORATION_BOOT_PAGE: 'decorate/shoppage/bootPage',
    /** 礼品卡 */
    PERMISSION_WESTORE_SHOP_DECORATION_GIFT_CARD: 'decorate/shoppage/giftCards',
    /** 领券中心 */
    PERMISSION_WESTORE_SHOP_DECORATION_GET_TICKET_CENTER: 'decorate/shoppage/receiveCouponCenter',
    /** 集点卡 */
    PERMISSION_WESTORE_SHOP_DECORATION_COLLECT_STAMP: 'decorate/shoppage/collectStamp',
    /** 限时折扣 */
    PERMISSION_WESTORE_SHOP_DECORATION_LIMITED_DISCOUNT: 'decorate/shoppage/limitedDiscount',
    /** 抽奖有礼 */
    PERMISSION_WESTORE_SHOP_DECORATION_GIFT_LUCKY_DRAW: 'decorate/shoppage/giftLuckyDraw',
    /**  "礼品卡主题"*/
    PERMISSION_PROMOTION_GIFT_CARD_THEME: '/main-operations/marketingActivities/giftCard?tab:themes',
    /**  礼品卡模板*/
    PERMISSION_PROMOTION_GIFT_CARD_TMPL: '/main-operations/marketingActivities/giftCard',
    /** 礼品卡信息 */
    PERMISSION_PROMOTION_GIFT_CARD_INFO: '/main-operations/marketingActivities/giftCard?tab:info',
    /** 批量制卡 */
    PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER: '/main-operations/marketingActivities/giftCard?tab:batch',
    /**小程序推广 */
    PERMISSION_WESTORE_WECHAT_MP_PAGE_QR_CODE: '/main-operations/weapp/popularize',
    /** 公众号设置 */
    PERMISSION_WESTORE_WECHAT_MP_OFFICIAL_ACCOUNT: '/main-operations/weapp/public',
    /** RFM分析 */
    PERMISSION_CUSTOMER_RFM_REPORT: '/main-operations/RFMAnalysis',
    /** 数据定义 */
    PERMISSION_CUSTOMER_CUSTOM_CONDITION: '/main-operations/dataDefinition',
    /** 用户画像 */
    PERMISSION_CUSTOMER_PERSONA: '/main-operations/userPortrait',
    /** 弹窗发券 */
    PERMISSION_PROMOTION_POPUP_TICKET_MGR: '/main-operations/crm/marketingActivities/popUpCoupons',
    /** 用户画像 */
    PERMISSION_PROMOTION_RIGHT_CARD: '/main-operations/marketingActivities/equityCard',
    /** 领券活动 */
    PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY: '/main-operations/crm/marketingActivities/getDiscount',
    /** 推荐菜品 */
    PERMISSION_PROMOTION_RECOMMEND_PRODUCT_ACTIVITY: '/main-operations/crm/marketingActivities/recommendProduct',
    /** 美团点评券 */
    PERMISSION_PROMOTION_VIRTUAL_TICKET_MT: '/main-operations/coupons/meituanCoupon',
    /** 支付宝门店 */
    PERMISSION_PROMOTION_ALIPAY_LOCATION: '/main-operations/coupons/alipayStore',
    /** 支付宝神券 */
    PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY: '/main-operations/coupons/alipayCoupon',
    /** 优惠券包 */
    PERMISSION_DISCOUNT_TICKET_PACK: '/main-operations/marketingActivities/discountPackage',
    /** 减运费 */
    PERMISSION_DISCOUNT_FREIGHT_REDUCE: '/main-operations/promotion/marketingActivities/reduceFreight',
    /** 新客专享 */
    PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE: '/main-operations/crm/marketingActivities/newCustomerExclusive',
    /** 商品时段 */
    PERMISSION_PRODUCT_TIME_PERIOD: '/main-operations/goods/productTimePeriod',
    /** 必点菜 */
    PERMISSION_PRODUCT_MUST_ORDER: '/main-operations/goods/mustOrderProduct',
    /** 营销活动管理 */
    PERMISSION_PROMOTION_ACTIVE_MANAGER: '/main-operations/manageCrm',
    /** 促销活动管理 */
    PARENT_PERMISSION_PROMOTION_EVENT_MANAGER: '/main-operations/managePromotion',
    /** 问卷调查 */
    PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY: '/main-operations/crm/marketingActivities/questionnaireSurvey',
    /** 快手券 */
    PERMISSION_PROMOTION_VIRTUAL_TICKET_KS: '/main-operations/coupons/kuaishouCoupon',
    /** *******企微权限******* */
    /** 企微概览 */
    PERMISSION_WECOM_OVERVIEW: '/main-operations/wecom/overView',
    /** 渠道活码 */
    PERMISSION_WECOM_CUSTOMER_CHANNEL_CODE: '/main-operations/wecom/channelCodeList',
    /** 社群活码 */
    PERMISSION_WECOM_GROUP_CHANNEL_CODE: '/main-operations/wecom/groupCodeList',
    /** LBS加好友 */
    PERMISSION_WECOM_LBS_FRIEND: '/main-operations/wecom/lbsFriendList',
    /** LBS引流入群 */
    PERMISSION_WECOM_LBS_GROUP: '/main-operations/wecom/lbsGroupList',
    /** 群欢迎语 */
    PERMISSION_WECOM_GROUP_GREET: '/main-operations/wecom/groupwelcommessage',
    /** 客户群发 */
    PERMISSION_WECOM_CUSTOMER_GROUP_SEND: '/main-operations/wecom/customerGroupSends',
    /** 社群群发 */
    PERMISSION_WECOM_GROUP_GROUP_SEND: '/main-operations/wecom/massGroupSends',
    /** 群发助手 */
    PERMISSION_WECOM_GROUP_SEND_ASSISANT: '/main-operations/wecom/groupSendAssistant',
    /** 素材库 */
    PERMISSION_WECOM_MATERIAL: '/main-operations/wecom/materialLibrary',
    /** 客户列表 */
    PERMISSION_WECOM_CUSTOMER: '/main-operations/wecom/customerList',
    /** 客户群 */
    PERMISSION_WECOM_CUSTOMER_GROUP: '/main-operations/wecom/customerGroupList',
    /** 群主管理 */
    PERMISSION_WECOM_GROUP_OWNER: '/main-operations/wecom/groupOwnerList',
    /** 社群标签 */
    PERMISSION_WECOM_GROUP_TAG: '/main-operations/wecom/groupTag',
    /** 客户标签 */
    PERMISSION_WECOM_CUSTOMER_TAG: '/main-operations/wecom/customerTag',
    /** 应用 */
    PERMISSION_WECOM_APP: '/main-operations/wecom/application',
    /** 员工管理 */
    PERMISSION_WECOM_STAFF_MGR: '/main-operations/wecom/staffList',
    /** 员工接口管理 */
    PERMISSION_WECOM_STAFF_LICENSE_MGR: '/main-operations/wecom/accountManage',
    /** 企微角色管理 */
    PERMISSION_WECOM_ROLE_MGR: '/main-operations/wecom/roleManage',
    /** *******平台小程序权限******* */
    /** 平台小程序门店列表 */
    PERMISSION_PLATFORM_LOCATION: '/main-operations/platform/location',
    /** 平台小程序商品列表 */
    PERMISSION_PLATFORM_PRODUCT: '/main-operations/platform/product',
    /** 平台小程序商品审核 */
    PERMISSION_PLATFORM_PRODUCT_AUDIT: '/main-operations/platform/examine',
    /** *******进销存权限******* */
    /** 成本卡档案*/
    PERMISSION_FILES_COST_CARD: '/document/costCard',
    /** 替代品管理*/
    PERMISSION_FILES_REPLACE_ITEM: '/document/itemReplace',
    /** 物品档案*/
    PERMISSION_FILES_RPODUCT_FILES: '/document/product/productStorage',
    /** 虚拟物品档案*/
    PERMISSION_FILES_VIRTUAL_ITEM: '/document/virtualItem',
    /** 仓库档案*/
    PERMISSION_FILES_WAREHOUSE_FILES: '/document/store',
    /** 仓库物品规则 */
    PERMISSION_WAREHOUSE_ITEM_RULES: '/document/stockItemRule',
    /** 物品分类*/
    PERMISSION_FILES_PRODUCT_TYPE: '/document/product/productCategory',
    /** 品牌*/
    PERMISSION_FILES_PRODUCT_VENDOR: '/document/product/productBrand',
    /** 档案设置*/
    PERMISSION_FILES_SETTING: '/document/settings',
    /** 物品查询模板 */
    PERMISSION_STOCK_ITEM_QUERY_TMPL: '/document/productQueryTemplate',
    /** 物品角标 */
    PERMISSION_ITEM_CORNER_MARK: '/document/itemCornerLabel',
    /** 订货单 */
    PERMISSION_CHAIN_REQUEST_ORDER: '/orders/requestOrder',
    /** 调出单 */
    PERMISSION_CHAIN_TRANSFER_OUT_ORDER: '/orders/transferOutOrder',
    /** 调入单 */
    PERMISSION_CHAIN_TRANSFER_IN_ORDER: '/orders/transferInOrder',
    /** 内部申请单 */
    PERMISSION_CHAIN_INNER_APPLY_ORDER: '/orders/innerApplyOrder',
    /** 订货单 */
    PERMISSION_CHAIN_REQUEST_ORDER_EARTH: '/earthOrders/earthLocationReplenishment',
    /** 调出单 */
    PERMISSION_CHAIN_TRANSFER_OUT_ORDER_EARTH: '/earthOrders/earthTransferOutOrder',
    /** 调入单 */
    PERMISSION_CHAIN_TRANSFER_IN_ORDER_EARTH: '/earthOrders/earthTransferInOrder',
    /** 内部申请单 */
    PERMISSION_CHAIN_INNER_APPLY_ORDER_EARTH: '/earthOrders/earthInnerApplyOrder',
    /** 配送中心 */
    PERMISSION_CHAIN_REQUEST_ORDER_STATISTICS: '/orders/distributionCenter',
    /** 门店配送价 */
    PERMISSION_CHAIN_PRODUCT_LOCATION: '/orders/locationChainPrice',
    /** 商品毛利 */
    PERMISSION_PRODUCT_DISTRIBUTION_GROSS_PROFIT: '/report/finance/productGrossProfit',
    /** 门店毛利 */
    PERMISSION_LOCATION_DISTRIBUTION_GROSS_PROFIT: '/report/finance/locationGrossProfit',
    /** 配送毛利 */
    PERMISSION_CHAIN_DISTRIBUTION_GROSS_PROFIT: '/report/finance/distributionGrossProfit',
    /** 配送网络 */
    PERMISSION_CHAIN_SHIP_NET: '/orders/shipNet',
    /** 配送属性 */
    PERMISSION_CHAIN_PRODUCT_LOCATION_PROP: '/orders/productLocationProp',
    /** 配送属性 */
    PERMISSION_CHAIN_PRODUCT_LOCATION_PRICE: '/orders/productLocationPrice',
    /** 采购属性 */
    PERMISSION_STOCK_PRODUCT_LOCATION_PURCHASE: '/purchasing/productPurchaseProp',
    /** 商品在途 */
    PERMISSION_CHAIN_PRODUCT_IN_TRANSIT: '/report/orders/transiGoods',
    /** 供应商 */
    PERMISSION_STOCK_SUPPLIER: '/purchasing/supplier',
    /** 供应商 */
    PERMISSION_WHOLESALE_CUSTOMER_FILE: '/wholesale-customer/customer',
    /** 供应商用户 */
    PERMISSION_STOCK_SUPPLIER_USER: '/purchasing/supplierUser',
    /** 供应商角色 */
    PERMISSION_STOCK_SUPPLIER_USER_ROLE: '/purchasing/supplierUserRole',
    /** 供应商微信解绑 */
    PERMISSION_STOCK_SUPPLIER_WECHAT_UNBIND: '/purchasing/supplierWechatUnbind',
    /** 收货单 */
    PERMISSION_CHAIN_RECEIVE_ORDER: '/purchasing/receiveOrder',
    /** 采购订单 */
    PERMISSION_STOCK_PURCHASE_ORDER: '/purchasing/purchaseOrder',
    /** 供应商直发单 */
    PERMISSION_STOCK_SUPPLIER_DIRECT_ORDER: '/purchasing/directOrder',
    /** 退货单 */
    PERMISSION_STOCK_RETURN_ORDER: '/purchasing/returnOrder',
    /** 采购汇总明细 */
    PERMISSION_PURCHASE_SUMMARY_DETAIL: '/report/purchasing/summaryDetails',
    /** 采购订单监控 */
    PERMISSION_PURCHASE_ORDER_MONITOR: '/report/purchasing/monitor',
    /** 供应商直发明细表 */
    PERMISSION_PURCHASE_ORDER_SUPPLIER_SHIPMENT_DETAIL: '/report/purchasing/directOrderDetails',
    /** 物品供货关系 */
    PERMISSION_STOCK_SUPPLIER_PRODUCT: '/purchasing/supply',
    /** 门店订货控制 */
    PERMISSION_CHAIN_LOCATION_REQUEST_CONTROL: '/orders/orderingControl',
    /** 门店要货模板 */
    PERMISSION_STOCK_REQUEST_ORDER_TEMPLATE: '/orders/requestTemplate',
    /** 退货申请原因 */
    PERMISSION_STOCK_INNER_RETURN_REASON: '/orders/innerReturnReason',
    /** 盘点单 */
    PERMISSION_STOCK_CHECK_ORDER: '/check/checkOrder',
    /** 销售发货单 */
    PERMISSION_STOCK_WHOLESALE_DELIVERY_ORDER: '/wholesale-manager/sale-order',
    /** 销售报价单 */
    PERMISSION_STOCK_WHOLESALE_QUOTE_ORDER: '/wholesale-manager/quote-order',
    /** 销售退货单 */
    PERMISSION_STOCK_WHOLESALE_RETURN_ORDER: '/wholesale-manager/return-order',
    /** 库存调整原因 */
    PERMISSION_STOCK_ADJUSTMENT_REASON: '/check/adjustmentReason',
    /** 库存调整单 */
    PERMISSION_STOCK_ADJUSTMENT_ORDER: '/check/adjustmentOrder',
    /** 物品库存 */
    PERMISSION_STOCK_PRODUCT_STOCK: '/report/check/goodsInventory',
    /** 库存转仓 */
    PERMISSION_STOCK_TRANSFER_STOREHOUSE: '/check/stockTransfer',
    /** 库存成本调整 */
    PERMISSION_STOCK_INVENTORY_COST_ADJUST: '/check/stockCostAdjustment',
    /** 库存成本重算 */
    PERMISSION_STOCK_INVENTORY_COST_RECAL: '/check/stockCostRecalculate',
    /** 会计期 */
    PERMISSION_STOCK_FINANCIAL_ACCOUNT_PERIOD: '/accounting/periods',
    /** 财务结转 */
    PERMISSION_STOCK_FINANCIAL_ACCOUNT_SETTLEMENT: '/accounting/settlementManager',
    /** 库存进出明细 */
    PERMISSION_FILES_PRODUCT_IN_OUT_DETAIL: '/report/check/entryExitDetails',
    /** 库存进出汇总 */
    PERMISSION_STOCK_INVENTORY_IN_OUT_SUMMARY: '/report/check/entryExitSummary',
    /** 入库汇总 */
    PERMISSION_STOCK_INVENTORY_IN_SUMMARY: '/report/check/entryStockSummary',
    /** 出库汇总 */
    PERMISSION_STOCK_INVENTORY_OUT_SUMMARY: '/report/check/exitStockSummary',
    /**进销存变动统计 */
    PERMISSION_STOCK_STATISTICS_OF_CHANGE: '/report/check/statisticsOfChange',
    /**损益统计表 */
    PERMISSION_STOCK_GAIN_LOSS_REPORT: '/report/check/profitLossReport',
    /** 生产计划单 */
    PERMISSION_STOCK_PRODUCE_PLAN_ORDER: '/process/productionPlan',
    /** 生产任务单 */
    PERMISSION_STOCK_PRODUCE_TASK: '/process/productionOrder',
    /** 加工间任务看板 */
    PERMISSION_STOCK_PRODUCE_TASK_BOARD: '/process/taskDashBoard',
    /** 生产看板 */
    PERMISSION_STOCK_PRODUCE_BOARD: '/process/productionBoard',
    /** 生产领料单 */
    PERMISSION_STOCK_PRODUCE_MATERIAL_ORDER: '/process/productionProcess',
    /** 快速生产单 */
    PERMISSION_STOCK_PRODUCE_FAST_ORDER: '/process/produceFastOrder',
    /** 生产汇总表 */
    PERMISSION_STOCK_PRODUCE_PROCESS_RATE: '/report/process/processSummaryReport',
    /** 生产人员生产汇总表 */
    PERMISSION_STOCK_PRODUCE_OPERATOR_PRODUCE_SUMMARY: '/report/process/processStaffReport',
    /** 生产入库单 */
    PERMISSION_STOCK_PRODUCE_STORAGE_ORDER: '/process/productionStorage',
    /** 门店加工单 */
    PERMISSION_STOCK_LOCATION_PRODUCE: '/process/locationProcessOrder',
    /** 打印模板配置 */
    PERMISSION_STOCK_SETTING_PRINT_TMPL: '/settings/printTemplate',
    /** 加工品管理 */
    PERMISSION_STOCK_PRODUCT_PRODUCE_MGR: '/process/processProducts',
    /** 配方 */
    PERMISSION_STOCK_PRODUCT_FORMULA: '/process/goodsFormula',
    /** 基本参数 */
    PERMISSION_SETTING_CHAIN_STOCK: '/settings/base',
    /** 退货/退菜报表 */
    PERMISSION_ANALYZE_SESSION_PRODUCT_REFUND_STATISTICS: '/main-report/return-product-statistics-report',
    /** 赠品统计 */
    PERMISSION_ANALYZE_PRODUCT_GIFT_STATISTICS: '/main-report/gift-statistics-report',
    /** 加料销售统计 */
    PERMISSION_ANALYZE_PROPERTY_SALE_STATISTICS: '/main-report/feed-sale-statistics-report',
    /** 做法统计 */
    PERMISSION_ANALYZE_MAKE_METHOD_STATISTICS: '/main-report/method-statistics-report',
    /** APP物品参数配置 */
    PERMISSION_STOCK_APP_ITEM_LIST_SETTING: '/settings/appProductSetting',
    /** 补货向导 */
    PERMISSION_DISTRIBUTION_MANAGEMENT_REQUEST_GUIDE: '/orders/replenishmentGuide',
    /** 配送结算 */
    PERMISSION_STOCK_FINANCIAL_DELIVER_SETTLEMENT: '/finance/distributionSettlement',
    /** 门店费用汇总 */
    PERMISSION_STOCK_LOCATION_FEE_SUMMARY: '/finance/locationFee',
    /** 门店往来账款 */
    PERMISSION_STOCK_LOCATION_ACCOUNT_AMOUNT: '/finance/locationDealings',
    /** 供应商预付 */
    PERMISSION_STOCK_SUPPLIER_PRE_PAY: '/finance/supplierPrepayment',
    /** 供应商结算 */
    PERMISSION_STOCK_SUPPLIER_SETTLEMENT_SUB: '/finance/supplierSettlement',
    /** 费用项目 */
    PERMISSION_STOCK_FINANCE_FEE_ITEM: '/finance/costProject',
    /** 门店预收 */
    PERMISSION_STOCK_LOCATION_PRE_RECEIVE: '/finance/locationPrepayment',
    /** 供应商往来账款 */
    PERMISSION_STOCK_SUPPLIER_ACCOUNT_AMOUNT: '/finance/supplierDealings',
    /** 供应商预付汇总 */
    PERMISSION_STOCK_SUPPLIER_PRE_PAY_SUMMARY: '/finance/supplierPrepaymentSum',
    /** 门店预付汇总 */
    PERMISSION_STOCK_LOCATION_PRE_RECEIVE_SUMMARY: '/finance/locationPrepaymentSum',
    /** 门店费用 */
    PERMISSION_STOCK_LOCATION_FEE: '/finance/locationExpense',
    /** 供应商费用 */
    PERMISSION_STOCK_SUPPLIER_FEE: '/finance/supplierExpense',
    /** 供应商费用汇总 */
    PERMISSION_STOCK_SUPPLIER_FEE_SUMMARY: '/finance/supplierExpenseSummary',
    /** 生产模板 */
    PERMISSION_STOCK_PRODUCE_TMPL: '/process/template',
    /** 作业人员 */
    PERMISSION_STOCK_PRODUCE_OPERATOR: '/process/operator',
    /** 商品报损 */
    PERMISSION_STOCK_PRODUCT_REPORT_LOSS: '/check/inventoryLossOrder',
    /** 物品改价记录 */
    PERMISSION_FILES_ITEM_PRICE_LOG: '/document/priceLogs',
    /** 客户物品销售查询 */
    PERMISSION_WHOLESALE_REPORT: '/report/customerSales/itemsSalesQuery',
    /** *******进销存权限******* */
    /**财务中心 */
    /**财务中心 数据概览 */
    PERMISSION_MERCHANT_PAY_DASHBOARD: '/main-finance/dashboard',
    /**财务中心 交易汇总  */
    PERMISSION_MERCHANT_PAY_TRADE: '/main-finance/payTrade',
    /**财务中心 支付记录 */
    PERMISSION_MERCHANT_PAY_RECORD: '/main-finance/payRecord',
    /**财务中心 退款记录 */
    PERMISSION_MERCHANT_PAY_REFUND: '/main-finance/payRefund',
    /**财务中心 我的应用 */
    PERMISSION_MERCHANT_PAY_MY_APP: '/main-finance/myApp',
    /**财务中心 我的商户有子tab，所以需要根据总+子权限是否任意一个有“QUERY”判断入口是否显示 */
    PERMISSION_MERCHANT_PAY_MY_MERCHANT: '/main-finance/myMerchant',
    PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_MGR: '/main-finance/myMerchant',
    PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_GROUP: '/main-finance/myMerchant',
    /**财务中心 渠道配置  */
    PERMISSION_MERCHANT_PAY_CHANNEL_CONFIG: '/main-finance/channelConfig',
    /**财务中心 门店子商户配置  */
    PERMISSION_MERCHANT_PAY_LOCATION_SUB_APP: '/main-finance/locationSubMerchantConfig',
    /**财务中心 平台交易汇总 */
    PERMISSION_PLATFORM_PAY_TRADE: '/main-finance/appletPayTrade',
    /**财务中心 平台支付记录 */
    PERMISSION_PLATFORM_PAY_RECORD: '/main-finance/appletPayRecord',
    /**财务中心 平台退款记录 */
    PERMISSION_PLATFORM_PAY_REFUND: '/main-finance/appletPayRefund',
    /**配送规则 */
    PERMISSION_AGGREGATE_TRANSFER_RULE: '/main-operations/aggregatedDelivery',
    /** 渠道 */
    PERMISSION_AGGREGATE_TRANSFER_CHANNEL: '/main-operations/aggregatedDelivery',
    /**聚合配送订单 */
    PERMISSION_AGGREGATE_TRANSFER_ORDER: '/main-operations/aggregated_order',
    /**开票主体 */
    PERMISSION_INVOICE_BODY: '/main-base/invoice-management',
    /** 开票申请 */
    PERMISSION_INVOICE_APPLY: '/main-base/invoice-apply',
    /** 门店设置*/
    PERMISSION_INVOICE_LOCATION_SETTING: '/main-base/invoice-locations',
    /** 开票设置*/
    PERMISSION_INVOICE_SETTING: '/main-base/invoice-setup',
    /** 开票记录*/
    PERMISSION_INVOICE_RECORD: '/main-base/invoice-record',
    PERMISSION_ANALYZE_SENSITIVE_OPERATION: '/main-report/sensitive-operation-report',
    PERMISSION_PRODUCT_MARKETING_REPORT: '/main-report/product-marketing-report',
    PERMISSION_PROMOTION_VIRTUAL_TICKET_DY: '/main-operations/coupons/douyinCoupon',
    /** 口碑券 */
    PERMISSION_PROMOTION_VIRTUAL_TICKET_KOU_BEI: '/main-operations/coupons/koubeiCoupon',
    /** 用户协议 */
    PERMISSION_SETTING_AGREEMENT: '/main-operations/weapp/userAgreement',
    /** 商城商品 */
    PERMISSION_PRODUCT_SHOP: '/product/product-mall',
    /** 快递模板 */
    PERMISSION_SETTING_EXPRESS_TMPL: '/main-operations/courierTemplate',
    /** 商城设置 */
    PERMISSION_SETTING_EXPRESS_SHOP_SETTING: '/main-operations/mallSetting',
    /** 评价设置 */
    PERMISSION_SETTING_EVALUATION_SETTING: '/main-operations/settings/evaluationSettings',
    /** 加盟分账 */
    // #region 加盟分账
    // 财务主体
    PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY: '/main-finance/financialEntity',
    /** 门店财务设置 */
    PERMISSION_FINANCE_SUBJECT_LOCATION_CONFIG: '/main-finance/locationFinanceSetting',
    // 财务主体变更记录
    PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY_CHANGE_RECORD: '/main-finance/financialEntityChangeRecord',
    // 储值分账方案
    PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_LEDGER: '/main-finance/storedValueConsumptionLedger',
    // 储值分账结算单
    PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM: '/main-finance/storedValueConsumptionSettlementForm',
    // 礼品卡分账方案
    PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_LEDGER: '/main-finance/giftCardConsumptionLedger',
    // 礼品卡结算单
    PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM: '/main-finance/giftCardConsumptionSettlementForm',
    // 券核销分账方案
    PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_LEDGER: '/main-finance/voucherVerificationLedger',
    // 券核销分账结算单
    PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM: '/main-finance/voucherVerificationSettlementForm',
    // 付款记录
    PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD: '/main-finance/paymentRecords',
    // 提现记录
    PERMISSION_FRANCHISE_DISTRIBUTION_WITHDRAWAL_RECORD: '/main-finance/withdrawalRecords',
    // 分账稽查
    PERMISSION_FRANCHISE_BATCH_SETTLEMENT_ORDER_CHECK: '/main-finance/distributionAudit',
    // 流水汇总
    PERMISSION_FRANCHISE_DISTRIBUTION_STREAM_SUMMARY: '/main-finance/streamSummary',
    // 付款记录汇总
    PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD_SUMMARY: '/main-finance/paymentRecordSummary',
    // 分账明细
    PERMISSION_FRANCHISE_DISTRIBUTION_STATISTIC: '/main-finance/settlementOrder',
    /** 自定义分账方案 */
    PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_LEDGER: '/main-finance/customLedger',
    PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_SETTLEMENT_FORM: '/main-finance/customSettlementForm',
    /** 资金参数 */
    PERMISSION_FRANCHISE_FINANCE_SETTING: '/main-finance/fundParams',
    /** 款项设置 */
    PERMISSION_FRANCHISE_DISTRIBUTION_FEE_ITEM: '/main-finance/moneySetting',
    /** 总部分账方案 */
    PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_LEDGER: '/main-finance/headquartersLedger',
    /** 总部费用单 */
    PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_EXPENSE: '/main-finance/headquartersExpense',
    /** 总部分账结算单 */
    PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM: '/main-finance/headquartersSettlementForm',
    /** 门店分账方案 */
    PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_LEDGER: '/main-finance/locationLedger',
    /** 门店费用单 */
    PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_EXPENSE: '/main-finance/locationExpense',
    /** 门店分账结算单 */
    PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM: '/main-finance/locationSettlementForm',
    /** 资金流水 */
    PERMISSION_FRANCHISE_FUND_ACCOUNT_FLOW: '/main-finance/capitalFlow',
    /** 记账户流水 */
    PERMISSION_FRANCHISE_RECORD_ACCOUNT_FLOW: '/main-finance/recordAccountFlow',
    /** 流水明细 */
    PERMISSION_FRANCHISE_COMBINE_BALANCE_FLOW: '/main-finance/summaryOfFlow',
    // #endregion
    // #region 效期管理
    // 效期商品
    PERMISSION_VALIDITY_PRODUCT: '/main-operations/EXPGoods',
    // 存储条件
    PERMISSION_VALIDITY_STORAGE_CONDITION: '/main-operations/storageCondition',
    // 效期看板
    PERMISSION_VALIDITY_BOARD: '/main-operations/EXPBoard',
    // 效期汇总
    PERMISSION_VALIDITY_SUMMARY: '/main-operations/EXPCollect',
    // 任务活动
    PERMISSION_DISCOUNT_TASK_ACTIVITY: '/main-operations/crm/marketingActivities/taskActivity',
    PERMISSION_PRODUCT_SORT: '/main-operations/goods/productSort',
    PERMISSION_PRODUCT_TAG_HEADQUARTERS: '/main-operations/goods/productionDepartment',
    PERMISSION_PRODUCT_TAG_LOCATION: '/main-operations/goods/productionDepartment',
    /** 商品打印配置 */
    PERMISSION_PRODUCT_PRINT_CONFIGURATION: '/main-operations/goods/productPrintConfig',
    PERMISSION_ANALYZE_PRODUCT_OVERVIEW_REPORT: '/main-report/product-overview-report',
    /** TV屏设置 */
    PERMISSION_SETTING_TAKE_SCREEN: '/main-operations/settings/tvSettings',
    /** 裱花网络 */
    PERMISSION_SETTING_CAKE_DECORATOR: '/main-operations/settings/cakeDecorator',
    /** 品牌管理 */
    PERMISSION_SETTING_VENDOR_MANAGER: '/main-operations/brandName',
    /** 共享互斥 */
    PERMISSION_PROMOTION_EXCLUSIVE_SHARE: '/main-operations/sharedMutex',
    /** 企业挂账管理  */
    PERMISSION_ENTERPRISE: '/main-operations/accountManagement',
    /**  个人挂账管理 */
    PERMISSION_PERSON_ARREARS: '/main-operations/employeeBillingManagement',
    /** 扫码点单 */
    PERMISSION_SETTING_SCAN_CODE_PAY: '/main-operations/settings/billScanningCode',
    /** 寄存单 */
    PERMISSION_STORAGE_ORDER: '/main-operations/receiptOfDepositary',
    PERMISSION_ORDER_TABLE_RESERVE: '/main-operations/tableOrder',
    /** 设置-叫号设置 */
    PERMISSION_SETTING_CALL_NUMBER: '/main-operations/callNumberSetting',
    /** 会员卡-共享分组列表 */
    PERMISSION_CUSTOMER_CARD_SHARE_GROUP: '/main-operations/clubCardGroup',
    /**会员卡-卡列表 */
    PERMISSION_CUSTOMER_CARD_LIST: '/main-operations/clubCard',
    /**会员卡-卡类型 */
    PERMISSION_CUSTOMER_CARD_TYPE: '/main-operations/cardKind',
    /**会员卡-IC卡 */
    PERMISSION_CUSTOMER_IC_CARD: '/main-operations/cardImport',
    /** 销售员管理 */
    PERMISSION_POS_SALESMAN: '/main-operations/salesman',
    /** kds设置 */
    PERMISSION_SETTING_WIN_KDS: '/main-operations/kdsSettings',
    /** 订金 */
    PERMISSION_DOWN_PAYMENT: '/main-operations/downPayment',
    /** 营业指标同环比 */
    PERMISSION_REPORT_BUSINESS_CYCLE_COMPARE: '/main-report/business-target-report',
    /** 趣味竞猜 */
    PERMISSION_PROMOTION_FUN_GUESS: '/main-operations/crm/marketingActivities/funGame', // 趣味竞猜
    /** 趣味竞猜-比赛 */
    PERMISSION_PROMOTION_FUN_MATCH: '/main-operations/crm/marketingActivities/funGame?tab:game', // 趣味竞猜-比赛
    /** 餐/时段营业统计 */
    PERMISSION_ANALYZE_SESSION_BUSINESS_STATISTICS: '/main-report/session-business-statistics-report',
    PERMISSION_ANALYZE_SESSION_PRODUCT_STATISTICS: '/main-report/session-product-statistics-report',
    /** 预储值 */
    PERMISSION_PRE_DEPOSITS: '/main-operations/preDeposit', // 预储值
    /** 服务费 */
    PERMISSION_BUSINESS_SERVICE_FEE: '/main-operations/serviceFee',
    /** 服务费统计 */
    PERMISSION_ANALYZE_SERVICE_FEE_ITEM: '/main-report/service-fee-statistics',
    /** 团购券核销记录 */
    PERMISSION_ANALYZE_PLATFORM_TICKET_VERIFY_LOG: '/main-report/group-purchase-coupon-record',
    /** 商品成本明细表 */
    PERMISSION_ITEM_COST_DETAIL: '/report/finance/productCostDetail',
    /** 套餐销售统计 */
    PERMISSION_ANALYZE_KIT_SALE_STATISTICS: '/main-report/kit-sales-ranking-report',
    PERMISSION_ANALYZE_PRODUCT_CLEARANCE_LOG: '/main-report/clear-sale-report',
    /** 断货分析 */
    PERMISSION_STOCK_INTERRUPT_INVENTORY_REPORT: '/report/check/stockInterrupt',
    /** 库存预警 */
    PERMISSION_STOCK_WARN_INVENTORY_REPORT: '/report/check/inventoryWarn',
    /** 供应链门店复制 */
    PERMISSION_STOCK_LOCATION_SYNC: '/settings/locationCopy',
    PARENT_PERMISSION_SMS_TMPL: '/main-operations/sms/setting/smsTemplate',
    PARENT_PERMISSION_SMS_TMPL_TYPE: '/main-operations/sms/setting/smsType',
    PERMISSION_SETTING_VOUCHER: '/main-operations/settings/vouchers',
    // 零售供应链-商品同步
    PERMISSION_APP_EARTH_BRIDGE: '/settings/couplerSettings/productSync',
    // 零售供应链-门店列表
    PERMISSION_APP_EARTH_BRIDGE_LOCATION: '/settings/couplerSettings/earthLocation',
    // 零售供应链-单据日志
    PERMISSION_APP_EARTH_BRIDGE_ORDER_LOG: '/settings/couplerSettings/transferOrder',
    // 零售供应链-授权设置
    PERMISSION_APP_EARTH_BRIDGE_AUTH: '/settings/couplerSettings/authorization',
    // 零售供应链-零售供应链设置
    PERMISSION_EARTH_CHAIN_SETTING: '/settings/couplerSettings/retailSupplyChainSetting',
    // 超量折扣
    PERMISSION_STOCK_EXCEED_DISCOUNT_ORDER: '/orders/exceedDiscountOrder',
    // 配送跟踪
    PERMISSION_TRANSFER_TRACK: '/report/orders/transferReportsTrack',
    // 会员卡交易流水
    PERMISSION_ANALYZE_CUSTOMER_CARD_TRADE_LOG: '/main-report/customer-card-trade-log',
    /** 储值活动效果分析 */
    PERMISSION_ANALYZE_GIFT_DEPOSIT: '/main-report/deposit-activity-effect-analysis',
    /** 会员卡操作明细 */
    PERMISSION_ANALYZE_CUSTOMER_CARD_OPERATE_LOG: '/main-report/vip-card-operate-analysis',
    // 补充之前缺失的搜索进销存报表
    /** 要货单提交状态表 */
    PERMISSION_CHAIN_REQUEST_ORDER_COMMIT_STATE: '/report/orders/requestOrderStatusList',
    /** 加工品原料耗用分析表 */
    PERMISSION_PRODUCE_MATERIAL_USE_ANALYZE: '/report/process/materialAnalysisReport',
    /** 应产率报表 */
    PERMISSION_SHOULD_PRODUCE_RATE_ANALYZE: '/report/process/expectedYieldReport',
    /** 门店商品毛利对比 */
    PERMISSION_LOCATION_PRODUCT_GROSS_CONTRAST: '/report/finance/locationGrossProfitDiff',
    /** 采购向导 */
    PERMISSION_PURCHASING_MANAGEMENT_PURCHASE_GUIDE: '/purchasing/purchaseGuide',
    /** 库存周转率 */
    PERMISSION_STOCK_INVENTORY_TURNOVER_RATE: '/report/check/inventoryTurnoverRate',
    /** 发送通知 */
    PERMISSION_NOTICE_CENTER_SEND_MSG: '/main-message/noticeCenter/sendMsg',
    // #endregion
    // #region 手机点餐设置
    PERMISSION_SETTING_DINING_IN: '/main-operations/businessSettings',
    PERMISSION_SETTING_TAKE_OUT: '/main-operations/businessSettings',
    PERMISSION_SETTING_GROUP_MEAL_TAKE_OUT: '/main-operations/businessSettings',
    PERMISSION_SETTING_SHIPPING_SELF_AND_TAKE_OUT: '/main-operations/businessSettings',
    PERMISSION_SETTING_SHIPPING_GROUP_MEAL: '/main-operations/businessSettings',
    PERMISSION_OPERATE_SETTING_DINING_IN: '/main-operations/businessSettings',
    PERMISSION_OPERATE_SETTING_TAKE_OUT: '/main-operations/businessSettings',
    PERMISSION_OPERATE_SETTING_GROUP_MEAL_TAKE_OUT: '/main-operations/businessSettings',
    /** 商品同步 */
    PERMISSION_TAKEOUT_DISH_ISSUE: '/main-operations/oms/takeout/product',
    PERMISSION_PRODUCT_DISTRIBUTION: '/main-product/product-release',
    PERMISSION_PRODUCT_RECIPE_TEMPLATE_CATEGORY: '/main-product/product-template',
    PERMISSION_PRODUCT_TIMED_PRICE: '/main-product/product-dynamic-price',
    PERMISSION_PRODUCT_DISTRIBUTION_RECORD: '/main-product/product-release/record',
    // #endregion
};

export { ACTIVE_STATUS, BUSINESSTYPEOPTIONS, CACHE_ROUTE_CONFIG, CARD_TYPE, CATEGORYDIMENSION, COMMON_FUNCTION_ROUTER_URL, ChoiceDiscountType, DEDUCTION_LIST, DEFAULT_PROFILE, DEFAULT_SORTER, DING_MODE, DISTRIBUTION_CENTER, ESupplierPrePayState, EXCEED_DISCOUNT_MARK, EXPRESSMALLSTATISTICS, GainLossTypeMap, HEAD_QUARTERS, IBussinessType, IGiftCardKind, INVOICE_STATUS_OPTIONS, INVOICE_STATUS_OPTIONS_COLOR, MARS_CORE_SERVER_PATH, MARS_CRM_PATH, MARS_Color, MARS_EARTH_SERVER_PATH, MARS_FINANCE_SERVER_PATH, MARS_IDP_SERVER_PATH, MARS_OMS_PAY_PATH, MARS_OMS_POS_PATH, MARS_SERVER_ADMIN, MARS_SERVER_API_PATH, MARS_SERVER_FINANCE, MARS_SERVER_PLATFORM_MP_PATH, MARS_SERVER_POS_PATH, MARS_SERVER_WECOM_PATH, MARS_SOUCE, MARS_USER_CENTER_PATH, MARS_WECHAT_MP_API_PATH, MARS_WECHAT_MP_PATH, MAX_DATA_LIMIT, MAX_LIMIT, MAX_MONEY_LIMIT, MAX_NUMBER_LIMIT, MAX_PRICE_LIMIT, MAX_RATE_LIMIT, NORMAL_SHOP, OPERATEORDER_SOURCE_MAP, OPERATE_LIST, ORDERFINANCIALSTATUSOPTIONS, ORDERSTATUSOPTIONS11, ORDER_STATUS_LIST, OSS_DOMAIN, OSS_ORIGIN, PAYMENT_TYPE_AND_DISCOUNT_TYPE_LIST, PRODUCT_CHAIN_PATH, PRODUCT_REPORT_PATH, PRODUCT_STOCK_PATH, QueryTypeObj, RefBusinessTypeObj, SALESMIX, SALE_CHANNEL_LIST, SALE_CHANNEL_MAP, SALE_CHANNEL_TYPE, SOURCEITEMVALUE, SOURCE_ITEM, STATE_CODE_MAP, STATE_LIST, STATE_LIST_BASE, STATE_LIST_STOCK, STATISTICALMETHODS, STOREDVALUETYPE, TABLE_COL_WIDTH, TABLE_HEIGHT, THIRD_SALE_CHANNEL_LIST, TIME_DIMENSION, TIME_DIMENSION_BusinessReceiptDetail, TIME_DIMENSION_BusinessReceiptStatistics, ZONE, businessType, city as cities, costRecalculateStateObj, dateTypeList, index as decorateRoutes, getOperateSourceIncludeTriparTitleData, orderOtherSourceList, orderSourceList, orderTypeList, index$1 as payRoutes, planOrderTypeMapping, index$3 as reportRoutes, index$2 as saleRoutes, settlementManagerStateObj, signTypeObj, statusList, statusMap, stock as stockRoutes, weekMap };
//# sourceMappingURL=index.esm.js.map
